;(() => {
  "use strict";

  console.info("[23DTF] Personalizer modal v1.0-pre11 · reset seguro tras carrito loaded");

  const PLACEMENTS = [
    {
      id: "front",
      label: "Impresión frontal",
      priceByZone: { front_full: "3 €", left_chest: "2 €" },
      mediaZone: "frontal",
      zones: [
        { id: "front_full", label: "Frontal completo", short: "Frontal completo", area: "30 × 35 cm", rect: { x: 82, y: 64, w: 216, h: 260 } },
        { id: "left_chest", label: "Pecho izquierdo", short: "Pecho izquierdo", area: "10 × 10 cm", rect: { x: 112, y: 88, w: 82, h: 82 } }
      ]
    },
    {
      id: "left_sleeve",
      label: "Manga izquierda",
      price: "1,50 €",
      mediaZone: "lateral",
      zones: [
        { id: "left_sleeve_outer", label: "Manga izquierda exterior", short: "Manga izquierda", area: "8 × 12 cm", rect: { x: 48, y: 122, w: 72, h: 150 } }
      ]
    },
    {
      id: "right_sleeve",
      label: "Manga derecha",
      price: "1,50 €",
      mediaZone: "lateral",
      zones: [
        { id: "right_sleeve_outer", label: "Manga derecha exterior", short: "Manga derecha", area: "8 × 12 cm", rect: { x: 260, y: 122, w: 72, h: 150 } }
      ]
    },
    {
      id: "back",
      label: "Impresión trasera",
      price: "4 €",
      mediaZone: "trasera",
      zones: [
        { id: "back_full", label: "Espalda completa", short: "Espalda completa", area: "30 × 35 cm", rect: { x: 82, y: 64, w: 216, h: 260 } }
      ]
    },
    {
      id: "inner_label",
      label: "Etiqueta interior",
      price: "1 €",
      mediaZone: "frontal",
      zones: [
        { id: "inner_label_zone", label: "Etiqueta interior", short: "Etiqueta interior", area: "6 × 4 cm", rect: { x: 158, y: 30, w: 64, h: 44 } }
      ]
    }
  ];

  const TEXT_TOOLS = [
    ["text", "✎ Texto"],
    ["color", "■ Color"],
    ["outline", "T Contorno"],
    ["shadow", "T Sombreado"],
    ["transform", "⤢ Transformar"],
    ["position", "✥ Posición"]
  ];

  const IMAGE_TOOLS = [
    ["transform", "⤢ Transformar"],
    ["position", "✥ Posición"],
    ["crop", "⌶ Recortar"],
    ["remove_bg", "✂ Quitar fondo"]
  ];

  const COLORS = [
    "#E66465", "#000000", "#FFFFFF", "#E8E8E8", "#BABABA", "#989898", "#696969", "#606060",
    "#3A3A3A", "#B5475C", "#D36371", "#F27981", "#FEA6A9", "#F9B2B7", "#FFC3C2", "#FFCECC",
    "#FFE6E3", "#A50024", "#C70F28", "#ED1C24", "#E64B3A", "#FFA397", "#EF7467", "#F37977",
    "#F69D91", "#CC5D54", "#B34436", "#9E4D49", "#6B2D2D", "#FFB18A", "#F7C194", "#FFCCA8",
    "#FFD7B3", "#EFC3AF", "#FFDECC", "#FFE9E2", "#FFEDD4", "#FFD39F", "#FFC571", "#F0BA60",
    "#FFA851", "#FA9044", "#F5873F", "#EA680F", "#F26522", "#F7572D", "#C93127", "#BB5727",
    "#8C4017", "#603913", "#9E5920", "#BF854B", "#E09A58", "#D07F2B", "#DD9D26", "#E2B56C",
    "#DEC48F", "#EAD6BB", "#F7F1D9", "#FDF7BD", "#FFF2B3", "#FFE98F", "#FFC829", "#FFE94D",
    "#F5F27B", "#ECE953", "#E5E43B", "#D2B648", "#C2CE6B", "#E9EFBC", "#E6F9DB", "#CCE251",
    "#74A952", "#A1C75B", "#54753F", "#465A3E", "#253A21", "#6FC75C", "#74B87E", "#48A05B",
    "#279143", "#006838", "#004924", "#66BC46", "#ECFDE9", "#CFEFCA", "#D1F3E4", "#C2E4D5",
    "#97D3B8", "#007258", "#00452D", "#91BA96", "#789472", "#7E8D68", "#7B8260", "#565B39",
    "#393500", "#248971", "#31A28E", "#00BEB8", "#43CAC9", "#4BB7BC", "#008B97", "#00505A",
    "#063140", "#BFD8C6", "#A9C4BA", "#70898D", "#284860", "#006993", "#1A85AC", "#3399B5",
    "#3DB7D3", "#D0F6F6", "#A2E5F4", "#99DCF3", "#43B3D4", "#34B6EF", "#037CC7", "#6EA5D9",
    "#C1D9F7", "#C5DDF3", "#0E3D84", "#4460A7", "#506B93", "#364B6A", "#0F1E3C", "#C6C1E4",
    "#B3B9DD", "#8091BE", "#7275B2", "#7D78C0", "#6D75BE", "#5C58AF", "#494570", "#23133D",
    "#46276B", "#512A7E", "#8A6AA7", "#B195C2", "#D3C5E8", "#DDC7D3", "#E9BDD5", "#F8DDF3",
    "#EE96C9", "#D072A6", "#C52D89", "#A82981", "#84175E", "#70265D", "#571147", "#CD368C",
    "#E0007B", "#FF8AAB", "#F768A0", "#A52F59", "#93003C", "#7C1123", "#512D32", "#8C6262",
    "#B09C9D", "#B6A9B2", "#EED0DA", "#FFE1E3", "#FFD5DB", "#FFCAD0", "#EFB1C0", "#E2AABA",
    "#B17D8C", "#C15860", "#CF4952", "#D3002E", "#F63C5A", "#F55886", "#FFB6CE", "#FFDCE9"
  ];

  const FONT_LIBRARY = [
    { name: "Arial Black", value: "\"23DTF Arial Black\", Arial, sans-serif", category: "Bold", popular: true },
    { name: "Arial", value: "\"23DTF Arial\", Arial, sans-serif", category: "Sans" },
    { name: "Arial Bold", value: "\"23DTF Arial Bold\", Arial, sans-serif", category: "Bold" },
    { name: "Arial Narrow", value: "\"23DTF Arial Narrow\", Arial Narrow, sans-serif", category: "Condensed" },
    { name: "Impact", value: "\"23DTF Impact\", Impact, sans-serif", category: "Bold", popular: true },
    { name: "Georgia", value: "\"23DTF Georgia\", Georgia, serif", category: "Serif", popular: true },
    { name: "Georgia Bold", value: "\"23DTF Georgia Bold\", Georgia, sans-serif", category: "Bold" },
    { name: "Trebuchet MS", value: "\"23DTF Trebuchet MS\", Trebuchet MS, sans-serif", category: "Sans" },
    { name: "Trebuchet MS Bold", value: "\"23DTF Trebuchet MS Bold\", Trebuchet MS, sans-serif", category: "Bold", popular: true },
    { name: "Verdana", value: "\"23DTF Verdana\", Verdana, sans-serif", category: "Sans" },
    { name: "Verdana Bold", value: "\"23DTF Verdana Bold\", Verdana, sans-serif", category: "Bold", popular: true },
    { name: "Century Gothic", value: "\"23DTF Century Gothic\", Century Gothic, serif", category: "Serif" },
    { name: "Century Gothic Bold", value: "\"23DTF Century Gothic Bold\", Century Gothic, sans-serif", category: "Bold", popular: true },
    { name: "Franklin Gothic Medium", value: "\"23DTF Franklin Gothic Medium\", Franklin Gothic Medium, sans-serif", category: "Bold", popular: true },
    { name: "Garamond", value: "\"23DTF Garamond\", Garamond, serif", category: "Serif" },
    { name: "Garamond Bold", value: "\"23DTF Garamond Bold\", Garamond, sans-serif", category: "Bold", popular: true },
    { name: "Book Antiqua", value: "\"23DTF Book Antiqua\", Book Antiqua, serif", category: "Serif" },
    { name: "Bookman Old Style", value: "\"23DTF Bookman Old Style\", Bookman Old Style, serif", category: "Serif" },
    { name: "Palatino Linotype", value: "\"23DTF Palatino Linotype\", Palatino Linotype, serif", category: "Serif" },
    { name: "Comic Sans MS", value: "\"23DTF Comic Sans MS\", Comic Sans MS, cursive", category: "Handmade" },
    { name: "Comic Sans MS Bold", value: "\"23DTF Comic Sans MS Bold\", Comic Sans MS, sans-serif", category: "Bold", popular: true },
    { name: "Segoe Print", value: "\"23DTF Segoe Print\", Segoe Print, cursive", category: "Handmade" },
    { name: "Segoe Print Bold", value: "\"23DTF Segoe Print Bold\", Segoe Print, sans-serif", category: "Bold", popular: true },
    { name: "Segoe Script", value: "\"23DTF Segoe Script\", Segoe Script, cursive", category: "Script" },
    { name: "Segoe Script Bold", value: "\"23DTF Segoe Script Bold\", Segoe Script, sans-serif", category: "Bold", popular: true },
    { name: "Ink Free", value: "\"23DTF Ink Free\", Ink Free, cursive", category: "Handmade", popular: true },
    { name: "MV Boli", value: "\"23DTF MV Boli\", MV Boli, cursive", category: "Handmade", popular: true },
    { name: "Monotype Corsiva", value: "\"23DTF Monotype Corsiva\", Monotype Corsiva, cursive", category: "Script", popular: true },
    { name: "Gabriola", value: "\"23DTF Gabriola\", Gabriola, cursive", category: "Handmade" },
    { name: "Bahnschrift", value: "\"23DTF Bahnschrift\", Bahnschrift, sans-serif", category: "Bold", popular: true },
    { name: "Calibri", value: "\"23DTF Calibri\", Calibri, sans-serif", category: "Sans" },
    { name: "Candara", value: "\"23DTF Candara\", Candara, sans-serif", category: "Sans" },
    { name: "Consolas", value: "\"23DTF Consolas\", Consolas, monospace", category: "Mono" },
    { name: "Constantia", value: "\"23DTF Constantia\", Constantia, serif", category: "Serif" },
    { name: "Corbel", value: "\"23DTF Corbel\", Corbel, sans-serif", category: "Sans" },
    { name: "Courier New", value: "\"23DTF Courier New\", Courier New, monospace", category: "Mono" },
    { name: "Times New Roman", value: "\"23DTF Times New Roman\", Times New Roman, serif", category: "Serif" },
    { name: "Tahoma", value: "\"23DTF Tahoma\", Tahoma, sans-serif", category: "Sans" },
    { name: "Arial Bold Italic", value: "\"23DTF Arial Bold Italic\", Arial, sans-serif", category: "Bold" },
    { name: "Arial Italic", value: "\"23DTF Arial Italic\", Arial, sans-serif", category: "Sans" },
    { name: "Arial Narrow Bold", value: "\"23DTF Arial Narrow Bold\", Arial Narrow, sans-serif", category: "Bold", popular: true },
    { name: "Arial Narrow Bold Italic", value: "\"23DTF Arial Narrow Bold Italic\", Arial Narrow, sans-serif", category: "Bold" },
    { name: "Arial Narrow Italic", value: "\"23DTF Arial Narrow Italic\", Arial Narrow, sans-serif", category: "Condensed" },
    { name: "Book Antiqua Bold", value: "\"23DTF Book Antiqua Bold\", Book Antiqua, sans-serif", category: "Bold", popular: true },
    { name: "Book Antiqua Bold Italic", value: "\"23DTF Book Antiqua Bold Italic\", Book Antiqua, sans-serif", category: "Bold" },
    { name: "Book Antiqua Italic", value: "\"23DTF Book Antiqua Italic\", Book Antiqua, serif", category: "Serif" },
    { name: "Bookman Old Style Bold", value: "\"23DTF Bookman Old Style Bold\", Bookman Old Style, sans-serif", category: "Bold" },
    { name: "Bookman Old Style Bold Italic", value: "\"23DTF Bookman Old Style Bold Italic\", Bookman Old Style, sans-serif", category: "Bold" },
    { name: "Bookman Old Style Italic", value: "\"23DTF Bookman Old Style Italic\", Bookman Old Style, serif", category: "Serif" },
    { name: "Calibri Bold", value: "\"23DTF Calibri Bold\", Calibri, sans-serif", category: "Bold" },
    { name: "Calibri Bold Italic", value: "\"23DTF Calibri Bold Italic\", Calibri, sans-serif", category: "Bold" },
    { name: "Calibri Italic", value: "\"23DTF Calibri Italic\", Calibri, sans-serif", category: "Sans" },
    { name: "Calibri Light", value: "\"23DTF Calibri Light\", Calibri, sans-serif", category: "Sans" },
    { name: "Calibri Light Italic", value: "\"23DTF Calibri Light Italic\", Calibri Light, sans-serif", category: "Sans" },
    { name: "Cambria Bold", value: "\"23DTF Cambria Bold\", Cambria, sans-serif", category: "Bold" },
    { name: "Cambria Bold Italic", value: "\"23DTF Cambria Bold Italic\", Cambria, sans-serif", category: "Bold" },
    { name: "Cambria Italic", value: "\"23DTF Cambria Italic\", Cambria, serif", category: "Serif" },
    { name: "Candara Bold", value: "\"23DTF Candara Bold\", Candara, sans-serif", category: "Bold" },
    { name: "Candara Bold Italic", value: "\"23DTF Candara Bold Italic\", Candara, sans-serif", category: "Bold" },
    { name: "Candara Italic", value: "\"23DTF Candara Italic\", Candara, sans-serif", category: "Sans" },
    { name: "Candara Light", value: "\"23DTF Candara Light\", Candara, sans-serif", category: "Sans" },
    { name: "Candara Light Italic", value: "\"23DTF Candara Light Italic\", Candara Light, sans-serif", category: "Sans" },
    { name: "Century", value: "\"23DTF Century\", Century, serif", category: "Serif" },
    { name: "Century Gothic Bold Italic", value: "\"23DTF Century Gothic Bold Italic\", Century Gothic, sans-serif", category: "Bold" },
    { name: "Century Gothic Italic", value: "\"23DTF Century Gothic Italic\", Century Gothic, serif", category: "Serif" },
    { name: "Comic Sans MS Bold Italic", value: "\"23DTF Comic Sans MS Bold Italic\", Comic Sans MS, sans-serif", category: "Bold" },
    { name: "Comic Sans MS Italic", value: "\"23DTF Comic Sans MS Italic\", Comic Sans MS, cursive", category: "Handmade" },
    { name: "Consolas Bold", value: "\"23DTF Consolas Bold\", Consolas, sans-serif", category: "Bold" },
    { name: "Consolas Bold Italic", value: "\"23DTF Consolas Bold Italic\", Consolas, sans-serif", category: "Bold" },
    { name: "Consolas Italic", value: "\"23DTF Consolas Italic\", Consolas, monospace", category: "Mono" },
    { name: "Constantia Bold", value: "\"23DTF Constantia Bold\", Constantia, sans-serif", category: "Bold" },
    { name: "Constantia Bold Italic", value: "\"23DTF Constantia Bold Italic\", Constantia, sans-serif", category: "Bold" },
    { name: "Constantia Italic", value: "\"23DTF Constantia Italic\", Constantia, serif", category: "Serif" },
    { name: "Corbel Bold", value: "\"23DTF Corbel Bold\", Corbel, sans-serif", category: "Bold" },
    { name: "Corbel Bold Italic", value: "\"23DTF Corbel Bold Italic\", Corbel, sans-serif", category: "Bold" },
    { name: "Corbel Italic", value: "\"23DTF Corbel Italic\", Corbel, sans-serif", category: "Sans" },
    { name: "Corbel Light", value: "\"23DTF Corbel Light\", Corbel, sans-serif", category: "Sans" },
    { name: "Corbel Light Italic", value: "\"23DTF Corbel Light Italic\", Corbel Light, sans-serif", category: "Sans" },
    { name: "Courier New Bold", value: "\"23DTF Courier New Bold\", Courier New, sans-serif", category: "Bold" },
    { name: "Courier New Bold Italic", value: "\"23DTF Courier New Bold Italic\", Courier New, sans-serif", category: "Bold" },
    { name: "Courier New Italic", value: "\"23DTF Courier New Italic\", Courier New, monospace", category: "Mono" },
    { name: "Franklin Gothic Medium Italic", value: "\"23DTF Franklin Gothic Medium Italic\", Franklin Gothic Medium, sans-serif", category: "Bold" },
    { name: "Garamond Italic", value: "\"23DTF Garamond Italic\", Garamond, serif", category: "Serif" },
    { name: "Georgia Bold Italic", value: "\"23DTF Georgia Bold Italic\", Georgia, sans-serif", category: "Bold" },
    { name: "Georgia Italic", value: "\"23DTF Georgia Italic\", Georgia, serif", category: "Serif" },
    { name: "Haettenschweiler", value: "\"23DTF Haettenschweiler\", Haettenschweiler, sans-serif", category: "Bold" },
    { name: "Lucida Console", value: "\"23DTF Lucida Console\", Lucida Console, monospace", category: "Mono" },
    { name: "Lucida Sans Unicode", value: "\"23DTF Lucida Sans Unicode\", Lucida Sans Unicode, sans-serif", category: "Sans" },
    { name: "MS Reference Sans Serif", value: "\"23DTF MS Reference Sans Serif\", MS Reference Sans Serif, sans-serif", category: "Sans" },
    { name: "Microsoft Sans Serif", value: "\"23DTF Microsoft Sans Serif\", Microsoft Sans Serif, sans-serif", category: "Sans" },
    { name: "Palatino Linotype Bold", value: "\"23DTF Palatino Linotype Bold\", Palatino Linotype, sans-serif", category: "Bold" },
    { name: "Palatino Linotype Bold Italic", value: "\"23DTF Palatino Linotype Bold Italic\", Palatino Linotype, sans-serif", category: "Bold" },
    { name: "Palatino Linotype Italic", value: "\"23DTF Palatino Linotype Italic\", Palatino Linotype, serif", category: "Serif" },
    { name: "Segoe UI Black", value: "\"23DTF Segoe UI Black\", Segoe UI, sans-serif", category: "Bold" },
    { name: "Segoe UI Black Italic", value: "\"23DTF Segoe UI Black Italic\", Segoe UI Black, sans-serif", category: "Bold" },
    { name: "Segoe UI Bold", value: "\"23DTF Segoe UI Bold\", Segoe UI, sans-serif", category: "Bold" },
    { name: "Segoe UI Bold Italic", value: "\"23DTF Segoe UI Bold Italic\", Segoe UI, sans-serif", category: "Bold" },
    { name: "Segoe UI Italic", value: "\"23DTF Segoe UI Italic\", Segoe UI, sans-serif", category: "Sans" },
    { name: "Segoe UI Light", value: "\"23DTF Segoe UI Light\", Segoe UI, sans-serif", category: "Sans" },
    { name: "Segoe UI Light Italic", value: "\"23DTF Segoe UI Light Italic\", Segoe UI Light, sans-serif", category: "Sans" },
    { name: "Segoe UI", value: "\"23DTF Segoe UI\", Segoe UI, sans-serif", category: "Sans" },
    { name: "Segoe UI Semibold", value: "\"23DTF Segoe UI Semibold\", Segoe UI, sans-serif", category: "Bold" },
    { name: "Segoe UI Semibold Italic", value: "\"23DTF Segoe UI Semibold Italic\", Segoe UI Semibold, sans-serif", category: "Bold" },
    { name: "Segoe UI Semilight", value: "\"23DTF Segoe UI Semilight\", Segoe UI, sans-serif", category: "Sans" },
    { name: "Segoe UI Semilight Italic", value: "\"23DTF Segoe UI Semilight Italic\", Segoe UI Semilight, sans-serif", category: "Sans" },
    { name: "Sylfaen", value: "\"23DTF Sylfaen\", Sylfaen, sans-serif", category: "Sans" },
    { name: "Tahoma Negreta", value: "\"23DTF Tahoma Negreta\", Tahoma, sans-serif", category: "Sans" },
    { name: "Times New Roman Bold", value: "\"23DTF Times New Roman Bold\", Times New Roman, sans-serif", category: "Bold" },
    { name: "Times New Roman Bold Italic", value: "\"23DTF Times New Roman Bold Italic\", Times New Roman, sans-serif", category: "Bold" },
    { name: "Times New Roman Italic", value: "\"23DTF Times New Roman Italic\", Times New Roman, serif", category: "Serif" },
    { name: "Trebuchet MS Bold Italic", value: "\"23DTF Trebuchet MS Bold Italic\", Trebuchet MS, sans-serif", category: "Bold" },
    { name: "Trebuchet MS Italic", value: "\"23DTF Trebuchet MS Italic\", Trebuchet MS, sans-serif", category: "Sans" },
    { name: "Verdana Bold Italic", value: "\"23DTF Verdana Bold Italic\", Verdana, sans-serif", category: "Bold" },
    { name: "Verdana Italic", value: "\"23DTF Verdana Italic\", Verdana, sans-serif", category: "Sans" }
  ];

  const FONT_COMBINATIONS = [
{
      id: "street_oops",
      name: "OOPS Street",
      subtitle: "3 líneas · streetwear",
      preview: [
{
          text: "mejor un",
          font: "\"23DTF Comic Sans MS Bold\", Comic Sans MS, cursive",
          color: "#6B7280",
          size: 13
        },
{
          text: "OOPS",
          font: "\"23DTF Arial Black\", Arial, sans-serif",
          color: "#DCEBFA",
          size: 28
        },
{
          text: "que un Y SI",
          font: "\"23DTF Impact\", Impact, sans-serif",
          color: "#E9C36D",
          size: 16
        }
      ],
      apply: {
        outlineColor: "#111111",
        outlineWeight: 0,
        shadowColor: "#547542",
        shadowDistance: 0,
        fontSize: 34,
        r: 0,
        groupGap: 0
      }
    },
{
      id: "racing_bold",
      name: "Racing Bold",
      subtitle: "racing / evento",
      preview: [
{
          text: "FULL",
          font: "\"23DTF Impact\", Impact, sans-serif",
          color: "#FF3B30",
          size: 22
        },
{
          text: "SPEED",
          font: "\"23DTF Arial Black\", Arial, sans-serif",
          color: "#111111",
          size: 25
        }
      ],
      apply: {
        outlineColor: "#111111",
        outlineWeight: 0,
        shadowColor: "#111111",
        shadowDistance: 0,
        fontSize: 38,
        r: 0,
        groupGap: 0
      }
    },
{
      id: "vintage_serif",
      name: "Vintage Serif",
      subtitle: "serif premium",
      preview: [
{
          text: "Club",
          font: "\"23DTF Garamond Bold\", Garamond, serif",
          color: "#111111",
          size: 21
        },
{
          text: "ORIGINAL",
          font: "\"23DTF Arial Narrow Bold\", Arial, sans-serif",
          color: "#D94233",
          size: 16
        }
      ],
      apply: {
        outlineColor: "#E9C36D",
        outlineWeight: 0,
        shadowColor: "#D94233",
        shadowDistance: 0,
        fontSize: 36,
        r: 0,
        groupGap: 1
      }
    },
{
      id: "minimal_clean",
      name: "Minimal Clean",
      subtitle: "limpio / moderno",
      preview: [
{
          text: "LESS",
          font: "\"23DTF Century Gothic Bold\", Century Gothic, sans-serif",
          color: "#111111",
          size: 18
        },
{
          text: "BUT BETTER",
          font: "\"23DTF Verdana Bold\", Verdana, sans-serif",
          color: "#6B7280",
          size: 15
        }
      ],
      apply: {
        outlineWeight: 0,
        shadowDistance: 0,
        fontSize: 30,
        r: 0,
        groupGap: 2
      }
    },
{
      id: "team_number",
      name: "Team Number",
      subtitle: "equipo / número",
      preview: [
{
          text: "23",
          font: "\"23DTF Arial Black\", Arial, sans-serif",
          color: "#FFFFFF",
          size: 34,
          stroke: true
        },
{
          text: "CUSTOM TEAM",
          font: "\"23DTF Arial Narrow Bold\", Arial, sans-serif",
          color: "#111111",
          size: 13
        }
      ],
      apply: {
        outlineColor: "#111111",
        outlineWeight: 0,
        shadowDistance: 0,
        fontSize: 42,
        r: 0,
        groupGap: 1
      }
    },
{
      id: "handmade_fun",
      name: "Handmade Fun",
      subtitle: "casual / divertido",
      preview: [
{
          text: "Hazlo",
          font: "\"23DTF Segoe Print Bold\", Segoe Print, cursive",
          color: "#2F94D0",
          size: 22
        },
{
          text: "a tu manera",
          font: "\"23DTF Ink Free\", Ink Free, cursive",
          color: "#DB2777",
          size: 15
        }
      ],
      apply: {
        outlineColor: "#FFFFFF",
        outlineWeight: 0,
        shadowColor: "#DB2777",
        shadowDistance: 0,
        fontSize: 34,
        r: 0,
        groupGap: 1
      }
    },
{
      id: "urban_stack",
      name: "Urban Stack",
      subtitle: "urbano / bold",
      preview: [
{
          text: "NO",
          font: "\"23DTF Arial Black\", Arial, sans-serif",
          color: "#111111",
          size: 17
        },
{
          text: "RULES",
          font: "\"23DTF Impact\", Impact, sans-serif",
          color: "#F55886",
          size: 29
        },
{
          text: "JUST STYLE",
          font: "\"23DTF Arial Narrow Bold\", Arial, sans-serif",
          color: "#111111",
          size: 12
        }
      ],
      apply: {
        outlineColor: "#111111",
        outlineWeight: 0,
        shadowDistance: 0,
        fontSize: 33,
        r: 0,
        groupGap: 0
      }
    },
{
      id: "elegant_script",
      name: "Elegant Script",
      subtitle: "elegante / serif",
      preview: [
{
          text: "Made",
          font: "\"23DTF Georgia Bold\", Georgia, serif",
          color: "#111111",
          size: 18
        },
{
          text: "with style",
          font: "\"23DTF Monotype Corsiva\", Monotype Corsiva, cursive",
          color: "#B5475C",
          size: 25
        }
      ],
      apply: {
        outlineColor: "#FFFFFF",
        outlineWeight: 0,
        shadowColor: "#111111",
        shadowDistance: 0,
        fontSize: 32,
        r: 0,
        groupGap: 1
      }
    }
  ];

  const SAMPLE_IMAGE = "data:image/svg+xml;utf8," + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="240" height="360" viewBox="0 0 240 360"><rect width="240" height="360" fill="#111827"/><rect x="66" y="96" width="108" height="180" rx="12" fill="#ea7b39"/><circle cx="120" cy="68" r="28" fill="#e8c4a8"/><path d="M92 66c8-18 38-25 54-5 4 5 6 12 6 18-17 5-43 5-61 0 0-4 0-8 1-13z" fill="#5f4638"/></svg>'
  );

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const escapeHtml = (value) => String(value ?? "").replace(/[&<>"']/g, (char) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  })[char]);
  const normalise = (value) => String(value || "").toLowerCase();
  const uid = () => "p23m_layer_" + Math.random().toString(36).slice(2, 9);

  /*
    23DTF REV77:
    REV74 ya movía la prenda y el zoom con fluidez, pero el movimiento visual
    de las capas podía fallar durante el drag porque applyLayerNodeStyle usaba
    cssEscape() sin tener una función definida en este archivo.
    Resultado: el estado de la capa sí cambiaba, pero el DOM no se pintaba hasta
    soltar el dedo/ratón y ejecutar renderLayers().
    Este helper evita ese fallo y mantiene el parche conservador.
  */
  function cssEscape(value) {
    const raw = String(value == null ? "" : value);
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(raw);
    return raw.replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  }

  function readProduct(root) {
    const node = root.querySelector("[data-p23m-product]");
    if (!node) return { media: [], variants: [], options: [] };

    try {
      return JSON.parse(node.textContent || "{}");
    } catch (error) {
      console.warn("[23DTF] No se pudo leer el JSON del producto", error);
      return { media: [], variants: [], options: [] };
    }
  }

  function initAll() {
    document.querySelectorAll("[data-p23m-root]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);

  function initRoot(root) {
    if (!root || root.dataset.p23mV35Ready === "true") return;
    root.dataset.p23mV35Ready = "true";

    const product = readProduct(root);
    const state = {
      rail: "product",
      mode: "image",
      placement: "front",
      zone: "front_full",
      subtoolText: "text",
      subtoolImage: "",
      activeLayerId: null,
      zoom: 100,
      grid: false,
      selectedColor: "",
      uploads: [],
      fileLibrarySort: "created_desc",
      personalizedQty: {},
      layersByZone: {},
      cropBefore: null,
      calibrator: { enabled: false, active: false, mode: "move", lastExport: "", panelX: 14, panelY: 14, copyStatus: null, copyTimer: null },
      isInteractingLayer: false,
      printAreaWarning: false,
      printAreaWarningTimer: null,
      lastContentRail: "layers",
      lastToolLayerId: null,
      mockupFitScale: 1,
      mockupPanX: 0,
      mockupPanY: 0,
      mockupPanSuppressClickUntil: 0,
      isPanningMockup: false,
      toolbarTap: { active: false, moved: false, x: 0, y: 0, t: 0 },
      placementTap: { active: false, moved: false, x: 0, y: 0, t: 0 },
      fileLibraryOpenedAt: 0,
      groupMoveLayerIds: [],
      fontSearch: "",
      fontTab: "all",
      layerPanelSuppressClickUntil: 0,
      imageGuardNotice: null,
      exportBusy: false,
      exportStatus: ""
    };

    const q = (selector) => root.querySelector(selector);
    const qa = (selector) => Array.from(root.querySelectorAll(selector));
    let cartConfirmationLastFocus = null;

    /*
      23DTF REV68 DRAFT:
      Persistencia local del proyecto de personalización.
      - IndexedDB se usa para soportar imágenes/base64 y diseños más pesados que localStorage.
      - El guardado se separa por producto/URL para evitar mezclar personalizaciones.
      - No sube nada a servidores todavía; solo protege al cliente ante recargas/cierres.
    */
    const DRAFT_VERSION = "REV68C_IMAGE_GUARD_1";
    const DRAFT_DB_NAME = "p23m_personalizer_drafts";
    const DRAFT_DB_VERSION = 1;
    const DRAFT_STORE = "drafts";
    let draftDbPromise = null;
    let draftBootstrapped = false;
    let draftRestoring = false;
    let draftSaveTimer = 0;
    let draftRestoreStarted = false;
    let draftLastSavedHash = "";
    let draftAutoSaveBlocked = false;
    let draftResetEpoch = 0;
    let draftSaveInFlight = Promise.resolve();

    function draftProductIdentity() {
      const source = product || {};
      const raw =
        source.id ||
        source.product_id ||
        source.productId ||
        source.handle ||
        source.url ||
        window.location.pathname ||
        "product";

      return String(raw || "product").replace(/[^\w.-]+/g, "_").slice(0, 90);
    }

    function draftStorageKey() {
      return "23dtf:" + draftProductIdentity() + ":" + String(window.location.pathname || "").replace(/[^\w.-]+/g, "_").slice(0, 90);
    }

    /*
      v1.0-pre11:
      Marcador temporal para garantizar un editor limpio al volver desde el
      carrito, incluso cuando el navegador recupera la página desde bfcache.
    */
    function successfulCartResetMarkerKey() {
      return "23dtf:reset-personalizer-after-cart:" + draftProductIdentity();
    }

    function markSuccessfulCartReset() {
      try {
        window.sessionStorage.setItem(successfulCartResetMarkerKey(), JSON.stringify({
          createdAt: Date.now(),
          path: String(window.location.pathname || "")
        }));
      } catch (error) {
        // El borrado de IndexedDB sigue funcionando aunque sessionStorage falle.
      }
    }

    function hasSuccessfulCartResetMarker() {
      try {
        const raw = window.sessionStorage.getItem(successfulCartResetMarkerKey());
        if (!raw) return false;
        const data = JSON.parse(raw);
        const age = Date.now() - Number(data && data.createdAt || 0);
        if (!Number.isFinite(age) || age < 0 || age > 12 * 60 * 60 * 1000) {
          window.sessionStorage.removeItem(successfulCartResetMarkerKey());
          return false;
        }
        return true;
      } catch (error) {
        return false;
      }
    }

    function clearSuccessfulCartResetMarker() {
      try { window.sessionStorage.removeItem(successfulCartResetMarkerKey()); } catch (error) {}
    }

    function openDraftDb() {
      if (!("indexedDB" in window)) return Promise.reject(new Error("IndexedDB no disponible"));
      if (draftDbPromise) return draftDbPromise;

      draftDbPromise = new Promise((resolve, reject) => {
        const request = window.indexedDB.open(DRAFT_DB_NAME, DRAFT_DB_VERSION);

        request.onupgradeneeded = () => {
          const db = request.result;
          if (!db.objectStoreNames.contains(DRAFT_STORE)) {
            db.createObjectStore(DRAFT_STORE, { keyPath: "key" });
          }
        };

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error || new Error("No se pudo abrir IndexedDB"));
        request.onblocked = () => reject(new Error("IndexedDB bloqueado por otra pestaña"));
      });

      return draftDbPromise;
    }

    async function draftDbGet(key) {
      const db = await openDraftDb();
      return new Promise((resolve, reject) => {
        const tx = db.transaction(DRAFT_STORE, "readonly");
        const store = tx.objectStore(DRAFT_STORE);
        const request = store.get(key);
        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => reject(request.error || new Error("No se pudo leer el borrador"));
      });
    }

    async function draftDbPut(record) {
      const db = await openDraftDb();
      return new Promise((resolve, reject) => {
        const tx = db.transaction(DRAFT_STORE, "readwrite");
        const store = tx.objectStore(DRAFT_STORE);
        store.put(record);
        tx.oncomplete = () => resolve(true);
        tx.onerror = () => reject(tx.error || new Error("No se pudo guardar el borrador"));
      });
    }

    async function draftDbDelete(key) {
      const db = await openDraftDb();
      return new Promise((resolve, reject) => {
        const tx = db.transaction(DRAFT_STORE, "readwrite");
        const store = tx.objectStore(DRAFT_STORE);
        store.delete(key);
        tx.oncomplete = () => resolve(true);
        tx.onerror = () => reject(tx.error || new Error("No se pudo borrar el borrador"));
      });
    }

    function clonePlain(value, fallback) {
      try {
        return JSON.parse(JSON.stringify(value ?? fallback));
      } catch (error) {
        return fallback;
      }
    }

    function hasDraftDesignData(snapshot) {
      if (!snapshot || typeof snapshot !== "object") return false;

      const layersByZone = snapshot.layersByZone || {};
      const hasLayers = Object.values(layersByZone).some((layers) => Array.isArray(layers) && layers.some((layer) => layer && layer.type === "image"));
      const hasUploads = Array.isArray(snapshot.uploads) && snapshot.uploads.length > 0;
      const hasQty = Object.values(snapshot.personalizedQty || {}).some((value) => Number(value || 0) > 0);

      return hasLayers || hasUploads || hasQty;
    }

    function serializeDraftState() {
      return {
        rail: state.rail,
        mode: state.mode,
        placement: state.placement,
        zone: state.zone,
        subtoolText: state.subtoolText,
        subtoolImage: state.subtoolImage,
        activeLayerId: state.activeLayerId,
        zoom: state.zoom,
        mockupPanX: Number(state.mockupPanX || 0),
        mockupPanY: Number(state.mockupPanY || 0),
        grid: state.grid,
        selectedColor: state.selectedColor,
        uploads: clonePlain(state.uploads, []),
        fileLibrarySort: state.fileLibrarySort,
        personalizedQty: clonePlain(state.personalizedQty, {}),
        layersByZone: clonePlain(state.layersByZone, {}),
        lastContentRail: state.lastContentRail,
        lastToolLayerId: state.lastToolLayerId,
        groupMoveLayerIds: clonePlain(state.groupMoveLayerIds, []),
        fontSearch: state.fontSearch,
        fontTab: state.fontTab
      };
    }

    function validPlacementId(id) {
      return PLACEMENTS.some((placement) => placement.id === id);
    }

    function validZoneId(id) {
      return PLACEMENTS.some((placement) => placement.zones.some((zone) => zone.id === id));
    }

    function applyDraftSnapshot(snapshot) {
      if (!snapshot || typeof snapshot !== "object") return false;

      const restoredRail = snapshot.rail || "product";
      state.rail = ["product", "uploads", "layers", "tool"].includes(restoredRail) ? restoredRail : "layers";
      state.mode = "image";
      state.placement = validPlacementId(snapshot.placement) ? snapshot.placement : "front";
      state.zone = validZoneId(snapshot.zone) ? snapshot.zone : (currentPlacement().zones[0] && currentPlacement().zones[0].id) || "front_full";
      state.subtoolText = snapshot.subtoolText || "text";
      state.subtoolImage = snapshot.subtoolImage || "";
      state.activeLayerId = snapshot.activeLayerId || null;
      state.zoom = clamp(Number(snapshot.zoom || 100), 100, 700);
      state.mockupPanX = Number(snapshot.mockupPanX || 0) || 0;
      state.mockupPanY = Number(snapshot.mockupPanY || 0) || 0;
      state.grid = !!snapshot.grid;
      state.selectedColor = snapshot.selectedColor || "";
      state.uploads = Array.isArray(snapshot.uploads) ? snapshot.uploads : [];
      state.fileLibrarySort = snapshot.fileLibrarySort || "created_desc";
      state.personalizedQty = snapshot.personalizedQty && typeof snapshot.personalizedQty === "object" ? snapshot.personalizedQty : {};
      const restoredLayersByZone = snapshot.layersByZone && typeof snapshot.layersByZone === "object" ? snapshot.layersByZone : {};
      state.layersByZone = Object.fromEntries(Object.entries(restoredLayersByZone).map(([zoneId, layers]) => [
        zoneId,
        Array.isArray(layers) ? layers.filter((layer) => layer && layer.type === "image") : []
      ]));
      state.lastContentRail = snapshot.lastContentRail || "layers";
      const restoredImageLayerIds = new Set(Object.values(state.layersByZone).flat().map((layer) => layer.id));
      state.lastToolLayerId = restoredImageLayerIds.has(snapshot.lastToolLayerId) ? snapshot.lastToolLayerId : null;
      state.groupMoveLayerIds = Array.isArray(snapshot.groupMoveLayerIds)
        ? snapshot.groupMoveLayerIds.filter((layerId) => restoredImageLayerIds.has(layerId))
        : [];
      state.fontSearch = snapshot.fontSearch || "";
      state.fontTab = snapshot.fontTab || "all";
      state.cropBefore = null;
      state.isInteractingLayer = false;
      state.printAreaWarning = false;
      state.layerPanelSuppressClickUntil = 0;

      const layers = currentLayers();
      if (state.activeLayerId && !layers.some((layer) => layer.id === state.activeLayerId)) {
        state.activeLayerId = layers[0] ? layers[0].id : null;
      }
      if (state.rail === "tool" && !state.activeLayerId) state.rail = layers.length ? "layers" : "product";

      Object.values(state.layersByZone).forEach((layersInZone) => {
        if (!Array.isArray(layersInZone)) return;
        layersInZone.forEach((layer) => {
          if (!layer || typeof layer !== "object") return;

          /*
            23DTF REV69G HOTFIX RESTORE:
            No llamamos a constrain(layer) durante la restauración del borrador.
            constrain() usa la zona activa actual; si se ejecuta mientras se restauran
            capas de espalda/mangas/etiqueta, puede aplicar el rectángulo equivocado
            y deformar o recolocar diseños guardados.

            Aquí solo normalizamos datos mínimos sin cambiar x/y/w/h/r.
            El render posterior ya validará la zona activa correcta.
          */
          layer.x = Number.isFinite(Number(layer.x)) ? Number(layer.x) : Number(layer.x || 0);
          layer.y = Number.isFinite(Number(layer.y)) ? Number(layer.y) : Number(layer.y || 0);
          layer.w = Math.max(1, Number(layer.w || 1));
          layer.h = Math.max(1, Number(layer.h || 1));
          layer.r = Number(layer.r || 0) || 0;

          if (layer.type === "image") {
            const restoredRatio = Number(layer.h || 1) / Math.max(1, Number(layer.w || 1));
            layer.aspectLocked = layer.aspectLocked !== false;
            layer.aspectRatio = Number(layer.aspectRatio || layer.naturalAspectRatio || restoredRatio || 1);
            layer.naturalAspectRatio = Number(layer.naturalAspectRatio || layer.aspectRatio || restoredRatio || 1);
          }
        });
      });

      return true;
    }

    function resetPersonalizerStateValues() {
      state.rail = "product";
      state.mode = "image";
      state.placement = "front";
      state.zone = "front_full";
      state.subtoolText = "text";
      state.subtoolImage = "";
      state.activeLayerId = null;
      state.zoom = 100;
      state.grid = false;
      state.selectedColor = "";
      state.uploads = [];
      state.fileLibrarySort = "created_desc";
      state.personalizedQty = {};
      state.layersByZone = {};
      state.cropBefore = null;
      state.isInteractingLayer = false;
      state.printAreaWarning = false;
      state.lastContentRail = "layers";
      state.lastToolLayerId = null;
      state.mockupFitScale = 1;
      state.mockupPanX = 0;
      state.mockupPanY = 0;
      state.mockupPanSuppressClickUntil = 0;
      state.isPanningMockup = false;
      state.fileLibraryOpenedAt = 0;
      state.groupMoveLayerIds = [];
      state.fontSearch = "";
      state.fontTab = "all";
      state.layerPanelSuppressClickUntil = 0;
      state.imageGuardNotice = null;
      state.exportBusy = false;
      state.exportStatus = "";
      state.draftSavedAt = 0;
      state.draftRestoredAt = 0;
      state.draftError = "";
    }

    async function restoreDraftIfAvailable() {
      if (draftRestoreStarted) return;
      draftRestoreStarted = true;
      draftRestoring = true;

      try {
        if (hasSuccessfulCartResetMarker()) {
          draftAutoSaveBlocked = true;
          draftResetEpoch += 1;
          window.clearTimeout(draftSaveTimer);
          try { await draftSaveInFlight; } catch (error) {}
          try { await draftDbDelete(draftStorageKey()); } catch (error) {}
          resetPersonalizerStateValues();
          draftLastSavedHash = "";
          clearSuccessfulCartResetMarker();
          return;
        }

        const record = await draftDbGet(draftStorageKey());
        if (record && record.version === DRAFT_VERSION && hasDraftDesignData(record.snapshot)) {
          applyDraftSnapshot(record.snapshot);
          draftLastSavedHash = JSON.stringify(serializeDraftState());
          state.draftRestoredAt = Date.now();
          state.draftSavedAt = Number(record.updatedAt || 0);
        }
      } catch (error) {
        console.warn("[23DTF] No se pudo restaurar el borrador local", error);
        state.draftError = "No se pudo restaurar el borrador local.";
      } finally {
        draftRestoring = false;
        draftBootstrapped = true;
        draftAutoSaveBlocked = false;
        renderAll();
      }
    }

    function scheduleDraftSave(delay) {
      if (!draftBootstrapped || draftRestoring || draftAutoSaveBlocked) return;
      const wait = Number.isFinite(Number(delay)) ? Number(delay) : 650;
      window.clearTimeout(draftSaveTimer);
      draftSaveTimer = window.setTimeout(saveDraftNow, Math.max(0, wait));
    }

    function scheduleDraftSaveFast() {
      scheduleDraftSave(80);
    }

    async function saveDraftNow() {
      if (!draftBootstrapped || draftRestoring || draftAutoSaveBlocked) return;

      const snapshot = serializeDraftState();
      const key = draftStorageKey();
      const saveEpoch = draftResetEpoch;

      const saveTask = (async () => {
        try {
          if (draftAutoSaveBlocked || saveEpoch !== draftResetEpoch) return;

          if (!hasDraftDesignData(snapshot)) {
            await draftDbDelete(key);
            if (saveEpoch !== draftResetEpoch) return;
            state.draftSavedAt = 0;
            state.draftError = "";
            draftLastSavedHash = "";
            return;
          }

          const nextHash = JSON.stringify(snapshot);
          if (nextHash === draftLastSavedHash) {
            const status = q("[data-p23m-draft-status]");
            if (status) status.textContent = state.draftSavedAt ? "Borrador guardado" : "Autoguardado activo";
            return;
          }

          if (draftAutoSaveBlocked || saveEpoch !== draftResetEpoch) return;

          await draftDbPut({
            key,
            version: DRAFT_VERSION,
            productKey: draftProductIdentity(),
            productHandle: product && product.handle ? String(product.handle) : "",
            path: String(window.location.pathname || ""),
            updatedAt: Date.now(),
            snapshot
          });

          /*
            Si se ordenó un reset mientras IndexedDB estaba escribiendo, borramos
            inmediatamente cualquier borrador antiguo que pudiera haber reaparecido.
          */
          if (draftAutoSaveBlocked || saveEpoch !== draftResetEpoch) {
            try { await draftDbDelete(key); } catch (error) {}
            return;
          }

          draftLastSavedHash = nextHash;
          state.draftSavedAt = Date.now();
          state.draftError = "";
          const status = q("[data-p23m-draft-status]");
          if (status) status.textContent = "Borrador guardado";
        } catch (error) {
          if (draftAutoSaveBlocked || saveEpoch !== draftResetEpoch) return;
          console.warn("[23DTF] No se pudo guardar el borrador local", error);
          state.draftError = "No se pudo guardar el borrador local.";
          const status = q("[data-p23m-draft-status]");
          if (status) status.textContent = state.draftError;
        }
      })();

      draftSaveInFlight = saveTask.catch(() => undefined);
      return saveTask;
    }

    async function clearLocalDraftAndDesign(options) {
      const settings = options && typeof options === "object" ? options : {};
      const keepAutosaveBlocked = !!settings.keepAutosaveBlocked;

      draftAutoSaveBlocked = true;
      draftResetEpoch += 1;
      window.clearTimeout(draftSaveTimer);

      try { await draftSaveInFlight; } catch (error) {}

      try {
        await draftDbDelete(draftStorageKey());
      } catch (error) {
        console.warn("[23DTF] No se pudo borrar el borrador local", error);
      }

      resetPersonalizerStateValues();
      draftLastSavedHash = "";

      try { closePersonalizedCartConfirmation(true); } catch (error) {}
      try { setAddToCartBusy(false); } catch (error) {}
      try { setPersonalizedCartConfirmationBusy(false); } catch (error) {}
      try { setPersonalizedCartConfirmationError(""); } catch (error) {}

      renderAll();

      /* Segunda eliminación: protege frente a una escritura antigua ya iniciada. */
      try { await draftDbDelete(draftStorageKey()); } catch (error) {}

      if (!keepAutosaveBlocked) {
        draftAutoSaveBlocked = false;
      }

      return true;
    }

    function isMobileViewport() {
      return window.matchMedia && window.matchMedia("(max-width: 989px)").matches;
    }

    function isRealToolbarTap(event) {
      if (!isMobileViewport()) return true;
      if (!event || !event.pointerType || event.pointerType === "mouse") return true;

      const tap = state.toolbarTap || {};
      if (!tap.active) return false;

      const x = Number(event.clientX || 0);
      const y = Number(event.clientY || 0);
      const dx = Math.abs(x - Number(tap.x || 0));
      const dy = Math.abs(y - Number(tap.y || 0));
      const dt = Date.now() - Number(tap.t || 0);

      return !tap.moved && dx <= 7 && dy <= 7 && dt <= 650;
    }

    function isRealPlacementTap(event) {
      if (!isMobileViewport()) return true;
      if (!event || !event.pointerType || event.pointerType === "mouse") return true;

      const tap = state.placementTap || {};
      if (!tap.active) return false;

      const x = Number(event.clientX || 0);
      const y = Number(event.clientY || 0);
      const dx = Math.abs(x - Number(tap.x || 0));
      const dy = Math.abs(y - Number(tap.y || 0));
      const dt = Date.now() - Number(tap.t || 0);

      /*
        Mismo criterio que toolbar:
        si el dedo se arrastra para hacer scroll, no cambia de zona.
      */
      return !tap.moved && dx <= 7 && dy <= 7 && dt <= 650;
    }

    function fileLibraryJustOpened() {
      return Date.now() - Number(state.fileLibraryOpenedAt || 0) < 450;
    }

    function openUploadsLibraryOnly() {
      /*
        v4.11e:
        Subidas solo abre Tus archivos. No cambia de zona, no crea capa,
        no aplica el último archivo y no cambia a Capas antes de abrir.
      */
      window.requestAnimationFrame(openFileLibrary);
    }

    function coordinateSpaceElement() {
      return q("[data-p23m-coordinate-space]") || q("[data-p23m-mockup]");
    }

    function ensureCoordinateSpace() {
      const mockup = q("[data-p23m-mockup]");
      if (!mockup) return null;

      let space = q("[data-p23m-coordinate-space]");
      if (!space) {
        space = document.createElement("div");
        space.className = "p23m__coord-space";
        space.dataset.p23mCoordinateSpace = "true";
        mockup.insertBefore(space, mockup.firstChild);
      }

      /*
        v4.10z:
        ÚNICO sistema de coordenadas 380x460.
        Todo lo que usa currentZone().rect debe vivir aquí:
        - imagen de producto
        - área visible de impresión
        - botón/drop de subida
        - capas del diseño
      */
      [
        ".p23m__product-image-wrap",
        "[data-p23m-safe]",
        "[data-p23m-canvas-upload]",
        "[data-p23m-layer-stage]"
      ].forEach((selector) => {
        const node = root.querySelector(selector);
        if (node && node.parentElement !== space) {
          space.appendChild(node);
        }
      });

      /*
        Refuerzo inline con priority important.
        Existían reglas desktop antiguas con mayor especificidad que cambiaban
        el tamaño real del mockup. Eso rompía las coordenadas internas.
      */
      mockup.style.setProperty("width", "380px", "important");
      mockup.style.setProperty("height", "460px", "important");
      mockup.style.setProperty("max-width", "none", "important");
      mockup.style.setProperty("max-height", "none", "important");

      space.style.setProperty("width", "380px", "important");
      space.style.setProperty("height", "460px", "important");

      return space;
    }

    function formatFileSize(bytes) {
      const value = Number(bytes || 0);
      if (!value) return "Tamaño no disponible";
      if (value < 1024 * 1024) return Math.max(1, Math.round(value / 1024)) + " KB";
      return (value / (1024 * 1024)).toFixed(value < 10 * 1024 * 1024 ? 2 : 1) + " MB";
    }


    /*
      23DTF REV68C IMAGE GUARD:
      Validación y optimización de imágenes pesadas antes de meterlas al canvas.
      Objetivo: evitar cierres de pestaña en móvil por archivos enormes, sin romper
      la futura producción DTF. En esta fase se conserva una copia de trabajo
      optimizada dentro del editor; la subida del original a Cloudflare/R2 vendrá
      en la fase de exportación/pedido.
    */
    const IMAGE_GUARD_WARN_BYTES = 8 * 1024 * 1024;
    const IMAGE_GUARD_BLOCK_BYTES = 20 * 1024 * 1024;
    const IMAGE_GUARD_OPTIMIZE_SIDE = 2800;
    const IMAGE_GUARD_WARN_SIDE = 5000;
    const IMAGE_GUARD_BLOCK_SIDE = 7000;
    const IMAGE_GUARD_MAX_PIXELS = 38 * 1000 * 1000;

    function isSvgFile(file) {
      return !!file && (file.type === "image/svg+xml" || /\.svg$/i.test(file.name || ""));
    }

    function imageGuardSetNotice(kind, title, message, extra) {
      state.imageGuardNotice = {
        kind: kind || "info",
        title: title || "Imagen revisada",
        message: message || "",
        extra: extra || "",
        time: Date.now()
      };
      renderImageGuardNotice();
      renderLayerPanel();
    }

    function imageGuardClearNotice() {
      state.imageGuardNotice = null;
      renderImageGuardNotice();
      renderLayerPanel();
    }

    function imageGuardNoticeHtml() {
      const notice = state.imageGuardNotice;
      if (!notice) return "";
      return '<div class="p23m-image-guard p23m-image-guard--' + escapeHtml(notice.kind || "info") + '">' +
        '<strong>' + escapeHtml(notice.title || "Imagen revisada") + '</strong>' +
        '<p>' + escapeHtml(notice.message || "") + '</p>' +
        (notice.extra ? '<small>' + escapeHtml(notice.extra) + '</small>' : '') +
      '</div>';
    }

    function renderImageGuardNotice() {
      const node = q("[data-p23m-image-guard-notice]");
      if (!node) return;
      node.innerHTML = imageGuardNoticeHtml();
      node.hidden = !state.imageGuardNotice;
    }

    function readImageMetaFromFile(file) {
      return new Promise((resolve, reject) => {
        if (!file) {
          reject(new Error("Archivo no disponible"));
          return;
        }

        const url = URL.createObjectURL(file);
        const image = new Image();
        image.onload = () => {
          const width = image.naturalWidth || image.width || 0;
          const height = image.naturalHeight || image.height || 0;
          URL.revokeObjectURL(url);
          resolve({ width, height });
        };
        image.onerror = () => {
          URL.revokeObjectURL(url);
          reject(new Error("No se pudo leer la imagen"));
        };
        image.src = url;
      });
    }

    function readFileAsDataUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result || ""));
        reader.onerror = () => reject(reader.error || new Error("No se pudo leer el archivo"));
        reader.readAsDataURL(file);
      });
    }

    function canvasToDataUrl(canvas, preferredType, quality) {
      const type = preferredType || "image/webp";
      try {
        const dataUrl = canvas.toDataURL(type, quality);
        if (type !== "image/png" && dataUrl && dataUrl.indexOf("data:image/png") === 0) {
          return canvas.toDataURL("image/png");
        }
        return dataUrl;
      } catch (error) {
        return canvas.toDataURL("image/png");
      }
    }

    function optimizedImageDataUrlFromFile(file, meta) {
      return new Promise((resolve, reject) => {
        const sourceWidth = Number(meta && meta.width || 0);
        const sourceHeight = Number(meta && meta.height || 0);
        if (!sourceWidth || !sourceHeight) {
          reject(new Error("La imagen no tiene dimensiones válidas"));
          return;
        }

        const ratio = Math.min(1, IMAGE_GUARD_OPTIMIZE_SIDE / Math.max(sourceWidth, sourceHeight));
        const targetWidth = Math.max(1, Math.round(sourceWidth * ratio));
        const targetHeight = Math.max(1, Math.round(sourceHeight * ratio));
        const url = URL.createObjectURL(file);
        const image = new Image();

        image.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = targetWidth;
            canvas.height = targetHeight;
            const ctx = canvas.getContext("2d", { alpha: true });
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
            ctx.clearRect(0, 0, targetWidth, targetHeight);
            ctx.drawImage(image, 0, 0, targetWidth, targetHeight);

            const dataUrl = canvasToDataUrl(canvas, "image/webp", 0.92);
            URL.revokeObjectURL(url);
            resolve({
              dataUrl,
              width: targetWidth,
              height: targetHeight,
              type: dataUrl.indexOf("data:image/webp") === 0 ? "image/webp" : "image/png"
            });
          } catch (error) {
            URL.revokeObjectURL(url);
            reject(error);
          }
        };

        image.onerror = () => {
          URL.revokeObjectURL(url);
          reject(new Error("No se pudo optimizar la imagen"));
        };
        image.src = url;
      });
    }

    function imageGuardShouldOptimize(file, meta) {
      const maxSide = Math.max(Number(meta.width || 0), Number(meta.height || 0));
      return Number(file.size || 0) >= IMAGE_GUARD_WARN_BYTES || maxSide > IMAGE_GUARD_OPTIMIZE_SIDE;
    }

    async function prepareUploadForCanvas(file) {
      const size = Number(file.size || 0);

      if (size > IMAGE_GUARD_BLOCK_BYTES) {
        throw new Error("Tu imagen pesa " + formatFileSize(size) + ". El máximo permitido para editar con estabilidad es " + formatFileSize(IMAGE_GUARD_BLOCK_BYTES) + ". Reduce el archivo antes de subirlo.");
      }

      if (isSvgFile(file)) {
        const src = await readFileAsDataUrl(file);
        if (size >= IMAGE_GUARD_WARN_BYTES) {
          imageGuardSetNotice("warning", "SVG pesado", "El archivo se ha aceptado, pero es pesado para móvil.", "Peso: " + formatFileSize(size));
        }
        return {
          src,
          type: file.type || "image/svg+xml",
          width: 0,
          height: 0,
          originalWidth: 0,
          originalHeight: 0,
          optimizedForEditor: false
        };
      }

      const meta = await readImageMetaFromFile(file);
      const maxSide = Math.max(Number(meta.width || 0), Number(meta.height || 0));
      const pixels = Number(meta.width || 0) * Number(meta.height || 0);

      if (!meta.width || !meta.height) {
        throw new Error("No se pudo leer la resolución de la imagen. Prueba con PNG, JPG o WEBP.");
      }

      if (maxSide > IMAGE_GUARD_BLOCK_SIDE || pixels > IMAGE_GUARD_MAX_PIXELS) {
        throw new Error("Tu imagen tiene " + meta.width + " × " + meta.height + " px y es demasiado grande para editarla con estabilidad en móvil. Reduce la imagen y vuelve a subirla.");
      }

      if (imageGuardShouldOptimize(file, meta)) {
        const optimized = await optimizedImageDataUrlFromFile(file, meta);
        const originalSrc = await readFileAsDataUrl(file);
        const reason = size >= IMAGE_GUARD_WARN_BYTES ? "Peso original: " + formatFileSize(size) : "Resolución original: " + meta.width + " × " + meta.height + " px";
        imageGuardSetNotice("warning", "Imagen optimizada para edición", "Hemos creado una copia más ligera para moverla bien en el canvas.", reason + " · Copia editor: " + optimized.width + " × " + optimized.height + " px");
        return {
          src: optimized.dataUrl,
          originalSrc,
          type: optimized.type,
          width: optimized.width,
          height: optimized.height,
          originalWidth: meta.width,
          originalHeight: meta.height,
          optimizedForEditor: true
        };
      }

      const src = await readFileAsDataUrl(file);
      if (size >= IMAGE_GUARD_WARN_BYTES || maxSide >= IMAGE_GUARD_WARN_SIDE) {
        imageGuardSetNotice("info", "Imagen aceptada", "La imagen es pesada, pero se puede editar.", "Peso: " + formatFileSize(size) + " · Resolución: " + meta.width + " × " + meta.height + " px");
      } else {
        imageGuardClearNotice();
      }
      return {
        src,
        type: file.type || "imagen",
        width: meta.width,
        height: meta.height,
        originalWidth: meta.width,
        originalHeight: meta.height,
        optimizedForEditor: false
      };
    }

    function formatDateTime(timestamp) {
      if (!timestamp) return "Ahora";
      try {
        return new Intl.DateTimeFormat("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        }).format(new Date(timestamp));
      } catch (error) {
        return "Ahora";
      }
    }

    function sortLabel(value) {
      const labels = {
        created_desc: "Creado: lo más nuevo primero",
        created_asc: "Creado: lo más viejo primero",
        name_desc: "Nombre: Z a A",
        name_asc: "Nombre: A a Z",
        relevance: "Relevancia: digitalizado primero"
      };
      return labels[value] || labels.created_desc;
    }

    function sortedUploads(files) {
      const list = files.slice();
      const sort = state.fileLibrarySort || "created_desc";
      list.sort((a, b) => {
        if (sort === "created_asc") return (a.createdAt || 0) - (b.createdAt || 0);
        if (sort === "name_desc") return String(b.name || "").localeCompare(String(a.name || ""), "es", { sensitivity: "base" });
        if (sort === "name_asc") return String(a.name || "").localeCompare(String(b.name || ""), "es", { sensitivity: "base" });
        if (sort === "relevance") {
          const score = (file) => {
            const type = String(file.type || "").toLowerCase();
            const name = String(file.name || "").toLowerCase();
            const transparentFriendly = type.includes("png") || type.includes("svg") || name.endsWith(".png") || name.endsWith(".svg");
            const area = (Number(file.width) || 0) * (Number(file.height) || 0);
            return (transparentFriendly ? 100000000000 : 0) + area;
          };
          return score(b) - score(a);
        }
        return (b.createdAt || 0) - (a.createdAt || 0);
      });
      return list;
    }

    function optionIndex(matchers, fallback) {
      const options = Array.isArray(product.options) ? product.options : [];
      const index = options.findIndex((option) => {
        const name = normalise(option.name || option);
        return matchers.some((matcher) => matcher.test(name));
      });
      return index >= 0 ? index : fallback;
    }

    function productSelectionData() {
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const colorIndex = optionIndex([/color/, /colour/], 0);
      const sizeIndex = optionIndex([/talla/, /size/, /tamano/, /tamaño/], colorIndex === 0 ? 1 : 0);
      const colors = [];
      const sizes = [];
      const seenColors = new Set();
      const seenSizes = new Set();

      variants.forEach((variant) => {
        const opts = Array.isArray(variant.options) ? variant.options : [];
        const color = opts[colorIndex] || opts[0] || "Único";
        const size = opts[sizeIndex] || opts[1] || "Única";
        if (!seenColors.has(color)) {
          seenColors.add(color);
          colors.push({ name: color, swatch: colorSwatch(color) });
        }
        if (!seenSizes.has(size)) {
          seenSizes.add(size);
          sizes.push(size);
        }
      });

      if (!colors.length) colors.push({ name: "Único", swatch: "#f3f4f6" });
      if (!sizes.length) sizes.push("Única");
      return { colors, sizes, variants, colorIndex, sizeIndex };
    }

    const DTF_COLOR_MAP = {
      "CODE": {
            "background": "BACKGROUND",
            "text": "TEXT"
      },
      "NY/YEL": {
            "background": "linear-gradient(135deg, #0B1B3A 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "AE": {
            "background": "#859c88",
            "text": "#000000"
      },
      "PB": {
            "background": "#4b9ca0",
            "text": "#ffffff"
      },
      "APR": {
            "background": "#ffd17b",
            "text": "#000000"
      },
      "AG": {
            "background": "#757a4d",
            "text": "#000000"
      },
      "AL": {
            "background": "#f97fb5",
            "text": "#000000"
      },
      "ALW": {
            "background": "#e7bbd7",
            "text": "#000000"
      },
      "AN": {
            "background": "#ca7576",
            "text": "#000000"
      },
      "AP": {
            "background": "#c2d500",
            "text": "#000000"
      },
      "AQ": {
            "background": "#0083c1",
            "text": "#000000"
      },
      "AQM": {
            "background": "#49bcc4",
            "text": "#000000"
      },
      "AQW": {
            "background": "#009ade",
            "text": "#000000"
      },
      "AR": {
            "background": "#aa9767",
            "text": "#000000"
      },
      "AS": {
            "background": "#d1d3d3",
            "text": "#000000"
      },
      "AY": {
            "background": "#c3c6c8",
            "text": "#000000"
      },
      "AZ": {
            "background": "#6fa7db",
            "text": "#000000"
      },
      "BC": {
            "background": "#e65300",
            "text": "#000000"
      },
      "BG": {
            "background": "#13572b",
            "text": "#ffffff"
      },
      "BGH": {
            "background": "#144733",
            "text": "#ffffff"
      },
      "BK": {
            "background": "#2d2a26",
            "text": "#ffffff"
      },
      "BR": {
            "background": "#845d32",
            "text": "#ffffff"
      },
      "BRD": {
            "background": "#846e59",
            "text": "#000000"
      },
      "BRH": {
            "background": "#9d5c63",
            "text": "#000000"
      },
      "BRW": {
            "background": "#c38e4d",
            "text": "#000000"
      },
      "BT": {
            "background": "#f6e5b0",
            "text": "#000000"
      },
      "BU": {
            "background": "#6a1833",
            "text": "#ffffff"
      },
      "BUH": {
            "background": "#8e173a",
            "text": "#ffffff"
      },
      "BUW": {
            "background": "#860337",
            "text": "#ffffff"
      },
      "BV": {
            "background": "#063f59",
            "text": "#ffffff"
      },
      "CA": {
            "background": "#572a31",
            "text": "#ffffff"
      },
      "CB": {
            "background": "#3b4647",
            "text": "#ffffff"
      },
      "CH": {
            "background": "#483729",
            "text": "#ffffff"
      },
      "CHC": {
            "background": "#4a5253",
            "text": "#ffffff"
      },
      "CHCH": {
            "background": "#3e4543",
            "text": "#ffffff"
      },
      "CK": {
            "background": "#564c3e",
            "text": "#ffffff"
      },
      "CL": {
            "background": "#fff6a3",
            "text": "#000000"
      },
      "CM": {
            "background": "#25342c",
            "text": "#ffffff"
      },
      "CO": {
            "background": "#ff8d6b",
            "text": "#000000"
      },
      "CR": {
            "background": "#ca4643",
            "text": "#ffffff"
      },
      "CS": {
            "background": "#1b1b1b",
            "text": "#ffffff"
      },
      "CV": {
            "background": "#5c8a86",
            "text": "#000000"
      },
      "DB": {
            "background": "#aab5d1",
            "text": "#000000"
      },
      "DBH": {
            "background": "#00496b",
            "text": "#ffffff"
      },
      "DBL": {
            "background": "#004a98",
            "text": "#ffffff"
      },
      "DBW": {
            "background": "#414e5e",
            "text": "#ffffff"
      },
      "DG": {
            "background": "#716c64",
            "text": "#ffffff"
      },
      "DGH": {
            "background": "#001e35",
            "text": "#ffffff"
      },
      "DGM": {
            "background": "#636569",
            "text": "#ffffff"
      },
      "DGW": {
            "background": "#7c7b79",
            "text": "#000000"
      },
      "DN": {
            "background": "#323e48",
            "text": "#ffffff"
      },
      "DNH": {
            "background": "#333e48",
            "text": "#ffffff"
      },
      "DNV": {
            "background": "#343e48",
            "text": "#ffffff"
      },
      "DNW": {
            "background": "#425071",
            "text": "#ffffff"
      },
      "DP": {
            "background": "#b07e98",
            "text": "#000000"
      },
      "DR": {
            "background": "#793d41",
            "text": "#ffffff"
      },
      "DS": {
            "background": "#b5aa8e",
            "text": "#000000"
      },
      "EM": {
            "background": "#48a177",
            "text": "#000000"
      },
      "EU": {
            "background": "#75bf91",
            "text": "#000000"
      },
      "FD": {
            "background": "#693d5e",
            "text": "#ffffff"
      },
      "FG": {
            "background": "#4e4a33",
            "text": "#ffffff"
      },
      "FU": {
            "background": "#bb378c",
            "text": "#000000"
      },
      "FUF": {
            "background": "#ff40b4",
            "text": "#000000"
      },
      "GF": {
            "background": "#545454",
            "text": "#ffffff"
      },
      "GM": {
            "background": "#a4a9ad",
            "text": "#000000"
      },
      "GR": {
            "background": "#00783f",
            "text": "#ffffff"
      },
      "GRP": {
            "background": "#d5e7d2",
            "text": "#000000"
      },
      "GY": {
            "background": "#413d3e",
            "text": "#ffffff"
      },
      "IB": {
            "background": "#cedfd7",
            "text": "#000000"
      },
      "IV": {
            "background": "#eee7d4",
            "text": "#000000"
      },
      "JA": {
            "background": "#fdd37b",
            "text": "#000000"
      },
      "KB": {
            "background": "#1e419c",
            "text": "#ffffff"
      },
      "KG": {
            "background": "#008556",
            "text": "#ffffff"
      },
      "KH": {
            "background": "#4e4a33",
            "text": "#ffffff"
      },
      "KI": {
            "background": "#ced8c4",
            "text": "#000000"
      },
      "LB": {
            "background": "#8cb7c9",
            "text": "#000000"
      },
      "LEY": {
            "background": "#fef315",
            "text": "#000000"
      },
      "LM": {
            "background": "#76bc21",
            "text": "#000000"
      },
      "LMF": {
            "background": "#38d430",
            "text": "#000000"
      },
      "LMW": {
            "background": "#70d44b",
            "text": "#000000"
      },
      "LP": {
            "background": "#ab94a4",
            "text": "#000000"
      },
      "LS": {
            "background": "#dfdbaa",
            "text": "#000000"
      },
      "LV": {
            "background": "#bca3ce",
            "text": "#000000"
      },
      "LVH": {
            "background": "#916c95",
            "text": "#000000"
      },
      "LY": {
            "background": "#f0e77b",
            "text": "#000000"
      },
      "LYN": {
            "background": "#f3efa1",
            "text": "#000000"
      },
      "MG": {
            "background": "#95e1bf",
            "text": "#000000"
      },
      "MGW": {
            "background": "#bde0d7",
            "text": "#000000"
      },
      "ML": {
            "background": "#ffdedc",
            "text": "#000000"
      },
      "MM": {
            "background": "#ad7f66",
            "text": "#000000"
      },
      "MO": {
            "background": "#86af9a",
            "text": "#000000"
      },
      "MU": {
            "background": "#ffb71b",
            "text": "#000000"
      },
      "MUH": {
            "background": "#fabf37",
            "text": "#000000"
      },
      "MXG": {
            "background": "#40665b",
            "text": "#ffffff"
      },
      "NC": {
            "background": "#ced8c4",
            "text": "#000000"
      },
      "NG": {
            "background": "#001e35",
            "text": "#ffffff"
      },
      "NP": {
            "background": "#f3e5d7",
            "text": "#000000"
      },
      "NV": {
            "background": "#022a3a",
            "text": "#ffffff"
      },
      "NY": {
            "background": "#002a3a",
            "text": "#ffffff"
      },
      "NYW": {
            "background": "#004366",
            "text": "#ffffff"
      },
      "OC": {
            "background": "#9d892e",
            "text": "#000000"
      },
      "OCW": {
            "background": "#906929",
            "text": "#ffffff"
      },
      "OD": {
            "background": "#782088",
            "text": "#ffffff"
      },
      "OL": {
            "background": "#9daf87",
            "text": "#000000"
      },
      "OLH": {
            "background": "#9daf87",
            "text": "#000000"
      },
      "OLW": {
            "background": "#497b7c",
            "text": "#ffffff"
      },
      "OR": {
            "background": "#ff671d",
            "text": "#000000"
      },
      "ORF": {
            "background": "#ff4713",
            "text": "#000000"
      },
      "ORN": {
            "background": "#fecb8b",
            "text": "#000000"
      },
      "ORP": {
            "background": "#f6d29d",
            "text": "#000000"
      },
      "ORW": {
            "background": "#ffad5f",
            "text": "#000000"
      },
      "PA": {
            "background": "#1b1b1b",
            "text": "#ffffff"
      },
      "PC": {
            "background": "#ffb0c0",
            "text": "#000000"
      },
      "PFD": {
            "background": "#edddcc",
            "text": "#000000"
      },
      "PG": {
            "background": "#bdcf9b",
            "text": "#000000"
      },
      "PH": {
            "background": "#ffa400",
            "text": "#000000"
      },
      "PK": {
            "background": "#f6dadf",
            "text": "#000000"
      },
      "PKG": {
            "background": "#aa2380",
            "text": "#ffffff"
      },
      "PKN": {
            "background": "#feb0c0",
            "text": "#000000"
      },
      "PKP": {
            "background": "#f1e4d7",
            "text": "#000000"
      },
      "PR": {
            "background": "#3bae68",
            "text": "#000000"
      },
      "PT": {
            "background": "#eaea6c",
            "text": "#000000"
      },
      "PU": {
            "background": "#351f69",
            "text": "#ffffff"
      },
      "PUH": {
            "background": "#865f74",
            "text": "#ffffff"
      },
      "PV": {
            "background": "#edb9a6",
            "text": "#000000"
      },
      "RB": {
            "background": "#0055b8",
            "text": "#ffffff"
      },
      "RD": {
            "background": "#ce0e2d",
            "text": "#ffffff"
      },
      "RG": {
            "background": "#e75300",
            "text": "#000000"
      },
      "RO": {
            "background": "#9a6a3a",
            "text": "#000000"
      },
      "RP": {
            "background": "#af0061",
            "text": "#ffffff"
      },
      "RS": {
            "background": "#f97fb5",
            "text": "#000000"
      },
      "RU": {
            "background": "#a09fa0",
            "text": "#000000"
      },
      "SA": {
            "background": "#e1b77e",
            "text": "#000000"
      },
      "SB": {
            "background": "#4e738a",
            "text": "#ffffff"
      },
      "SC": {
            "background": "#00b2e3",
            "text": "#000000"
      },
      "SD": {
            "background": "#f4edcb",
            "text": "#000000"
      },
      "SK": {
            "background": "#95d4e9",
            "text": "#000000"
      },
      "SKN": {
            "background": "#b9dbe5",
            "text": "#000000"
      },
      "SKP": {
            "background": "#b2e1d8",
            "text": "#000000"
      },
      "SKW": {
            "background": "#d1e2ed",
            "text": "#000000"
      },
      "SL": {
            "background": "#cacbca",
            "text": "#000000"
      },
      "ST": {
            "background": "#50748a",
            "text": "#ffffff"
      },
      "SY": {
            "background": "#ffd600",
            "text": "#000000"
      },
      "SYF": {
            "background": "#e2e735",
            "text": "#000000"
      },
      "TE": {
            "background": "#849593",
            "text": "#000000"
      },
      "TG": {
            "background": "#ff9421",
            "text": "#000000"
      },
      "TP": {
            "background": "#008375",
            "text": "#ffffff"
      },
      "TU": {
            "background": "#00a5b5",
            "text": "#000000"
      },
      "TUH": {
            "background": "#00c4b3",
            "text": "#000000"
      },
      "UB": {
            "background": "#6fa7db",
            "text": "#000000"
      },
      "UW": {
            "background": "#8f9cbb",
            "text": "#000000"
      },
      "VA": {
            "background": "#f4edcb",
            "text": "#000000"
      },
      "VAP": {
            "background": "#f2eccb",
            "text": "#000000"
      },
      "VI": {
            "background": "#9b99b1",
            "text": "#000000"
      },
      "WA": {
            "background": "#c09473",
            "text": "#000000"
      },
      "WEH": {
            "background": "#c3c6c8",
            "text": "#000000"
      },
      "WG": {
            "background": "#5e6263",
            "text": "#ffffff"
      },
      "WH": {
            "background": "#ffffff",
            "text": "#000000"
      },
      "WHSB": {
            "background": "#ffffff",
            "text": "#000000"
      },
      "WHW": {
            "background": "#ffffff",
            "text": "#000000"
      },
      "WN": {
            "background": "#69123e",
            "text": "#ffffff"
      },
      "WR": {
            "background": "#e7374c",
            "text": "#000000"
      },
      "WT": {
            "background": "#fff6a3",
            "text": "#000000"
      },
      "YE": {
            "background": "#f5f0a1",
            "text": "#000000"
      },
      "YN": {
            "background": "#fff6a3",
            "text": "#000000"
      },
      "YW": {
            "background": "#f7d710",
            "text": "#000000"
      },
      "ZC": {
            "background": "#65665d",
            "text": "#ffffff"
      },
      "OFW": {
            "background": "#ffffff",
            "text": "#000000"
      },
      "BKBK": {
            "background": "#2d2a26",
            "text": "#ffffff"
      },
      "WHBK": {
            "background": "linear-gradient(135deg, #ffffff 0 50%, #2d2a26 50% 100%)",
            "text": "#000000"
      },
      "WHRD": {
            "background": "linear-gradient(135deg, #ffffff 0 50%, #ce0e2d 50% 100%)",
            "text": "#000000"
      },
      "WHGR": {
            "background": "linear-gradient(135deg, #ffffff 0 50%, #00783f 50% 100%)",
            "text": "#000000"
      },
      "RDRB": {
            "background": "linear-gradient(135deg, #ce0e2d 0 50%,  #0055b8 50% 100%)",
            "text": "#ffffff"
      },
      "WHRB": {
            "background": "linear-gradient(135deg, #ffffff 0 50%, #0055b8 50% 100%)",
            "text": "#000000"
      },
      "RDGF": {
            "background": "linear-gradient(135deg, #ce0e2d 0 50%, #545454 50% 100%)",
            "text": "#ffffff"
      },
      "SYBK": {
            "background": "linear-gradient(135deg, #ffd600 0 50%, #2d2a26 50% 100%)",
            "text": "#000000"
      },
      "RDBK": {
            "background": "linear-gradient(135deg, #ce0e2d 0 50%, #2d2a26 50% 100%)",
            "text": "#ffffff"
      },
      "RBRD": {
            "background": "linear-gradient(135deg, #0055b8 0 50%, #ce0e2d 50% 100%)",
            "text": "#ffffff"
      },
      "RDWH": {
            "background": "linear-gradient(135deg, #ce0e2d 0 50%, #ffffff 50% 100%)",
            "text": "#000000"
      },
      "WHNY": {
            "background": "linear-gradient(135deg, #ffffff 0 50%, #002a3a 50% 100%)",
            "text": "#000000"
      },
      "RDNY": {
            "background": "linear-gradient(135deg, #ce0e2d 0 50%, #002a3a 50% 100%)",
            "text": "#ffffff"
      },
      "CHCRD": {
            "background": "linear-gradient(135deg, #4a5253 0 50%, #ce0e2d 50% 100%)",
            "text": "#ffffff"
      },
      "RBSL": {
            "background": "linear-gradient(135deg, #0055b8 0 50%, #cacbca 50% 100%)",
            "text": "#ffffff"
      },
      "SLGRA": {
            "background": "linear-gradient(135deg, #cacbca 0 50%, #00783f 50% 100%)",
            "text": "#000000"
      },
      "WHGM": {
            "background": "linear-gradient(135deg, #ffffff 0 50%, #a4a9ad 50% 100%)",
            "text": "#000000"
      },
      "WHKG": {
            "background": "linear-gradient(135deg, #ffffff 0 50%, #008556 50% 100%)",
            "text": "#000000"
      },
      "WHWH": {
            "background": "linear-gradient(135deg, #ffffff 0 50%, #ffffff 50% 100%)",
            "text": "#000000"
      },
      "ZCBK": {
            "background": "linear-gradient(135deg, #65665d 0 50%, #2d2a26 50% 100%)",
            "text": "#ffffff"
      },
      "SBWH": {
            "background": "linear-gradient(135deg, #4e738a 0 50%, #ffffff 50% 100%)",
            "text": "#000000"
      },
      "ASNY": {
            "background": "linear-gradient(135deg, #d1d3d3 0 50%, #002a3a 50% 100%)",
            "text": "#000000"
      },
      "BGWH": {
            "background": "linear-gradient(135deg, #13572b 0 50%, #ffffff 50% 100%)",
            "text": "#000000"
      },
      "BGBK": {
            "background": "linear-gradient(135deg, #13572b 0 50%, #2d2a26 50% 100%)",
            "text": "#ffffff"
      },
      "BKAS": {
            "background": "linear-gradient(135deg, #2d2a26 0 50%, #d1d3d3 50% 100%)",
            "text": "#ffffff"
      },
      "BKFUF": {
            "background": "linear-gradient(135deg, #2d2a26 0 50%, #ff40b4 50% 100%)",
            "text": "#ffffff"
      },
      "BKRD": {
            "background": "linear-gradient(135deg, #2d2a26 0 50%, #ce0e2d 50% 100%)",
            "text": "#ffffff"
      },
      "BKSL": {
            "background": "linear-gradient(135deg, #2d2a26 0 50%, #cacbca 50% 100%)",
            "text": "#000000"
      },
      "BKSYF": {
            "background": "linear-gradient(135deg, #2d2a26 0 50%, #e2e735 50% 100%)",
            "text": "#ffffff"
      },
      "BKWH": {
            "background": "linear-gradient(135deg, #2d2a26 0 50%, #ffffff 50% 100%)",
            "text": "#000000"
      },
      "FUWH": {
            "background": "linear-gradient(135deg, #bb378c 0 50%, #ffffff 50% 100%)",
            "text": "#000000"
      },
      "GFBK": {
            "background": "linear-gradient(135deg, #545454 0 50%, #2d2a26 50% 100%)",
            "text": "#ffffff"
      },
      "GFRD": {
            "background": "linear-gradient(135deg, #545454 0 50%, #ce0e2d 50% 100%)",
            "text": "#ffffff"
      },
      "GMWH": {
            "background": "linear-gradient(135deg, #a4a9ad 0 50%, #ffffff 50% 100%)",
            "text": "#000000"
      },
      "GRWH": {
            "background": "linear-gradient(135deg, #00783f 0 50%, #ffffff 50% 100%)",
            "text": "#000000"
      },
      "NYAS": {
            "background": "linear-gradient(135deg, #002a3a 0 50%, #d1d3d3 50% 100%)",
            "text": "#ffffff"
      },
      "NYBK": {
            "background": "linear-gradient(135deg, #002a3a 0 50%, #2d2a26 50% 100%)",
            "text": "#ffffff"
      },
      "NYFUF": {
            "background": "linear-gradient(135deg, #002a3a 0 50%, #ff40b4 50% 100%)",
            "text": "#ffffff"
      },
      "NYORF": {
            "background": "linear-gradient(135deg, #002a3a 0 50%, #ff4713 50% 100%)",
            "text": "#ffffff"
      },
      "NYRB": {
            "background": "linear-gradient(135deg, #002a3a 0 50%, #0055b8 50% 100%)",
            "text": "#ffffff"
      },
      "NYSYF": {
            "background": "linear-gradient(135deg, #002a3a 0 50%, #e2e735 50% 100%)",
            "text": "#ffffff"
      },
      "NYSL": {
            "background": "linear-gradient(135deg, #002a3a 0 50%, #cacbca 50% 100%)",
            "text": "#ffffff"
      },
      "NYWH": {
            "background": "linear-gradient(135deg, #002a3a 0 50%, #ffffff 50% 100%)",
            "text": "#000000"
      },
      "ORFBK": {
            "background": "linear-gradient(135deg, #ff4713 0 50%, #2d2a26 50% 100%)",
            "text": "#ffffff"
      },
      "PKGM": {
            "background": "linear-gradient(135deg, #f6dadf 0 50%, #a4a9ad 50% 100%)",
            "text": "#000000"
      },
      "RBBK": {
            "background": "linear-gradient(135deg, #0055b8 0 50%, #2d2a26 50% 100%)",
            "text": "#ffffff"
      },
      "RBWH": {
            "background": "linear-gradient(135deg, #0055b8 0 50%, #ffffff 50% 100%)",
            "text": "#0"
      },
      "01": {
            "background": "#000080",
            "text": "#000000"
      },
      "02": {
            "background": "#1B7161",
            "text": "#000000"
      },
      "03": {
            "background": "#5D6532",
            "text": "#000000"
      },
      "04": {
            "background": "#06402B",
            "text": "#000000"
      },
      "05": {
            "background": "#A5E8F2",
            "text": "#000000"
      },
      "06": {
            "background": "#9D825D",
            "text": "#000000"
      },
      "07": {
            "background": "#FFFFFF",
            "text": "#000000"
      },
      "08": {
            "background": "#808080",
            "text": "#000000"
      },
      "09": {
            "background": "#0000FF",
            "text": "#000000"
      },
      "10": {
            "background": "#084D6E",
            "text": "#000000"
      },
      "11": {
            "background": "#98fbcb",
            "text": "#000000"
      },
      "12": {
            "background": "#FF0000",
            "text": "#000000"
      },
      "13": {
            "background": "linear-gradient(135deg, #084d6e 0 50%, #ffffff 50% 100%)",
            "text": "#000000"
      },
      "15": {
            "background": "#2DACCB",
            "text": "#000000"
      },
      "16": {
            "background": "#FC4B08",
            "text": "#000000"
      },
      "17": {
            "background": "#FFFF00",
            "text": "#000000"
      },
      "18": {
            "background": "#550000",
            "text": "#000000"
      },
      "20": {
            "background": "#FFFF00",
            "text": "#000000"
      },
      "22": {
            "background": "#f69100",
            "text": "#000000"
      },
      "23": {
            "background": "#ff0080",
            "text": "#000000"
      },
      "25": {
            "background": "#69E359",
            "text": "#000000"
      },
      "26": {
            "background": "#8800ff",
            "text": "#000000"
      },
      "27": {
            "background": "#0997B1",
            "text": "#000000"
      },
      "29": {
            "background": "#4CBB17",
            "text": "#000000"
      },
      "30": {
            "background": "#21CE94",
            "text": "#000000"
      },
      "31": {
            "background": "#5771E6",
            "text": "#000000"
      },
      "32": {
            "background": "#00913F",
            "text": "#000000"
      },
      "33": {
            "background": "#005aa3",
            "text": "#ffffff"
      },
      "34": {
            "background": "#b04269",
            "text": "#000000"
      },
      "35": {
            "background": "#636b2f",
            "text": "#000000"
      },
      "36": {
            "background": "#636b2f",
            "text": "#000000"
      },
      "37": {
            "background": "#FF0080",
            "text": "#000000"
      },
      "38": {
            "background": "#da70d6",
            "text": "#000000"
      },
      "39": {
            "background": "#1D4C64",
            "text": "#000000"
      },
      "40": {
            "background": "#155644",
            "text": "#000000"
      },
      "41": {
            "background": "#ffffe3",
            "text": "#000000"
      },
      "42": {
            "background": "#293133",
            "text": "#000000"
      },
      "43": {
            "background": "#ffff31",
            "text": "#000000"
      },
      "44": {
            "background": "#222222",
            "text": "#000000"
      },
      "45": {
            "background": "rgb(168, 156, 122)",
            "text": "#000000"
      },
      "46": {
            "background": "#ECE2C6",
            "text": "#000000"
      },
      "47": {
            "background": "#0b1b3a",
            "text": "#ffffff"
      },
      "48": {
            "background": "#9C9C9C",
            "text": "#000000"
      },
      "49": {
            "background": "#944d02",
            "text": "#000000"
      },
      "50": {
            "background": "#00a4dc",
            "text": "#ffffff"
      },
      "51": {
            "background": "#00a64f",
            "text": "#ffffff"
      },
      "52": {
            "background": "linear-gradient(135deg, #9c9c9c 0 50%, #000000 50% 100%)",
            "text": "#000000"
      },
      "53": {
            "background": "#ff4466",
            "text": "#000000"
      },
      "54": {
            "background": "#f07951",
            "text": "#000000"
      },
      "55": {
            "background": "#87cefa",
            "text": "#000000"
      },
      "56": {
            "background": "#f80000",
            "text": "#000000"
      },
      "57": {
            "background": "#8c1713",
            "text": "#ffffff"
      },
      "58": {
            "background": "#cbccce",
            "text": "#000000"
      },
      "59": {
            "background": "#CBCEC5",
            "text": "#000000"
      },
      "60": {
            "background": "#dc002e",
            "text": "#ffffff"
      },
      "61": {
            "background": "#000080",
            "text": "#000000"
      },
      "62": {
            "background": "#191970",
            "text": "#000000"
      },
      "63": {
            "background": "#1560BD",
            "text": "#000000"
      },
      "64": {
            "background": "#00334f",
            "text": "#000000"
      },
      "65": {
            "background": "#4169E1",
            "text": "#000000"
      },
      "66": {
            "background": "#210330",
            "text": "#000000"
      },
      "67": {
            "background": "#80091b",
            "text": "#000000"
      },
      "68": {
            "background": "#734158",
            "text": "#000000"
      },
      "69": {
            "background": "#9b3b4b",
            "text": "#000000"
      },
      "70": {
            "background": "#7a1120",
            "text": "#ffffff"
      },
      "71": {
            "background": "#4F6D90",
            "text": "#000000"
      },
      "72": {
            "background": "#252850",
            "text": "#000000"
      },
      "73": {
            "background": "#a58e71",
            "text": "#000000"
      },
      "74": {
            "background": "#eed9c4",
            "text": "#000000"
      },
      "75": {
            "background": "#a8c9b3",
            "text": "#000000"
      },
      "76": {
            "background": "#950606",
            "text": "#000000"
      },
      "77": {
            "background": "#550000",
            "text": "#000000"
      },
      "78": {
            "background": "#828282",
            "text": "#000000"
      },
      "79": {
            "background": "#2F6287",
            "text": "#000000"
      },
      "80": {
            "background": "#2A3F54",
            "text": "#000000"
      },
      "81": {
            "background": "#587156",
            "text": "#000000"
      },
      "82": {
            "background": "#c9d58b",
            "text": "#000000"
      },
      "83": {
            "background": "#3c4e3a",
            "text": "#000000"
      },
      "84": {
            "background": "#ffc0cb",
            "text": "#000000"
      },
      "85": {
            "background": "#4d5645",
            "text": "#000000"
      },
      "86": {
            "background": "#596e84",
            "text": "#000000"
      },
      "87": {
            "background": "#653c2e",
            "text": "#ffffff"
      },
      "88": {
            "background": "#7D8080",
            "text": "#000000"
      },
      "89": {
            "background": "#7a7a7a",
            "text": "#ffffff"
      },
      "90": {
            "background": "#f6d29d",
            "text": "#000000"
      },
      "91": {
            "background": "#98e2bf",
            "text": "#000000"
      },
      "92": {
            "background": "#bbdce5",
            "text": "#000000"
      },
      "93": {
            "background": "#bce1ec",
            "text": "#000000"
      },
      "94": {
            "background": "#b4e1d8",
            "text": "#000000"
      },
      "95": {
            "background": "#f4edcb",
            "text": "#000000"
      },
      "96": {
            "background": "#ebc54e",
            "text": "#000000"
      },
      "97": {
            "background": "#f3e5d7",
            "text": "#000000"
      },
      "98": {
            "background": "#d7bea1",
            "text": "#000000"
      },
      "99": {
            "background": "#9daf87",
            "text": "#000000"
      },
      "100": {
            "background": "#13572b",
            "text": "#ffffff"
      },
      "101": {
            "background": "#00783e",
            "text": "#ffffff"
      },
      "102": {
            "background": "#00a276",
            "text": "#000000"
      },
      "103": {
            "background": "#008375",
            "text": "#ffffff"
      },
      "104": {
            "background": "#00c4b3",
            "text": "#000000"
      },
      "105": {
            "background": "#00b2e3",
            "text": "#000000"
      },
      "106": {
            "background": "#6fa7db",
            "text": "#000000"
      },
      "107": {
            "background": "#004a98",
            "text": "#ffffff"
      },
      "108": {
            "background": "#00496b",
            "text": "#ffffff"
      },
      "109": {
            "background": "#022a3a",
            "text": "#ffffff"
      },
      "110": {
            "background": "#001e35",
            "text": "#ffffff"
      },
      "111": {
            "background": "#333e48",
            "text": "#ffffff"
      },
      "112": {
            "background": "#3b4647",
            "text": "#ffffff"
      },
      "113": {
            "background": "#3e4543",
            "text": "#ffffff"
      },
      "114": {
            "background": "#564c3e",
            "text": "#ffffff"
      },
      "115": {
            "background": "#4a2b2a",
            "text": "#ffffff"
      },
      "116": {
            "background": "#a09fa0",
            "text": "#000000"
      },
      "117": {
            "background": "#636569",
            "text": "#ffffff"
      },
      "118": {
            "background": "#7c7b79",
            "text": "#000000"
      },
      "119": {
            "background": "#cacbca",
            "text": "#000000"
      },
      "120": {
            "background": "#c3c6c8",
            "text": "#000000"
      },
      "121": {
            "background": "#6a6378",
            "text": "#ffffff"
      },
      "122": {
            "background": "#8f9cbb",
            "text": "#ffffff"
      },
      "123": {
            "background": "#f4edcb",
            "text": "#000000"
      },
      "124": {
            "background": "#fff6a3",
            "text": "#000000"
      },
      "125": {
            "background": "#f5f0a1",
            "text": "#000000"
      },
      "126": {
            "background": "#e4e833",
            "text": "#000000"
      },
      "127": {
            "background": "#c9c800",
            "text": "#000000"
      },
      "128": {
            "background": "#eee315",
            "text": "#000000"
      },
      "129": {
            "background": "#fabf37",
            "text": "#000000"
      },
      "130": {
            "background": "#fecb8b",
            "text": "#000000"
      },
      "131": {
            "background": "#fdd37b",
            "text": "#000000"
      },
      "132": {
            "background": "#e75300",
            "text": "#000000"
      },
      "133": {
            "background": "#f8ac00",
            "text": "#000000"
      },
      "134": {
            "background": "#ff4612",
            "text": "#ffffff"
      },
      "135": {
            "background": "#b23c27",
            "text": "#ffffff"
      },
      "136": {
            "background": "#c62822",
            "text": "#ffffff"
      },
      "137": {
            "background": "#9a6a3a",
            "text": "#ffffff"
      },
      "138": {
            "background": "#855d31",
            "text": "#ffffff"
      },
      "139": {
            "background": "#a08d73",
            "text": "#ffffff"
      },
      "140": {
            "background": "#d7bea1",
            "text": "#000000"
      },
      "141": {
            "background": "#ced8c4",
            "text": "#000000"
      },
      "142": {
            "background": "#a8c19f",
            "text": "#000000"
      },
      "143": {
            "background": "#9daf87",
            "text": "#000000"
      },
      "144": {
            "background": "#3bae68",
            "text": "#000000"
      },
      "145": {
            "background": "#144733",
            "text": "#ffffff"
      },
      "146": {
            "background": "#0b3d2e",
            "text": "#ffffff"
      },
      "147": {
            "background": "#00783e",
            "text": "#ffffff"
      },
      "148": {
            "background": "#13572b",
            "text": "#ffffff"
      },
      "149": {
            "background": "#2aa8a1",
            "text": "#ffffff"
      },
      "150": {
            "background": "#008375",
            "text": "#ffffff"
      },
      "151": {
            "background": "#00c4b3",
            "text": "#000000"
      },
      "152": {
            "background": "#00b2e3",
            "text": "#000000"
      },
      "153": {
            "background": "#83b1c9",
            "text": "#ffffff"
      },
      "154": {
            "background": "#c4ddf1",
            "text": "#000000"
      },
      "155": {
            "background": "#6fa7db",
            "text": "#000000"
      },
      "156": {
            "background": "#0060a9",
            "text": "#ffffff"
      },
      "157": {
            "background": "#004a98",
            "text": "#ffffff"
      },
      "158": {
            "background": "#00496b",
            "text": "#ffffff"
      },
      "159": {
            "background": "#022a3a",
            "text": "#ffffff"
      },
      "160": {
            "background": "#001e35",
            "text": "#ffffff"
      },
      "161": {
            "background": "#333e48",
            "text": "#ffffff"
      },
      "162": {
            "background": "#3b4647",
            "text": "#ffffff"
      },
      "163": {
            "background": "#3e4543",
            "text": "#ffffff"
      },
      "164": {
            "background": "#564c3e",
            "text": "#ffffff"
      },
      "165": {
            "background": "#4a2b2a",
            "text": "#ffffff"
      },
      "166": {
            "background": "#a09fa0",
            "text": "#000000"
      },
      "167": {
            "background": "#636569",
            "text": "#ffffff"
      },
      "168": {
            "background": "#a4777e",
            "text": "#000000"
      },
      "169": {
            "background": "#916c95",
            "text": "#000000"
      },
      "170": {
            "background": "#b4a6ac",
            "text": "#000000"
      },
      "171": {
            "background": "#879ba3",
            "text": "#ffffff"
      },
      "172": {
            "background": "#659a9e",
            "text": "#ffffff"
      },
      "173": {
            "background": "#d4ddc4",
            "text": "#000000"
      },
      "174": {
            "background": "#d7e8d2",
            "text": "#000000"
      },
      "175": {
            "background": "#f3e5d7",
            "text": "#000000"
      },
      "176": {
            "background": "#f6d29d",
            "text": "#000000"
      },
      "177": {
            "background": "#f4edcb",
            "text": "#000000"
      },
      "178": {
            "background": "#fff6a3",
            "text": "#000000"
      },
      "179": {
            "background": "#f5f0a1",
            "text": "#000000"
      },
      "180": {
            "background": "#e4e833",
            "text": "#000000"
      },
      "181": {
            "background": "#c9c800",
            "text": "#000000"
      },
      "182": {
            "background": "#eee315",
            "text": "#000000"
      },
      "183": {
            "background": "#fabf37",
            "text": "#000000"
      },
      "184": {
            "background": "#fecb8b",
            "text": "#000000"
      },
      "185": {
            "background": "#fdd37b",
            "text": "#000000"
      },
      "186": {
            "background": "#e75300",
            "text": "#000000"
      },
      "187": {
            "background": "#f8ac00",
            "text": "#000000"
      },
      "188": {
            "background": "#ff4612",
            "text": "#ffffff"
      },
      "189": {
            "background": "#b23c27",
            "text": "#ffffff"
      },
      "190": {
            "background": "#c62822",
            "text": "#ffffff"
      },
      "191": {
            "background": "#9a6a3a",
            "text": "#ffffff"
      },
      "192": {
            "background": "#855d31",
            "text": "#ffffff"
      },
      "193": {
            "background": "#a08d73",
            "text": "#ffffff"
      },
      "194": {
            "background": "#d7bea1",
            "text": "#000000"
      },
      "195": {
            "background": "#ced8c4",
            "text": "#000000"
      },
      "196": {
            "background": "#a8c19f",
            "text": "#000000"
      },
      "197": {
            "background": "#9daf87",
            "text": "#000000"
      },
      "198": {
            "background": "#3bae68",
            "text": "#000000"
      },
      "199": {
            "background": "#144733",
            "text": "#ffffff"
      },
      "200": {
            "background": "#0b3d2e",
            "text": "#ffffff"
      },
      "201": {
            "background": "#00783e",
            "text": "#ffffff"
      },
      "202": {
            "background": "#13572b",
            "text": "#ffffff"
      },
      "203": {
            "background": "#2aa8a1",
            "text": "#ffffff"
      },
      "204": {
            "background": "#008375",
            "text": "#ffffff"
      },
      "205": {
            "background": "#00c4b3",
            "text": "#000000"
      },
      "206": {
            "background": "#00b2e3",
            "text": "#000000"
      },
      "207": {
            "background": "#83b1c9",
            "text": "#ffffff"
      },
      "208": {
            "background": "#c4ddf1",
            "text": "#000000"
      },
      "209": {
            "background": "#6fa7db",
            "text": "#000000"
      },
      "210": {
            "background": "#0060a9",
            "text": "#ffffff"
      },
      "211": {
            "background": "#004a98",
            "text": "#ffffff"
      },
      "212": {
            "background": "#00496b",
            "text": "#ffffff"
      },
      "213": {
            "background": "#022a3a",
            "text": "#ffffff"
      },
      "214": {
            "background": "#001e35",
            "text": "#ffffff"
      },
      "215": {
            "background": "#333e48",
            "text": "#ffffff"
      },
      "216": {
            "background": "#3b4647",
            "text": "#ffffff"
      },
      "217": {
            "background": "#3e4543",
            "text": "#ffffff"
      },
      "218": {
            "background": "#564c3e",
            "text": "#ffffff"
      },
      "219": {
            "background": "#4a2b2a",
            "text": "#ffffff"
      },
      "220": {
            "background": "#a09fa0",
            "text": "#000000"
      },
      "221": {
            "background": "#636569",
            "text": "#ffffff"
      },
      "222": {
            "background": "#a4777e",
            "text": "#000000"
      },
      "223": {
            "background": "#916c95",
            "text": "#000000"
      },
      "224": {
            "background": "#b4a6ac",
            "text": "#000000"
      },
      "225": {
            "background": "#879ba3",
            "text": "#ffffff"
      },
      "226": {
            "background": "#659a9e",
            "text": "#ffffff"
      },
      "227": {
            "background": "#d4ddc4",
            "text": "#000000"
      },
      "228": {
            "background": "#d7e8d2",
            "text": "#000000"
      },
      "229": {
            "background": "#f3e5d7",
            "text": "#000000"
      },
      "230": {
            "background": "#f6d29d",
            "text": "#000000"
      },
      "231": {
            "background": "#f4edcb",
            "text": "#000000"
      },
      "232": {
            "background": "#fff6a3",
            "text": "#000000"
      },
      "233": {
            "background": "#f5f0a1",
            "text": "#000000"
      },
      "234": {
            "background": "#e4e833",
            "text": "#000000"
      },
      "235": {
            "background": "#c9c800",
            "text": "#000000"
      },
      "236": {
            "background": "#eee315",
            "text": "#000000"
      },
      "237": {
            "background": "#fabf37",
            "text": "#000000"
      },
      "238": {
            "background": "#fecb8b",
            "text": "#000000"
      },
      "239": {
            "background": "#fdd37b",
            "text": "#000000"
      },
      "240": {
            "background": "#e75300",
            "text": "#000000"
      },
      "241": {
            "background": "#f8ac00",
            "text": "#000000"
      },
      "242": {
            "background": "#ff4612",
            "text": "#ffffff"
      },
      "243": {
            "background": "#b23c27",
            "text": "#ffffff"
      },
      "244": {
            "background": "#c62822",
            "text": "#ffffff"
      },
      "245": {
            "background": "#9a6a3a",
            "text": "#ffffff"
      },
      "246": {
            "background": "#855d31",
            "text": "#ffffff"
      },
      "247": {
            "background": "#a08d73",
            "text": "#ffffff"
      },
      "248": {
            "background": "#d7bea1",
            "text": "#000000"
      },
      "249": {
            "background": "#ced8c4",
            "text": "#000000"
      },
      "250": {
            "background": "#a8c19f",
            "text": "#000000"
      },
      "251": {
            "background": "#9daf87",
            "text": "#000000"
      },
      "252": {
            "background": "#3bae68",
            "text": "#000000"
      },
      "253": {
            "background": "#144733",
            "text": "#ffffff"
      },
      "254": {
            "background": "#0b3d2e",
            "text": "#ffffff"
      },
      "255": {
            "background": "#00783e",
            "text": "#ffffff"
      },
      "256": {
            "background": "#13572b",
            "text": "#ffffff"
      },
      "257": {
            "background": "#2aa8a1",
            "text": "#ffffff"
      },
      "258": {
            "background": "#008375",
            "text": "#ffffff"
      },
      "259": {
            "background": "#00c4b3",
            "text": "#000000"
      },
      "260": {
            "background": "#00b2e3",
            "text": "#000000"
      },
      "261": {
            "background": "#83b1c9",
            "text": "#ffffff"
      },
      "262": {
            "background": "#c4ddf1",
            "text": "#000000"
      },
      "263": {
            "background": "#6fa7db",
            "text": "#000000"
      },
      "264": {
            "background": "#d4ddc4",
            "text": "#000000"
      },
      "265": {
            "background": "#c1916d",
            "text": "#000000"
      },
      "267": {
            "background": "#659a9e",
            "text": "#ffffff"
      },
      "268": {
            "background": "#a6929e",
            "text": "#000000"
      },
      "275": {
            "background": "#606d64",
            "text": "#ffffff"
      },
      "430": {
            "background": "#38555d",
            "text": "#ffffff"
      },
      "711": {
            "background": "#7863a6",
            "text": "#ffffff"
      },
      "801": {
            "background": "#004a98",
            "text": "#ffffff"
      },
      "802": {
            "background": "#dc002e",
            "text": "#ffffff"
      },
      "803": {
            "background": "#001d43",
            "text": "#ffffff"
      },
      "806": {
            "background": "#000000",
            "text": "#ffffff"
      },
      "980": {
            "background": "#ffffff",
            "text": "#000000"
      },
      "00": {
            "background": "#000000",
            "text": "#000000"
      },
      "14": {
            "background": "#50C878",
            "text": "#000000"
      },
      "19": {
            "background": "#ff8000",
            "text": "#000000"
      },
      "21": {
            "background": "#E1AD01",
            "text": "#000000"
      },
      "24": {
            "background": "#ff4040",
            "text": "#000000"
      },
      "28": {
            "background": "#40E0D0",
            "text": "#000000"
      },
      "00/00": {
            "background": "linear-gradient(135deg, #000000 0 50%, #000000 50% 100%)",
            "text": "#ffffff"
      },
      "00/05": {
            "background": "linear-gradient(135deg, #000000 0 50%, #A5E8F2 50% 100%)",
            "text": "#000000"
      },
      "00/08": {
            "background": "linear-gradient(135deg, #000000 0 50%, #808080 50% 100%)",
            "text": "#000000"
      },
      "00/12": {
            "background": "linear-gradient(135deg, #000000 0 50%, #FF0000 50% 100%)",
            "text": "#000000"
      },
      "00/16": {
            "background": "linear-gradient(135deg, #000000 0 50%, #FC4B08 50% 100%)",
            "text": "#000000"
      },
      "00/17": {
            "background": "linear-gradient(135deg, #000000 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "00/19": {
            "background": "linear-gradient(135deg, #000000 0 50%, #ff8000 50% 100%)",
            "text": "#000000"
      },
      "00/20": {
            "background": "linear-gradient(135deg, #000000 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "00/25": {
            "background": "linear-gradient(135deg, #000000 0 50%, #69E359 50% 100%)",
            "text": "#000000"
      },
      "01/12": {
            "background": "linear-gradient(135deg, #000080 0 50%, #FF0000 50% 100%)",
            "text": "#000000"
      },
      "01/16": {
            "background": "linear-gradient(135deg, #000080 0 50%, #FC4B08 50% 100%)",
            "text": "#000000"
      },
      "01/19": {
            "background": "linear-gradient(135deg, #000080 0 50%, #ff8000 50% 100%)",
            "text": "#000000"
      },
      "01/20": {
            "background": "linear-gradient(135deg, #000080 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "01/25": {
            "background": "linear-gradient(135deg, #000080 0 50%, #69E359 50% 100%)",
            "text": "#000000"
      },
      "02/20": {
            "background": "linear-gradient(135deg, #1B7161 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "03/20": {
            "background": "linear-gradient(135deg, #5D6532 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "07/08": {
            "background": "linear-gradient(135deg, #ffffff 0 50%, #808080 50% 100%)",
            "text": "#000000"
      },
      "08/00": {
            "background": "linear-gradient(135deg, #808080 0 50%, #000000 50% 100%)",
            "text": "#000000"
      },
      "08/05": {
            "background": "linear-gradient(135deg, #808080 0 50%, #A5E8F2 50% 100%)",
            "text": "#000000"
      },
      "08/12": {
            "background": "linear-gradient(135deg, #808080 0 50%, #FF0000 50% 100%)",
            "text": "#000000"
      },
      "08/16": {
            "background": "linear-gradient(135deg, #808080 0 50%, #FC4B08 50% 100%)",
            "text": "#000000"
      },
      "08/17": {
            "background": "linear-gradient(135deg, #808080 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "08/18": {
            "background": "linear-gradient(135deg, #808080 0 50%, #550000 50% 100%)",
            "text": "#000000"
      },
      "08/19": {
            "background": "linear-gradient(135deg, #808080 0 50%, #ff8000 50% 100%)",
            "text": "#000000"
      },
      "08/20": {
            "background": "linear-gradient(135deg, #808080 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "08/25": {
            "background": "linear-gradient(135deg, #808080 0 50%, #69E359 50% 100%)",
            "text": "#000000"
      },
      "09/20": {
            "background": "linear-gradient(135deg, #0000FF 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "12/08": {
            "background": "linear-gradient(135deg, #FF0000 0 50%, #808080 50% 100%)",
            "text": "#000000"
      },
      "12/20": {
            "background": "linear-gradient(135deg, #FF0000 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "18/20": {
            "background": "linear-gradient(135deg, #550000 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "25/61": {
            "background": "linear-gradient(135deg, #69E359 0 50%, #000080 50% 100%)",
            "text": "#000000"
      },
      "29/20": {
            "background": "linear-gradient(135deg, #4CBB17 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "36/46": {
            "background": "linear-gradient(135deg, #636b2f 0 50%, #ECE2C6 50% 100%)",
            "text": "#000000"
      },
      "46/00": {
            "background": "linear-gradient(135deg, #ECE2C6 0 50%, #000000 50% 100%)",
            "text": "#000000"
      },
      "46/49": {
            "background": "linear-gradient(135deg, #ECE2C6 0 50%, #944d02 50% 100%)",
            "text": "#000000"
      },
      "61/00": {
            "background": "linear-gradient(135deg, #000080 0 50%, #000000 50% 100%)",
            "text": "#000000"
      },
      "61/05": {
            "background": "linear-gradient(135deg, #000080 0 50%, #A5E8F2 50% 100%)",
            "text": "#000000"
      },
      "61/12": {
            "background": "linear-gradient(135deg, #000080 0 50%, #FF0000 50% 100%)",
            "text": "#000000"
      },
      "61/16": {
            "background": "linear-gradient(135deg, #000080 0 50%, #FC4B08 50% 100%)",
            "text": "#000000"
      },
      "61/17": {
            "background": "linear-gradient(135deg, #000080 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "61/19": {
            "background": "linear-gradient(135deg, #000080 0 50%, #ff8000 50% 100%)",
            "text": "#000000"
      },
      "61/20": {
            "background": "linear-gradient(135deg, #000080 0 50%, #FFFF00 50% 100%)",
            "text": "#000000"
      },
      "61/25": {
            "background": "linear-gradient(135deg, #000080 0 50%, #69E359 50% 100%)",
            "text": "#000000"
      },
      "61/41": {
            "background": "linear-gradient(135deg, #000080 0 50%, #ffffe3 50% 100%)",
            "text": "#000000"
      },
      "71/00": {
            "background": "linear-gradient(135deg, #4F6D90 0 50%, #000000 50% 100%)",
            "text": "#000000"
      },
      "77/00": {
            "background": "linear-gradient(135deg, #550000 0 50%, #000000 50% 100%)",
            "text": "#000000"
      },
      "78/00": {
            "background": "linear-gradient(135deg, #828282 0 50%, #000000 50% 100%)",
            "text": "#000000"
      },
      "88/00": {
            "background": "linear-gradient(135deg, #7D8080 0 50%, #000000 50% 100%)",
            "text": "#000000"
      }
};

    function colorMapEntry(value) {
      const raw = String(value || "").trim();
      if (!raw) return null;

      const upper = raw.toUpperCase();
      const compact = upper.replace(/\s+/g, "");
      const beforeDash = upper.split(/\s[-–—]\s/)[0].trim();
      const firstToken = upper.match(/[A-Z0-9]+(?:\/[A-Z0-9]+)?/);

      const candidates = [
        upper,
        compact,
        beforeDash,
        beforeDash.replace(/\s+/g, ""),
        firstToken ? firstToken[0] : "",
        compact.replace(/-/g, ""),
        compact.replace(/_/g, "")
      ].filter(Boolean);

      for (const candidate of candidates) {
        if (DTF_COLOR_MAP[candidate]) return DTF_COLOR_MAP[candidate];
      }

      if (upper.includes("/")) {
        const slash = upper.match(/[A-Z0-9]+\/[A-Z0-9]+/);
        if (slash && DTF_COLOR_MAP[slash[0]]) return DTF_COLOR_MAP[slash[0]];
      }

      return null;
    }

    function colorSwatch(value) {
      const entry = colorMapEntry(value);
      if (entry && entry.background) return entry.background;

      const raw = String(value || "").trim();
      const key = normalise(raw).replace(/\s+/g, "").replace(/_/g, "-");
      const map = {
        bk: "#111111", black: "#111111", negro: "#111111", ne: "#111111",
        wh: "#ffffff", white: "#ffffff", blanco: "#ffffff",
        ny: "#071632", navy: "#071632", marino: "#071632",
        gm: "#6b7280", gy: "#6b7280", grey: "#6b7280", gray: "#6b7280", gris: "#6b7280",
        rd: "#dc2626", red: "#dc2626", rojo: "#dc2626",
        rb: "#2563eb", royal: "#2563eb", blue: "#2563eb", azul: "#2563eb",
        or: "#f97316", orange: "#f97316", naranja: "#f97316",
        ye: "#facc15", yellow: "#facc15", amarillo: "#facc15",
        gr: "#16a34a", green: "#16a34a", verde: "#16a34a",
        pk: "#f9a8d4", pink: "#f9a8d4", rosa: "#f9a8d4",
        pu: "#7c3aed", purple: "#7c3aed", morado: "#7c3aed",
        beige: "#d6b98c", natural: "#e7dcc8", grafito: "#374151", antracita: "#374151"
      };

      if (map[key]) return map[key];

      return "#f3f4f6";
    }

    function activeColorName() {
      if (state.selectedColor) return state.selectedColor;

      const qtyEntry = Object.entries(state.personalizedQty || {}).find((entry) => Number(entry[1] || 0) > 0);
      if (qtyEntry && qtyEntry[0]) return String(qtyEntry[0]).split("__")[0];

      const data = productSelectionData();
      return data.colors && data.colors[0] ? data.colors[0].name : "";
    }

    function activeGarmentBackground() {
      const color = activeColorName();
      return colorSwatch(color || "blanco");
    }

    function safeAssetUrl(filename) {
      const explicit = filename === "23dtf-inner-label-neck.png" ? window.P23DTF_INNER_LABEL_ASSET_URL : "";
      if (explicit) return explicit;

      const script = document.currentScript || Array.from(document.scripts).find((item) => String(item.src || "").includes("23dtf-personalizer-modal"));
      if (script && script.src) {
        try {
          return new URL(filename, script.src).toString().split("?")[0];
        } catch (error) {
          return "/cdn/shop/t/9/assets/" + filename;
        }
      }

      return "/cdn/shop/t/9/assets/" + filename;
    }

    function isInnerLabelPlacement() {
      return currentPlacement().id === "inner_label" || state.zone === "inner_label_zone";
    }

    function qtyKey(color, size) {
      return String(color) + "__" + String(size);
    }

    function personalizedQtyTotal() {
      return Object.values(state.personalizedQty).reduce((sum, value) => sum + (Number(value) || 0), 0);
    }

    function personalizedGroups() {
      const data = productSelectionData();
      const groups = [];

      data.colors.forEach((color) => {
        const sizes = [];
        let total = 0;

        data.sizes.forEach((size) => {
          const qty = Number(state.personalizedQty[qtyKey(color.name, size)] || 0);
          if (qty > 0) {
            total += qty;
            sizes.push({ size, qty });
          }
        });

        if (total > 0) groups.push({ color: color.name, swatch: color.swatch, total, sizes });
      });

      return groups;
    }

    function unitLabel(qty) {
      return Number(qty) === 1 ? "ud" : "uds";
    }

    function enableDragScroll(scroller) {
      if (!scroller || scroller.dataset.p23mDragScrollReady === "true") return;
      scroller.dataset.p23mDragScrollReady = "true";

      let active = false;
      let startX = 0;
      let startY = 0;
      let scrollLeft = 0;
      let scrollTop = 0;
      let pointerId = null;

      scroller.addEventListener("pointerdown", (event) => {
        if (event.button !== 0) return;
        if (event.target.closest("input, button, select, textarea, a, label")) return;

        active = true;
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        scrollLeft = scroller.scrollLeft;
        scrollTop = scroller.scrollTop;
        scroller.classList.add("is-dragging");
        try {
          scroller.setPointerCapture?.(pointerId);
        } catch (error) {
          // Evita InvalidStateError en scroll/drag dentro de tablas reconstruidas.
        }
      });

      scroller.addEventListener("pointermove", (event) => {
        if (!active) return;
        event.preventDefault();
        scroller.scrollLeft = scrollLeft - (event.clientX - startX);
        scroller.scrollTop = scrollTop - (event.clientY - startY);
      });

      function stopDrag() {
        if (!active) return;
        active = false;
        scroller.classList.remove("is-dragging");
        if (pointerId !== null) {
          try {
            scroller.releasePointerCapture?.(pointerId);
          } catch (error) {
            // El pointer puede haberse perdido al reconstruir la tabla.
          }
        }
        pointerId = null;
      }

      scroller.addEventListener("pointerup", stopDrag);
      scroller.addEventListener("pointercancel", stopDrag);
      scroller.addEventListener("mouseleave", stopDrag);
    }

    function preserveMatrixScroll(callback) {
      const wrap = q(".p23m-matrix-wrap") || q("[data-p23m-drag-scroll]");
      const scrollTop = wrap ? wrap.scrollTop : 0;
      const scrollLeft = wrap ? wrap.scrollLeft : 0;
      const activeColorBefore = state.selectedColor;

      callback();

      window.requestAnimationFrame(() => {
        const nextWrap = q(".p23m-matrix-wrap") || q("[data-p23m-drag-scroll]");
        if (!nextWrap) return;

        nextWrap.scrollTop = scrollTop;
        nextWrap.scrollLeft = scrollLeft;

        /*
          Si el navegador intenta saltar al principio por reconstrucción del HTML,
          mantenemos la posición real del usuario. El color seleccionado ya está
          visible porque el cambio viene de un click/input en esa misma fila.
        */
        if (activeColorBefore && activeColorBefore === state.selectedColor) {
          nextWrap.scrollTop = scrollTop;
          nextWrap.scrollLeft = scrollLeft;
        }
      });
    }

    function renderProductSelection() {
      const box = q("[data-p23m-product-selection]");
      if (!box) return;

      const data = productSelectionData();
      const total = personalizedQtyTotal();
      const activeColor = activeColorName();

      const rows = data.colors.map((color) => {
        const cells = data.sizes.map((size) => {
          const key = qtyKey(color.name, size);
          const value = Number(state.personalizedQty[key] || 0);
          return '<td class="p23m-matrix__qty-cell"><input class="p23m-matrix__qty" type="number" min="0" step="1" inputmode="numeric" value="' + value + '" data-p23m-personalized-qty="' + escapeHtml(key) + '" aria-label="' + escapeHtml(color.name + ' ' + size) + '"></td>';
        }).join("");

        const selectedClass = String(color.name) === String(activeColor) ? " is-selected-color" : "";
        const colorEntry = colorMapEntry(color.name);
        const textColor = colorEntry && colorEntry.text ? colorEntry.text : "#202223";
        const swatchStyle = 'background:' + escapeHtml(color.swatch) + ';color:' + escapeHtml(textColor);

        return '<tr class="p23m-matrix__row' + selectedClass + '" data-p23m-select-color="' + escapeHtml(color.name) + '">' +
          '<th scope="row" class="p23m-matrix__color-th">' +
            '<button type="button" class="p23m-matrix__color-button" data-p23m-select-color="' + escapeHtml(color.name) + '" aria-label="Seleccionar color ' + escapeHtml(color.name) + '">' +
              '<span class="mpv2-matrix-color__swatch mpv2c-modal__color-swatch p23m-matrix__swatch" style="' + swatchStyle + '"></span>' +
              '<span class="mpv2c-modal__color-label p23m-matrix__color-label">' + escapeHtml(color.name) + '</span>' +
            '</button>' +
          '</th>' + cells + '</tr>';
      }).join("");

      const groups = personalizedGroups();
      const hint = q("[data-p23m-selection-hint]");
      if (hint) hint.hidden = total > 0;

      const summaryHtml = groups.length
        ? '<div class="p23m__personalizer-summary"><div class="p23m__personalizer-summary-head"><strong>Resumen de personalización</strong><span>' + total + ' ' + unitLabel(total) + '</span></div><div class="p23m__personalizer-groups">' + groups.map((group) => {
            return '<div class="p23m__personalizer-group"><div class="p23m__personalizer-group-color"><span class="p23m__personalizer-swatch" style="background:' + escapeHtml(group.swatch) + '"></span><strong>' + escapeHtml(group.color) + '</strong><em>' + group.total + ' ' + unitLabel(group.total) + '</em></div><div class="p23m__personalizer-group-sizes">' + group.sizes.map((item) => '<span>' + escapeHtml(item.size) + ': <b>' + Number(item.qty) + ' ' + unitLabel(item.qty) + '</b></span>').join('') + '</div></div>';
          }).join('') + '</div></div>'
        : '';

      box.innerHTML =
        '<div class="p23m-matrix-wrap" data-p23m-drag-scroll>' +
          '<table class="mpv2-matrix p23m-matrix"><thead><tr><th>Color</th>' + data.sizes.map((size) => '<th>' + escapeHtml(size) + '</th>').join("") + '</tr></thead><tbody>' + rows + '</tbody></table>' +
        '</div>' +
        summaryHtml +
        '<button type="button" class="p23m__continue-design" data-p23m-continue-design ' + (total <= 0 ? 'disabled' : '') + '>Continuar a diseño</button>';

      enableDragScroll(q("[data-p23m-drag-scroll]"));
    }

    function currentPlacement() {
      return PLACEMENTS.find((item) => item.id === state.placement) || PLACEMENTS[0];
    }

    function printMapApi() {
      return window.P23DTFPrintMaps || null;
    }

    function mappedZone(baseZone) {
      if (!baseZone) return baseZone;

      const api = printMapApi();
      if (!api || typeof api.getZoneMap !== "function") return baseZone;

      const mapped = api.getZoneMap(baseZone.id, product.handle, product.refFabricante || product.referenciaFabricante || product.manufacturerReference || "", product.fabricante || product.manufacturer || "");
      if (!mapped || !mapped.rect) return baseZone;

      const next = Object.assign({}, baseZone, {
        rect: Object.assign({}, baseZone.rect || {}, mapped.rect),
        mapRotation: Number(mapped.rotation || 0),
        printCm: mapped.printCm || baseZone.printCm || null
      });

      if (next.printCm && next.printCm.w && next.printCm.h) {
        next.area = next.printCm.w + " × " + next.printCm.h + " cm";
      }

      return next;
    }

    function currentZone() {
      const placement = currentPlacement();
      const base = placement.zones.find((item) => item.id === state.zone) || placement.zones[0] || PLACEMENTS[0].zones[0];
      return mappedZone(base);
    }

    function currentLayers() {
      if (!state.layersByZone[state.zone]) state.layersByZone[state.zone] = [];
      return state.layersByZone[state.zone];
    }

    function activeLayer() {
      const layers = currentLayers();
      return layers.find((item) => item.id === state.activeLayerId) ||
        layers.find((item) => item.id === state.lastToolLayerId) ||
        layers[0] ||
        null;
    }

    function isLayerOutsidePrintArea(layer) {
      if (!layer) return false;
      const zone = currentZone().rect;
      const x = Number(layer.x || 0);
      const y = Number(layer.y || 0);
      const w = Number(layer.w || 0);
      const h = Number(layer.h || 0);
      return x < zone.x || y < zone.y || (x + w) > (zone.x + zone.w) || (y + h) > (zone.y + zone.h);
    }

    function showPrintAreaWarning() {
      state.printAreaWarning = true;
      window.clearTimeout(state.printAreaWarningTimer);
      state.printAreaWarningTimer = window.setTimeout(() => {
        state.printAreaWarning = false;
        renderPrintAreaWarning();
      }, 1200);
      renderPrintAreaWarning();
    }

    function hidePrintAreaWarning() {
      state.printAreaWarning = false;
      window.clearTimeout(state.printAreaWarningTimer);
      renderPrintAreaWarning();
    }

    function syncPrintAreaWarningForLayer(layer) {
      if (isLayerOutsidePrintArea(layer)) showPrintAreaWarning();
      else hidePrintAreaWarning();
    }

    function layerVisibleIntersection(layer) {
      if (!layer) return { w: 0, h: 0, area: 0 };

      const zone = currentZone().rect;
      const layerLeft = Number(layer.x || 0);
      const layerTop = Number(layer.y || 0);
      const layerRight = layerLeft + Number(layer.w || 0);
      const layerBottom = layerTop + Number(layer.h || 0);

      const zoneLeft = Number(zone.x || 0);
      const zoneTop = Number(zone.y || 0);
      const zoneRight = zoneLeft + Number(zone.w || 0);
      const zoneBottom = zoneTop + Number(zone.h || 0);

      const w = Math.max(0, Math.min(layerRight, zoneRight) - Math.max(layerLeft, zoneLeft));
      const h = Math.max(0, Math.min(layerBottom, zoneBottom) - Math.max(layerTop, zoneTop));

      return { w, h, area: w * h };
    }

    function isLayerFullyOutsidePrintArea(layer) {
      return layerVisibleIntersection(layer).area <= 1;
    }

    function centerLayerInPrintArea(layer) {
      if (!layer) return false;

      const zone = currentZone().rect;
      const maxW = Math.max(24, zone.w * 1.5, zone.w);
      const maxH = Math.max(24, zone.h * 1.5, zone.h);

      layer.w = clamp(Number(layer.w) || 50, 24, maxW);
      layer.h = clamp(Number(layer.h) || 50, 24, maxH);
      layer.x = zone.x + (zone.w - layer.w) / 2;
      layer.y = zone.y + (zone.h - layer.h) / 2;

      state.activeLayerId = layer.id;
      state.lastToolLayerId = layer.id;
      hidePrintAreaWarning();
      return true;
    }

    function recoverLayerIfFullyOutside(layer) {
      if (!layer || !isLayerFullyOutsidePrintArea(layer)) return false;
      centerLayerInPrintArea(layer);
      root.classList.add("is-p23m-layer-recovered");
      window.setTimeout(() => root.classList.remove("is-p23m-layer-recovered"), 180);
      return true;
    }

    function clearActiveLayerSelection() {
      if (state.activeLayerId) {
        state.lastToolLayerId = state.activeLayerId;
      }

      state.activeLayerId = null;

      /*
        Importante:
        No limpiamos state.subtoolImage ni state.subtoolText.
        Si el cliente está en Transformar / Posición / Diseño y hace click fuera
        para deseleccionar visualmente la capa, el panel contextual debe seguir visible.
      */
      renderLayers();
      renderLayerPanel();
      renderToolbar();
      renderControls();
      renderCanvasUploadButton();
      renderPrintAreaWarning();
    }

    function makeTextLayer(text) {
      const zone = currentZone().rect;
      return {
        id: uid(),
        type: "text",
        text: text || "Tu texto aquí",
        color: "#d94233",
        font: "\"23DTF Georgia\", Georgia, serif",
        x: zone.x + Math.max(10, zone.w * 0.25),
        y: zone.y + Math.max(10, zone.h * 0.15),
        w: Math.min(110, zone.w * 0.58),
        h: 42,
        r: 0,
        visible: true,
        fontSize: 28,
        originalFontSize: 28,
        originalFitW: Math.min(110, zone.w * 0.58),
        originalFitH: 42,
        textBoxAspect: 42 / Math.min(110, zone.w * 0.58),
        manualTextResize: false,
        originalR: 0,
        outlineColor: "#111111",
        outlineWeight: 0,
        shadowColor: "#111111",
        shadowDistance: 0,
        flipX: false,
        flipY: false,
        originalX: zone.x + Math.max(10, zone.w * 0.25),
        originalY: zone.y + Math.max(10, zone.h * 0.15),
        originalText: text || "Tu texto aquí",
        originalFont: "\"23DTF Georgia\", Georgia, serif",
        originalColor: "#d94233",
        originalFontSize: 28,
        originalOutlineColor: "#111111",
        originalOutlineWeight: 0,
        originalShadowColor: "#111111",
        originalShadowDistance: 0,
        preserveTextBox: false
      };
    }

    function makeImageLayer(src, name) {
      const zone = currentZone().rect;
      const initialW = Math.min(120, zone.w * 0.68);
      const initialH = Math.min(120, zone.h * 0.68);
      return {
        id: uid(),
        type: "image",
        src: src || "",
        name: name || "Imagen subida",
        x: zone.x + Math.max(10, zone.w * 0.22),
        y: zone.y + Math.max(10, zone.h * 0.18),
        w: initialW,
        h: initialH,
        r: Number(currentZone().mapRotation || 0),
        visible: true,
        flipX: false,
        flipY: false,
        pattern: "none",
        mirrorMode: false,
        orientationMode: "",
        aspectLocked: true,
        aspectRatio: initialH / initialW,
        naturalAspectRatio: initialH / initialW
      };
    }

    function fitImageLayerToUpload(layer) {
      if (!layer || layer.type !== "image") return;
      const zone = currentZone().rect;
      const imageW = Number(layer.uploadWidth || 0);
      const imageH = Number(layer.uploadHeight || 0);
      if (!imageW || !imageH) return;

      const maxW = zone.w * 0.72;
      const maxH = zone.h * 0.72;
      const ratio = imageW / imageH;
      const naturalAspect = imageH / imageW;
      let nextW = maxW;
      let nextH = nextW / ratio;

      if (nextH > maxH) {
        nextH = maxH;
        nextW = nextH * ratio;
      }

      layer.w = Math.max(24, nextW);
      layer.h = Math.max(24, nextH);
      layer.originalFitW = layer.w;
      layer.originalFitH = layer.h;
      layer.originalR = Number(currentZone().mapRotation || 0);
      layer.originalFlipX = false;
      layer.originalFlipY = false;

      /*
        v4.11m-REV21:
        Guardamos el archivo original para que "Restablecer diseño" pueda
        deshacer también un recorte aplicado.
      */
      if (!layer.originalSrc) layer.originalSrc = layer.src;
      if (!layer.originalName) layer.originalName = layer.name;
      layer.originalUploadWidth = imageW;
      layer.originalUploadHeight = imageH;
      layer.originalNaturalAspectRatio = naturalAspect;

      layer.aspectLocked = true;
      layer.aspectRatio = naturalAspect;
      layer.naturalAspectRatio = naturalAspect;
      layer.x = zone.x + (zone.w - layer.w) / 2;
      layer.y = zone.y + (zone.h - layer.h) / 2;
      layer.originalX = layer.x;
      layer.originalY = layer.y;
    }

    function ensureTextLayer(text) {
      /*
        REV60B:
        Añadir texto debe crear SIEMPRE una capa nueva.
        Antes reutilizaba la primera capa de texto y cambiaba el texto existente.
      */
      const layer = makeTextLayer(text || "Tu texto aquí");
      const textCount = currentLayers().filter((item) => item.type === "text").length;
      const offset = Math.min(36, textCount * 8);

      layer.x += offset;
      layer.y += offset;
      layer.originalX = layer.x;
      layer.originalY = layer.y;
      layer.originalText = layer.text;
      layer.originalFont = layer.font;
      layer.originalColor = layer.color;
      layer.originalFontSize = layer.fontSize;
      layer.originalOutlineColor = layer.outlineColor;
      layer.originalOutlineWeight = layer.outlineWeight;
      layer.originalShadowColor = layer.shadowColor;
      layer.originalShadowDistance = layer.shadowDistance;
      layer.originalFlipX = false;
      layer.originalFlipY = false;

      currentLayers().push(layer);
      layer.visible = true;
      state.activeLayerId = layer.id;
      state.lastToolLayerId = layer.id;
      state.mode = "text";
      return layer;
    }

    function ensureImageLayer(src, name) {
      let layer = currentLayers().find((item) => item.type === "image");
      if (!layer) {
        layer = makeImageLayer(src, name);
        currentLayers().push(layer);
      }
      if (src) layer.src = src;
      if (name) layer.name = name;
      layer.visible = true;
      state.activeLayerId = layer.id;
      state.lastToolLayerId = layer.id;
      state.mode = "image";
      return layer;
    }

    function switchRail(nextRail) {
      state.rail = nextRail;

      if (nextRail !== "tool") {
        state.lastContentRail = nextRail;
      }

      if (nextRail === "text" || nextRail === "designs" || nextRail === "clipart") {
        state.mode = "text";
        if (!state.subtoolText) state.subtoolText = "text";
      }

      if (nextRail === "uploads") {
        state.mode = "image";
        state.subtoolImage = "";
      }

      if (nextRail === "product" || nextRail === "layers") {
        const layer = activeLayer();
        state.mode = layer && layer.type === "text" ? "text" : "image";
        if (state.mode === "image") state.subtoolImage = "";
      }

      renderAll();
    }

    function mediaForPlacement(placementOverride) {
      const media = Array.isArray(product.media) ? product.media : [];
      if (!media.length) return null;

      const desired = (placementOverride || currentPlacement()).mediaZone || "frontal";
      const color = activeColorName();
      const normalizedColor = normalise(color).replace(/\s+/g, "");
      const hasZone = (item) => normalise(item.alt).includes("zona: " + desired) || normalise(item.alt).includes("zona:" + desired);
      const hasColor = (item) => {
        if (!normalizedColor) return false;
        const alt = normalise(item.alt).replace(/\s+/g, "");
        return alt.includes("color:" + normalizedColor) || alt.includes("color|" + normalizedColor) || alt.includes("color-" + normalizedColor);
      };

      const byZoneAndColor = media.filter((item) => hasZone(item) && hasColor(item));
      if (byZoneAndColor.length) return byZoneAndColor[0];

      const byZone = media.filter(hasZone);
      if (byZone.length) return byZone[0];

      const byColor = media.filter(hasColor);
      return byColor[0] || media[0] || null;
    }

    function shouldMirrorMockup(placementOverride) {
      const placement = placementOverride || currentPlacement();
      if (!placement) return false;

      /*
        Manga derecha:
        Usamos la misma imagen lateral de la prenda, pero reflejada visualmente.
        Importante: esto refleja SOLO el mockup/producto. Las capas del cliente
        se mantienen normales para no invertir textos, logos ni números.
      */
      return placement.id === "right_sleeve";
    }

    function effectiveMockupScale() {
      const zoomScale = (Number(state.zoom || 100) || 100) / 100;
      const fitScale = Number(state.mockupFitScale || 1) || 1;
      return zoomScale * fitScale;
    }

    function applyMockupTransformOnly(scaleOverride) {
      const mockup = q("[data-p23m-mockup]");
      if (!mockup) return;
      const scale = Number.isFinite(scaleOverride) ? scaleOverride : effectiveMockupScale();
      mockup.style.transform = "translate3d(" + Number(state.mockupPanX || 0) + "px," + Number(state.mockupPanY || 0) + "px,0) scale(" + scale + ")";
    }

    function updateZoomLabelOnly(value) {
      const numeric = clamp(Number(value || 100) || 100, 100, 700);
      const rounded = Math.round(numeric);
      const progress = clamp((numeric - 100) / 600, 0, 1);
      const label = q("[data-p23m-zoom-value]");

      if (label) label.textContent = rounded + "%";

      const mockup = q("[data-p23m-mockup]");
      if (mockup) mockup.style.setProperty("--p23m-zoom-scale", String(numeric / 100));

      const track = q("[data-p23m-zoom-track]");
      if (track) {
        track.style.setProperty("--p23m-zoom-progress", String(progress));
        track.setAttribute("aria-valuenow", String(rounded));
      }

      const reset = q("[data-p23m-zoom-reset]");
      const shell = q("[data-p23m-zoom-reset-shell]");
      if (reset || shell) {
        const shouldShow = rounded > 100;
        if (reset) {
          reset.hidden = !shouldShow;
          reset.classList.toggle("is-visible", shouldShow);
        }
        if (shell) {
          shell.hidden = !shouldShow;
          shell.classList.toggle("is-visible", shouldShow);
        }
      }
    }

    function clampMockupPan() {
      const stage = mockupStageElement();
      if (!stage) return;

      const scale = effectiveMockupScale();
      const scaledW = 380 * scale;
      const scaledH = 460 * scale;
      const stageW = Math.max(1, stage.clientWidth || 1);
      const stageH = Math.max(1, stage.clientHeight || 1);
      const visibleX = Math.min(110, scaledW * 0.35, stageW * 0.35);
      const visibleY = Math.min(110, scaledH * 0.35, stageH * 0.35);
      const maxX = Math.max(0, (scaledW + stageW) / 2 - visibleX);
      const maxY = Math.max(0, (scaledH + stageH) / 2 - visibleY);

      state.mockupPanX = clamp(Number(state.mockupPanX || 0), -maxX, maxX);
      state.mockupPanY = clamp(Number(state.mockupPanY || 0), -maxY, maxY);
    }

    function mockupStageElement() {
      const mockup = q("[data-p23m-mockup]");
      if (!mockup) return null;
      return mockup.closest(".p23m__stage") || mockup.parentElement || q("[data-p23m-canvas]");
    }

    function stageAvailableSize(stage) {
      if (!stage) return { w: 380, h: 460 };

      const style = window.getComputedStyle ? window.getComputedStyle(stage) : null;
      const px = (value) => Number.parseFloat(value || "0") || 0;
      const paddingX = style ? px(style.paddingLeft) + px(style.paddingRight) : 0;
      const paddingY = style ? px(style.paddingTop) + px(style.paddingBottom) : 0;

      return {
        w: Math.max(1, stage.clientWidth - paddingX),
        h: Math.max(1, stage.clientHeight - paddingY)
      };
    }

    function applyResponsiveMockupScale() {
      ensureCoordinateSpace();
      const mockup = q("[data-p23m-mockup]");
      if (!mockup) return;

      const stage = mockupStageElement();
      const available = stageAvailableSize(stage);

      /*
        Coordenadas internas base del editor.
        Importante: NO cambiamos estas medidas; solo escalamos visualmente
        el mockup entero para que prenda, área y capas mantengan proporción.
      */
      const baseW = 380;
      const baseH = 460;

      const fit = Math.min(1, available.w / baseW, available.h / baseH);
      state.mockupFitScale = Math.max(0.42, Number.isFinite(fit) ? fit : 1);

      mockup.style.setProperty("width", "380px", "important");
      mockup.style.setProperty("height", "460px", "important");
      mockup.style.setProperty("max-width", "none", "important");
      mockup.style.setProperty("max-height", "none", "important");
      mockup.style.setProperty("--p23m-fit-scale", String(state.mockupFitScale));
      mockup.style.setProperty("--p23m-zoom-scale", String((Number(state.zoom || 100) || 100) / 100));
      clampMockupPan();
      mockup.style.transform = "translate3d(" + state.mockupPanX + "px," + state.mockupPanY + "px,0) scale(" + effectiveMockupScale() + ")";
    }

    const scheduleResponsiveMockupScale = makeRafJob(() => {
      applyResponsiveMockupScale();
    });

    function renderProductImage() {
      const image = q("[data-p23m-product-image]");
      const fallback = q("[data-p23m-fallback-svg]");
      const canvas = q("[data-p23m-canvas]");
      if (!image || !fallback) return;

      const innerLabel = isInnerLabelPlacement();
      const mirror = !innerLabel && shouldMirrorMockup();
      const garmentBackground = activeGarmentBackground();

      root.classList.toggle("is-p23m-mirror-mockup", mirror);
      root.classList.toggle("is-p23m-inner-label-view", innerLabel);

      if (canvas) {
        canvas.style.setProperty("--p23m-inner-label-bg", garmentBackground);
      }

      image.style.transformOrigin = "50% 50%";
      fallback.style.transformOrigin = "50% 50%";
      image.style.transform = mirror ? "scaleX(-1)" : "";
      fallback.style.transform = mirror ? "scaleX(-1)" : "";
      image.style.background = innerLabel ? garmentBackground : "";
      image.style.objectFit = innerLabel ? "contain" : "";

      if (innerLabel) {
        image.src = safeAssetUrl("23dtf-inner-label-neck.png");
        image.alt = "Etiqueta interior";
        image.classList.remove("is-empty");
        fallback.classList.add("is-hidden");
        return;
      }

      const media = mediaForPlacement();
      if (media && media.src) {
        image.src = media.src;
        image.alt = media.alt || product.title || "";
        image.classList.remove("is-empty");
        fallback.classList.add("is-hidden");
      } else {
        image.removeAttribute("src");
        image.classList.add("is-empty");
        fallback.classList.remove("is-hidden");
      }
    }

    const TEXT_RAIL_PRESETS = [
      { label: "Texto simple", value: "Tu texto aquí", className: "is-basic" },
      { label: "Texto grande", value: "TU TEXTO\nAQUÍ", className: "is-bold" },
      { label: "Frase corta", value: "Crea lo que quieras", className: "is-blue" },
      { label: "Racing", value: "FULL\nSPEED", className: "is-red" },
      { label: "Equipo", value: "23\nCUSTOM TEAM", className: "is-team" },
      { label: "Streetwear", value: "NO\nRULES", className: "is-urban" }
    ];

    function textRailPresetButton(template) {
      return '<button type="button" class="p23m-text-preset ' + escapeHtml(template.className || "") + '" data-p23m-template="' + escapeHtml(template.value) + '">' +
        '<span>' + escapeHtml(template.label) + '</span>' +
        '<strong>' + escapeHtml(template.value) + '</strong>' +
      '</button>';
    }

    function renderTextRailPanel() {
      const panel = q('[data-p23m-panel="text"]');
      if (!panel) return;

      /*
        v4.11m-REV52:
        El rail lateral Texto queda solo para añadir textos rápidos. Las fuentes y combinaciones pasan al botón vertical Texto cuando hay una capa de texto seleccionada.
      */
      panel.innerHTML =
        '<button type="button" class="p23m__back" data-p23m-back-to-layers>‹ Ver todas las capas de diseño</button>' +
        '<div class="p23m-text-rail-clean">' +
          '<div class="p23m-text-rail-clean__head">' +
            '<h3>Añadir texto</h3>' +
            '<p>Elige una base rápida. Después selecciona el texto y pulsa <b>Texto</b> en la barra vertical para editar contenido, fuentes y combinaciones.</p>' +
          '</div>' +
          '<button type="button" class="p23m-text-add-primary" data-p23m-template="Tu texto aquí">+ Añadir texto básico</button>' +
          '<div class="p23m-text-rail-clean__section">' +
            '<h4>Plantillas rápidas de texto</h4>' +
            '<div class="p23m-text-presets-grid">' + TEXT_RAIL_PRESETS.map(textRailPresetButton).join("") + '</div>' +
          '</div>' +
        '</div>';
    }

    function renderPanels() {
      root.classList.toggle("is-p23m-tool-only", state.rail === "tool");
      qa("[data-p23m-rail]").forEach((button) => {
        /*
          v4.11m-REV17:
          En modo herramienta estamos editando una capa. Visualmente activamos
          "Capas" aunque internamente state.rail siga siendo "tool" para que
          renderControls() funcione.
        */
        const activeRail = state.rail === "tool" ? "layers" : state.rail;
        button.classList.toggle("is-active", button.dataset.p23mRail === activeRail);
      });

      qa("[data-p23m-panel]").forEach((panel) => {
        const active = state.rail !== "tool" && panel.dataset.p23mPanel === state.rail;
        panel.hidden = !active;
        panel.classList.toggle("is-active", active);
      });

      if (state.rail === "text") {
        renderTextRailPanel();
      }
    }

    function renderUploads() {
      const count = q("[data-p23m-upload-count]");
      if (count) count.textContent = state.uploads.length ? String(state.uploads.length) : "0";
    }

    function renderPlacements() {
      const box = q("[data-p23m-placements]");
      if (!box) return;

      box.innerHTML = PLACEMENTS.map((item) => {
        const isActive = item.id === state.placement;
        let activePrice = "";

        /*
          23DTF v1.0-pre9:
          El precio de una zona solo se muestra cuando la zona seleccionada
          contiene al menos una capa visible. Seleccionar una pestaña vacía
          ya no enseña un precio que todavía no se está cobrando.
        */
        const selectedZoneLayers = isActive && state.zone && state.layersByZone
          ? (state.layersByZone[state.zone] || [])
          : [];
        const selectedZoneHasDesign = selectedZoneLayers.some((layer) => layer && layer.visible !== false);

        if (isActive && selectedZoneHasDesign) {
          activePrice = item.price || "";
          if (item.priceByZone && state.zone) activePrice = item.priceByZone[state.zone] || activePrice;
        }
        return '<button type="button" data-p23m-placement="' + escapeHtml(item.id) + '" ' +
          (item.disabled ? "disabled " : "") +
          'class="' + (isActive ? "is-active" : "") + '">' +
          '<span class="p23m__placement-name">' + escapeHtml(item.label) + '</span>' +
          (activePrice ? '<small class="p23m__placement-price">' + escapeHtml(activePrice) + '</small>' : "") +
          "</button>";
      }).join("");
    }

    function subtoolLabel(rawLabel) {
      return String(rawLabel || "").replace(/^[^\wÁÉÍÓÚÜÑáéíóúüñ]+(?:\s+)?/, "").trim() || String(rawLabel || "");
    }

    function subtoolIconSvg(id) {
      const icons = {
        text: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5h14"/><path d="M12 5v14"/><path d="M9 19h6"/></svg>',
        color: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 4.5 6.5 10a5.5 5.5 0 1 0 11 0L12 4.5Z"/><path d="M12 18.2a2.8 2.8 0 0 0 2.8-2.8"/></svg>',
        font: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 6h14"/><path d="M12 6v12"/><path d="M9 18h6"/></svg>',
        transform: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 3H3v5"/><path d="M16 3h5v5"/><path d="M8 21H3v-5"/><path d="M16 21h5v-5"/><path d="M3 3l6 6"/><path d="M21 3l-6 6"/><path d="M3 21l6-6"/><path d="M21 21l-6-6"/></svg>',
        position: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3v18"/><path d="M3 12h18"/><path d="M8 7 12 3l4 4"/><path d="M8 17l4 4 4-4"/><path d="M7 8 3 12l4 4"/><path d="M17 8l4 4-4 4"/></svg>',
        crop: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 3v14h14"/><path d="M3 7h14v14"/><path d="M7 7h10v10"/></svg>',
        pattern: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 4h6v6H4z"/><path d="M14 4h6v6h-6z"/><path d="M4 14h6v6H4z"/><path d="M14 14h6v6h-6z"/></svg>',
        remove_bg: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 20 20 4"/><path d="M7 4h10a3 3 0 0 1 3 3v10"/><path d="M17 20H7a3 3 0 0 1-3-3V7"/><path d="M9 9h6v6H9z"/></svg>',
        outline: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 6h14"/><path d="M12 6v12"/><path d="M8 18h8"/><path d="M7 3h10a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Z"/></svg>',
        shadow: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 7h10"/><path d="M11 7v10"/><path d="M8 17h6"/><path d="M14 10h4v8H9v-3"/></svg>'
      };
      return icons[id] || '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="7"/></svg>';
    }

    function renderToolbar() {
      const box = q("[data-p23m-toolbar]");
      if (!box) return;

      const layer = activeLayer();

      if (!layer || !currentLayers().length) {
        box.innerHTML = "";
        box.hidden = true;
        box.classList.add("is-p23m-hidden");
        return;
      }

      box.hidden = false;
      box.classList.remove("is-p23m-hidden");

      const tools = layer.type === "text" ? TEXT_TOOLS : IMAGE_TOOLS;
      const active = layer.type === "text" ? (state.subtoolText || "text") : (state.subtoolImage || "transform");

      box.innerHTML = tools.map(([id, rawLabel]) => {
        const disabled = id === "remove_bg";
        const label = subtoolLabel(rawLabel);
        return '<button type="button" data-p23m-subtool="' + escapeHtml(id) + '" data-p23m-tooltip="' + escapeHtml(label) + '" aria-label="' + escapeHtml(label) + '" title="' + escapeHtml(label) + '" ' +
          (disabled ? "disabled " : "") +
          'class="' + (id === active ? "is-active" : "") + (disabled ? " is-disabled" : "") + '">' +
          '<span class="p23m__tool-icon">' + subtoolIconSvg(id) + '</span>' +
          '<span class="p23m__tool-label">' + escapeHtml(label) + '</span>' +
          "</button>";
      }).join("");
    }

    function updatePrintAreaLayerMask() {
      ensureCoordinateSpace();
      const layerStage = q("[data-p23m-layer-stage]");
      if (!layerStage) return;

      const zone = currentZone();
      const rect = zone && zone.rect ? zone.rect : { x: 0, y: 0, w: 380, h: 460 };

      const baseW = 380;
      const baseH = 460;
      const left = Math.max(0, Number(rect.x || 0));
      const top = Math.max(0, Number(rect.y || 0));
      const right = Math.max(0, baseW - (Number(rect.x || 0) + Number(rect.w || 0)));
      const bottom = Math.max(0, baseH - (Number(rect.y || 0) + Number(rect.h || 0)));

      layerStage.style.setProperty("--p23m-mask-top", top + "px");
      layerStage.style.setProperty("--p23m-mask-right", right + "px");
      layerStage.style.setProperty("--p23m-mask-bottom", bottom + "px");
      layerStage.style.setProperty("--p23m-mask-left", left + "px");
      layerStage.classList.add("is-p23m-print-mask-active");
    }

    function renderZone() {
      const zone = currentZone();
      const canvas = q("[data-p23m-canvas]");
      const safeHost = ensureCoordinateSpace() || canvas;
      let safe = q("[data-p23m-safe]");
      const pill = q("[data-p23m-zone-pill]");
      const label = q("[data-p23m-active-zone-label]");
      const menu = q("[data-p23m-zone-menu]");

      /*
        v4.10y:
        El área de impresión usa coordenadas internas del mockup 380x460.
        Por eso debe vivir dentro de [data-p23m-mockup], no dentro del canvas.
        Si se queda en canvas, al escalar responsive el mockup se desplaza visualmente.
      */
      if (!safe && safeHost) {
        safe = document.createElement("div");
        safe.dataset.p23mSafe = "true";
        safe.className = "p23m__safe";
        safeHost.appendChild(safe);
      } else if (safe && safeHost && safe.parentElement !== safeHost) {
        safeHost.appendChild(safe);
      }

      if (pill) pill.textContent = (zone.short || zone.label) + " ▾";
      if (label) label.textContent = zone.label;

      if (safe) {
        /*
          23DTF REV73:
          El área de impresión queda SIEMPRE visible. Antes solo aparecía durante
          interacción/calibración y eso hacía más difícil colocar el diseño con precisión.
        */
        const visible = true;
        safe.style.left = zone.rect.x + "px";
        safe.style.top = zone.rect.y + "px";
        safe.style.width = zone.rect.w + "px";
        safe.style.height = zone.rect.h + "px";
        safe.style.position = "absolute";
        safe.style.boxSizing = "border-box";
        safe.style.pointerEvents = "none";
        safe.style.transformOrigin = "50% 50%";
        safe.style.transform = "rotate(" + Number(zone.mapRotation || 0) + "deg)";
        safe.style.border = "1.5px dashed #ef4444";
        safe.style.background = "rgba(239, 68, 68, .035)";
        safe.style.boxShadow = "none";
        safe.style.opacity = "1";
        safe.style.zIndex = "45";
        safe.classList.add("is-p23m-visible");
      }

      if (menu) {
        menu.innerHTML = currentPlacement().zones.map((baseItem) => {
          const item = mappedZone(baseItem);
          return '<button type="button" data-p23m-zone="' + escapeHtml(item.id) + '" class="' + (item.id === state.zone ? "is-active" : "") + '">' +
          "<strong>" + escapeHtml(item.label) + "</strong><br><small>Área recomendada: " + escapeHtml(item.area) + "</small></button>";
        }).join("");
      }
    }

    function renderCanvasUploadButton() {
      ensureCoordinateSpace();
      const button = q("[data-p23m-canvas-upload]");
      if (!button) return;

      const zone = currentZone();
      /*
        v4.11m-REV21:
        El botón redondo de subir solo debe aparecer cuando la zona no tenga
        ninguna capa visible. Antes solo miraba imágenes, por eso seguía
        apareciendo cuando el cliente añadía texto.
      */
      const hasVisibleLayer = currentLayers().some((layer) => layer.visible);
      const isCropMode = state.subtoolImage === "crop";
      const shouldShow = !hasVisibleLayer && !isCropMode;

      button.hidden = !shouldShow;
      button.classList.toggle("is-visible", shouldShow);

      if (shouldShow && zone && zone.rect) {
        const size = Math.round(clamp(Math.min(zone.rect.w, zone.rect.h) * 0.78, 74, 204));
        button.style.left = (zone.rect.x + zone.rect.w / 2) + "px";
        button.style.top = (zone.rect.y + zone.rect.h / 2) + "px";
        button.style.setProperty("--p23m-drop-size", size + "px");
      }
    }

    function renderPrintAreaWarning() {
      let warning = q("[data-p23m-print-warning]");
      const canvas = q("[data-p23m-canvas]");
      const shouldShow = !!state.printAreaWarning;

      if (!canvas && !warning) return;

      if (!warning && canvas) {
        warning = document.createElement("div");
        warning.className = "p23m__print-warning";
        warning.dataset.p23mPrintWarning = "true";
        warning.textContent = "Parte de tu diseño para esta capa está fuera del área de impresión";
        canvas.appendChild(warning);
      }

      if (warning) {
        warning.hidden = !shouldShow;
        warning.classList.toggle("is-visible", shouldShow);
      }
    }

    function constrain(layer) {
      const zone = currentZone().rect;
      const maxW = Math.max(zone.w * 1.5, zone.w);
      const maxH = Math.max(zone.h * 1.5, zone.h);

      if (layer && layer.type === "image" && layer.aspectLocked !== false) {
        /*
          23DTF REV69G HOTFIX RESTORE:
          Antes se limitaban w y h por separado. Si el borrador se restauraba con
          una zona ya recalculada o un mapa distinto, una dimensión podía clampirse
          y la otra no, deformando la imagen. Para imágenes mantenemos proporción.
        */
        const ratio = Math.max(0.01, Number(layer.naturalAspectRatio || layer.aspectRatio || (Number(layer.h || 1) / Math.max(1, Number(layer.w || 1))) || 1));
        let nextW = Math.max(24, Number(layer.w || 50));
        let nextH = Math.max(24, Number(layer.h || nextW * ratio));

        if (nextW > maxW) {
          nextW = maxW;
          nextH = nextW * ratio;
        }
        if (nextH > maxH) {
          nextH = maxH;
          nextW = nextH / ratio;
        }
        if (nextW < 24) {
          nextW = 24;
          nextH = nextW * ratio;
        }
        if (nextH < 24) {
          nextH = 24;
          nextW = nextH / ratio;
        }

        layer.w = nextW;
        layer.h = nextH;
        layer.aspectRatio = ratio;
      } else {
        layer.w = clamp(Number(layer.w) || 50, 24, maxW);
        layer.h = clamp(Number(layer.h) || 50, 24, maxH);
      }

      if (!Number.isFinite(Number(layer.x))) layer.x = zone.x;
      if (!Number.isFinite(Number(layer.y))) layer.y = zone.y;
      clampLayerInsidePrintArea(layer);
    }

    function clampLayerInsidePrintArea(layer) {
      if (!layer) return;
      const zone = currentZone().rect;
      const zoneX = Number(zone.x || 0);
      const zoneY = Number(zone.y || 0);
      const zoneW = Math.max(1, Number(zone.w || 1));
      const zoneH = Math.max(1, Number(zone.h || 1));
      const layerW = Math.max(1, Number(layer.w || 1));
      const layerH = Math.max(1, Number(layer.h || 1));

      /*
        23DTF REV65:
        El diseño queda bloqueado dentro del área real de impresión.
        Motivo: en móvil se podía arrastrar la imagen fuera del bloque imprimible y
        parecía que se desplazaba el canvas/producto. Si el diseño es más grande
        que la zona, queda centrado para evitar saltos imposibles de sujetar.
      */
      if (layerW <= zoneW) {
        layer.x = clamp(Number(layer.x || 0), zoneX, zoneX + zoneW - layerW);
      } else {
        layer.x = zoneX + (zoneW - layerW) / 2;
      }

      if (layerH <= zoneH) {
        layer.y = clamp(Number(layer.y || 0), zoneY, zoneY + zoneH - layerH);
      } else {
        layer.y = zoneY + (zoneH - layerH) / 2;
      }
    }

    function currentLayerAspectRatio(layer) {
      const w = Number(layer && layer.w || 0);
      const h = Number(layer && layer.h || 0);
      return w > 0 && h > 0 ? h / w : 1;
    }

    function naturalLayerAspectRatio(layer) {
      if (!layer) return 1;
      const stored = Number(layer.naturalAspectRatio || 0);
      if (stored > 0) return stored;
      const uploadW = Number(layer.uploadWidth || 0);
      const uploadH = Number(layer.uploadHeight || 0);
      if (uploadW > 0 && uploadH > 0) return uploadH / uploadW;
      return currentLayerAspectRatio(layer);
    }

    function layerAspectRatio(layer) {
      if (!layer) return 1;
      const stored = Number(layer.aspectRatio || 0);
      return stored > 0 ? stored : currentLayerAspectRatio(layer);
    }

    function aspectLocked(layer) {
      /*
        v4.11i:
        Quitamos escala libre para cliente final.
        Las imágenes mantienen proporción siempre para proteger el resultado impreso.
      */
      return !!layer && layer.type === "image";
    }

    function layerSizeLimits() {
      const zone = currentZone().rect;
      return {
        minW: 24,
        minH: 24,
        maxW: Math.max(zone.w * 1.5, zone.w),
        maxH: Math.max(zone.h * 1.5, zone.h)
      };
    }

    function setLayerSize(layer, nextW, nextH, anchor) {
      if (!layer) return;
      const limits = layerSizeLimits();
      const baseX = Number(layer.x || 0);
      const baseY = Number(layer.y || 0);
      const baseW = Number(layer.w || 50);
      const baseH = Number(layer.h || 50);

      nextW = clamp(Number(nextW) || baseW, limits.minW, limits.maxW);
      nextH = clamp(Number(nextH) || baseH, limits.minH, limits.maxH);

      if (anchor === "center") {
        layer.x = baseX + (baseW - nextW) / 2;
        layer.y = baseY + (baseH - nextH) / 2;
      } else if (anchor === "west") {
        layer.x = baseX + (baseW - nextW);
      } else if (anchor === "north") {
        layer.y = baseY + (baseH - nextH);
      } else if (anchor === "north-west") {
        layer.x = baseX + (baseW - nextW);
        layer.y = baseY + (baseH - nextH);
      } else if (anchor === "north-east") {
        layer.y = baseY + (baseH - nextH);
      } else if (anchor === "south-west") {
        layer.x = baseX + (baseW - nextW);
      }

      layer.w = nextW;
      layer.h = nextH;
    }

    function resizeLayerFromControl(layer, key, value, delta) {
      if (!layer) return;

      const limits = layerSizeLimits();
      const currentW = Number(layer.w || 50);
      const currentH = Number(layer.h || 50);
      const raw = delta ? (Number(layer[key] || 0) + Number(value || 0)) : Number(value || 0);

      /*
        v4.11m-REV39:
        En texto, Anchura/Altura escalan de forma proporcional.
        No permitimos que el marco se deforme; solo se hace grande/pequeño.
      */
      if (layer.type === "text" && (key === "w" || key === "h")) {
        const baseFontSize = textLayerFontSize(layer);

        layer.manualTextResize = true;

        if (key === "w") {
          layer.textWrapWidth = clamp(Math.round(raw), 10, currentZone().rect.w * 1.2);
          fitTextLayerToRealBounds(layer);
        } else {
          const scale = clamp(Number(raw || currentH) / Math.max(1, currentH), 0.06, 8);
          layer.fontSize = clamp(Math.round(baseFontSize * scale), 2, 260);
          fitTextLayerToRealBounds(layer);
        }

        return;
      }

      let nextW = currentW;
      let nextH = currentH;
      const ratio = naturalLayerAspectRatio(layer) || layerAspectRatio(layer) || 1;

      /*
        v4.11j:
        Sin escala libre. Anchura y Altura SIEMPRE modifican el tamaño
        proporcionalmente y actualizan ambos campos.
      */
      layer.aspectLocked = true;
      layer.aspectRatio = ratio;

      if (key === "w") {
        nextW = clamp(Math.round(raw), limits.minW, limits.maxW);
        nextH = clamp(Math.round(nextW * ratio), limits.minH, limits.maxH);
        if (nextH >= limits.maxH) nextW = clamp(Math.round(nextH / ratio), limits.minW, limits.maxW);
      }

      if (key === "h") {
        nextH = clamp(Math.round(raw), limits.minH, limits.maxH);
        nextW = clamp(Math.round(nextH / ratio), limits.minW, limits.maxW);
        if (nextW >= limits.maxW) nextH = clamp(Math.round(nextW * ratio), limits.minH, limits.maxH);
      }

      setLayerSize(layer, nextW, nextH, "center");
    }

    function toggleLayerAspect(layer) {
      /*
        v4.11i:
        El modo libre queda desactivado. Si por caché o código antiguo se llama
        a este handler, no alternamos nada: mantenemos proporción vinculada.
      */
      if (!layer || layer.type !== "image") return;
      layer.aspectLocked = true;
      layer.aspectRatio = layerAspectRatio(layer);
      renderAll();
    }

    function resetLayerAspect(layer) {
      if (!layer || layer.type !== "image") return;

      const zone = currentZone().rect;

      /*
        v4.11m-REV34:
        Reset total limpio. No llama a clearVisualPattern ni a lógica antigua
        de pattern, porque eso podía recalcular tamaños y dejar la imagen apretada.
      */
      if (layer.originalSrc) layer.src = layer.originalSrc;
      if (layer.originalName) layer.name = layer.originalName;
      if (layer.originalUploadWidth) layer.uploadWidth = Number(layer.originalUploadWidth || 0);
      if (layer.originalUploadHeight) layer.uploadHeight = Number(layer.originalUploadHeight || 0);

      const ratio = Number(layer.originalNaturalAspectRatio || 0) || imageOriginalAspect(layer) || 1;
      let nextW = Number(layer.originalFitW || 0);
      let nextH = Number(layer.originalFitH || 0);

      if (!(nextW > 0 && nextH > 0)) {
        const maxW = Math.max(24, zone.w * 0.68);
        const maxH = Math.max(24, zone.h * 0.68);
        nextW = Math.min(120, maxW);
        nextH = nextW * ratio;

        if (nextH > maxH) {
          nextH = maxH;
          nextW = nextH / ratio;
        }
      }

      layer.aspectLocked = true;
      layer.aspectRatio = ratio || (nextH / nextW) || 1;
      layer.naturalAspectRatio = layer.aspectRatio;
      layer.w = clamp(Math.round(nextW), 24, Math.max(zone.w * 1.5, zone.w));
      layer.h = clamp(Math.round(nextH), 24, Math.max(zone.h * 1.5, zone.h));
      layer.x = zone.x + (zone.w - layer.w) / 2;
      layer.y = zone.y + (zone.h - layer.h) / 2;
      layer.r = Number(layer.originalR ?? currentZone().mapRotation ?? 0) || 0;
      layer.flipX = false;
      layer.flipY = false;
      layer.pattern = "none";
      layer.mirrorMode = false;
      layer.orientationMode = "";
      delete layer.cropDraft;
      delete layer.singlePatternW;
      delete layer.singlePatternH;

      state.printAreaWarning = false;
      renderAll();
    }

    function applyLayerPatternMode(layer, nextPattern) {
      if (!layer || layer.type !== "image") return;
      const limits = layerSizeLimits();
      const pattern = nextPattern === "none" ? "none" : "none";
      const wasDouble = layer.pattern === "none";
      const centerX = Number(layer.x || 0) + Number(layer.w || 0) / 2;

      if (pattern === "none" && !wasDouble) {
        layer.singlePatternW = Number(layer.w || 0);
        layer.singlePatternH = Number(layer.h || 0);
        const gap = Math.max(2, Math.round(Number(layer.w || 0) * 0.04));
        const nextW = clamp(Math.round(Number(layer.w || 0) * 2 + gap), limits.minW, limits.maxW);
        layer.w = nextW;
        layer.x = centerX - nextW / 2;
      }

      if (pattern === "none" && wasDouble) {
        const gap = Math.max(2, Math.round(Number(layer.w || 0) * 0.02));
        const restoredW = Number(layer.singlePatternW || 0) || Math.max(limits.minW, Math.round((Number(layer.w || 0) - gap) / 2));
        const restoredH = Number(layer.singlePatternH || 0) || Number(layer.h || 0);
        layer.w = clamp(Math.round(restoredW), limits.minW, limits.maxW);
        layer.h = clamp(Math.round(restoredH), limits.minH, limits.maxH);
        layer.x = centerX - layer.w / 2;
        delete layer.singlePatternW;
        delete layer.singlePatternH;
      }

      layer.pattern = pattern;
    }

    function clearVisualPattern(layer) {
      if (!layer || layer.type !== "image") return;
      applyLayerPatternMode(layer, "none");
      layer.mirrorMode = false;
    }

    function patternedImageMarkup(layer, sx, sy) {
      const src = escapeHtml(layer && layer.src || "");
      const alt = escapeHtml(layer && layer.name || "Diseño");
      const mirrorMode = !!(layer && layer.mirrorMode);

      /*
        v4.11m-REV34:
        Limpieza total: sin Normal, sin mosaicos, sin Diseño antiguo.
        Espejo solo refleja una única imagen.
      */
      if (layer && layer.pattern && layer.pattern !== "none") {
        layer.pattern = "none";
      }

      const renderSx = mirrorMode ? -1 : 1;
      return '<img draggable="false" src="' + src + '" alt="' + alt + '" style="transform:scale(' + renderSx + ',1);object-fit:fill;">' + cropOverlayMarkup(layer);
    }

    function layerShadow(layer) {
      const distance = Number(layer.shadowDistance || 0) * 12;
      if (!distance) return "none";
      return distance.toFixed(1) + "px " + distance.toFixed(1) + "px 0 " + (layer.shadowColor || "#000");
    }

    function textLayerFontSize(layer) {
      if (!layer || layer.type !== "text") return 42;
      const value = Number(layer.fontSize || 0);
      /*
        REV58:
        Permitimos texto pequeño, pero evitamos valores de 2px generados
        accidentalmente por autofit/resize que hacen desaparecer el texto.
      */
      return clamp(value > 0 ? value : 24, 5, 260);
    }

    function textLayerPrimaryFontFamily(layer) {
      const fontValue = layer && layer.font ? String(layer.font) : "";
      const first = fontValue.split(",")[0] || "";
      return first.trim().replace(/^['\"]+|['\"]+$/g, "");
    }

    function is23dtfFontLayer(layer) {
      return /^23DTF\s+/i.test(textLayerPrimaryFontFamily(layer));
    }

    function textLayerFontWeight(layer) {
      /*
        23DTF REV69S TEXT CANVAS FONT RENDER:
        Las @font-face locales del theme están declaradas como font-weight:400.
        Si el editor pide 900, el navegador sintetiza un falso bold que no
        siempre coincide con la rasterización SVG/canvas de exportación.
        Para fuentes 23DTF usamos 400 en editor, medición y exportación.
      */
      if (is23dtfFontLayer(layer)) return "400";
      return "900";
    }

    function textLayerBoxAspect(layer) {
      if (!layer || layer.type !== "text") return 1;
      const stored = Number(layer.textBoxAspect || 0);
      if (stored > 0) return stored;
      const w = Math.max(1, Number(layer.w || 1));
      const h = Math.max(1, Number(layer.h || 1));
      layer.textBoxAspect = h / w;
      return layer.textBoxAspect;
    }

    function syncTextFontSizeFromResize(layer, base, nextW, nextH, baseFontSize) {
      if (!layer || layer.type !== "text") return;

      const safeBaseW = Math.max(1, Number(base.w || layer.w || 1));
      const safeBaseH = Math.max(1, Number(base.h || layer.h || 1));
      const scaleX = Number(nextW || layer.w || safeBaseW) / safeBaseW;
      const scaleY = Number(nextH || layer.h || safeBaseH) / safeBaseH;

      /*
        v4.11m-REV39:
        Como el marco del texto mantiene proporción, usamos escala uniforme.
        Así el texto crece o reduce sin que el marco se deforme.
      */
      const scale = Math.max(scaleX, scaleY);
      layer.fontSize = clamp(Math.round(Number(baseFontSize || textLayerFontSize(layer)) * scale), 4, 220);
      layer.textBoxAspect = Math.max(1, Number(layer.h || 1)) / Math.max(1, Number(layer.w || 1));
    }

    function measureTextLayerRealMetrics(layer) {
      if (!layer || layer.type !== "text") return { w: 24, h: 24 };

      const fontSize = textLayerFontSize(layer);
      const probe = document.createElement("div");
      const stroke = Number(layer.outlineWeight || 0);
      const shadowExtra = Number(layer.shadowDistance || 0) > 0 ? 4 : 0;
      const safety = 3;

      probe.textContent = String(layer.text || "").replace(/\r/g, "") || "Texto";
      probe.style.position = "absolute";
      probe.style.left = "-99999px";
      probe.style.top = "-99999px";
      probe.style.visibility = "hidden";
      probe.style.pointerEvents = "none";
      probe.style.display = "inline-block";
      probe.style.width = layer.textWrapWidth ? Math.max(18, Number(layer.textWrapWidth || 0)) + "px" : "max-content";
      probe.style.maxWidth = layer.textWrapWidth ? Math.max(18, Number(layer.textWrapWidth || 0)) + "px" : "none";
      probe.style.height = "auto";
      probe.style.padding = "0";
      probe.style.margin = "0";
      probe.style.border = "0";
      probe.style.whiteSpace = layer.textWrapWidth ? "pre-wrap" : "pre";
      probe.style.overflowWrap = layer.textWrapWidth ? "break-word" : "normal";
      probe.style.textAlign = "center";
      probe.style.fontFamily = layer.font || "Georgia, serif";
      probe.style.fontSize = fontSize + "px";
      probe.style.fontWeight = textLayerFontWeight(layer);
      probe.style.fontSynthesis = "none";
      probe.style.lineHeight = ".9";
      probe.style.letterSpacing = "normal";
      probe.style.webkitTextStroke = stroke + "px " + (layer.outlineColor || "#000");
      probe.style.textShadow = layerShadow(layer);

      document.body.appendChild(probe);
      const rect = probe.getBoundingClientRect();
      probe.remove();

      const extra = Math.ceil((stroke * 2) + shadowExtra + safety);
      const maxW = Math.max(currentZone().rect.w * 1.5, currentZone().rect.w);
      const maxH = Math.max(currentZone().rect.h * 1.5, currentZone().rect.h);

      return {
        /*
          REV58:
          Bajamos el mínimo del marco medido para que texto pequeño no quede
          dentro de una caja visual exagerada.
        */
        w: clamp(Math.ceil(rect.width + extra), 10, maxW),
        h: clamp(Math.ceil(rect.height + extra), 10, maxH)
      };
    }

    function fitTextLayerToRealBounds(layer) {
      if (!layer || layer.type !== "text") return;

      const zone = currentZone().rect;
      const currentW = Math.max(6, Number(layer.w || 80));
      const currentH = Math.max(6, Number(layer.h || 30));
      const centerX = Number(layer.x || 0) + currentW / 2;
      const centerY = Number(layer.y || 0) + currentH / 2;

      const maxW = Math.max(18, zone.w * 0.98);
      const maxH = Math.max(18, zone.h * 0.98);
      let metrics = measureTextLayerRealMetrics(layer);
      let guard = 0;

      while ((metrics.w > maxW || metrics.h > maxH) && textLayerFontSize(layer) > 8 && guard < 180) {
        /*
          REV58:
          El autofit puede reducir para evitar que el texto se salga de zona,
          pero no debe hundir la fuente hasta valores invisibles. Si el cliente
          quiere texto muy pequeño, lo hará manualmente con las esquinas.
        */
        layer.fontSize = Math.max(8, textLayerFontSize(layer) - 1);
        metrics = measureTextLayerRealMetrics(layer);
        guard += 1;
      }

      layer.w = clamp(metrics.w, 10, maxW);
      layer.h = clamp(metrics.h, 10, maxH);
      layer.x = centerX - layer.w / 2;
      layer.y = centerY - layer.h / 2;
      layer.textBoxAspect = layer.h / Math.max(1, layer.w);
    }

    function estimateTextLayerMetrics(layer) {
      return measureTextLayerRealMetrics(layer);
    }

    function ensureTextLayerVisualBounds(layer) {
      fitTextLayerToRealBounds(layer);
    }

    function normalizeSpanishTextLayer(layer) {
      if (!layer || layer.type !== "text") return;
      const txt = String(layer.text || "").trim();
      if (!txt || txt === "Your" || txt === "YOUR" || txt === "YOUR TEXT HERE" || txt === "YOUR TEXT here" || txt === "Your Text Here") {
        layer.text = "Tu texto aquí";
      }
    }

    function layerTransform(layer) {
      const x = Number(layer && layer.x || 0);
      const y = Number(layer && layer.y || 0);
      const r = Number(layer && layer.r || 0);
      return "translate3d(" + x + "px," + y + "px,0) rotate(" + r + "deg)";
    }

    function applyLayerNodeStyle(layer) {
      if (!layer || !layer.id) return;
      let node = q('[data-p23m-layer="' + cssEscape(layer.id) + '"]');
      if (!node) {
        node = qa("[data-p23m-layer]").find((item) => item.dataset && item.dataset.p23mLayer === layer.id);
      }
      if (!node) return;

      /*
        23DTF REV77:
        Pintado directo de la capa viva. No reconstruimos el canvas; solo tocamos
        transform/size del nodo actual para que el diseño siga el dedo en tiempo real.
      */
      node.classList.add("is-live-transforming");
      node.style.left = "0px";
      node.style.top = "0px";
      node.style.width = Number(layer.w || 0) + "px";
      node.style.height = Number(layer.h || 0) + "px";
      node.style.transform = layerTransform(layer);
      node.style.willChange = "transform,width,height";
      node.style.backfaceVisibility = "hidden";
    }

    function makeRafJob(fn) {
      let raf = 0;
      let latestArgs = null;
      return function schedule() {
        latestArgs = arguments;
        if (raf) return;
        raf = window.requestAnimationFrame(() => {
          raf = 0;
          const args = latestArgs;
          latestArgs = null;
          fn.apply(null, args || []);
        });
      };
    }

    function renderLayers() {
      ensureCoordinateSpace();
      const stage = q("[data-p23m-layer-stage]");
      if (!stage) return;

      stage.innerHTML = "";

      currentLayers().filter((layer) => layer.visible).forEach((layer, layerIndex) => {
        constrain(layer);

        /*
          v4.11m-REV38:
          Antes de dibujar una capa de texto activa, garantizamos que la caja
          visual/marco envuelve todo el texto renderizado.
        */
        if (layer.type === "text") {
          normalizeSpanishTextLayer(layer);
          /*
            REV56:
            Durante drag/resize no recalculamos continuamente el marco desde
            métricas reales porque provoca saltos y sensación de que el marco
            "pelea" con el gesto. Al soltar, startResize/startDrag vuelve a
            renderizar y la capa queda estable.
          */
          if (!state.isInteractingLayer && !layer.preserveTextBox) {
            ensureTextLayerVisualBounds(layer);
          }
          constrain(layer);
        }

        const item = document.createElement("div");
        item.className = "p23m__layer-item" + (layer.id === state.activeLayerId ? " is-active" : "");
        item.dataset.p23mLayer = layer.id;
        /*
          23DTF REV73:
          Las capas se colocan con transform/translate3d en vez de left/top.
          Esto evita reflows durante drag/zoom y deja el movimiento mucho más suave.
        */
        item.style.left = "0px";
        item.style.top = "0px";
        item.style.width = layer.w + "px";
        item.style.height = layer.h + "px";
        item.style.transform = layerTransform(layer);
        item.style.willChange = "transform,width,height";
        item.style.backfaceVisibility = "hidden";

        /*
          v4.11m-REV25:
          z-index explícito por orden de capas. Evita que iOS pinte una imagen
          nueva detrás/invisible mientras solo queda visible la selección.
          El orden del array es el orden real del canvas: último = arriba.
        */
        item.style.zIndex = String((layerIndex + 1) * 10);
        item.style.visibility = "visible";
        item.style.opacity = "1";

        if (layer.type === "text") {
          /*
            REV60B:
            Durante drag/resize desactivamos contenteditable para evitar el cursor/caret azul.
          */
          const isCanvasEditing = !state.isInteractingLayer && state.canvasTextEditLayerId === layer.id && state.rail === "tool" && state.subtoolText === "text";
          item.classList.toggle("is-editing-text", !!isCanvasEditing);
          item.innerHTML =
            '<div class="p23m__layer-text" ' +
            (isCanvasEditing ? 'contenteditable="true" spellcheck="false" data-p23m-canvas-text-edit="' + escapeHtml(layer.id) + '" ' : '') +
            'style="color:' + escapeHtml(layer.color) +
            ";font-family:" + escapeHtml(layer.font) +
            ";font-size:" + textLayerFontSize(layer) + "px" +
            ";font-weight:" + textLayerFontWeight(layer) +
            ";font-synthesis:none" +
            ";transform:scale(" + (layer.flipX ? -1 : 1) + "," + (layer.flipY ? -1 : 1) + ")" +
            ";text-shadow:" + layerShadow(layer) +
            ";-webkit-text-stroke:" + Number(layer.outlineWeight || 0) + "px " + escapeHtml(layer.outlineColor || "#000") +
            ';">' + escapeHtml(layer.text || "Tu texto aquí") + "</div>";
        } else {
          const sx = 1;
          const sy = 1;
          const isCropMode = layer.id === state.activeLayerId && state.subtoolImage === "crop";
          if (isCropMode) ensureCropDraft(layer);
          item.classList.toggle("is-free-transform", layer.type === "image" && !aspectLocked(layer));
          item.classList.toggle("is-cropping", !!isCropMode);
          item.innerHTML = patternedImageMarkup(layer, sx, sy);
        }

        if (layer.id === state.activeLayerId) {
          const freeHandles = layer.type === "image" && !aspectLocked(layer) ?
            '<span class="p23m__handle n-edge" data-p23m-resize="n"></span>' +
            '<span class="p23m__handle e-edge" data-p23m-resize="e"></span>' +
            '<span class="p23m__handle s-edge" data-p23m-resize="s"></span>' +
            '<span class="p23m__handle w-edge" data-p23m-resize="w"></span>' :
            (layer.type === "text" ?
              '<span class="p23m__handle e-edge" data-p23m-resize="e" title="Ajustar ancho de texto"></span>' +
              '<span class="p23m__handle w-edge" data-p23m-resize="w" title="Ajustar ancho de texto"></span>' : "");

          const moveFrameLines = layer.type === "text" ?
            '<span class="p23m__move-frame move-top" data-p23m-move-frame title="Mover texto"></span>' +
            '<span class="p23m__move-frame move-right" data-p23m-move-frame title="Mover texto"></span>' +
            '<span class="p23m__move-frame move-bottom" data-p23m-move-frame title="Mover texto"></span>' +
            '<span class="p23m__move-frame move-left" data-p23m-move-frame title="Mover texto"></span>' : "";

          item.insertAdjacentHTML("beforeend",
            '<div class="p23m__selection">' +
            moveFrameLines +
            '<span class="p23m__handle nw" data-p23m-resize="nw"></span>' +
            '<span class="p23m__handle ne" data-p23m-resize="ne"></span>' +
            '<span class="p23m__handle sw" data-p23m-resize="sw"></span>' +
            '<span class="p23m__handle se" data-p23m-resize="se"></span>' +
            freeHandles +
            '<span class="p23m__rotate" data-p23m-rotate-layer title="Girar">↻</span>' +
            '<button type="button" class="p23m__delete" data-p23m-delete-layer>×</button>' +
            "</div>"
          );
        }

        stage.appendChild(item);
      });
    }

    function renderLiveLayerUpdate(layer) {
      if (layer) constrain(layer);
      renderLayers();
      updatePrintAreaLayerMask();
      renderLayerPanel();
      renderCanvasUploadButton();
      renderCropActions();
      calibratorRender();
      scheduleDraftSave();
    }

    function layerPrintedCm(layer) {
      const api = printMapApi();
      if (!api || typeof api.cmForLayer !== "function" || !layer) return null;
      return api.cmForLayer(currentZone(), { w: layer.w, h: layer.h });
    }

    function layerDpi(layer) {
      const api = printMapApi();
      const cm = layerPrintedCm(layer);
      if (!api || typeof api.dpiForLayer !== "function" || !layer || !cm) return null;
      return api.dpiForLayer({ width: layer.uploadWidth || 0, height: layer.uploadHeight || 0 }, cm);
    }

    function layerQualityText(layer) {
      const dpi = layerDpi(layer);
      if (dpi === null) return "";
      const api = printMapApi();
      const quality = api && typeof api.qualityForDpi === "function" ? api.qualityForDpi(dpi) : null;
      return " · " + (quality ? quality.label : "DPI") + " / " + dpi + "DPI";
    }

    function layerMeasuresText(layer) {
      const cm = layerPrintedCm(layer);
      if (!cm) return "Anchura: " + Math.round(layer.w) + " · Altura: " + Math.round(layer.h);
      return "Anchura: " + cm.w + " cm · Altura: " + cm.h + " cm" + layerQualityText(layer);
    }

    function displayLayerOrder() {
      return currentLayers().slice().reverse();
    }

    function reorderLayersByDisplay(dragId, targetId, position) {
      const layers = currentLayers();
      const dragged = layers.find((layer) => layer.id === dragId);
      if (!dragged) return false;

      let display = layers.slice().reverse().filter((layer) => layer.id !== dragId);
      const targetIndex = display.findIndex((layer) => layer.id === targetId);

      if (targetIndex < 0) return false;

      const insertIndex = position === "after" ? targetIndex + 1 : targetIndex;
      display.splice(insertIndex, 0, dragged);

      state.layersByZone[state.zone] = display.slice().reverse();
      state.activeLayerId = dragId;
      state.lastToolLayerId = dragId;
      focusLayerForEditing(dragged);
      return true;
    }

    function clearLayerDropState() {
      qa("[data-p23m-layer-card]").forEach((card) => {
        card.classList.remove("is-dragging", "is-drop-before", "is-drop-after");
      });
      root.classList.remove("is-p23m-layer-reordering");
    }

    function startLayerPanelReorder(card, event) {
      if (!card || event.type !== "pointerdown") return false;
      if (event.target.closest("[data-p23m-layer-action], [data-p23m-group-move-layer], [data-p23m-toggle-layer], [data-p23m-remove-layer], .p23m__layer-actions")) return false;

      const dragId = card.dataset.p23mLayerCard;
      const layer = currentLayers().find((item) => item.id === dragId);
      if (!layer) return false;

      const startX = Number(event.clientX || 0);
      const startY = Number(event.clientY || 0);
      const pointerId = event.pointerId;

      /*
        v4.11m-REV27:
        Más rápido que REV26, pero todavía con presión para no romper el scroll.
        En móvil no evitamos el scroll hasta que el drag queda activado.
      */
      /*
        REV60B:
        En móvil/tablet priorizamos el scroll de Capas.
        Reordenar sigue funcionando, pero exige presión más clara.
      */
      const pressDelay = event.pointerType === "mouse" ? 90 : 420;
      const scrollTolerance = event.pointerType === "mouse" ? 8 : 36;

      let activated = false;
      let cancelled = false;
      let targetId = dragId;
      let targetPosition = "before";
      let lastDropKey = "";
      let pressTimer = null;

      function resetCardMotion() {
        card.style.removeProperty("--p23m-layer-drag-y");
        card.style.removeProperty("z-index");
      }

      function clearDropMarkers() {
        qa("[data-p23m-layer-card]").forEach((node) => {
          node.classList.remove("is-drop-before", "is-drop-after", "is-drop-near");
        });
      }

      function resolveDrop(clientY) {
        const cards = qa("[data-p23m-layer-card]").filter((node) => node !== card);
        if (!cards.length) return { id: dragId, position: "before" };

        for (const node of cards) {
          const rect = node.getBoundingClientRect();
          const middle = rect.top + rect.height / 2;
          if (clientY < middle) {
            return { id: node.dataset.p23mLayerCard, position: "before", node };
          }
        }

        const last = cards[cards.length - 1];
        return { id: last.dataset.p23mLayerCard, position: "after", node: last };
      }

      function paintDropMarker(drop) {
        clearDropMarkers();
        if (!drop || !drop.node) return;

        drop.node.classList.add("is-drop-near");
        drop.node.classList.add(drop.position === "after" ? "is-drop-after" : "is-drop-before");
      }

      function activateDrag(activationEvent) {
        if (cancelled || activated) return;
        activated = true;

        state.activeLayerId = dragId;
        state.lastToolLayerId = dragId;
        state.mode = layer.type === "text" ? "text" : "image";
        state.rail = "layers";

        root.classList.add("is-p23m-layer-reordering");
        card.classList.add("is-dragging");
        card.style.setProperty("--p23m-layer-drag-y", "0px");
        card.style.zIndex = "80";

        try {
          if (card.setPointerCapture && pointerId !== undefined) card.setPointerCapture(pointerId);
        } catch (error) {}

        if (navigator.vibrate && event.pointerType !== "mouse") {
          try { navigator.vibrate(8); } catch (error) {}
        }

        const drop = resolveDrop(activationEvent ? activationEvent.clientY : startY);
        targetId = drop.id || dragId;
        targetPosition = drop.position || "before";
        lastDropKey = targetId + ":" + targetPosition;
        paintDropMarker(drop);
      }

      function cancelDrag() {
        cancelled = true;
        window.clearTimeout(pressTimer);
        clearDropMarkers();
        clearLayerDropState();
        resetCardMotion();

        try {
          if (card.releasePointerCapture && pointerId !== undefined) card.releasePointerCapture(pointerId);
        } catch (error) {}
      }

      pressTimer = window.setTimeout(() => activateDrag(event), pressDelay);

      let isPanelScrolling = false;
      let lastScrollY = startY;

      function panelScrollElement() {
        return card.closest(".p23m__panel") || q(".p23m__panel") || card.parentElement;
      }

      function scrollPanelBy(deltaY) {
        const panel = panelScrollElement();
        if (!panel) return;
        panel.scrollTop = panel.scrollTop + deltaY;
      }

      const move = (moveEvent) => {
        const dx = Number(moveEvent.clientX || 0) - startX;
        const dy = Number(moveEvent.clientY || 0) - startY;

        /*
          23DTF REV64:
          En Capas usamos scroll táctil manual antes de activar el reordenado.
          Motivo: las tarjetas necesitan permitir 3 gestos sobre el mismo sitio:
          1) deslizar verticalmente para recorrer todo el panel,
          2) tap/click para seleccionar la capa,
          3) mantener pulsado para reordenar.
          Con touch-action:none el navegador no hace scroll nativo; por eso movemos
          el panel nosotros hasta que la presión larga activa el drag.
        */
        if (!activated) {
          const absX = Math.abs(dx);
          const absY = Math.abs(dy);

          if (absY > 5 && absY >= absX) {
            isPanelScrolling = true;
            window.clearTimeout(pressTimer);

            const nextY = Number(moveEvent.clientY || 0);
            scrollPanelBy(lastScrollY - nextY);
            lastScrollY = nextY;

            state.layerPanelSuppressClickUntil = Date.now() + 450;
            moveEvent.preventDefault();
            moveEvent.stopPropagation();
            return;
          }

          if (Math.max(absX, absY) > scrollTolerance) {
            cancelDrag();
            window.removeEventListener("pointermove", move);
            window.removeEventListener("pointerup", up);
          }
          return;
        }

        moveEvent.preventDefault();
        moveEvent.stopPropagation();

        card.style.setProperty("--p23m-layer-drag-y", dy + "px");

        const drop = resolveDrop(moveEvent.clientY);
        targetId = drop.id || dragId;
        targetPosition = drop.position || "before";
        const key = targetId + ":" + targetPosition;

        if (key !== lastDropKey) {
          lastDropKey = key;
          paintDropMarker(drop);
          if (navigator.vibrate && event.pointerType !== "mouse") {
            try { navigator.vibrate(3); } catch (error) {}
          }
        }
      };

      const up = () => {
        window.clearTimeout(pressTimer);
        window.removeEventListener("pointermove", move);
        window.removeEventListener("pointerup", up);

        if (isPanelScrolling && !activated) {
          state.layerPanelSuppressClickUntil = Date.now() + 450;
        }

        if (activated && targetId) {
          reorderLayersByDisplay(dragId, targetId, targetPosition);
          renderLayers();
          renderLayerPanel();
          renderToolbar();
          renderControls();
          renderCanvasUploadButton();
        }

        clearDropMarkers();
        clearLayerDropState();
        resetCardMotion();

        try {
          if (card.releasePointerCapture && pointerId !== undefined) card.releasePointerCapture(pointerId);
        } catch (error) {}
      };

      window.addEventListener("pointermove", move, { passive: false });
      window.addEventListener("pointerup", up);

      return true;
    }

    function layerActionIcon(name) {
      const icons = {
        eye: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="3"/></svg>',
        eyeOff: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3l18 18"/><path d="M10.6 10.6A3 3 0 0 0 13.4 13.4"/><path d="M9.9 5.2A10.6 10.6 0 0 1 12 5c6 0 9.5 7 9.5 7a17.5 17.5 0 0 1-2.4 3.3"/><path d="M6.4 6.7C3.9 8.4 2.5 12 2.5 12s3.5 7 9.5 7a9.7 9.7 0 0 0 4-.8"/></svg>',
        link: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.1 0l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1"/><path d="M14 11a5 5 0 0 0-7.1 0l-2 2A5 5 0 0 0 12 20.1l1.1-1.1"/></svg>',
        trash: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M6 7l1 14h10l1-14"/><path d="M9 7V4h6v3"/></svg>'
      };
      return icons[name] || "";
    }

    function isLayerGroupMoving(layerId) {
      return Array.isArray(state.groupMoveLayerIds) && state.groupMoveLayerIds.includes(layerId);
    }

    function toggleLayerGroupMove(layerId) {
      if (!layerId) return;
      if (!Array.isArray(state.groupMoveLayerIds)) state.groupMoveLayerIds = [];

      if (state.groupMoveLayerIds.includes(layerId)) {
        state.groupMoveLayerIds = state.groupMoveLayerIds.filter((id) => id !== layerId);
      } else {
        state.groupMoveLayerIds = state.groupMoveLayerIds.concat(layerId);
      }
    }

    function groupMoveLayersFor(layer) {
      if (!layer || !isLayerGroupMoving(layer.id)) return [layer];

      const ids = new Set(state.groupMoveLayerIds || []);
      const layers = currentLayers().filter((item) => ids.has(item.id) && item.visible !== false);
      return layers.length > 1 ? layers : [layer];
    }

    function cleanupGroupMoveIds() {
      if (!Array.isArray(state.groupMoveLayerIds)) {
        state.groupMoveLayerIds = [];
        return;
      }

      const existing = new Set(currentLayers().map((layer) => layer.id));
      state.groupMoveLayerIds = state.groupMoveLayerIds.filter((id) => existing.has(id));
    }

    function exportPanelHtml() {
      const totalLayers = Object.values(state.layersByZone || {}).reduce((sum, list) => sum + (Array.isArray(list) ? list.filter((layer) => layer && layer.visible !== false).length : 0), 0);
      const disabled = totalLayers && !state.exportBusy ? "" : " disabled";
      const status = state.exportStatus ? '<small data-p23m-export-status>' + escapeHtml(state.exportStatus) + '</small>' : '<small data-p23m-export-status>Herramienta interna: genera el ZIP local o sube la misma estructura a Cloudflare R2 para pruebas. Este panel se ocultará antes de producción.</small>';
      return '<div class="p23m__export-panel">' +
        '<div><strong>Exportación interna v1.0-pre</strong>' + status + '</div>' +
        '<button type="button" data-p23m-export-project' + disabled + '>' + (state.exportBusy ? "Procesando…" : "Exportar ZIP") + '</button>' +
        '<button type="button" data-p23m-upload-cloudflare' + disabled + '>' + (state.exportBusy ? "Subiendo…" : "Subir prueba a Cloudflare") + '</button>' +
      '</div>';
    }

    function renderLayerPanel() {
      const box = q("[data-p23m-layers]");
      if (!box) return;

      const items = displayLayerOrder();
      if (!items.length) {
        box.innerHTML = imageGuardNoticeHtml() +
          '<div class="p23m__layers-empty">' +
            '<div class="p23m__layers-empty-illustration" aria-hidden="true">' +
              '<span class="p23m__layers-empty-card"></span>' +
              '<span class="p23m__layers-empty-brush"></span>' +
              '<span class="p23m__layers-empty-dots">•••</span>' +
            '</div>' +
            '<strong>Empieza a diseñar</strong>' +
            '<p>Las capas de tu diseño aparecerán aquí.</p>' +
          '</div>' +
          '<div class="p23m__draft-panel">' +
            '<span data-p23m-draft-status>' + (state.draftError ? escapeHtml(state.draftError) : (state.draftSavedAt ? "Borrador guardado" : "Autoguardado activo")) + '</span>' +
            '<button type="button" data-p23m-clear-draft>Limpiar borrador</button>' +
          '</div>' +
          exportPanelHtml();
        return;
      }

      cleanupGroupMoveIds();

      box.innerHTML = imageGuardNoticeHtml() + items.map((layer) => {
        const preview = layer.type === "image" ? '<img src="' + escapeHtml(layer.src) + '" alt="">' : "T";
        const isGrouped = isLayerGroupMoving(layer.id);
        return '<div class="p23m__layer ' + (layer.id === state.activeLayerId ? "is-active" : "") + (isGrouped ? " is-group-move" : "") + '" data-p23m-layer-card="' + escapeHtml(layer.id) + '">' +
          '<div class="p23m__layer-row">' +
          '<span class="p23m__layer-grip" data-p23m-layer-drag="' + escapeHtml(layer.id) + '" aria-hidden="true" title="Mantén pulsado para reordenar">⋮⋮</span>' +
          '<button type="button" class="p23m__layer-preview" data-p23m-select-layer="' + escapeHtml(layer.id) + '">' + preview + "</button>" +
          '<button type="button" class="p23m__layer-main" data-p23m-select-layer="' + escapeHtml(layer.id) + '">' +
          "<strong>" + (layer.type === "text" ? "Texto" : "Archivo") + "</strong><br>" +
          "<span>" + escapeHtml(layer.type === "text" ? layer.text : (layer.name || "Imagen subida")) + "</span>" +
          (layer.type === "image" ? "<small class=\"p23m__layer-measures\">" + escapeHtml(layerMeasuresText(layer)) + "</small>" : "") +
          "</button>" +
          '<div class="p23m__layer-actions">' +
          '<button type="button" class="p23m__layer-action-btn' + (isGrouped ? " is-active" : "") + '" data-p23m-layer-action="group" data-p23m-group-move-layer="' + escapeHtml(layer.id) + '" aria-label="' + (isGrouped ? "Quitar de movimiento conjunto" : "Anclar para mover con otras capas") + '" title="' + (isGrouped ? "Quitar de movimiento conjunto" : "Anclar para mover con otras capas") + '">' + layerActionIcon("link") + "</button>" +
          '<button type="button" class="p23m__layer-action-btn" data-p23m-layer-action="toggle" data-p23m-toggle-layer="' + escapeHtml(layer.id) + '" aria-label="' + (layer.visible ? "Ocultar capa" : "Mostrar capa") + '" title="' + (layer.visible ? "Ocultar capa" : "Mostrar capa") + '">' + layerActionIcon(layer.visible ? "eye" : "eyeOff") + "</button>" +
          '<button type="button" class="p23m__layer-action-btn is-danger" data-p23m-layer-action="remove" data-p23m-remove-layer="' + escapeHtml(layer.id) + '" aria-label="Eliminar capa" title="Eliminar capa">' + layerActionIcon("trash") + "</button>" +
          "</div></div></div>";
      }).join("") +
        '<div class="p23m__draft-panel">' +
          '<span data-p23m-draft-status>' + (state.draftError ? escapeHtml(state.draftError) : "Borrador guardado automático") + '</span>' +
          '<button type="button" data-p23m-clear-draft>Limpiar borrador</button>' +
        '</div>' +
        exportPanelHtml();
    }

    function ensureCropDraft(layer) {
      if (!layer || layer.type !== "image") return null;
      if (!layer.cropDraft || typeof layer.cropDraft !== "object") {
        layer.cropDraft = { left: 0, top: 0, right: 0, bottom: 0 };
      }

      ["left", "top", "right", "bottom"].forEach((key) => {
        const value = Number(layer.cropDraft[key] || 0);
        layer.cropDraft[key] = clamp(Number.isFinite(value) ? value : 0, 0, 45);
      });

      const maxSum = 92;
      if ((layer.cropDraft.left + layer.cropDraft.right) > maxSum) {
        layer.cropDraft.right = Math.max(0, maxSum - layer.cropDraft.left);
      }
      if ((layer.cropDraft.top + layer.cropDraft.bottom) > maxSum) {
        layer.cropDraft.bottom = Math.max(0, maxSum - layer.cropDraft.top);
      }

      return layer.cropDraft;
    }

    function cropFrameStyle(layer) {
      const crop = ensureCropDraft(layer) || { left: 0, top: 0, right: 0, bottom: 0 };
      return "left:" + Number(crop.left || 0) + "%;top:" + Number(crop.top || 0) + "%;right:" + Number(crop.right || 0) + "%;bottom:" + Number(crop.bottom || 0) + "%;";
    }

    function cropOverlayMarkup(layer) {
      if (!layer || layer.type !== "image" || layer.id !== state.activeLayerId || state.subtoolImage !== "crop") return "";
      ensureCropDraft(layer);

      return '' +
        '<div class="p23m__crop-frame-ui" data-p23m-crop-frame>' +
          '<div class="p23m__crop-box" style="' + cropFrameStyle(layer) + '" data-p23m-crop-box>' +
            '<span class="p23m__crop-grid"></span>' +
            '<span class="p23m__crop-handle crop-nw" data-p23m-crop-handle="nw" title="Recortar esquina superior izquierda"></span>' +
            '<span class="p23m__crop-handle crop-n" data-p23m-crop-handle="n" title="Recortar arriba"></span>' +
            '<span class="p23m__crop-handle crop-ne" data-p23m-crop-handle="ne" title="Recortar esquina superior derecha"></span>' +
            '<span class="p23m__crop-handle crop-e" data-p23m-crop-handle="e" title="Recortar derecha"></span>' +
            '<span class="p23m__crop-handle crop-se" data-p23m-crop-handle="se" title="Recortar esquina inferior derecha"></span>' +
            '<span class="p23m__crop-handle crop-s" data-p23m-crop-handle="s" title="Recortar abajo"></span>' +
            '<span class="p23m__crop-handle crop-sw" data-p23m-crop-handle="sw" title="Recortar esquina inferior izquierda"></span>' +
            '<span class="p23m__crop-handle crop-w" data-p23m-crop-handle="w" title="Recortar izquierda"></span>' +
          '</div>' +
        '</div>';
    }

    function syncCropControlUi(layer) {
      const crop = ensureCropDraft(layer);
      if (!crop) return;

      ["left", "right", "top", "bottom"].forEach((key) => {
        const value = Math.round(Number(crop[key] || 0));
        qa('[data-p23m-control="crop_' + key + '"]').forEach((input) => {
          if (document.activeElement !== input) input.value = String(value);
          const row = input.closest(".p23m-crop__row");
          const labelValue = row ? row.querySelector("[data-p23m-crop-value]") : null;
          if (labelValue) labelValue.textContent = value + "%";
        });
      });
    }

    function cropControls(layer) {
      const crop = ensureCropDraft(layer) || { left: 0, top: 0, right: 0, bottom: 0 };
      const row = (key, label) => (
        '<div class="p23m-crop__row">' +
          '<label>' + label + '<strong data-p23m-crop-value>' + Math.round(Number(crop[key] || 0)) + '%</strong></label>' +
          '<input type="range" min="0" max="45" step="1" value="' + Math.round(Number(crop[key] || 0)) + '" data-p23m-control="crop_' + key + '">' +
        '</div>'
      );

      return '<div class="p23m__control-title">Recortar</div>' +
        '<div class="p23m-crop">' +
          '<p class="p23m__hint">Arrastra el marco sobre la imagen o ajusta los márgenes. La zona clara se conservará; lo oscuro se eliminará al aplicar.</p>' +
          row("left", "Izquierda") +
          row("right", "Derecha") +
          row("top", "Arriba") +
          row("bottom", "Abajo") +
          '<p class="p23m__hint p23m-crop__footer-hint">Usa los botones Cancelar o Aplicar recorte que aparecen sobre el canvas.</p>' +
        '</div>';
    }

    function applyCropToImageLayer(layer) {
      if (!layer || layer.type !== "image") return;
      const crop = ensureCropDraft(layer);
      if (!crop) return;

      const leftPct = clamp(Number(crop.left || 0), 0, 45) / 100;
      const rightPct = clamp(Number(crop.right || 0), 0, 45) / 100;
      const topPct = clamp(Number(crop.top || 0), 0, 45) / 100;
      const bottomPct = clamp(Number(crop.bottom || 0), 0, 45) / 100;

      if ((leftPct + rightPct) >= .92 || (topPct + bottomPct) >= .92) return;

      const image = new Image();
      image.onload = () => {
        const naturalW = image.naturalWidth || image.width || Number(layer.uploadWidth || 0);
        const naturalH = image.naturalHeight || image.height || Number(layer.uploadHeight || 0);
        if (!naturalW || !naturalH) return;

        const sx = Math.round(naturalW * leftPct);
        const sy = Math.round(naturalH * topPct);
        const sw = Math.max(1, Math.round(naturalW * (1 - leftPct - rightPct)));
        const sh = Math.max(1, Math.round(naturalH * (1 - topPct - bottomPct)));

        /*
          23DTF REV65:
          El recorte ya no genera un PNG gigante en móviles.
          iOS/Chrome podía cerrar la pestaña al convertir una foto grande a dataURL.
          Conservamos proporción y transparencia, pero limitamos píxeles de salida.
        */
        const maxCropSide = 2200;
        const maxCropPixels = 4200000;
        const cropScale = Math.min(
          1,
          maxCropSide / Math.max(1, sw),
          maxCropSide / Math.max(1, sh),
          Math.sqrt(maxCropPixels / Math.max(1, sw * sh))
        );
        const outW = Math.max(1, Math.round(sw * cropScale));
        const outH = Math.max(1, Math.round(sh * cropScale));

        const cropCanvas = document.createElement("canvas");
        cropCanvas.width = outW;
        cropCanvas.height = outH;
        const ctx = cropCanvas.getContext("2d");
        if (!ctx) return;

        ctx.clearRect(0, 0, outW, outH);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(image, sx, sy, sw, sh, 0, 0, outW, outH);

        const nextAspect = sh / sw;
        const limits = layerSizeLimits();

        /*
          v4.11m-REV22:
          No mantenemos la caja completa porque eso estira visualmente el PNG
          recortado cuando cambia la proporción. La caja visual nueva debe ser
          exactamente el marco que el cliente eligió sobre el diseño.
          Esto conserva la escala real elegida antes del recorte y evita deformaciones.
        */
        const baseX = Number(layer.x || 0);
        const baseY = Number(layer.y || 0);
        const baseW = Number(layer.w || 80);
        const baseH = Number(layer.h || 80);

        const keptXPct = leftPct;
        const keptYPct = topPct;
        const keptWPct = Math.max(0.08, 1 - leftPct - rightPct);
        const keptHPct = Math.max(0.08, 1 - topPct - bottomPct);

        const cropBoxX = baseX + baseW * keptXPct;
        const cropBoxY = baseY + baseH * keptYPct;
        const cropBoxW = Math.max(limits.minW, baseW * keptWPct);
        const cropBoxH = Math.max(limits.minH, baseH * keptHPct);

        /*
          REV32:
          La caja final se ajusta a la proporción real del PNG recortado.
          Así no quedan espacios arriba/abajo ni laterales tras aplicar recorte.
        */
        let visualW = cropBoxW;
        let visualH = visualW * nextAspect;
        let visualX = cropBoxX;
        let visualY = cropBoxY + (cropBoxH - visualH) / 2;
        if (visualH > cropBoxH) {
          visualH = cropBoxH;
          visualW = visualH / nextAspect;
          visualX = cropBoxX + (cropBoxW - visualW) / 2;
          visualY = cropBoxY;
        }
        const nextVisualX = visualX;
        const nextVisualY = visualY;
        const nextVisualW = clamp(Math.round(visualW), limits.minW, limits.maxW);
        const nextVisualH = clamp(Math.round(visualH), limits.minH, limits.maxH);

        if (!layer.originalSrc) layer.originalSrc = layer.src;
        if (!layer.originalName) layer.originalName = layer.name;
        if (!layer.originalUploadWidth) layer.originalUploadWidth = Number(layer.uploadWidth || naturalW || 0);
        if (!layer.originalUploadHeight) layer.originalUploadHeight = Number(layer.uploadHeight || naturalH || 0);
        if (!layer.originalNaturalAspectRatio && layer.originalUploadWidth && layer.originalUploadHeight) {
          layer.originalNaturalAspectRatio = layer.originalUploadHeight / layer.originalUploadWidth;
        }

        clearVisualPattern(layer);

        let croppedDataUrl = "";
        try {
          croppedDataUrl = cropCanvas.toDataURL("image/png");
        } catch (error) {
          console.warn("[23DTF] Error al generar el PNG recortado", error);
          window.alert("No se pudo aplicar el recorte en este dispositivo. Prueba con una imagen menos pesada o vuelve a subirla como PNG/JPG optimizado.");
          return;
        }

        layer.src = croppedDataUrl;
        layer.appliedCrop = {
          left: Math.round(leftPct * 100),
          top: Math.round(topPct * 100),
          right: Math.round(rightPct * 100),
          bottom: Math.round(bottomPct * 100),
          sourceWidth: naturalW,
          sourceHeight: naturalH,
          outputWidth: outW,
          outputHeight: outH
        };
        layer.name = String(layer.name || "Imagen").replace(/\s·\srecortada$/i, "") + " · recortada";
        layer.uploadWidth = outW;
        layer.uploadHeight = outH;
        layer.naturalAspectRatio = nextAspect;
        layer.aspectRatio = nextAspect;
        layer.aspectLocked = true;
        layer.pattern = "none";
        layer.mirrorMode = false;
        layer.orientationMode = "";
        layer.x = nextVisualX;
        layer.y = nextVisualY;
        layer.w = nextVisualW;
        layer.h = nextVisualH;
        clampLayerInsidePrintArea(layer);
        delete layer.cropDraft;

        state.cropBefore = null;
        state.mode = "image";
        state.subtoolImage = "transform";
        state.rail = "tool";

        renderLayers();
        renderLayerPanel();
        renderControls();
        renderAll();
      };

      image.onerror = () => {
        window.alert("No se pudo recortar esta imagen. Prueba a subirla de nuevo como PNG o JPG.");
      };

      image.src = layer.src;
    }

    function startCropFrame(layer, handle, event) {
      if (!layer || layer.type !== "image") return;
      event.preventDefault();
      event.stopPropagation();

      const layerEl = event.target.closest("[data-p23m-layer]");
      if (!layerEl) return;

      const rect = layerEl.getBoundingClientRect();
      const startCrop = Object.assign({ left: 0, top: 0, right: 0, bottom: 0 }, ensureCropDraft(layer));
      const minVisible = 8;

      const pctX = (clientX) => clamp(((clientX - rect.left) / Math.max(1, rect.width)) * 100, 0, 100);
      const pctY = (clientY) => clamp(((clientY - rect.top) / Math.max(1, rect.height)) * 100, 0, 100);

      const updateLiveCropBox = makeRafJob(() => {
        const cropBox = layerEl.querySelector("[data-p23m-crop-box]");
        if (cropBox) cropBox.setAttribute("style", cropFrameStyle(layer));
        renderCropActions();
      });

      const move = (moveEvent) => {
        moveEvent.preventDefault();
        moveEvent.stopPropagation();

        const next = Object.assign({}, startCrop);

        if (handle.includes("w")) {
          next.left = clamp(pctX(moveEvent.clientX), 0, 100 - next.right - minVisible);
        }
        if (handle.includes("e")) {
          next.right = clamp(100 - pctX(moveEvent.clientX), 0, 100 - next.left - minVisible);
        }
        if (handle.includes("n")) {
          next.top = clamp(pctY(moveEvent.clientY), 0, 100 - next.bottom - minVisible);
        }
        if (handle.includes("s")) {
          next.bottom = clamp(100 - pctY(moveEvent.clientY), 0, 100 - next.top - minVisible);
        }

        layer.cropDraft = {
          left: Math.round(next.left),
          top: Math.round(next.top),
          right: Math.round(next.right),
          bottom: Math.round(next.bottom)
        };

        /*
          23DTF REV65:
          No reconstruimos todo el canvas en cada milímetro de recorte.
          En móvil eso podía saturar la pestaña y terminar en “No se puede abrir esta página”.
        */
        updateLiveCropBox();
        syncCropControlUi(layer);
      };

      bindPointer(move, () => {
        renderLayers();
        renderControls();
        renderCropActions();
      });
    }

    function svgIcon(name) {
      const icons = {
        centerV: '<svg viewBox="0 0 24 24"><path d="M4 12h16"/><path d="M8 7l4-4 4 4"/><path d="M8 17l4 4 4-4"/><path d="M12 3v18"/></svg>',
        centerH: '<svg viewBox="0 0 24 24"><path d="M12 4v16"/><path d="M7 8 3 12l4 4"/><path d="M17 8l4 4-4 4"/><path d="M3 12h18"/></svg>',
        left: '<svg viewBox="0 0 24 24"><path d="M5 4v16"/><path d="M19 12H8"/><path d="M12 8l-4 4 4 4"/></svg>',
        right: '<svg viewBox="0 0 24 24"><path d="M19 4v16"/><path d="M5 12h11"/><path d="M12 8l4 4-4 4"/></svg>',
        top: '<svg viewBox="0 0 24 24"><path d="M4 5h16"/><path d="M12 19V8"/><path d="M8 12l4-4 4 4"/></svg>',
        bottom: '<svg viewBox="0 0 24 24"><path d="M4 19h16"/><path d="M12 5v11"/><path d="M8 12l4 4 4-4"/></svg>',
        none: '<svg viewBox="0 0 24 24"><path d="M5 19 19 5"/><path d="M7 7h10v10H7z"/></svg>',
        repeat: '<svg viewBox="0 0 24 24"><path d="M4 4h6v6H4z"/><path d="M14 4h6v6h-6z"/><path d="M4 14h6v6H4z"/><path d="M14 14h6v6h-6z"/></svg>',
        repeatX: '<svg viewBox="0 0 24 24"><path d="M3 8h5v8H3z"/><path d="M10 8h5v8h-5z"/><path d="M17 8h4v8h-4z"/></svg>',
        repeatY: '<svg viewBox="0 0 24 24"><path d="M8 3h8v5H8z"/><path d="M8 10h8v5H8z"/><path d="M8 17h8v4H8z"/></svg>',
        mirror: '<svg viewBox="0 0 24 24"><path d="M12 4v16"/><path d="M4 7l6 5-6 5z"/><path d="M20 7l-6 5 6 5z"/></svg>',
        flipHorizontal: '<svg viewBox="0 0 24 24"><path d="M12 4v16"/><path d="M4 7l6 5v-5z"/><path d="M20 7l-6 5v-5z"/><path d="M4 17l6-5v5z"/><path d="M20 17l-6-5v5z"/></svg>',
        flipVertical: '<svg viewBox="0 0 24 24"><path d="M4 12h16"/><path d="M7 4l5 6H7z"/><path d="M17 4l-5 6h5z"/><path d="M7 20l5-6H7z"/><path d="M17 20l-5-6h5z"/></svg>'
      };
      return icons[name] || icons.none;
    }

    function patternControls() {
      const layer = activeLayer();
      const activePattern = (layer && layer.pattern) || "none";
      const buttons = [
        ["none", "Sin patrón", "none"],
        ["repeat", "Repetir", "repeat"],
        ["repeat-x", "Horizontal", "repeatX"],
        ["repeat-y", "Vertical", "repeatY"],
        ["mirror", "Espejo", "mirror"]
      ];

      return '<div class="p23m__control-title">Diseño</div>' +
        '<div class="p23m-pattern-tools">' +
          '<div class="p23m-pattern-tools__grid">' +
            buttons.map((item) => '<button type="button" class="p23m-icon-btn' + (activePattern === item[0] ? ' is-active' : '') + '" data-p23m-pattern="' + item[0] + '" title="' + item[1] + '" aria-label="' + item[1] + '"><span>' + svgIcon(item[2]) + '</span><small>' + item[1] + '</small></button>').join("") +
          '</div>' +
        '</div>';
    }

    function imageOriginalAspect(layer) {
      if (!layer || layer.type !== "image") return 1;
      const w = Number(layer.originalUploadWidth || layer.uploadWidth || 0);
      const h = Number(layer.originalUploadHeight || layer.uploadHeight || 0);
      if (w > 0 && h > 0) return h / w;
      return Number(layer.originalNaturalAspectRatio || layer.naturalAspectRatio || layer.aspectRatio || 1) || 1;
    }

    function applyImageFormat(layer, format) {
      if (!layer || layer.type !== "image") return;

      const baseRotation = Number(layer.originalR ?? currentZone().mapRotation ?? 0) || 0;
      const aspect = imageOriginalAspect(layer);
      const originalIsPortrait = aspect >= 1;

      /*
        v4.11m-REV34:
        Formato horizontal/vertical NO intercambia w/h.
        El intercambio de caja era lo que aplastaba la imagen.
        Ahora cambiamos la orientación mediante rotación de capa completa,
        por lo que el marco y el diseño giran juntos sin deformarse.
      */
      if (format === "horizontal") {
        layer.r = originalIsPortrait ? baseRotation - 90 : baseRotation;
        layer.orientationMode = "horizontal";
      } else if (format === "vertical") {
        layer.r = originalIsPortrait ? baseRotation : baseRotation + 90;
        layer.orientationMode = "vertical";
      } else {
        layer.r = baseRotation;
        layer.orientationMode = "";
      }

      layer.flipX = false;
      layer.flipY = false;
      layer.pattern = "none";
    }

    function textTransformExtraControls(layer) {
      return '<div class="p23m__control-row p23m-transform-flip-row p23m-transform-actions-row">' +
        '<label>Orientación y espejo</label>' +
        '<div class="p23m-transform-flip-grid p23m-transform-actions-grid">' +
          '<button type="button" class="p23m-icon-btn" data-p23m-text-format="normal" title="Normal" aria-label="Normal"><span>' + svgIcon("none") + '</span><small>Normal</small></button>' +
          '<button type="button" class="p23m-icon-btn" data-p23m-text-format="horizontal" title="Horizontal" aria-label="Horizontal"><span>' + svgIcon("flipHorizontal") + '</span><small>Horizontal</small></button>' +
          '<button type="button" class="p23m-icon-btn" data-p23m-text-format="vertical" title="Vertical" aria-label="Vertical"><span>' + svgIcon("flipVertical") + '</span><small>Vertical</small></button>' +
          '<button type="button" class="p23m-icon-btn p23m-flip-pattern-btn" data-p23m-text-mirror="toggle" title="Espejo" aria-label="Espejo"><span>' + svgIcon("mirror") + '</span><small>Espejo</small></button>' +
        '</div>' +
      '</div>';
    }

    function resetTextLayer(layer) {
      if (!layer || layer.type !== "text") return;

      const zone = currentZone().rect;
      const fitW = Number(layer.originalFitW || 0) || Math.min(110, zone.w * 0.58);
      const fitH = Number(layer.originalFitH || 0) || 42;

      layer.text = layer.originalText || "Tu texto aquí";
      layer.font = layer.originalFont || "\"23DTF Georgia\", Georgia, serif";
      layer.color = layer.originalColor || "#d94233";
      layer.fontSize = Number(layer.originalFontSize || 28);
      layer.w = fitW;
      layer.h = fitH;
      layer.x = Number(layer.originalX || (zone.x + (zone.w - fitW) / 2));
      layer.y = Number(layer.originalY || (zone.y + (zone.h - fitH) / 2));
      layer.r = Number(layer.originalR || 0);
      layer.flipX = !!layer.originalFlipX;
      layer.flipY = !!layer.originalFlipY;
      layer.textWrapWidth = null;
      layer.manualTextResize = false;
      layer.outlineColor = layer.originalOutlineColor || "#111111";
      layer.outlineWeight = Number(layer.originalOutlineWeight || 0);
      layer.shadowColor = layer.originalShadowColor || "#111111";
      layer.shadowDistance = Number(layer.originalShadowDistance || 0);
      layer.preserveTextBox = false;

      fitTextLayerToRealBounds(layer);
      state.printAreaWarning = false;
      renderAll();
    }

    function imageTransformExtraControls(layer) {
      /*
        v4.11m-REV35:
        Estos botones son acciones directas. Ejecutan el cambio al pulsar,
        pero no quedan visualmente seleccionados. Así evitamos confusión:
        el único estado persistente visible queda en la herramienta activa
        de la barra vertical del canvas.
      */
      return '<div class="p23m__control-row p23m-transform-flip-row p23m-transform-actions-row">' +
        '<label>Orientación y espejo</label>' +
        '<div class="p23m-transform-flip-grid p23m-transform-actions-grid">' +
          '<button type="button" class="p23m-icon-btn" data-p23m-format="vertical" title="Formato vertical" aria-label="Formato vertical"><span>' + svgIcon("flipVertical") + '</span><small>Formato vertical</small></button>' +
          '<button type="button" class="p23m-icon-btn" data-p23m-format="horizontal" title="Formato horizontal" aria-label="Formato horizontal"><span>' + svgIcon("flipHorizontal") + '</span><small>Formato horizontal</small></button>' +
          '<button type="button" class="p23m-icon-btn p23m-flip-pattern-btn" data-p23m-mirror-mode="toggle" title="Espejo" aria-label="Espejo"><span>' + svgIcon("mirror") + '</span><small>Espejo</small></button>' +
          '<button type="button" class="p23m-icon-btn p23m-flip-pattern-btn" data-p23m-format="normal" title="Normal" aria-label="Normal"><span>' + svgIcon("none") + '</span><small>Normal</small></button>' +
        '</div>' +
      '</div>';
    }

    function fontLibraryLabel(value) {
      const font = FONT_LIBRARY.find((item) => item.value === value || item.name === value);
      return font ? font.name : "Fuente personalizada";
    }

    function filteredFontLibrary() {
      const query = normalise(state.fontSearch || "");
      return FONT_LIBRARY.filter((font) => {
        const matchesTab = state.fontTab === "popular" ? !!font.popular : true;
        const matchesQuery = !query || normalise(font.name).includes(query) || normalise(font.category).includes(query);
        return matchesTab && matchesQuery;
      });
    }

    function fontPreviewMarkup(font, active) {
      return '<button type="button" class="p23m-font-row' + (active ? " is-active" : "") + '" data-p23m-font="' + escapeHtml(font.value) + '" title="' + escapeHtml(font.name) + '">' +
        '<span class="p23m-font-row__favorite" aria-hidden="true">♡</span>' +
        '<span class="p23m-font-row__body">' +
          '<strong style="font-family:' + escapeHtml(font.value) + '">' + escapeHtml(font.name) + '</strong>' +
          '<small>' + escapeHtml(font.category) + '</small>' +
        '</span>' +
        '<span class="p23m-font-row__check">' + (active ? "✓" : "") + '</span>' +
      '</button>';
    }

    function fontCombinationPreview(combo) {
      return combo.preview.map((line) => {
        return '<span style="font-family:' + escapeHtml(line.font) + ';color:' + escapeHtml(line.color) + ';font-size:' + Number(line.size || 14) + 'px;-webkit-text-stroke:' + (line.stroke ? "1px #111" : "0") + '">' + escapeHtml(line.text) + '</span>';
      }).join("");
    }

    function fontCombinationButton(combo) {
      return '<button type="button" class="p23m-font-combo" data-p23m-font-combo="' + escapeHtml(combo.id) + '" title="' + escapeHtml(combo.name) + '">' +
        '<span class="p23m-font-combo__preview">' + fontCombinationPreview(combo) + '</span>' +
        '<strong>' + escapeHtml(combo.name) + '</strong>' +
        '<small>' + escapeHtml(combo.subtitle || "Editable") + '</small>' +
      '</button>';
    }

    function fontControls(layer) {
      const currentFont = String(layer.font || "");
      const used = FONT_LIBRARY.filter((font) => font.value === currentFont);
      const visible = filteredFontLibrary();

      const usedMarkup = used.length ?
        '<div class="p23m-font-section"><div class="p23m-font-section__title">Utilizadas en el diseño</div>' +
        used.map((font) => fontPreviewMarkup(font, true)).join("") + '</div>' : "";

      return '<div class="p23m-font-panel p23m-font-panel--embedded">' +
          '<div class="p23m-font-search-row">' +
            '<input type="search" value="' + escapeHtml(state.fontSearch || "") + '" placeholder="Buscar fuente" data-p23m-font-search>' +
            '<button type="button" data-p23m-font-tab="all" class="' + (state.fontTab === "all" ? "is-active" : "") + '">Todas</button>' +
            '<button type="button" data-p23m-font-tab="popular" class="' + (state.fontTab === "popular" ? "is-active" : "") + '">Populares</button>' +
          '</div>' +
          usedMarkup +
          '<div class="p23m-font-section">' +
            '<div class="p23m-font-section__title">Todas las fuentes <small>' + visible.length + '</small></div>' +
            '<div class="p23m-font-list">' + visible.map((font) => fontPreviewMarkup(font, font.value === currentFont)).join("") + '</div>' +
          '</div>' +
          '<div class="p23m-font-combos">' +
            '<div class="p23m-font-section__title">Combinaciones de fuente <small>' + FONT_COMBINATIONS.length + '</small></div>' +
            '<div class="p23m-font-combos__grid">' + FONT_COMBINATIONS.map(fontCombinationButton).join("") + '</div>' +
          '</div>' +
        '</div>';
    }

    function combinationLineFont(line, recipe) {
      return line.font || recipe.font || "'Anton', Impact, Arial Black, sans-serif";
    }

    function combinationLineColor(line, recipe) {
      return line.color || recipe.color || "#111111";
    }

    function combinationLineSize(line, recipe, maxPreviewSize) {
      const baseSize = Number(recipe.fontSize || 34);
      const previewSize = Number(line.size || maxPreviewSize || 18);
      const maxSize = Math.max(1, Number(maxPreviewSize || previewSize));
      return clamp(Math.round((previewSize / maxSize) * baseSize), 8, 92);
    }

    function createTextLayerFromCombinationLine(line, recipe, centerX, centerY, fontSize) {
      const newLayer = makeTextLayer(line.text || recipe.text || "Tu texto aquí");
      newLayer.font = combinationLineFont(line, recipe);
      newLayer.color = combinationLineColor(line, recipe);
      newLayer.fontSize = fontSize;
      newLayer.originalFontSize = fontSize;
      /*
        REV56:
        Las combinaciones son una base visual de fuentes, no deben entrar con
        contorno/sombra/rotación por defecto. El cliente lo activa después
        desde Contorno, Sombreado o Transformar.
      */
      newLayer.outlineColor = line.outlineColor || recipe.outlineColor || "#111111";
      newLayer.outlineWeight = 0;
      newLayer.shadowColor = recipe.shadowColor || "#111111";
      newLayer.shadowDistance = 0;
      newLayer.r = 0;
      newLayer.manualTextResize = true;
      newLayer.textWrapWidth = null;
      newLayer.x = centerX - Number(newLayer.w || 80) / 2;
      newLayer.y = centerY - Number(newLayer.h || 30) / 2;
      fitTextLayerToRealBounds(newLayer);
      return newLayer;
    }

    function applyFontCombination(layer, comboId) {
      if (!layer || layer.type !== "text") return;
      const combo = FONT_COMBINATIONS.find((item) => item.id === comboId);
      if (!combo) return;

      const recipe = combo.apply || {};
      const sourceLines = Array.isArray(combo.layers) && combo.layers.length ? combo.layers : (combo.preview || []);

      /*
        v4.11m-REV54:
        Si la combinación tiene varias líneas, ya no intentamos meterlo todo
        en una sola capa. Creamos varias capas reales de texto, cada una con
        su fuente/color/tamaño, y las dejamos ancladas para moverlas juntas.
      */
      if (sourceLines.length > 1) {
        const layers = currentLayers();
        const oldIndex = Math.max(0, layers.findIndex((item) => item.id === layer.id));
        const centerX = Number(layer.x || 0) + Number(layer.w || 80) / 2;
        const centerY = Number(layer.y || 0) + Number(layer.h || 60) / 2;
        const maxPreviewSize = Math.max.apply(null, sourceLines.map((line) => Number(line.size || 1)));

        const newLayers = sourceLines.map((line) => {
          const fontSize = combinationLineSize(line, recipe, maxPreviewSize);
          return createTextLayerFromCombinationLine(line, recipe, centerX, centerY, fontSize);
        });

        const gap = Math.max(0, Math.round(Number(recipe.groupGap || 1)));
        const totalH = newLayers.reduce((sum, item) => sum + Number(item.h || 0), 0) + gap * Math.max(0, newLayers.length - 1);
        let cursorY = centerY - totalH / 2;

        newLayers.forEach((item) => {
          item.x = centerX - Number(item.w || 0) / 2;
          item.y = cursorY;
          item.originalX = item.x;
          item.originalY = item.y;
          item.originalFitW = item.w;
          item.originalFitH = item.h;
          item.originalR = 0;
          item.originalText = item.text;
          item.originalFont = item.font;
          item.originalColor = item.color;
          item.originalFontSize = item.fontSize;
          item.originalOutlineColor = item.outlineColor;
          item.originalOutlineWeight = item.outlineWeight;
          item.originalShadowColor = item.shadowColor;
          item.originalShadowDistance = item.shadowDistance;
          item.originalFlipX = false;
          item.originalFlipY = false;
          item.preserveTextBox = true;
          cursorY += Number(item.h || 0) + gap;
        });

        if (oldIndex >= 0) {
          layers.splice(oldIndex, 1, ...newLayers);
        } else {
          layers.push(...newLayers);
        }

        state.groupMoveLayerIds = newLayers.map((item) => item.id);
        state.activeLayerId = newLayers[newLayers.length - 1].id;
        state.lastToolLayerId = state.activeLayerId;
        state.mode = "text";
        state.rail = "layers";
        state.subtoolText = "text";
        state.canvasTextEditLayerId = null;
        state.focusTextEditor = false;
        cleanupGroupMoveIds();
        return;
      }

      const singleLine = sourceLines[0] || {};
      if (typeof recipe.text === "string") layer.text = recipe.text;
      else if (singleLine.text) layer.text = singleLine.text;
      if (singleLine.font || recipe.font) layer.font = combinationLineFont(singleLine, recipe);
      if (singleLine.color || recipe.color) layer.color = combinationLineColor(singleLine, recipe);
      if (recipe.outlineColor) layer.outlineColor = recipe.outlineColor;
      layer.outlineWeight = 0;
      if (recipe.shadowColor) layer.shadowColor = recipe.shadowColor;
      layer.shadowDistance = 0;
      if (typeof recipe.fontSize === "number") layer.fontSize = recipe.fontSize;
      layer.r = 0;

      layer.textWrapWidth = null;
      layer.manualTextResize = true;
      fitTextLayerToRealBounds(layer);

      state.mode = "text";
      state.rail = "tool";
      state.subtoolText = "text";
      state.canvasTextEditLayerId = layer.id;
      state.focusTextEditor = false;
    }

    function renderControls() {
      const box = q("[data-p23m-dynamic-controls]");
      if (!box) return;

      const layer = activeLayer();
      if (!layer) {
        box.innerHTML = "";
        box.hidden = true;
        return;
      }

      const activeTool = layer.type === "text" ? state.subtoolText : state.subtoolImage;
      const isCropInLayers = layer.type === "image" && activeTool === "crop" && state.rail === "layers";

      if (state.rail !== "tool" && !isCropInLayers) {
        box.innerHTML = "";
        box.hidden = true;
        return;
      }

      if (layer.type === "image" && !activeTool) {
        box.innerHTML = "";
        box.hidden = true;
        return;
      }

      box.hidden = false;

      if (layer.type === "text") {
        if (activeTool === "text") {
          box.innerHTML = '<div class="p23m__control-title">Editar texto</div>' +
            '<div class="p23m__control-row"><label>Contenido</label><textarea class="p23m__text-editor" data-p23m-control="text" rows="3" placeholder="Tu texto aquí">' + escapeHtml(layer.text || "Tu texto aquí") + "</textarea></div>" +
            '<div class="p23m__control-title p23m__control-title--sub">Fuente del texto</div>' +
            fontControls(layer);
        } else if (activeTool === "color") {
          box.innerHTML = '<div class="p23m__control-title">Color del texto</div>' + swatches("color", layer.color);
        } else if (activeTool === "font") {
          box.innerHTML = fontControls(layer);
        } else if (activeTool === "outline") {
          box.innerHTML = '<div class="p23m__control-title">Contorno</div>' + swatches("outlineColor", layer.outlineColor) +
            '<div class="p23m__control-row"><label>Peso</label><input type="range" min="0" max="3" step="0.1" value="' + Number(layer.outlineWeight || 0) + '" data-p23m-control="outlineWeight"></div>';
        } else if (activeTool === "shadow") {
          box.innerHTML = '<div class="p23m__control-title">Sombra</div>' + swatches("shadowColor", layer.shadowColor) +
            '<div class="p23m__control-row"><label>Distancia</label><input type="range" min="0" max="1" step="0.05" value="' + Number(layer.shadowDistance || 0) + '" data-p23m-control="shadowDistance"></div>';
        } else if (activeTool === "position") {
          box.innerHTML = positionControls();
        } else {
          box.innerHTML = transformControls(layer) + textTransformExtraControls(layer) + transformResetControl();
        }
      } else {
        if (activeTool === "crop") {
          box.innerHTML = cropControls(layer);
        } else if (activeTool === "position") {
          box.innerHTML = positionControls();
        } else {
          /*
            v4.11m-REV31:
            El bloque Diseño queda anulado. Si por estado anterior activeTool
            llega como "pattern", se muestra Transformar igualmente.
          */
          box.innerHTML = transformControls(layer) + imageTransformExtraControls(layer) + transformResetControl();
        }
      }

      if (state.focusTextEditor && layer.type === "text" && activeTool === "text") {
        state.focusTextEditor = false;
        window.requestAnimationFrame(() => {
          const canvasEditor = q('[data-p23m-canvas-text-edit="' + cssEscape(layer.id) + '"]');
          if (canvasEditor) {
            canvasEditor.focus({ preventScroll: true });
            try {
              const range = document.createRange();
              range.selectNodeContents(canvasEditor);
              range.collapse(false);
              const selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);
            } catch (error) {}
            return;
          }

          const input = q('[data-p23m-control="text"]');
          if (!input) return;
          input.focus();
          try {
            const length = input.value.length;
            input.setSelectionRange(length, length);
          } catch (error) {}
        });
      }
    }

    function normalizeHexColor(value) {
      const raw = String(value || "").trim();
      if (/^#[0-9a-f]{6}$/i.test(raw)) return raw.toUpperCase();
      return "#000000";
    }

    function hexToRgbText(value) {
      const hex = normalizeHexColor(value).replace("#", "");
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      return "R:" + r + " G:" + g + " B:" + b;
    }

    function swatchTitle(value) {
      const hex = normalizeHexColor(value);
      return hex + " (" + hexToRgbText(hex) + ")";
    }

    function swatches(key, selected) {
      const selectedHex = normalizeHexColor(selected);
      const colorItems = COLORS.map((color) => {
        const colorHex = normalizeHexColor(color);
        return '<button type="button" class="p23m__swatch' + (selectedHex === colorHex ? " is-selected" : "") + '" style="background:' + colorHex + '" data-p23m-swatch="' + key + ":" + colorHex + '" aria-label="' + escapeHtml(swatchTitle(colorHex)) + '" title="' + escapeHtml(swatchTitle(colorHex)) + '"></button>';
      }).join("");

      return '<div class="p23m-color-block">' +
        '<div class="p23m-color-block__current">' +
          '<span>Color personalizado</span>' +
          '<strong>' + escapeHtml(selectedHex) + '</strong>' +
          '<small>(' + escapeHtml(hexToRgbText(selectedHex)) + ')</small>' +
        '</div>' +
        '<div class="p23m-color-block__top">' +
          '<label class="p23m__swatch p23m__swatch--hex tab-solid-swatches-selection-hex" title="Elegir color personalizado">' +
            '<input aria-label="hex-color-input" type="color" value="' + escapeHtml(selectedHex) + '" data-p23m-hex-color="' + escapeHtml(key) + '">' +
            '<span aria-hidden="true">✓</span>' +
          '</label>' +
          '<input class="p23m-color-block__hex-input" type="text" inputmode="text" maxlength="7" value="' + escapeHtml(selectedHex) + '" data-p23m-hex-text="' + escapeHtml(key) + '" aria-label="Código HEX">' +
        '</div>' +
        '<div class="p23m__swatches p23m__swatches--printful">' + colorItems + "</div>" +
      '</div>';
    }

    function transformResetControl() {
      const resetIcon = '<svg class="p23m-transform__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7.2 7.4A7 7 0 1 1 5 12.5"/><path d="M7.2 7.4H3.8V4"/><path d="M9 12h6"/><path d="M12 9v6"/></svg>';
      return '<div class="p23m-transform__reset-row"><button type="button" class="p23m-transform__reset p23m-transform__reset-total" title="Restablecer diseño original" aria-label="Restablecer diseño original" data-p23m-reset-aspect>' + resetIcon + '<span>Restablecer diseño</span></button></div>';
    }

    function transformControls(layer) {
      const rotation = clamp(Math.round(Number(layer.r || 0)), -180, 180);
      const width = Math.round(Number(layer.w || 0));
      const height = Math.round(Number(layer.h || 0));

      return '<div class="p23m__control-title">Transformar</div>' +
        '<div class="p23m-transform">' +
          '<div class="p23m-transform__group">' +
            '<label>Girar</label>' +
            '<div class="p23m-transform__range-line">' +
              '<input type="range" min="-180" max="180" step="1" value="' + rotation + '" data-p23m-control="r">' +
              '<input class="p23m-transform__number" type="number" min="-180" max="180" step="1" value="' + rotation + '" data-p23m-control="r">' +
            '</div>' +
          '</div>' +
          '<div class="p23m-transform__size-grid is-no-link">' +
            '<div class="p23m-transform__size-item">' +
              '<label>Anchura <span title="Escalado proporcional del diseño">ⓘ</span></label>' +
              '<div class="p23m-transform__stepper">' +
                '<button type="button" aria-label="Reducir anchura" data-p23m-step="w:-6">−</button>' +
                '<input type="number" min="24" step="1" value="' + width + '" data-p23m-control="w">' +
                '<button type="button" aria-label="Aumentar anchura" data-p23m-step="w:6">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="p23m-transform__size-item">' +
              '<label>Altura <span title="Escalado proporcional del diseño">ⓘ</span></label>' +
              '<div class="p23m-transform__stepper">' +
                '<button type="button" aria-label="Reducir altura" data-p23m-step="h:-6">−</button>' +
                '<input type="number" min="24" step="1" value="' + height + '" data-p23m-control="h">' +
                '<button type="button" aria-label="Aumentar altura" data-p23m-step="h:6">+</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }

    function positionControls() {
      const buttons = [
        ["center-v", "Centrar vertical", "centerV"],
        ["center-h", "Centrar horizontal", "centerH"],
        ["left", "Izquierda", "left"],
        ["right", "Derecha", "right"],
        ["top", "Arriba", "top"],
        ["bottom", "Abajo", "bottom"]
      ];

      return '<div class="p23m__control-title">Posición</div>' +
        '<div class="p23m-position-tools">' +
          buttons.map((item) => '<button type="button" class="p23m-icon-btn" data-p23m-align="' + item[0] + '" title="' + item[1] + '" aria-label="' + item[1] + '"><span>' + svgIcon(item[2]) + '</span><small>' + item[1] + '</small></button>').join("") +
        '</div>';
    }

    function focusLayerForEditing(layer, options) {
      if (!layer) return false;

      const opts = options || {};
      state.activeLayerId = layer.id;
      state.lastToolLayerId = layer.id;
      state.mode = layer.type === "text" ? "text" : "image";

      /*
        v4.11m:
        Al tocar/clicar una capa en el canvas o en Capas, abrimos automáticamente
        la barra correcta según el tipo de diseño.
      */
      if (state.mode === "text") {
        state.subtoolText = state.subtoolText || "text";
        if (opts.defaultTool) state.subtoolText = opts.defaultTool;
        state.rail = "tool";
      } else {
        state.subtoolImage = state.subtoolImage || "transform";
        if (opts.defaultTool) state.subtoolImage = opts.defaultTool;
        state.rail = "tool";
      }

      return true;
    }

    function reactivateCanvasTextSelection(layerId, shouldFocus) {
      const layer = currentLayers().find((item) => item.id === layerId);
      if (!layer || layer.type !== "text") return false;

      state.activeLayerId = layer.id;
      state.lastToolLayerId = layer.id;
      state.mode = "text";
      state.rail = "tool";
      state.subtoolText = "text";
      state.canvasTextEditLayerId = layer.id;
      state.focusTextEditor = false;

      /*
        v4.11m-REV46:
        Edición directa y marco deben convivir.
        Si el texto editable mantiene contenteditable pero perdió la selección,
        volvemos a pintar el marco sin obligar al cliente a ir a Capas.
      */
      renderPanels();
      renderLayers();
      renderLayerPanel();
      renderToolbar();
      renderControls();
      renderCanvasUploadButton();

      if (shouldFocus) focusCanvasTextEditor(layer.id);
      return true;
    }

    function focusCanvasTextEditor(layerId) {
      window.requestAnimationFrame(() => {
        const node = q('[data-p23m-canvas-text-edit="' + cssEscape(layerId) + '"]');
        if (!node) return;

        node.focus({ preventScroll: true });

        try {
          const range = document.createRange();
          range.selectNodeContents(node);
          range.collapse(false);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        } catch (error) {}
      });
    }

    function openLayerEditorFromCanvas(layer) {
      if (!layer) return;

      state.activeLayerId = layer.id;
      state.lastToolLayerId = layer.id;
      state.mode = layer.type === "text" ? "text" : "image";
      state.rail = "tool";

      if (layer.type === "text") {
        state.subtoolText = "text";
        state.focusTextEditor = true;
        state.canvasTextEditLayerId = layer.id;
      } else {
        state.subtoolImage = "transform";
        state.canvasTextEditLayerId = null;
      }

      renderPanels();
      renderLayers();
      renderLayerPanel();
      renderToolbar();
      renderControls();
      renderCanvasUploadButton();
      renderCropActions();

      if (layer.type === "text") {
        focusCanvasTextEditor(layer.id);
      }
    }

    function revealLayerOnCanvas(id) {
      window.requestAnimationFrame(() => {
        const layerNode = qa("[data-p23m-layer]").find((node) => node.dataset && node.dataset.p23mLayer === id);
        if (!layerNode || typeof layerNode.scrollIntoView !== "function") return;

        try {
          layerNode.scrollIntoView({ block: "center", inline: "center", behavior: "smooth" });
        } catch (error) {
          layerNode.scrollIntoView();
        }
      });
    }

    function selectLayerAndOpenLayers(id) {
      const layer = currentLayers().find((item) => item.id === id);
      if (!layer) return;

      state.activeLayerId = layer.id;
      state.lastToolLayerId = layer.id;
      state.mode = layer.type === "text" ? "text" : "image";
      state.rail = "layers";
      state.canvasTextEditLayerId = null;
      state.focusTextEditor = false;

      /*
        No cambiamos subtoolImage/subtoolText aquí.
        Así los botones verticales conservan su último estado, pero no se abre
        su panel hasta que el cliente pulse uno de esos botones.
      */
      renderPanels();
      renderLayers();
      renderLayerPanel();
      renderToolbar();
      renderControls();
      renderCanvasUploadButton();
      renderCropActions();
      revealLayerOnCanvas(layer.id);
    }

    function setActiveLayer(id) {
      const layer = currentLayers().find((item) => item.id === id);
      if (!layer) return;
      focusLayerForEditing(layer);
      renderAll();
      scheduleDraftSaveFast();
    }

    function applyTemplate(text) {
      // El personalizador 23DTF funciona únicamente con imágenes.
      // Conservamos la función como guardia para neutralizar plantillas antiguas
      // que pudieran seguir presentes en una página almacenada en caché.
      return null;
    }

    function addImageLayerFromUpload(upload) {
      if (!upload || !upload.src) return null;
      const layer = makeImageLayer(upload.src, upload.name);
      layer.uploadWidth = Number(upload.width || 0);
      layer.uploadHeight = Number(upload.height || 0);
      layer.uploadSize = Number(upload.editorSize || upload.size || 0);
      layer.originalSrc = upload.originalSrc || upload.src;
      layer.originalName = upload.name || "Imagen subida";
      layer.originalUploadWidth = Number(upload.originalWidth || upload.width || 0);
      layer.originalUploadHeight = Number(upload.originalHeight || upload.height || 0);
      layer.originalUploadSize = Number(upload.originalSize || upload.size || 0);
      layer.optimizedForEditor = !!upload.optimizedForEditor;
      layer.productionOriginalPending = !!upload.productionOriginalPending;
      fitImageLayerToUpload(layer);
      /*
        v4.11m-REV25:
        Las nuevas imágenes se añaden al final del array, que ahora equivale
        a capa superior en el canvas.
      */
      currentLayers().push(layer);
      state.activeLayerId = layer.id;
      state.lastToolLayerId = layer.id;
      state.mode = "image";
      state.rail = "layers";
      state.subtoolImage = "";

      /*
        v4.11m-REV29:
        Al añadir imagen no abrimos automáticamente Transformar.
        Primero mostramos Capas; las herramientas se abren desde la barra vertical.
      */
      return layer;
    }

    async function uploadFile(file) {
      if (!file) return;
      if (!file.type || !file.type.startsWith("image/")) {
        window.alert("Sube un archivo de imagen válido: PNG, JPG, WEBP o SVG.");
        return;
      }

      try {
        const prepared = await prepareUploadForCanvas(file);
        const upload = {
          id: uid(),
          name: file.name || "Imagen subida",
          src: prepared.src,
          originalSrc: prepared.originalSrc || prepared.src,
          type: prepared.type || file.type || "imagen",
          size: file.size || 0,
          editorSize: prepared.src ? Math.round(prepared.src.length * 0.75) : 0,
          createdAt: Date.now(),
          width: Number(prepared.width || 0),
          height: Number(prepared.height || 0),
          originalWidth: Number(prepared.originalWidth || prepared.width || 0),
          originalHeight: Number(prepared.originalHeight || prepared.height || 0),
          originalSize: file.size || 0,
          optimizedForEditor: !!prepared.optimizedForEditor,
          productionOriginalPending: !!prepared.optimizedForEditor
        };

        state.uploads.unshift(upload);
        addImageLayerFromUpload(upload);
        renderAll();
        renderFileLibrary();
        closeFileLibrary();
        scheduleDraftSaveFast();
      } catch (error) {
        const message = error && error.message ? error.message : "No se pudo preparar la imagen.";
        imageGuardSetNotice("danger", "Imagen no aceptada", message, "Prueba con una imagen optimizada para web antes de subirla.");
        window.alert(message);
      }
    }

    function scaleTextLayerFromPointer(layer, base, baseFontSize, handle, dx, dy) {
      if (!layer || layer.type !== "text") return false;

      /*
        REV59:
        Las esquinas del marco de texto deben comportarse como las imágenes:
        el punto contrario se queda como ancla y el texto escala desde la esquina
        que el cliente está arrastrando.

        El fallo anterior venía de llamar a fitTextLayerToRealBounds(layer),
        que centra el marco tras medir el texto real. Al cambiar la altura del
        texto en cada render, el centro se recalculaba y parecía que el marco se
        deslizaba solo hacia abajo/fuera del área.
      */
      const signedX = handle.includes("w") ? -dx : dx;
      const signedY = handle.includes("n") ? -dy : dy;

      const baseW = Math.max(1, Number(base.w || layer.w || 1));
      const baseH = Math.max(1, Number(base.h || layer.h || 1));
      const relX = signedX / baseW;
      const relY = signedY / baseH;
      const dominant = Math.abs(relX) >= Math.abs(relY) ? relX : relY;
      const scale = clamp(1 + dominant, 0.08, 10);

      layer.fontSize = clamp(Math.round(Number(baseFontSize || textLayerFontSize(layer)) * scale), 5, 260);
      layer.textWrapWidth = base.textWrapWidth || null;

      const metrics = measureTextLayerRealMetrics(layer);
      const zone = currentZone().rect;
      const nextW = clamp(Number(metrics.w || baseW), 10, Math.max(18, zone.w * 0.98));
      const nextH = clamp(Number(metrics.h || baseH), 10, Math.max(18, zone.h * 0.98));

      const baseX = Number(base.x || layer.x || 0);
      const baseY = Number(base.y || layer.y || 0);
      const rightEdge = baseX + baseW;
      const bottomEdge = baseY + baseH;

      layer.w = nextW;
      layer.h = nextH;

      if (handle.includes("w")) {
        layer.x = rightEdge - nextW;
      } else {
        layer.x = baseX;
      }

      if (handle.includes("n")) {
        layer.y = bottomEdge - nextH;
      } else {
        layer.y = baseY;
      }

      layer.textBoxAspect = layer.h / Math.max(1, layer.w);
      return true;
    }

    function wrapTextLayerFromPointer(layer, base, handle, dx) {
      if (!layer || layer.type !== "text") return false;

      /*
        REV57:
        Los tiradores centrales izquierdo/derecho NO deben funcionar como un
        autofit del texto. Deben controlar el ancho de composición de forma
        directa, manteniendo el tirador bajo el dedo/ratón.

        Antes llamábamos a fitTextLayerToRealBounds(layer), y ese ajuste podía
        reducir el ancho real al contenido, haciendo que el tirador desapareciera
        o dejara de ser fácil de agarrar cuando el texto se comprimía mucho.
      */
      const zone = currentZone().rect;
      const signedX = handle.includes("w") ? -dx : dx;
      const minWrap = 18;
      const maxWrap = Math.max(32, zone.w * 1.25);
      const nextWrap = clamp(Math.round(Number(base.wrapW || base.w || 80) + signedX), minWrap, maxWrap);

      const centerY = Number(base.y || layer.y || 0) + Number(base.h || layer.h || 0) / 2;
      const rightEdge = Number(base.x || 0) + Number(base.w || 0);

      layer.textWrapWidth = nextWrap;
      layer.w = nextWrap;

      const metrics = measureTextLayerRealMetrics(layer);
      layer.h = clamp(Number(metrics.h || layer.h || 24), 8, Math.max(18, zone.h * 0.98));

      if (handle.includes("w")) {
        layer.x = rightEdge - layer.w;
      } else {
        layer.x = Number(base.x || layer.x || 0);
      }

      layer.y = centerY - layer.h / 2;
      layer.textBoxAspect = layer.h / Math.max(1, layer.w);
      return true;
    }

    function handleLayerDoubleTap(layer, event) {
      /*
        v4.11m-REV45:
        El doble tap/doble click queda desactivado para editar.
        Motivo: en móvil interfiere con mover capa, seleccionar capa y contenteditable.
        La edición directa se activa solo desde el botón Texto de la toolbar.
      */
      return false;
    }

    function startDrag(layer, event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      try { event.target.setPointerCapture && event.target.setPointerCapture(event.pointerId); } catch (e) {}
      const sx = event.clientX;
      const sy = event.clientY;
      const scale = effectiveMockupScale();

      const movingLayers = groupMoveLayersFor(layer);
      const basePositions = movingLayers.map((item) => ({
        layer: item,
        x: Number(item.x || 0),
        y: Number(item.y || 0)
      }));

      state.activeLayerId = layer.id;
      state.lastToolLayerId = layer.id;
      if (layer.type === "text") {
        state.canvasTextEditLayerId = null;
        state.focusTextEditor = false;
      }
      state.isInteractingLayer = true;
      state.printAreaWarning = false;
      root.classList.add("is-p23m-layer-interacting");
      root.classList.toggle("is-p23m-group-moving", movingLayers.length > 1);
      /*
        REV74: no redibujamos todo el editor en cada inicio de gesto.
        El redibujado completo se reserva para el final; durante el movimiento
        solo tocamos transform de la capa con requestAnimationFrame.
      */
      renderPrintAreaWarning();

      const paintDrag = makeRafJob(() => {
        basePositions.forEach((entry) => applyLayerNodeStyle(entry.layer));
        updatePrintAreaLayerMask();
      });

      const move = (moveEvent) => {
        moveEvent.preventDefault();
        moveEvent.stopPropagation();

        const dx = (moveEvent.clientX - sx) / scale;
        const dy = (moveEvent.clientY - sy) / scale;

        basePositions.forEach((entry) => {
          entry.layer.x = entry.x + dx;
          entry.layer.y = entry.y + dy;
          clampLayerInsidePrintArea(entry.layer);
        });

        paintDrag();
      };

      bindPointer(move, () => {
        state.isInteractingLayer = false;
        root.classList.remove("is-p23m-layer-interacting");
        root.classList.remove("is-p23m-group-moving");

        let recovered = false;
        movingLayers.forEach((item) => {
          recovered = recoverLayerIfFullyOutside(item) || recovered;
        });

        if (!recovered) syncPrintAreaWarningForLayer(layer);

        qa("[data-p23m-layer].is-live-transforming").forEach((node) => node.classList.remove("is-live-transforming"));
        renderZone();
        renderLayers();
        renderLayerPanel();
        renderControls();
      });
    }

    function startResize(layer, handle, event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      try { event.target.setPointerCapture && event.target.setPointerCapture(event.pointerId); } catch (e) {}

      const sx = event.clientX;
      const sy = event.clientY;
      const base = { x: layer.x, y: layer.y, w: layer.w, h: layer.h, textWrapWidth: layer.textWrapWidth || null, wrapW: layer.textWrapWidth || layer.w };
      const baseFontSize = layer.type === "text" ? textLayerFontSize(layer) : 0;
      const scale = effectiveMockupScale();
      const ratio = layer.type === "text" ? textLayerBoxAspect(layer) : layerAspectRatio(layer);
      const keepRatio = aspectLocked(layer) || layer.type === "text";
      const limits = layerSizeLimits();

      state.activeLayerId = layer.id;
      state.lastToolLayerId = layer.id;
      if (layer.type === "text") {
        state.canvasTextEditLayerId = null;
        state.focusTextEditor = false;
      }
      state.isInteractingLayer = true;
      state.printAreaWarning = false;
      root.classList.add("is-p23m-layer-interacting");
      renderPrintAreaWarning();

      const paintResize = makeRafJob(() => {
        applyLayerNodeStyle(layer);
        updatePrintAreaLayerMask();
      });

      const move = (moveEvent) => {
        moveEvent.preventDefault();
        moveEvent.stopPropagation();
        const dx = (moveEvent.clientX - sx) / scale;
        const dy = (moveEvent.clientY - sy) / scale;

        if (layer.type === "text") {
          layer.manualTextResize = true;

          if (handle === "e" || handle === "w") {
            wrapTextLayerFromPointer(layer, base, handle, dx);
          } else {
            scaleTextLayerFromPointer(layer, base, baseFontSize, handle, dx, dy);
          }

          renderLayers();
          renderLayerPanel();
          syncPrintAreaWarningForLayer(layer);
          return;
        }

        let nextW = base.w;
        let nextH = base.h;
        let anchor = "south-east";

        if (keepRatio) {
          const signedX = handle.includes("w") ? -dx : dx;
          const signedY = handle.includes("n") ? -dy : dy;
          const deltaByX = signedX;
          const deltaByY = signedY / ratio;
          const delta = Math.abs(deltaByX) >= Math.abs(deltaByY) ? deltaByX : deltaByY;

          /*
            23DTF REV62 SAFE:
            En imágenes, el redimensionado mínimo/máximo mantiene proporción.
            Motivo: clamp() independiente por ancho/alto podía deformar diseños pequeños.
          */
          nextW = clamp(base.w + delta, limits.minW, limits.maxW);
          nextH = nextW * ratio;

          if (nextH > limits.maxH) {
            nextH = limits.maxH;
            nextW = clamp(nextH / ratio, limits.minW, limits.maxW);
          }

          if (nextH < limits.minH) {
            nextH = limits.minH;
            nextW = clamp(nextH / ratio, limits.minW, limits.maxW);
          }

          if (nextW < limits.minW) {
            nextW = limits.minW;
            nextH = clamp(nextW * ratio, limits.minH, limits.maxH);
          }
        } else {
          if (handle.includes("e")) nextW = base.w + dx;
          if (handle.includes("s")) nextH = base.h + dy;
          if (handle.includes("w")) nextW = base.w - dx;
          if (handle.includes("n")) nextH = base.h - dy;

          nextW = clamp(nextW, limits.minW, limits.maxW);
          nextH = clamp(nextH, limits.minH, limits.maxH);
        }

        if (handle.includes("n") && handle.includes("w")) anchor = "north-west";
        else if (handle.includes("n") && handle.includes("e")) anchor = "north-east";
        else if (handle.includes("s") && handle.includes("w")) anchor = "south-west";
        else if (handle.includes("w")) anchor = "west";
        else if (handle.includes("n")) anchor = "north";

        layer.x = base.x;
        layer.y = base.y;
        layer.w = base.w;
        layer.h = base.h;
        setLayerSize(layer, nextW, nextH, anchor);

        if (layer.type === "text") {
          layer.manualTextResize = true;
          syncTextFontSizeFromResize(layer, base, layer.w, layer.h, baseFontSize);
          fitTextLayerToRealBounds(layer);
        }

        clampLayerInsidePrintArea(layer);
        paintResize();
      };

      bindPointer(move, () => {
        state.isInteractingLayer = false;
        root.classList.remove("is-p23m-layer-interacting");

        const recovered = recoverLayerIfFullyOutside(layer);
        if (!recovered) syncPrintAreaWarningForLayer(layer);

        qa("[data-p23m-layer].is-live-transforming").forEach((node) => node.classList.remove("is-live-transforming"));
        renderZone();
        renderLayers();
        renderLayerPanel();
        renderControls();
      });
    }

    function startRotate(layer, event) {
      event.preventDefault();
      event.stopPropagation();

      const layerEl = event.target.closest("[data-p23m-layer]");
      const rect = layerEl ? layerEl.getBoundingClientRect() : null;
      const cx = rect ? rect.left + rect.width / 2 : event.clientX;
      const cy = rect ? rect.top + rect.height / 2 : event.clientY;
      const baseRotation = Number(layer.r || 0);
      const startAngle = Math.atan2(event.clientY - cy, event.clientX - cx) * 180 / Math.PI;

      state.activeLayerId = layer.id;
      state.lastToolLayerId = layer.id;
      state.isInteractingLayer = true;
      root.classList.add("is-p23m-layer-interacting");
      renderZone();
      renderLayers();

      const paintRotate = makeRafJob(() => {
        applyLayerNodeStyle(layer);
      });

      const move = (moveEvent) => {
        const currentAngle = Math.atan2(moveEvent.clientY - cy, moveEvent.clientX - cx) * 180 / Math.PI;
        let nextRotation = baseRotation + currentAngle - startAngle;
        nextRotation = ((nextRotation + 180) % 360 + 360) % 360 - 180;
        layer.r = Math.round(nextRotation);
        paintRotate();
      };

      bindPointer(move, () => {
        state.isInteractingLayer = false;
        root.classList.remove("is-p23m-layer-interacting");
        renderZone();
        renderLayers();
        renderLayerPanel();
      });
    }



    function bindPointer(move, done) {
      const up = () => {
        window.removeEventListener("pointermove", move);
        window.removeEventListener("pointerup", up);
        window.removeEventListener("pointercancel", up);
        if (typeof done === "function") done();
      };
      window.addEventListener("pointermove", move, { passive: false });
      window.addEventListener("pointerup", up);
      window.addEventListener("pointercancel", up);
    }

    function startMockupPan(event) {
      if (!event || event.type !== "pointerdown") return false;
      if (event.pointerType === "mouse" && Number(event.button || 0) !== 0) return false;

      const canvas = event.target.closest && event.target.closest("[data-p23m-canvas]");
      if (!canvas || !root.contains(canvas)) return false;

      const interactive = event.target.closest("[data-p23m-layer], button, input, textarea, select, label, a, .p23m__zoom, .p23m__zone-float, .p23m__canvas-tools, [data-p23m-crop-actions], [data-p23m-filelib], [data-p23m-calibrator-panel]");
      if (interactive) return false;

      const startX = Number(event.clientX || 0);
      const startY = Number(event.clientY || 0);
      const baseX = Number(state.mockupPanX || 0);
      const baseY = Number(state.mockupPanY || 0);
      let moved = false;

      const mockup = q("[data-p23m-mockup]");
      const stage = mockupStageElement();
      const panScale = effectiveMockupScale();
      const stageW = Math.max(1, stage ? stage.clientWidth || 1 : 1);
      const stageH = Math.max(1, stage ? stage.clientHeight || 1 : 1);
      const scaledW = 380 * panScale;
      const scaledH = 460 * panScale;
      const visibleX = Math.min(110, scaledW * 0.35, stageW * 0.35);
      const visibleY = Math.min(110, scaledH * 0.35, stageH * 0.35);
      const maxX = Math.max(0, (scaledW + stageW) / 2 - visibleX);
      const maxY = Math.max(0, (scaledH + stageH) / 2 - visibleY);

      const paintMockupPan = makeRafJob(() => {
        if (mockup) {
          mockup.style.transform = "translate3d(" + state.mockupPanX + "px," + state.mockupPanY + "px,0) scale(" + panScale + ")";
        }
      });

      const move = (moveEvent) => {
        const dx = Number(moveEvent.clientX || 0) - startX;
        const dy = Number(moveEvent.clientY || 0) - startY;

        if (!moved && Math.hypot(dx, dy) < 4) return;
        moved = true;
        moveEvent.preventDefault();
        moveEvent.stopPropagation();

        state.isPanningMockup = true;
        state.mockupPanX = clamp(baseX + dx, -maxX, maxX);
        state.mockupPanY = clamp(baseY + dy, -maxY, maxY);
        canvas.classList.add("is-p23m-panning");
        paintMockupPan();
      };

      bindPointer(move, () => {
        canvas.classList.remove("is-p23m-panning");
        state.isPanningMockup = false;
        if (moved) {
          state.mockupPanSuppressClickUntil = Date.now() + 350;
          scheduleDraftSaveFast();
        }
      });

      return true;
    }

    function handleClick(event) {
      if (event.type === "click" && Date.now() < Number(state.mockupPanSuppressClickUntil || 0)) {
        const canvasClick = event.target && event.target.closest ? event.target.closest("[data-p23m-canvas]") : null;
        if (canvasClick && root.contains(canvasClick)) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          return;
        }
      }
      if (event.type === "click" && Date.now() < Number(state.layerPanelSuppressClickUntil || 0)) {
        const guardedLayerClick = event.target && event.target.closest ? event.target.closest("[data-p23m-layer-card], [data-p23m-select-layer]") : null;
        if (guardedLayerClick && root.contains(guardedLayerClick)) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          return;
        }
      }

      const canvasTextTarget = event.target && event.target.closest ? event.target.closest("[data-p23m-canvas-text-edit]") : null;
      if (canvasTextTarget && root.contains(canvasTextTarget)) {
        const layerId = canvasTextTarget.dataset.p23mCanvasTextEdit;

        /*
          v4.11m-REV46:
          Si el usuario toca el texto editable y el marco estaba oculto por
          deselección, reactivamos la capa y el marco. Si ya estaba activa,
          no tocamos nada para no romper la escritura/caret.
        */
        if (event.type === "pointerdown" && state.activeLayerId !== layerId) {
          event.preventDefault();
          event.stopPropagation();
          reactivateCanvasTextSelection(layerId, true);
        }

        return;
      }

      if (event.type === "pointerdown" && calibratorPanelPointerDown(event)) return;
      if (calibratorHandleClick(event)) return;
      if (event.type === "pointerdown") {
        if (startMockupPan(event)) return;

        const toolbarTarget = event.target.closest("[data-p23m-subtool]");
        if (toolbarTarget && root.contains(toolbarTarget) && isMobileViewport() && event.pointerType !== "mouse") {
          state.toolbarTap = {
            active: true,
            moved: false,
            x: Number(event.clientX || 0),
            y: Number(event.clientY || 0),
            t: Date.now()
          };
          return;
        }

        const placementTarget = event.target.closest("[data-p23m-placement]");
        if (placementTarget && root.contains(placementTarget) && isMobileViewport() && event.pointerType !== "mouse") {
          state.placementTap = {
            active: true,
            moved: false,
            x: Number(event.clientX || 0),
            y: Number(event.clientY || 0),
            t: Date.now()
          };
          return;
        }

        const sortClick = event.target.closest("[data-p23m-filelib-sortbox], [data-p23m-filelib-sort-toggle], [data-p23m-filelib-sort-menu], [data-p23m-filelib-sort-value]");
        if (sortClick && root.contains(sortClick)) {
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          return;
        }

        const layerPanelAction = event.target.closest("[data-p23m-layer-action], [data-p23m-group-move-layer], [data-p23m-toggle-layer], [data-p23m-remove-layer], .p23m__layer-actions");
        if (layerPanelAction && root.contains(layerPanelAction)) {
          /*
            v4.11m-REV28:
            Las acciones de ver/ocultar y eliminar no deben iniciar drag ni
            bloquear el click posterior. Dejamos que el handler de click normal actúe.
          */
          return;
        }

        const layerPanelCard = event.target.closest("[data-p23m-layer-card]");
        /*
          23DTF REV64:
          La tarjeta completa de Capas acepta los tres gestos: deslizar, click
          para seleccionar y mantener pulsado para reordenar. Las acciones
          laterales siguen excluidas arriba para no borrar/ocultar por error.
        */
        if (layerPanelCard && root.contains(layerPanelCard)) {
          startLayerPanelReorder(layerPanelCard, event);
          return;
        }

        /*
          v4.11f:
          Los botones normales NO deben ejecutarse en pointerdown.
          Solo permitimos pointerdown para manipular una capa directamente:
          mover, girar o redimensionar. Todo lo demás espera a un click real.
        */
        const layerPointerTarget = event.target.closest("[data-p23m-layer]");
        const isLayerPointer =
          layerPointerTarget &&
          root.contains(layerPointerTarget) &&
          !event.target.closest("[data-p23m-delete-layer], [data-p23m-canvas-text-edit], button, input, textarea, select, label, a");

        const isLayerTransformPointer =
          event.target.closest("[data-p23m-resize], [data-p23m-rotate-layer], [data-p23m-move-frame]") &&
          layerPointerTarget &&
          root.contains(layerPointerTarget);

        if (!isLayerPointer && !isLayerTransformPointer) {
          return;
        }
      }

      if (event.type === "pointermove") {
        if (state.toolbarTap && state.toolbarTap.active) {
          const dx = Math.abs(Number(event.clientX || 0) - Number(state.toolbarTap.x || 0));
          const dy = Math.abs(Number(event.clientY || 0) - Number(state.toolbarTap.y || 0));
          if (dx > 7 || dy > 7) state.toolbarTap.moved = true;
        }

        if (state.placementTap && state.placementTap.active) {
          const dx = Math.abs(Number(event.clientX || 0) - Number(state.placementTap.x || 0));
          const dy = Math.abs(Number(event.clientY || 0) - Number(state.placementTap.y || 0));
          if (dx > 7 || dy > 7) state.placementTap.moved = true;
        }

        /*
          Crucial:
          pointermove nunca debe caer a los handlers de click.
          Si no salimos aquí, al pasar el ratón o mover el dedo sobre botones
          se ejecutan rail/subidas/acciones como si fueran clicks.
        */
        return;
      }

      const rail = event.target.closest("[data-p23m-rail]");
      if (rail && root.contains(rail)) {
        event.preventDefault();
        if (rail.dataset.p23mRail === "uploads") {
          openUploadsLibraryOnly();
          return;
        }
        switchRail(rail.dataset.p23mRail);
        return;
      }

      const continueDesign = event.target.closest("[data-p23m-continue-design]");
      if (continueDesign && root.contains(continueDesign)) {
        event.preventDefault();
        if (personalizedQtyTotal() <= 0) return;
        openUploadsLibraryOnly();
        return;
      }

      const exportButton = event.target.closest("[data-p23m-export-project]");
      if (exportButton && root.contains(exportButton)) {
        event.preventDefault();
        exportPersonalizationLocal();
        return;
      }

      const cloudflareUploadButton = event.target.closest("[data-p23m-upload-cloudflare]");
      if (cloudflareUploadButton && root.contains(cloudflareUploadButton)) {
        event.preventDefault();
        uploadPersonalizationToCloudflare();
        return;
      }

      const cartConfirmClose = event.target.closest("[data-p23m-cart-confirm-close]");
      if (cartConfirmClose && root.contains(cartConfirmClose)) {
        event.preventDefault();
        closePersonalizedCartConfirmation(false);
        return;
      }

      const cartConfirmSubmit = event.target.closest("[data-p23m-cart-confirm-submit]");
      if (cartConfirmSubmit && root.contains(cartConfirmSubmit)) {
        event.preventDefault();
        addPersonalizedSelectionToCart();
        return;
      }

      const addToCartButton = event.target.closest("[data-p23m-add-to-cart]");
      if (addToCartButton && root.contains(addToCartButton)) {
        event.preventDefault();
        openPersonalizedCartConfirmation();
        return;
      }

      const clearDraftButton = event.target.closest("[data-p23m-clear-draft]");
      if (clearDraftButton && root.contains(clearDraftButton)) {
        event.preventDefault();
        const ok = window.confirm("¿Quieres limpiar este borrador y empezar esta personalización desde cero?");
        if (!ok) return;
        clearLocalDraftAndDesign();
        return;
      }

      const colorTarget = event.target.closest("[data-p23m-select-color]");
      if (colorTarget && root.contains(colorTarget)) {
        if (event.target.closest("[data-p23m-personalized-qty]")) return;
        const colorName = colorTarget.dataset.p23mSelectColor;
        if (colorName) {
          event.preventDefault();
          state.selectedColor = colorName;
          preserveMatrixScroll(() => {
            renderProductSelection();
          });
          renderProductImage();
        }
        return;
      }

      const placementButton = event.target.closest("[data-p23m-placement]");
      if (placementButton && root.contains(placementButton)) {
        event.preventDefault();

        if (!isRealPlacementTap(event)) {
          if (state.placementTap) state.placementTap.active = false;
          return;
        }

        if (state.placementTap) state.placementTap.active = false;

        const next = PLACEMENTS.find((item) => item.id === placementButton.dataset.p23mPlacement);
        if (!next || next.disabled || !next.zones.length) return;
        state.placement = next.id;
        state.zone = next.zones[0].id;
        state.mockupPanX = 0;
        state.mockupPanY = 0;
        state.activeLayerId = currentLayers()[0]?.id || null;
        renderAll();
        return;
      }

      const subtool = event.target.closest("[data-p23m-subtool]");
      if (subtool && root.contains(subtool)) {
        event.preventDefault();

        if (!isRealToolbarTap(event)) {
          if (state.toolbarTap) state.toolbarTap.active = false;
          return;
        }

        if (state.toolbarTap) state.toolbarTap.active = false;

        const layer = activeLayer();
        if (!layer) return;

        const nextTool = subtool.dataset.p23mSubtool;
        state.mode = layer.type === "text" ? "text" : "image";

        if (layer.type === "text") {
          state.subtoolText = nextTool;
          state.rail = "tool";

          /*
            v4.11m-REV45:
            La edición directa en canvas se activa solo desde el botón Texto.
            Si se pulsa otra herramienta, salimos de contenteditable.
          */
          if (nextTool === "text") {
            state.canvasTextEditLayerId = layer.id;
            state.focusTextEditor = true;
          } else {
            state.canvasTextEditLayerId = null;
            state.focusTextEditor = false;
          }
        } else {
          state.subtoolImage = nextTool;
          state.rail = "tool";
          state.cropBefore = null;
          state.canvasTextEditLayerId = null;
          state.focusTextEditor = false;
        }

        renderAll();
        return;
      }

      const zoomReset = event.target.closest("[data-p23m-zoom-reset]");
      if (zoomReset && root.contains(zoomReset)) {
        event.preventDefault();
        event.stopPropagation();
        state.zoom = 100;
        state.mockupPanX = 0;
        state.mockupPanY = 0;
        const zoom = q("[data-p23m-zoom]");
        if (zoom) {
          zoom.value = "100";
          zoom.setAttribute("aria-valuenow", "100");
        }
        updateZoomLabelOnly(100);
        applyMockupTransformOnly();
        scheduleDraftSaveFast();
        return true;
      }

      const cropCancel = event.target.closest("[data-p23m-crop-cancel]");
      if (cropCancel && root.contains(cropCancel)) {
        event.preventDefault();
        const layer = activeLayer();
        if (layer && state.cropBefore && state.cropBefore.id === layer.id) {
          Object.assign(layer, { x: state.cropBefore.x, y: state.cropBefore.y, w: state.cropBefore.w, h: state.cropBefore.h });
          delete layer.cropDraft;
        }
        state.cropBefore = null;
        state.subtoolImage = "transform";
        state.rail = "tool";
        renderAll();
        return;
      }

      const cropApply = event.target.closest("[data-p23m-crop-apply]");
      if (cropApply && root.contains(cropApply)) {
        event.preventDefault();
        const layer = activeLayer();
        if (layer && layer.type === "image") {
          applyCropToImageLayer(layer);
          return;
        }
        state.cropBefore = null;
        state.subtoolImage = "transform";
        state.rail = "tool";
        renderAll();
        return;
      }

      const zonePill = event.target.closest("[data-p23m-zone-pill]");
      if (zonePill && root.contains(zonePill)) {
        event.preventDefault();
        const menu = q("[data-p23m-zone-menu]");
        if (menu) menu.hidden = !menu.hidden;
        return;
      }

      const zoneButton = event.target.closest("[data-p23m-zone]");
      if (zoneButton && root.contains(zoneButton)) {
        event.preventDefault();
        state.zone = zoneButton.dataset.p23mZone;
        state.activeLayerId = currentLayers()[0]?.id || null;
        const menu = q("[data-p23m-zone-menu]");
        if (menu) menu.hidden = true;
        renderAll();
        return;
      }

      const template = event.target.closest("[data-p23m-template]");
      if (template && root.contains(template)) {
        event.preventDefault();
        applyTemplate(template.dataset.p23mTemplate);
        return;
      }

      const applyUploadButton = event.target.closest("[data-p23m-apply-upload]");
      if (applyUploadButton && root.contains(applyUploadButton)) {
        event.preventDefault();

        const filelib = q("[data-p23m-filelib]");
        const isInsideFilelib = filelib && filelib.contains(applyUploadButton) && !filelib.hidden;
        if (!isInsideFilelib || fileLibraryJustOpened()) return;

        const upload = state.uploads.find((item) => item.id === applyUploadButton.dataset.p23mApplyUpload);
        if (!upload) return;

        addImageLayerFromUpload(upload);
        renderAll();
        closeFileLibrary();
        scheduleDraftSaveFast();
        return;
      }

      const filelibClose = event.target.closest("[data-p23m-filelib-close]");
      if (filelibClose && root.contains(filelibClose)) {
        event.preventDefault();
        closeFileLibrary();
        return;
      }

      const sortToggle = event.target.closest("[data-p23m-filelib-sort-toggle]");
      if (sortToggle && root.contains(sortToggle)) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        const menu = q("[data-p23m-filelib-sort-menu]");
        if (menu) {
          const willOpen = menu.hidden;
          menu.hidden = !willOpen;
          sortToggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
        }
        qa("[data-p23m-filelib-sort-value]").forEach((button) => {
          button.classList.toggle("is-active", button.dataset.p23mFilelibSortValue === state.fileLibrarySort);
        });
        return;
      }

      const sortOption = event.target.closest("[data-p23m-filelib-sort-value]");
      if (sortOption && root.contains(sortOption)) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        state.fileLibrarySort = sortOption.dataset.p23mFilelibSortValue || "created_desc";
        const menu = q("[data-p23m-filelib-sort-menu]");
        const toggle = q("[data-p23m-filelib-sort-toggle]");
        if (menu) menu.hidden = true;
        if (toggle) toggle.setAttribute("aria-expanded", "false");
        renderFileLibrary();
        return;
      }

      const filelibArea = event.target.closest("[data-p23m-filelib]");
      const sortSafeArea = event.target.closest("[data-p23m-filelib-sortbox], [data-p23m-filelib-sort-toggle], [data-p23m-filelib-sort-menu], [data-p23m-filelib-sort-value]");
      if (filelibArea && !sortSafeArea) {
        const menu = q("[data-p23m-filelib-sort-menu]");
        const toggle = q("[data-p23m-filelib-sort-toggle]");
        if (menu && !menu.hidden) {
          menu.hidden = true;
          if (toggle) toggle.setAttribute("aria-expanded", "false");
        }
      }

      const filelibUpload = event.target.closest("[data-p23m-filelib-upload]");
      if (filelibUpload && root.contains(filelibUpload)) {
        event.preventDefault();
        openNativeUploadFromLibrary();
        return;
      }

      const openFilelib = event.target.closest("[data-p23m-open-filelib]");
      if (openFilelib && root.contains(openFilelib)) {
        event.preventDefault();
        openFileLibrary();
        return;
      }

      const uploadButton = event.target.closest("[data-p23m-upload-btn]");
      if (uploadButton && root.contains(uploadButton)) {
        event.preventDefault();
        openUploadsLibraryOnly();
        return;
      }

      const priceButton = event.target.closest("[data-p23m-price-info]");
      if (priceButton && root.contains(priceButton)) {
        event.preventDefault();
        const popover = q("[data-p23m-price-popover]");
        if (popover) popover.hidden = !popover.hidden;
        return;
      }

      const gridButton = event.target.closest("[data-p23m-grid]");
      if (gridButton && root.contains(gridButton)) {
        event.preventDefault();
        state.grid = !state.grid;
        const canvas = q("[data-p23m-canvas]");
        if (canvas) canvas.classList.toggle("is-grid", state.grid);
        gridButton.classList.toggle("is-active", state.grid);
        return;
      }

      const fitButton = event.target.closest("[data-p23m-fit]");
      if (fitButton && root.contains(fitButton)) {
        event.preventDefault();
        state.zoom = 100;
        state.mockupPanX = 0;
        state.mockupPanY = 0;
        normalizeZoomControls();
        scheduleResponsiveMockupScale();
        return;
      }

      const cropHandle = event.target.closest("[data-p23m-crop-handle]");
      if (cropHandle && root.contains(cropHandle)) {
        if (event.type !== "pointerdown") return;
        const layerNode = cropHandle.closest("[data-p23m-layer]");
        const layer = layerNode ? currentLayers().find((item) => item.id === layerNode.dataset.p23mLayer) : null;
        if (layer && layer.type === "image") {
          state.activeLayerId = layer.id;
          state.lastToolLayerId = layer.id;
          state.mode = "image";
          state.rail = "tool";
          state.subtoolImage = "crop";
          renderPanels();
          startCropFrame(layer, cropHandle.dataset.p23mCropHandle, event);
        }
        return;
      }

      const layerEl = event.target.closest("[data-p23m-layer]");
      if (layerEl && root.contains(layerEl)) {
        const id = layerEl.dataset.p23mLayer;
        const layer = currentLayers().find((item) => item.id === id);
        if (!layer) return;

        const deleteButton = event.target.closest("[data-p23m-delete-layer]");
        if (deleteButton) {
          event.preventDefault();
          event.stopPropagation();
          const layers = currentLayers();
          const index = layers.indexOf(layer);
          if (index >= 0) layers.splice(index, 1);
          const nextLayer = layers[0] || null;
          if (nextLayer) {
            focusLayerForEditing(nextLayer);
          } else {
            state.activeLayerId = null;
            state.rail = "layers";
            state.subtoolImage = "";
          }
          renderAll();
          return;
        }

        const moveFrame = event.target.closest("[data-p23m-move-frame]");
        if (moveFrame) {
          /*
            v4.11m-REV48:
            Al tocar/arrastrar las líneas del marco salimos del modo edición
            directa y abrimos Capas. Así el cliente entiende que ahora está
            manipulando la capa completa, no escribiendo dentro del texto.
            Para volver a editar, debe pulsar otra vez el botón Texto.
          */
          state.activeLayerId = layer.id;
          state.lastToolLayerId = layer.id;
          state.mode = layer.type === "text" ? "text" : "image";
          state.rail = "layers";
          state.canvasTextEditLayerId = null;
          state.focusTextEditor = false;

          renderPanels();
          renderToolbar();
          renderControls();

          startDrag(layer, event);
          return;
        }

        const rotate = event.target.closest("[data-p23m-rotate-layer]");
        if (rotate) {
          startRotate(layer, event);
          return;
        }

        const resize = event.target.closest("[data-p23m-resize]");
        if (resize) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          startResize(layer, resize.dataset.p23mResize, event);
          return;
        }

        /*
          v4.11m-REV45:
          1 click/tap sobre texto o imagen = abre Capas.
          No usamos doble click para editar porque genera conflictos con drag,
          selección y escritura directa en móviles.
        */
        if (event.type === "click" && Number(event.detail || 0) >= 2) {
          event.preventDefault();
          return;
        }

        if (event.type === "pointerdown") {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          state.activeLayerId = layer.id;
          state.lastToolLayerId = layer.id;
          state.mode = layer.type === "text" ? "text" : "image";
          startDrag(layer, event);
          return;
        }

        selectLayerAndOpenLayers(layer.id);
        return;
      }

      const canvas = event.target.closest("[data-p23m-canvas]");
      const clickedLayer = event.target.closest("[data-p23m-layer]");
      const clickedInteractive = event.target.closest("button, input, textarea, select, label, a, [data-p23m-zone-pill], [data-p23m-zone-menu], [data-p23m-filelib], [data-p23m-calibrator-panel]");
      if (canvas && root.contains(canvas) && !clickedLayer && !clickedInteractive && state.activeLayerId) {
        event.preventDefault();
        clearActiveLayerSelection();
        return;
      }

      const alignButton = event.target.closest("[data-p23m-align]");
      if (alignButton && root.contains(alignButton)) {
        event.preventDefault();
        const layer = activeLayer();
        if (layer) {
          const zone = currentZone().rect;
          const action = alignButton.dataset.p23mAlign;
          if (action === "center-h") layer.x = zone.x + (zone.w - layer.w) / 2;
          if (action === "center-v") layer.y = zone.y + (zone.h - layer.h) / 2;
          if (action === "left") layer.x = zone.x;
          if (action === "right") layer.x = zone.x + zone.w - layer.w;
          if (action === "top") layer.y = zone.y;
          if (action === "bottom") layer.y = zone.y + zone.h - layer.h;
          renderAll();
        }
        return;
      }

      const layerSelect = event.target.closest("[data-p23m-select-layer]");
      if (layerSelect && root.contains(layerSelect)) {
        event.preventDefault();
        selectLayerAndOpenLayers(layerSelect.dataset.p23mSelectLayer);
        return;
      }

      const layerGroupMove = event.target.closest("[data-p23m-group-move-layer]");
      if (layerGroupMove && root.contains(layerGroupMove)) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        const layerId = layerGroupMove.dataset.p23mGroupMoveLayer;
        const layer = currentLayers().find((item) => item.id === layerId);
        if (layer) {
          toggleLayerGroupMove(layer.id);
          state.activeLayerId = layer.id;
          state.lastToolLayerId = layer.id;
          state.rail = "layers";
          state.mode = layer.type === "text" ? "text" : "image";
          renderLayers();
          renderLayerPanel();
          renderControls();
        }
        return;
      }

      const layerToggle = event.target.closest("[data-p23m-toggle-layer]");
      if (layerToggle && root.contains(layerToggle)) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        const layer = currentLayers().find((item) => item.id === layerToggle.dataset.p23mToggleLayer);
        if (layer) {
          layer.visible = !layer.visible;
          state.activeLayerId = layer.id;
          state.lastToolLayerId = layer.id;
          state.rail = "layers";
          renderLayers();
          renderLayerPanel();
          renderCanvasUploadButton();
          renderPrintAreaWarning();
        }
        return;
      }

      const layerRemove = event.target.closest("[data-p23m-remove-layer]");
      if (layerRemove && root.contains(layerRemove)) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        const layers = currentLayers();
        const layer = layers.find((item) => item.id === layerRemove.dataset.p23mRemoveLayer);
        if (layer) {
          const index = layers.indexOf(layer);
          if (index >= 0) layers.splice(index, 1);
          cleanupGroupMoveIds();
          state.activeLayerId = layers[layers.length - 1]?.id || null;
          state.lastToolLayerId = state.activeLayerId;
          state.rail = "layers";
          state.subtoolImage = "";
          renderAll();
        }
        return;
      }

      const swatch = event.target.closest("[data-p23m-swatch]");
      if (swatch && root.contains(swatch)) {
        event.preventDefault();
        const layer = activeLayer();
        if (!layer) return;
        const parts = swatch.dataset.p23mSwatch.split(":");
        const key = parts[0];
        const value = normalizeHexColor(parts[1]);
        layer[key] = value;
        renderAll();
        return;
      }

      const fontTab = event.target.closest("[data-p23m-font-tab]");
      if (fontTab && root.contains(fontTab)) {
        event.preventDefault();
        state.fontTab = fontTab.dataset.p23mFontTab || "all";
        renderControls();
        return;
      }

      const fontCombo = event.target.closest("[data-p23m-font-combo]");
      if (fontCombo && root.contains(fontCombo)) {
        event.preventDefault();
        const layer = activeLayer();
        if (layer && layer.type === "text") {
          applyFontCombination(layer, fontCombo.dataset.p23mFontCombo);
          renderAll();
        }
        return;
      }

      const font = event.target.closest("[data-p23m-font]");
      if (font && root.contains(font)) {
        event.preventDefault();
        const layer = activeLayer();
        if (layer && layer.type === "text") {
          layer.font = font.dataset.p23mFont;
          layer.manualTextResize = true;
          fitTextLayerToRealBounds(layer);
          state.mode = "text";
          state.rail = "tool";
          state.subtoolText = "text";
          renderAll();
        }
        return;
      }

      const toggleAspect = event.target.closest("[data-p23m-toggle-aspect]");
      if (toggleAspect && root.contains(toggleAspect)) {
        event.preventDefault();
        const layer = activeLayer();
        toggleLayerAspect(layer);
        return;
      }

      const resetAspect = event.target.closest("[data-p23m-reset-aspect]");
      if (resetAspect && root.contains(resetAspect)) {
        event.preventDefault();
        const layer = activeLayer();
        if (layer && layer.type === "text") {
          resetTextLayer(layer);
        } else {
          resetLayerAspect(layer);
        }
        return;
      }

      const formatButton = event.target.closest("[data-p23m-format]");
      if (formatButton && root.contains(formatButton)) {
        event.preventDefault();
        const layer = activeLayer();
        if (!layer || layer.type !== "image") return;

        const format = formatButton.dataset.p23mFormat || "normal";
        if (format === "normal") {
          applyImageFormat(layer, "normal");
          layer.mirrorMode = false;
        } else {
          applyImageFormat(layer, format);
        }

        state.mode = "image";
        state.rail = "tool";
        state.subtoolImage = "transform";

        renderLayers();
        renderControls();
        renderLayerPanel();
        return;
      }

      const mirrorButton = event.target.closest("[data-p23m-mirror-mode]");
      if (mirrorButton && root.contains(mirrorButton)) {
        event.preventDefault();
        const layer = activeLayer();
        if (!layer || layer.type !== "image") return;

        layer.mirrorMode = !layer.mirrorMode;
        layer.pattern = "none";
        state.mode = "image";
        state.rail = "tool";
        state.subtoolImage = "transform";

        renderLayers();
        renderControls();
        renderLayerPanel();
        return;
      }

      const patternButton = event.target.closest("[data-p23m-pattern]");
      if (patternButton && root.contains(patternButton)) {
        event.preventDefault();
        const layer = activeLayer();
        if (!layer || layer.type !== "image") return;

        applyImageFormat(layer, "normal");
        layer.mirrorMode = false;
        layer.pattern = "none";

        state.mode = "image";
        state.rail = "tool";
        state.subtoolImage = "transform";

        renderLayers();
        renderControls();
        renderLayerPanel();
        return;
      }

      const step = event.target.closest("[data-p23m-step]");
      if (step && root.contains(step)) {
        event.preventDefault();
        const layer = activeLayer();
        if (!layer) return;
        const parts = step.dataset.p23mStep.split(":");
        const key = parts[0];
        resizeLayerFromControl(layer, key, Number(parts[1] || 0), true);
        renderControls();
        renderLiveLayerUpdate(layer);
        return;
      }

      const flip = event.target.closest("[data-p23m-flip]");
      if (flip && root.contains(flip)) {
        event.preventDefault();
        const layer = activeLayer();
        if (!layer || layer.type !== "image") return;
        if (flip.dataset.p23mFlip === "x") layer.flipX = !layer.flipX;
        if (flip.dataset.p23mFlip === "y") layer.flipY = !layer.flipY;
        state.rail = "tool";
        state.subtoolImage = "transform";
        renderLayers();
        renderControls();
        renderLayerPanel();
        renderCropActions();
      }
    }

    function handleInput(event) {
      const canvasTextEdit = event.target.closest && event.target.closest("[data-p23m-canvas-text-edit]");
      if (canvasTextEdit && root.contains(canvasTextEdit)) {
        const layer = currentLayers().find((item) => item.id === canvasTextEdit.dataset.p23mCanvasTextEdit);
        if (!layer || layer.type !== "text") return;

        state.activeLayerId = layer.id;
        state.lastToolLayerId = layer.id;
        state.mode = "text";
        state.rail = "tool";
        state.subtoolText = "text";
        state.canvasTextEditLayerId = layer.id;

        const nextText = (canvasTextEdit.innerText || canvasTextEdit.textContent || "").replace(/\u00a0/g, " ");
        layer.text = nextText || "Tu texto aquí";
        layer.textWrapWidth = Math.max(10, Number(layer.textWrapWidth || layer.w || 40));
        fitTextLayerToRealBounds(layer);

        const item = canvasTextEdit.closest("[data-p23m-layer]");
        if (item) {
          item.style.left = layer.x + "px";
          item.style.top = layer.y + "px";
          item.style.width = layer.w + "px";
          item.style.height = layer.h + "px";
        }

        renderLayerPanel();

        const textarea = q('[data-p23m-control="text"]');
        if (textarea && document.activeElement !== textarea) {
          textarea.value = layer.text;
        }

        return;
      }


      const fontSearch = event.target.closest && event.target.closest("[data-p23m-font-search]");
      if (fontSearch && root.contains(fontSearch)) {
        state.fontSearch = fontSearch.value || "";
        renderControls();
        const input = q("[data-p23m-font-search]");
        if (input) {
          input.focus();
          const len = input.value.length;
          try { input.setSelectionRange(len, len); } catch (error) {}
        }
        return;
      }

      const hexPicker = event.target.closest && event.target.closest("[data-p23m-hex-color]");
      if (hexPicker && root.contains(hexPicker)) {
        const layer = activeLayer();
        if (!layer) return;

        const key = hexPicker.dataset.p23mHexColor;
        layer[key] = normalizeHexColor(hexPicker.value);
        renderLiveLayerUpdate(layer);

        const hexText = q('[data-p23m-hex-text="' + cssEscape(key) + '"]');
        if (hexText && document.activeElement !== hexText) hexText.value = layer[key];
        return;
      }

      const hexTextInput = event.target.closest && event.target.closest("[data-p23m-hex-text]");
      if (hexTextInput && root.contains(hexTextInput)) {
        const layer = activeLayer();
        if (!layer) return;

        const key = hexTextInput.dataset.p23mHexText;
        let value = String(hexTextInput.value || "").trim();
        if (value && value[0] !== "#") value = "#" + value;
        if (/^#[0-9a-f]{6}$/i.test(value)) {
          layer[key] = normalizeHexColor(value);
          renderLiveLayerUpdate(layer);

          const picker = q('[data-p23m-hex-color="' + cssEscape(key) + '"]');
          if (picker && document.activeElement !== picker) picker.value = layer[key];
        }
        return;
      }

      if (calibratorHandleInput(event)) return;
      if (event.target.matches("[data-p23m-filelib-search]")) {
        renderFileLibrary();
        return;
      }

      const qty = event.target.closest("[data-p23m-personalized-qty]");
      if (qty && root.contains(qty)) {
        const key = qty.dataset.p23mPersonalizedQty;
        const rawValue = String(qty.value || "").trim();
        const value = rawValue === "" ? 0 : Math.max(0, parseInt(rawValue, 10) || 0);
        state.personalizedQty[key] = value;
        if (value > 0 && key) state.selectedColor = String(key).split("__")[0] || state.selectedColor;
        const totalNode = q("[data-p23m-personalized-total]");
        if (totalNode) totalNode.textContent = String(personalizedQtyTotal());
        renderProductImage();
        scheduleDraftSave();
        return;
      }

      const control = event.target.closest("[data-p23m-control]");
      if (!control || !root.contains(control)) return;

      const layer = activeLayer();
      if (!layer) return;

      const key = control.dataset.p23mControl;

      if (key === "text") {
        layer[key] = control.value;
        renderLiveLayerUpdate(layer);
        return;
      }

      const raw = Number(control.value);
      let value = Number.isFinite(raw) ? raw : 0;

      if (key.indexOf("crop_") === 0) {
        if (layer.type !== "image") return;

        const cropKey = key.replace("crop_", "");
        const crop = ensureCropDraft(layer);
        const previous = Number(crop[cropKey] || 0);
        crop[cropKey] = clamp(Math.round(value), 0, 45);

        const horizontal = Number(crop.left || 0) + Number(crop.right || 0);
        const vertical = Number(crop.top || 0) + Number(crop.bottom || 0);

        if (horizontal > 92) crop[cropKey] = Math.max(0, 92 - (horizontal - previous));
        if (vertical > 92) crop[cropKey] = Math.max(0, 92 - (vertical - previous));

        renderLayers();
        syncCropControlUi(layer);
        renderCropActions();
        return;
      }

      if (key === "r") {
        value = clamp(Math.round(value), -180, 180);
        layer[key] = value;
        qa('[data-p23m-control="' + key + '"]').forEach((peer) => {
          if (peer !== control) peer.value = String(value);
        });
        renderLiveLayerUpdate(layer);
        return;
      }

      if (key === "w" || key === "h") {
        resizeLayerFromControl(layer, key, value, false);
        qa('[data-p23m-control="w"]').forEach((peer) => { peer.value = String(Math.round(layer.w || 0)); });
        qa('[data-p23m-control="h"]').forEach((peer) => { peer.value = String(Math.round(layer.h || 0)); });
        renderLiveLayerUpdate(layer);
        return;
      }

      layer[key] = value;
      constrain(layer);

      qa('[data-p23m-control="' + key + '"]').forEach((peer) => {
        if (peer !== control) peer.value = String(value);
      });

      renderLiveLayerUpdate(layer);
    }

    function handleQuantityFocus(event) {
      const qty = event.target.closest && event.target.closest("[data-p23m-personalized-qty]");
      if (!qty || !root.contains(qty)) return;
      if (String(qty.value || "").trim() === "0") qty.value = "";
      window.requestAnimationFrame(() => {
        try { qty.select(); } catch (error) {}
      });
    }

    function handleQuantityCommit(event) {
      const qty = event.target.closest && event.target.closest("[data-p23m-personalized-qty]");
      if (!qty || !root.contains(qty)) return;
      const key = qty.dataset.p23mPersonalizedQty;
      const value = Math.max(0, parseInt(qty.value || "0", 10) || 0);
      state.personalizedQty[key] = value;
      qty.value = String(value);
      preserveMatrixScroll(() => renderProductSelection());
      renderProductImage();
      scheduleDraftSave();
    }

    function handleFile(event) {
      if (!event.target.matches("[data-p23m-file-input]")) return;
      uploadFile(event.target.files && event.target.files[0]);
    }

    function handleUploadDrag(event) {
      const dropzone = event.target.closest("[data-p23m-upload-dropzone]");
      if (!dropzone || !root.contains(dropzone)) return;
      event.preventDefault();

      if (event.type === "dragover" || event.type === "dragenter") {
        dropzone.classList.add("is-dragover");
      }

      if (event.type === "dragleave") {
        const related = event.relatedTarget;
        if (!related || !dropzone.contains(related)) {
          dropzone.classList.remove("is-dragover");
        }
      }
    }

    function handleUploadDrop(event) {
      const dropzone = event.target.closest("[data-p23m-upload-dropzone]");
      if (!dropzone || !root.contains(dropzone)) return;
      event.preventDefault();
      dropzone.classList.remove("is-dragover");

      const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      uploadFile(file);
    }


    function ensureZoomResetButton() {
      const wrap = q(".p23m__zoom");
      if (!wrap) return null;

      let shell = q("[data-p23m-zoom-reset-shell]");
      if (!shell) {
        shell = document.createElement("div");
        shell.className = "p23m__zoom-reset-shell";
        shell.dataset.p23mZoomResetShell = "true";
        shell.hidden = true;

        const parent = wrap.parentElement || q("[data-p23m-canvas]") || root;
        parent.appendChild(shell);
      }

      let reset = q("[data-p23m-zoom-reset]");
      if (!reset) {
        reset = document.createElement("button");
        reset.type = "button";
        reset.className = "p23m__zoom-reset";
        reset.dataset.p23mZoomReset = "true";
        reset.setAttribute("aria-label", "Restablecer vista al 100%");
        reset.title = "Restablecer vista al 100%";
        reset.innerHTML = "&#8634;";
      }

      if (reset.parentElement !== shell) shell.appendChild(reset);
      return reset;
    }

    function ensureZoomSliderUI() {
      const wrap = q(".p23m__zoom");
      if (!wrap) return null;

      let nativeInput = q("[data-p23m-zoom]");
      if (nativeInput) {
        nativeInput.tabIndex = -1;
        nativeInput.setAttribute("aria-hidden", "true");
      }

      let track = q("[data-p23m-zoom-track]");
      if (!track) {
        track = document.createElement("div");
        track.className = "p23m__zoom-track";
        track.dataset.p23mZoomTrack = "true";
        track.setAttribute("role", "slider");
        track.setAttribute("aria-label", "Zoom");
        track.setAttribute("aria-orientation", "vertical");
        track.setAttribute("aria-valuemin", "100");
        track.setAttribute("aria-valuemax", "700");
        track.tabIndex = 0;
        track.innerHTML = '<span class="p23m__zoom-track-line" aria-hidden="true"></span><span class="p23m__zoom-track-fill" aria-hidden="true"></span><span class="p23m__zoom-track-thumb" aria-hidden="true"></span>';

        const label = q("[data-p23m-zoom-value]");
        if (label && label.parentElement === wrap) {
          label.insertAdjacentElement("afterend", track);
        } else if (nativeInput && nativeInput.parentElement === wrap) {
          nativeInput.insertAdjacentElement("afterend", track);
        } else {
          wrap.appendChild(track);
        }
      }

      return track;
    }

    function normalizeZoomControls() {
      const zoom = q("[data-p23m-zoom]");
      const value = clamp(Number(state.zoom || 100), 100, 700);

      state.zoom = value;
      if (zoom) {
        zoom.min = "100";
        zoom.max = "700";
        zoom.step = "1";
        zoom.value = String(Math.round(value));
        zoom.setAttribute("aria-valuemin", "100");
        zoom.setAttribute("aria-valuemax", "700");
        zoom.setAttribute("aria-valuenow", String(Math.round(value)));
      }
      ensureZoomSliderUI();
      ensureZoomResetButton();
      updateZoomLabelOnly(value);
    }

    const zoomControlState = {
      active: false,
      pointerId: null,
      pointerTarget: null,
      raf: 0,
      pending: 100,
      saveTimer: 0
    };

    function setZoomVisual(value, persist) {
      const next = clamp(Number(value || 100) || 100, 100, 700);
      state.zoom = next;

      const zoom = q("[data-p23m-zoom]");
      if (zoom) {
        zoom.value = String(Math.round(next));
        zoom.setAttribute("aria-valuenow", String(Math.round(next)));
      }

      updateZoomLabelOnly(next);
      applyMockupTransformOnly();

      if (persist) {
        window.clearTimeout(zoomControlState.saveTimer);
        zoomControlState.saveTimer = window.setTimeout(scheduleDraftSaveFast, 120);
      }
    }

    function scheduleZoomPaint(value, persist) {
      zoomControlState.pending = clamp(Number(value || state.zoom || 100) || 100, 100, 700);
      if (zoomControlState.raf) return;

      zoomControlState.raf = window.requestAnimationFrame(() => {
        zoomControlState.raf = 0;
        setZoomVisual(zoomControlState.pending, persist);
      });
    }

    function zoomValueFromPointer(event) {
      const track = q("[data-p23m-zoom-track]") || q("[data-p23m-zoom]") || q(".p23m__zoom");
      if (!track) return state.zoom || 100;

      const rect = track.getBoundingClientRect();
      const height = Math.max(1, rect.height || 1);
      const y = clamp(Number(event.clientY || 0), rect.top, rect.bottom);
      const progress = clamp((rect.bottom - y) / height, 0, 1);
      return 100 + progress * 600;
    }

    function handleZoomPointerDown(event) {
      const zoom = event.target.closest && event.target.closest("[data-p23m-zoom-track], [data-p23m-zoom]");
      if (!zoom || !root.contains(zoom)) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      zoomControlState.active = true;
      zoomControlState.pointerId = event.pointerId;
      zoomControlState.pointerTarget = zoom;
      root.classList.add("is-p23m-zooming");

      try { zoom.setPointerCapture(event.pointerId); } catch (error) {}
      scheduleZoomPaint(zoomValueFromPointer(event), true);
    }

    function handleZoomPointerMove(event) {
      if (!zoomControlState.active || event.pointerId !== zoomControlState.pointerId) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      scheduleZoomPaint(zoomValueFromPointer(event), true);
    }

    function finishZoomPointer(event) {
      if (!zoomControlState.active) return;
      if (event && zoomControlState.pointerId !== null && event.pointerId !== zoomControlState.pointerId) return;

      const zoom = zoomControlState.pointerTarget || q("[data-p23m-zoom-track]") || q("[data-p23m-zoom]");
      if (zoom && event) {
        try { zoom.releasePointerCapture(event.pointerId); } catch (error) {}
      }

      zoomControlState.active = false;
      zoomControlState.pointerId = null;
      zoomControlState.pointerTarget = null;
      root.classList.remove("is-p23m-zooming");
      clampMockupPan();
      applyMockupTransformOnly();
      scheduleDraftSaveFast();
    }

    function handleZoom(event) {
      if (!event.target.matches("[data-p23m-zoom]")) return;
      if (zoomControlState.active) return;
      const next = clamp(Number(event.target.value) || 100, 100, 700);
      scheduleZoomPaint(next, true);
    }

    root.addEventListener("click", handleClick, true);
    root.addEventListener("pointerdown", handleClick, true);
    root.addEventListener("pointermove", handleClick, true);
    root.addEventListener("input", handleInput, true);
    root.addEventListener("focusin", handleQuantityFocus, true);
    root.addEventListener("focusin", calibratorHandleFieldFocus, true);
    root.addEventListener("keydown", calibratorHandleKeydown, true);
    root.addEventListener("change", handleQuantityCommit, true);
    root.addEventListener("change", calibratorCommitFields, true);
    root.addEventListener("change", handleFile, true);
    root.addEventListener("dragenter", handleUploadDrag, true);
    root.addEventListener("dragover", handleUploadDrag, true);
    root.addEventListener("dragleave", handleUploadDrag, true);
    root.addEventListener("drop", handleUploadDrop, true);
    root.addEventListener("pointerdown", handleZoomPointerDown, true);
    root.addEventListener("pointermove", handleZoomPointerMove, true);
    root.addEventListener("pointerup", finishZoomPointer, true);
    root.addEventListener("pointercancel", finishZoomPointer, true);
    root.addEventListener("input", handleZoom, true);
    root.addEventListener("change", (event) => {
      if (!event.target.matches("[data-p23m-zoom]")) return;
      if (zoomControlState.active) return;
      const finalZoom = clamp(Number(event.target.value) || state.zoom || 100, 100, 700);
      setZoomVisual(finalZoom, true);
      clampMockupPan();
      applyMockupTransformOnly();
      scheduleDraftSaveFast();
    }, true);

    calibratorInjectStyle();
    ensureCoordinateSpace();

    window.addEventListener("resize", scheduleResponsiveMockupScale, { passive: true });

    const stageForResize = mockupStageElement();
    if (stageForResize && "ResizeObserver" in window) {
      const p23mMockupResizeObserver = new ResizeObserver(scheduleResponsiveMockupScale);
      p23mMockupResizeObserver.observe(stageForResize);
    }

    renderAll();
    restoreDraftIfAvailable();

    window.addEventListener("pagehide", () => {
      if (!draftAutoSaveBlocked) saveDraftNow();
    }, { passive: true });
    window.addEventListener("beforeunload", () => {
      if (!draftAutoSaveBlocked) saveDraftNow();
    });
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden" && !draftAutoSaveBlocked) saveDraftNow();
    });

    window.addEventListener("pageshow", () => {
      if (!hasSuccessfulCartResetMarker()) return;
      clearLocalDraftAndDesign({ keepAutosaveBlocked: false })
        .then(() => {
          clearSuccessfulCartResetMarker();
          root.dispatchEvent(new CustomEvent("p23m:reset-after-cart", { bubbles: true }));
        })
        .catch((error) => {
          console.warn("[23DTF] No se pudo completar el reset al volver del carrito", error);
        });
    });

    root.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        const cartConfirm = q("[data-p23m-cart-confirm]");
        if (cartConfirm && !cartConfirm.hidden && !state.exportBusy) {
          event.preventDefault();
          closePersonalizedCartConfirmation(false);
          return;
        }

        const modal = q("[data-p23m-filelib]");
        if (modal && !modal.hidden) {
          event.preventDefault();
          closeFileLibrary();
        }
      }
    }, true);


    function fileLibrarySearchTerm() {
      const input = q("[data-p23m-filelib-search]");
      return input ? String(input.value || "").trim().toLowerCase() : "";
    }

    function fileLibraryFiles() {
      const term = fileLibrarySearchTerm();
      const filtered = term
        ? state.uploads.filter((file) => String(file.name || "").toLowerCase().includes(term))
        : state.uploads;
      return sortedUploads(filtered);
    }

    function closestFromEventTarget(target, selector) {
      let node = target && target.nodeType === 1 ? target : target && target.parentElement;
      return node && node.closest ? node.closest(selector) : null;
    }

    function ensureFileLibraryIosInlineHeader(modal) {
      if (!modal) return null;

      const body = modal.querySelector(".p23m-filelib__body");
      if (!body) return null;

      let header = body.querySelector("[data-p23m-filelib-ios-inline-header]");
      if (!header) {
        header = document.createElement("div");
        header.className = "p23m-filelib__ios-inline-header";
        header.dataset.p23mFilelibIosInlineHeader = "true";
        header.innerHTML = '<h2>Tus archivos</h2><button type="button" aria-label="Cerrar Tus archivos" data-p23m-filelib-close data-p23m-filelib-ios-inline-close>×</button>';
        body.insertBefore(header, body.firstChild);
      }

      return header;
    }

    function ensureFileLibraryIosCloseButton(modal) {
      if (!modal) return null;

      const dialog = modal.querySelector(".p23m-filelib__dialog") || modal;
      let button = dialog.querySelector("[data-p23m-filelib-ios-close]");

      dialog.classList.add("has-ios-close");
      ensureFileLibraryIosInlineHeader(modal);

      if (!button) {
        button = document.createElement("button");
        button.type = "button";
        button.className = "p23m-filelib__ios-close";
        button.dataset.p23mFilelibClose = "true";
        button.dataset.p23mFilelibIosClose = "true";
        button.setAttribute("aria-label", "Cerrar Tus archivos");
        button.textContent = "×";
        dialog.appendChild(button);
      }

      return button;
    }

    function ensureFileLibraryForceCloseButton(modal) {
      if (!modal) return null;

      /*
        v4.11m-REV5:
        Ya no usamos X global/flotante. El cierre extra se integra dentro del
        propio popup Tus archivos y se muestra solo en iOS por CSS.
      */
      return ensureFileLibraryIosCloseButton(modal);
    }

    function ensureFileLibraryEvents(modal) {
      if (!modal || modal.dataset.p23mFilelibDirectReady === "true") return;
      modal.dataset.p23mFilelibDirectReady = "true";

      const closeFromFileLibrary = (event) => {
        const closeTarget = closestFromEventTarget(event.target, "[data-p23m-filelib-close]");
        const backdrop = closestFromEventTarget(event.target, ".p23m-filelib__backdrop");

        if ((closeTarget && modal.contains(closeTarget)) || (backdrop && modal.contains(backdrop))) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          closeFileLibrary();
          return true;
        }

        return false;
      };

      /*
        v4.11m-REV3:
        iPhone/Safari puede perder el click dentro de overlays con scroll.
        Por eso cerramos en la fase más temprana posible para el botón X:
        touchstart / pointerdown / touchend / pointerup / click.
      */
      modal.addEventListener("touchstart", closeFromFileLibrary, { capture: true, passive: false });
      modal.addEventListener("touchend", closeFromFileLibrary, { capture: true, passive: false });
      modal.addEventListener("pointerdown", closeFromFileLibrary, true);
      modal.addEventListener("pointerup", closeFromFileLibrary, true);
      modal.addEventListener("click", closeFromFileLibrary, true);

      const header = modal.querySelector(".p23m-filelib__header");
      if (header) {
        header.addEventListener("touchmove", (event) => {
          event.preventDefault();
        }, { capture: true, passive: false });
      }
    }

    function openFileLibrary() {
      const modal = q("[data-p23m-filelib]");
      if (!modal) return;

      ensureFileLibraryEvents(modal);
      ensureFileLibraryForceCloseButton(modal);

      state.fileLibraryOpenedAt = Date.now();

      modal.hidden = false;
      modal.removeAttribute("hidden");
      modal.setAttribute("aria-hidden", "false");
      modal.classList.add("is-open");
      modal.classList.add("is-opening");
      root.classList.add("is-p23m-filelib-open");
      document.documentElement.classList.add("p23m-filelib-open");
      document.body.classList.add("p23m-filelib-open");

      renderFileLibrary();
      ensureFileLibraryIosInlineHeader(modal);

      window.setTimeout(() => {
        modal.classList.remove("is-opening");
      }, 460);

      window.requestAnimationFrame(() => {
        modal.scrollTop = 0;
        const body = modal.querySelector(".p23m-filelib__body");
        if (body) body.scrollTop = 0;
      });

      setTimeout(() => q("[data-p23m-filelib-search]")?.focus({ preventScroll: true }), 60);
    }

    function closeFileLibrary() {
      const modal = q("[data-p23m-filelib]");
      if (!modal) return;

      modal.hidden = true;
      modal.setAttribute("hidden", "");
      modal.setAttribute("aria-hidden", "true");
      modal.classList.remove("is-open");
      modal.classList.remove("is-opening");
      root.classList.remove("is-p23m-filelib-open");
      document.documentElement.classList.remove("p23m-filelib-open");
      document.body.classList.remove("p23m-filelib-open");
    }

    function renderFileCard(file, compact) {
      const id = escapeHtml(file.id);
      const name = escapeHtml(file.name || "Archivo");
      const src = escapeHtml(file.src || "");
      const type = escapeHtml(file.type || "imagen");
      const size = escapeHtml(formatFileSize(file.size));
      const resolution = file.width && file.height ? escapeHtml(file.width + " × " + file.height + " px") : "Resolución pendiente";
      const created = escapeHtml(formatDateTime(file.createdAt));
      const optimizedBadge = file.optimizedForEditor ? '<em class="p23m-image-guard__badge">Optimizada</em>' : '';
      const originalInfo = file.optimizedForEditor && file.originalWidth && file.originalHeight ? '<span><b>Original:</b> ' + escapeHtml(file.originalWidth + " × " + file.originalHeight + " px · " + formatFileSize(file.originalSize || file.size)) + '</span>' : '';

      if (compact) {
        return '' +
          '<button type="button" class="p23m-filelib__recent-card" data-p23m-apply-upload="' + id + '">' +
            '<span class="p23m-filelib__recent-thumb"><img src="' + src + '" alt=""></span>' +
            '<span class="p23m-filelib__recent-meta">' +
              '<span class="p23m-filelib__recent-name">' + name + optimizedBadge + '</span>' +
              '<small>' + size + (file.width && file.height ? " · " + resolution : "") + '</small>' +
            '</span>' +
          '</button>';
      }

      return '' +
        '<article class="p23m-filelib__card">' +
          '<label class="p23m-filelib__card-check"><input type="checkbox"></label>' +
          '<button type="button" class="p23m-filelib__card-thumb" data-p23m-apply-upload="' + id + '">' +
            '<img src="' + src + '" alt="' + name + '">' +
            '<span class="p23m-filelib__card-overlay"><span>Aplicar</span></span>' +
          '</button>' +
          '<div class="p23m-filelib__card-body">' +
            '<strong>' + name + optimizedBadge + '</strong>' +
            '<span><b>Tipo:</b> ' + type + '</span>' +
            '<span><b>Tamaño editor:</b> ' + size + '</span>' +
            '<span><b>Resolución editor:</b> ' + resolution + '</span>' +
            originalInfo +
            '<span><b>Creado:</b> ' + created + '</span>' +
          '</div>' +
        '</article>';
    }

    function renderFileLibrary() {
      const recent = q("[data-p23m-filelib-recent]");
      const grid = q("[data-p23m-filelib-grid]");
      const count = q("[data-p23m-filelib-count]");
      const empty = q("[data-p23m-filelib-empty]");
      const sortLabelEl = q("[data-p23m-filelib-sort-label]");
      const sortMenu = q("[data-p23m-filelib-sort-menu]");
      const sortToggle = q("[data-p23m-filelib-sort-toggle]");
      const files = fileLibraryFiles();
      const recentFiles = sortedUploads(state.uploads).slice(0, 4);

      if (count) count.textContent = "Archivos en Tus archivos (" + state.uploads.length + ")";
      if (sortLabelEl) sortLabelEl.textContent = sortLabel(state.fileLibrarySort);
      qa("[data-p23m-filelib-sort-value]").forEach((button) => {
        button.classList.toggle("is-active", button.dataset.p23mFilelibSortValue === state.fileLibrarySort);
      });
      if (sortMenu && sortToggle) sortToggle.setAttribute("aria-expanded", sortMenu.hidden ? "false" : "true");
      if (recent) recent.innerHTML = recentFiles.map((file) => renderFileCard(file, true)).join("");
      if (grid) grid.innerHTML = files.map((file) => renderFileCard(file, false)).join("");
      if (empty) empty.hidden = state.uploads.length > 0;
    }

    function openNativeUploadFromLibrary() {
      const input = q("[data-p23m-file-input]");
      if (input) {
        input.value = "";
        input.click();
      }
    }


    function calibratorInjectStyle() {
      if (document.getElementById("p23m-calibrator-style")) return;
      const style = document.createElement("style");
      style.id = "p23m-calibrator-style";
      style.textContent = `
        .p23m.is-calibrating [data-p23m-safe] {
          border: 2px solid #ef4444 !important;
          background: rgba(239, 68, 68, .10) !important;
          box-shadow: 0 0 0 9999px rgba(0, 0, 0, .02), 0 0 0 6px rgba(239, 68, 68, .14) !important;
          pointer-events: auto !important;
          z-index: 40 !important;
          cursor: move !important;
        }
        .p23m.is-calibrating {
          position: relative;
        }
        .p23m-calibrator-panel {
          position: absolute;
          left: 14px;
          top: 14px;
          z-index: 80;
          width: 300px;
          border: 1px solid #fecaca;
          border-radius: 10px;
          background: #fff;
          box-shadow: 0 16px 40px rgba(0,0,0,.16);
          color: #111827;
          font-size: 12px;
          overflow: hidden;
        }
        .p23m-calibrator-panel__head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          padding: 10px 12px;
          background: #fee2e2;
          color: #991b1b;
          font-weight: 800;
          cursor: grab;
          user-select: none;
          touch-action: none;
        }
        .p23m-calibrator-panel__head:active {
          cursor: grabbing;
        }
        .p23m-calibrator-panel__body { padding: 10px 12px; display: grid; gap: 8px; }
        .p23m-calibrator-panel code { font-size: 11px; color: #374151; word-break: break-all; }
        .p23m-calibrator-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 6px; }
        .p23m-calibrator-grid label { display: grid; gap: 3px; color: #6b7280; font-weight: 700; }
        .p23m-calibrator-grid input {
          width: 100%; border: 1px solid #d1d5db; border-radius: 6px; padding: 5px 6px; font: inherit; color: #111827;
        }
        .p23m-calibrator-actions { display: flex; flex-wrap: wrap; gap: 6px; }
        .p23m-calibrator-actions button {
          border: 1px solid #d1d5db; border-radius: 7px; background: #fff; padding: 7px 8px; font-weight: 800; cursor: pointer;
        }
        .p23m-calibrator-actions button.primary { background: #ef4444; border-color: #ef4444; color: #fff; }
        .p23m-calibrator-actions button.soft { background: #fff1f2; border-color: #fecaca; color: #991b1b; }
        .p23m-calibrator-status {
          border-radius: 8px;
          padding: 8px 10px;
          font-weight: 800;
          line-height: 1.35;
          border: 1px solid transparent;
        }
        .p23m-calibrator-status.is-success { background: #ecfdf5; border-color: #bbf7d0; color: #166534; }
        .p23m-calibrator-status.is-error { background: #fef2f2; border-color: #fecaca; color: #991b1b; }
        .p23m-calibrator-toast {
          position: fixed;
          right: 24px;
          bottom: 24px;
          z-index: 999999;
          max-width: 340px;
          border-radius: 10px;
          padding: 12px 14px;
          box-shadow: 0 16px 40px rgba(0,0,0,.18);
          font-size: 13px;
          font-weight: 900;
          line-height: 1.35;
          pointer-events: none;
        }
        .p23m-calibrator-toast.is-success { background: #dcfce7; color: #14532d; border: 1px solid #86efac; }
        .p23m-calibrator-toast.is-error { background: #fee2e2; color: #7f1d1d; border: 1px solid #fca5a5; }
        .p23m-calibrator-handle {
          position: absolute; width: 13px; height: 13px; border-radius: 3px; border: 2px solid #fff; background: #ef4444;
          box-shadow: 0 1px 4px rgba(0,0,0,.22); z-index: 42;
        }
        .p23m-calibrator-handle.nw { left: -8px; top: -8px; cursor: nwse-resize; }
        .p23m-calibrator-handle.ne { right: -8px; top: -8px; cursor: nesw-resize; }
        .p23m-calibrator-handle.sw { left: -8px; bottom: -8px; cursor: nesw-resize; }
        .p23m-calibrator-handle.se { right: -8px; bottom: -8px; cursor: nwse-resize; }
        .p23m-calibrator-label {
          position: absolute; left: 50%; bottom: -28px; transform: translateX(-50%); white-space: nowrap;
          border-radius: 999px; background: #ef4444; color: #fff; padding: 4px 8px; font-size: 11px; font-weight: 800;
          box-shadow: 0 2px 8px rgba(0,0,0,.16);
        }

        [data-p23m-safe] {
          opacity: 0;
          pointer-events: none;
          transition: opacity .14s ease;
        }
        [data-p23m-safe].is-p23m-visible,
        .p23m.is-calibrating [data-p23m-safe] {
          opacity: 1;
        }
        .p23m__layer-item .p23m__selection {
          opacity: 1;
        }
        .p23m__rotate {
          position: absolute;
          left: 50%;
          top: -34px;
          width: 26px;
          height: 26px;
          transform: translateX(-50%);
          border: 1px solid #0d6aa8;
          border-radius: 999px;
          background: #fff;
          color: #0d6aa8;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          font-weight: 800;
          line-height: 1;
          cursor: grab;
          box-shadow: 0 8px 18px rgba(0,0,0,.16);
          pointer-events: auto;
        }
        .p23m__print-warning {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          z-index: 70;
          border: 0;
          border-bottom: 1px solid #f59e0b;
          background: #fffbeb;
          color: #92400e;
          box-shadow: 0 8px 22px rgba(0,0,0,.10);
          padding: 11px 18px;
          font-size: 13px;
          font-weight: 700;
          text-align: center;
        }
        .p23m__print-warning[hidden] {
          display: none !important;
        }

        [data-p23m-safe].is-p23m-visible {
          border: 2px solid #ef4444 !important;
          background: rgba(239, 68, 68, .08) !important;
          box-shadow: 0 0 0 5px rgba(239, 68, 68, .12) !important;
          opacity: 1 !important;
          z-index: 45 !important;
        }

        /* urgent print area v4.9i */

        .p23m.is-p23m-layer-interacting [data-p23m-safe],
        .p23m.is-p23m-layer-interacting .p23m__safe,
        [data-p23m-safe].is-p23m-visible,
        .p23m__safe.is-p23m-visible {
          display: block !important;
          opacity: 1 !important;
          visibility: visible !important;
          border: 2px dashed #ef4444 !important;
          background: rgba(239, 68, 68, .08) !important;
          box-shadow: 0 0 0 5px rgba(239, 68, 68, .12) !important;
          z-index: 45 !important;
          pointer-events: none !important;
        }
        .p23m__print-warning {
          position: absolute !important;
          left: 0 !important;
          right: 0 !important;
          top: 0 !important;
          z-index: 80 !important;
          border: 0 !important;
          border-bottom: 1px solid #f59e0b !important;
          border-radius: 0 !important;
          background: #fffbeb !important;
          color: #92400e !important;
          box-shadow: 0 8px 22px rgba(0,0,0,.10) !important;
          padding: 11px 18px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          text-align: center !important;
          max-width: none !important;
          transform: none !important;
        }
        .p23m__print-warning[hidden] {
          display: none !important;
        }

        .p23m.is-p23m-inner-label-view [data-p23m-canvas] {
          background: var(--p23m-inner-label-bg, #ffffff) !important;
        }
        .p23m.is-p23m-inner-label-view [data-p23m-product-image] {
          background: var(--p23m-inner-label-bg, #ffffff) !important;
          object-fit: contain !important;
        }

        .p23m-qol__table-wrap {
          border: 1px solid #e5e7eb;
          border-radius: 10px;
          background: #fff;
          overflow: auto;
        }
        .p23m-qol__table {
          width: 100%;
          min-width: 620px;
          border-collapse: separate;
          border-spacing: 0;
          font-size: 13px;
        }
        .p23m-qol__table th,
        .p23m-qol__table td {
          border: 0;
          border-bottom: 1px solid #ececec;
          padding: 10px 8px;
          vertical-align: middle;
        }
        .p23m-qol__table thead th {
          background: #fafafa;
          color: #6d7175;
          font-weight: 600;
          font-size: 12px;
          text-align: center;
          white-space: nowrap;
        }
        .p23m-qol__table thead th:first-child {
          text-align: left;
          position: sticky;
          left: 0;
          z-index: 2;
          background: #fafafa;
        }
        .p23m-qol__product-cell {
          min-width: 180px;
          position: sticky;
          left: 0;
          z-index: 1;
          background: #fff;
        }
        .p23m-qol__row:hover .p23m-qol__product-cell,
        .p23m-qol__row:hover {
          background: #f8fafc;
        }
        .p23m-qol__row.is-selected-color,
        .p23m-qol__row.is-selected-color .p23m-qol__product-cell {
          background: #eff6ff !important;
          box-shadow: inset 3px 0 0 #0d6aa8;
        }
        .p23m-qol__color-button {
          border: 0;
          background: transparent;
          padding: 0;
          display: flex;
          align-items: center;
          gap: 10px;
          width: 100%;
          text-align: left;
          cursor: pointer;
          color: #202223;
        }
        .p23m-qol__color-title {
          font-weight: 650;
          line-height: 1.2;
          word-break: break-word;
        }
        .p23m-qol__qty-cell {
          text-align: center;
          min-width: 74px;
        }
        .p23m-qol__input {
          width: 58px;
          min-height: 36px;
          border: 1px solid #d6d9dc;
          border-radius: 7px;
          background: #fff;
          text-align: center;
          font-size: 13px;
          font-weight: 600;
          color: #202223;
        }
        .p23m-qol__input:focus {
          outline: 2px solid rgba(13, 106, 168, .22);
          border-color: #0d6aa8;
        }
        .p23m__personalizer-swatch-button {
          flex: 0 0 auto;
          border: 1px solid #d1d5db !important;
          cursor: pointer;
          background-size: cover !important;
          background-position: center !important;
          background-repeat: no-repeat !important;
          padding: 0 !important;
          box-shadow: inset 0 0 0 1px rgba(0,0,0,.04);
        }

        /* v4.9m: tabla con personalización igualada a matriz del producto, sin miniaturas de producto */
        .p23m-matrix-wrap {
          width: 100%;
          max-height: 370px;
          overflow: auto;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          background: #fff;
        }
        .p23m-matrix {
          width: max-content;
          min-width: 100%;
          border-collapse: collapse;
          background: #fff;
        }
        .p23m-matrix th,
        .p23m-matrix td {
          padding: 12px 10px;
          border-bottom: 1px solid rgba(18,18,18,.08);
          text-align: center;
          vertical-align: middle;
          background: #fff;
        }
        .p23m-matrix thead th {
          position: sticky;
          top: 0;
          z-index: 3;
          background: #fff;
          color: #3f3f46;
          font-size: 13px;
          font-weight: 700;
          text-transform: none;
          white-space: nowrap;
        }
        .p23m-matrix thead th:first-child,
.p23m-matrix__color-th {
  position: sticky;
  left: 0;
  z-index: 4;
  background: #fff !important;
  text-align: left !important;
  width: 95px !important;
  min-width: 95px !important;
  max-width: 95px !important;
}
        .p23m-matrix__row:hover th,
        .p23m-matrix__row:hover td {
          background: #f8fafc;
        }
        .p23m-matrix__row.is-selected-color th,
        .p23m-matrix__row.is-selected-color td {
          background: #FEEEEE !important;
        }
        .p23m-matrix__row.is-selected-color .p23m-matrix__color-th {
          box-shadow: inset 4px 0 0 #DF0201;
        }
       .p23m-matrix__color-button {
  border: 0;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 95px !important;
  max-width: 95px !important;
  text-align: left;
  cursor: pointer;
  color: #202223;
  font: inherit;
}
        .p23m-matrix__swatch {
          width: 28px !important;
          height: 28px !important;
          flex: 0 0 28px !important;
          border-radius: 8px !important;
          border: 1px solid rgba(18,18,18,.14) !important;
          box-shadow: inset 0 0 0 1px rgba(255,255,255,.25);
          background-size: auto !important;
          background-position: initial !important;
          background-repeat: initial !important;
        }
        .p23m-matrix__color-label {
          font-size: 13px;
          font-weight: 700;
          line-height: 1.2;
          color: #3f3f46;
          word-break: break-word;
        }
        .p23m-matrix__qty-cell {
  min-width: 68px;
}

.p23m-matrix__qty {
  width: 58px;
  min-height: 38px;
  padding: 4px 6px;
  border-radius: 9px;
  border: 1px solid rgba(18,18,18,.18);
  background: #fff;
  text-align: center;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  color: #202223;
}
        .p23m-matrix__qty:focus {
          outline: 2px solid rgba(13,106,168,.22);
          border-color: #0d6aa8;
        }
      `;
      document.head.appendChild(style);
    }

    function calibratorCurrentInfo() {
      const api = printMapApi();
      const mapInfo = api && typeof api.getCurrentProductPrintMap === "function" ? api.getCurrentProductPrintMap(product.handle, product.refFabricante || product.referenciaFabricante || product.manufacturerReference || "", product.fabricante || product.manufacturer || "") : null;
      const groupId = mapInfo && mapInfo.groupId ? mapInfo.groupId : "tshirt_sleeve_coords_1";
      const productKey = mapInfo && mapInfo.productKey ? mapInfo.productKey : "";
      const zone = currentZone();
      return { api, groupId, productKey, zoneId: state.zone, zone };
    }

    function calibratorApplyRect(rect, rotation, options) {
      const opts = options || {};
      const info = calibratorCurrentInfo();
      if (!info.api || typeof info.api.updateGroupZone !== "function") return;
      info.api.updateGroupZone(info.groupId, info.zoneId, {
        rect: {
          x: Math.round(Number(rect.x) || 0),
          y: Math.round(Number(rect.y) || 0),
          w: Math.max(10, Math.round(Number(rect.w) || 10)),
          h: Math.max(10, Math.round(Number(rect.h) || 10))
        },
        rotation: Math.round(Number(rotation || 0))
      });
      renderZone();
      renderCanvasUploadButton();
      renderLayers();
      renderLayerPanel();
      if (!opts.skipPanel) calibratorRenderPanel();
    }

    function calibratorShowMessage(type, message) {
      const safeType = type === "error" ? "error" : "success";
      const safeMessage = String(message || (safeType === "error" ? "No se pudo copiar." : "Copiado correctamente."));

      state.calibrator.copyStatus = { type: safeType, message: safeMessage };
      window.clearTimeout(state.calibrator.copyTimer);

      let toast = document.querySelector("[data-p23m-calibrator-toast]");
      if (!toast) {
        toast = document.createElement("div");
        toast.dataset.p23mCalibratorToast = "true";
        document.body.appendChild(toast);
      }

      toast.className = "p23m-calibrator-toast is-" + safeType;
      toast.textContent = safeMessage;
      toast.hidden = false;

      state.calibrator.copyTimer = window.setTimeout(() => {
        state.calibrator.copyStatus = null;
        const currentToast = document.querySelector("[data-p23m-calibrator-toast]");
        if (currentToast) currentToast.hidden = true;
        calibratorRenderPanel();
      }, 2600);

      calibratorRenderPanel();
    }

    function calibratorFallbackCopy(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "readonly");
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      textarea.style.top = "0";
      document.body.appendChild(textarea);
      textarea.select();

      let copied = false;
      try {
        copied = document.execCommand("copy");
      } catch (error) {
        copied = false;
      }

      textarea.remove();
      return copied;
    }

    function calibratorCopyText(text, successMessage, errorMessage) {
      const value = String(text || "");
      if (!value.trim()) {
        calibratorShowMessage("error", errorMessage || "No hay texto para copiar.");
        return Promise.resolve(false);
      }

      if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
        return navigator.clipboard.writeText(value)
          .then(() => {
            calibratorShowMessage("success", successMessage);
            return true;
          })
          .catch((error) => {
            console.warn("[23DTF] No se pudo copiar con Clipboard API", error);
            const copied = calibratorFallbackCopy(value);
            calibratorShowMessage(copied ? "success" : "error", copied ? successMessage : (errorMessage || "No se pudo copiar. Revisa permisos del navegador."));
            return copied;
          });
      }

      const copied = calibratorFallbackCopy(value);
      calibratorShowMessage(copied ? "success" : "error", copied ? successMessage : (errorMessage || "No se pudo copiar. Revisa permisos del navegador."));
      return Promise.resolve(copied);
    }

    function calibratorExportGroup() {
      const info = calibratorCurrentInfo();
      const maps = window.P23DTF_PRINT_GROUP_MAPS || {};
      const group = maps[info.groupId] || null;

      if (!group) {
        const message = "No se pudo copiar el grupo: no existe el mapa " + info.groupId + ".";
        console.warn("[23DTF] " + message);
        calibratorShowMessage("error", message);
        return "";
      }

      const txt = JSON.stringify({ [info.groupId]: group }, null, 2);
      state.calibrator.lastExport = txt;
      calibratorCopyText(txt, "Grupo copiado con éxito.", "No se pudo copiar el grupo.");
      console.log("[23DTF] Grupo calibrado", txt);
      return txt;
    }

    function calibratorExportAll() {
      const api = printMapApi();
      const txt = api && typeof api.exportMaps === "function" ? api.exportMaps() : JSON.stringify(window.P23DTF_PRINT_GROUP_MAPS || {}, null, 2);
      state.calibrator.lastExport = txt;
      calibratorCopyText(txt, "Texto copiado.", "No se pudo copiar el texto.");
      console.log("[23DTF] Todos los mapas calibrados", txt);
      return txt;
    }

    function calibratorRenderSafe() {
      const safe = q("[data-p23m-safe]");
      if (!safe) return;
      if (!state.calibrator.enabled) {
        safe.innerHTML = "";
        safe.removeEventListener("pointerdown", calibratorPointerDown);
        return;
      }
      if (!safe.dataset.p23mCalibratorBound) {
        safe.dataset.p23mCalibratorBound = "true";
        safe.addEventListener("pointerdown", calibratorPointerDown);
      }
      safe.innerHTML = '<span class="p23m-calibrator-handle nw" data-p23m-calibrator-resize="nw"></span><span class="p23m-calibrator-handle ne" data-p23m-calibrator-resize="ne"></span><span class="p23m-calibrator-handle sw" data-p23m-calibrator-resize="sw"></span><span class="p23m-calibrator-handle se" data-p23m-calibrator-resize="se"></span><span class="p23m-calibrator-label">Zona de impresión</span>';
    }

    function calibratorRenderPanel() {
      const host = root;
      if (!host) return;
      let panel = q("[data-p23m-calibrator-panel]");
      if (!state.calibrator.enabled) {
        if (panel) panel.remove();
        return;
      }
      if (!panel) {
        panel = document.createElement("div");
        panel.className = "p23m-calibrator-panel";
        panel.dataset.p23mCalibratorPanel = "true";
        host.appendChild(panel);
      }
      if (!Number.isFinite(Number(state.calibrator.panelX))) state.calibrator.panelX = 14;
      if (!Number.isFinite(Number(state.calibrator.panelY))) state.calibrator.panelY = 14;
      panel.style.left = Math.round(state.calibrator.panelX) + "px";
      panel.style.top = Math.round(state.calibrator.panelY) + "px";
      const info = calibratorCurrentInfo();
      const rect = info.zone && info.zone.rect ? info.zone.rect : { x: 0, y: 0, w: 10, h: 10 };
      const rotation = Number(info.zone && info.zone.mapRotation || 0);
      panel.innerHTML =
        '<div class="p23m-calibrator-panel__head" data-p23m-calibrator-drag title="Arrastrar panel"><span>Calibrador activo</span><button type="button" data-p23m-calibrator-action="disable">×</button></div>' +
        '<div class="p23m-calibrator-panel__body">' +
          '<div><strong>Grupo:</strong><br><code>' + escapeHtml(info.groupId) + '</code></div>' +
          '<div><strong>Zona:</strong><br><code>' + escapeHtml(info.zoneId) + '</code></div>' +
          '<div class="p23m-calibrator-grid">' +
            '<label>X<input data-p23m-calibrator-field="x" type="text" inputmode="numeric" autocomplete="off" value="' + Math.round(rect.x) + '"></label>' +
            '<label>Y<input data-p23m-calibrator-field="y" type="text" inputmode="numeric" autocomplete="off" value="' + Math.round(rect.y) + '"></label>' +
            '<label>W<input data-p23m-calibrator-field="w" type="text" inputmode="numeric" autocomplete="off" value="' + Math.round(rect.w) + '"></label>' +
            '<label>H<input data-p23m-calibrator-field="h" type="text" inputmode="numeric" autocomplete="off" value="' + Math.round(rect.h) + '"></label>' +
            '<label>R<input data-p23m-calibrator-field="rotation" type="text" inputmode="numeric" autocomplete="off" value="' + Math.round(rotation) + '"></label>' +
          '</div>' +
          '<div class="p23m-calibrator-actions">' +
            '<button type="button" class="soft" data-p23m-calibrator-action="rotate-left">R -1</button>' +
            '<button type="button" class="soft" data-p23m-calibrator-action="rotate-right">R +1</button>' +
            '<button type="button" class="primary" data-p23m-calibrator-action="export-group">Copiar grupo</button>' +
            '<button type="button" data-p23m-calibrator-action="export-all">Copiar todo</button>' +
          '</div>' +
          (state.calibrator.copyStatus ? '<div class="p23m-calibrator-status is-' + escapeHtml(state.calibrator.copyStatus.type) + '">' + escapeHtml(state.calibrator.copyStatus.message) + '</div>' : '') +
          '<div class="p23m__hint">Puedes arrastrar la cabecera del panel para moverlo dentro del popup. La zona roja sigue sirviendo para ajustar el área de impresión.</div>' +
        '</div>';
    }

    function calibratorRender() {
      root.classList.toggle("is-calibrating", !!state.calibrator.enabled);
      calibratorInjectStyle();
      calibratorRenderSafe();
      calibratorRenderPanel();
    }

    function calibratorParseFieldValue(value) {
      const text = String(value ?? "").trim().replace(",", ".");
      if (text === "" || text === "-" || text === "+") return null;
      const number = Number(text);
      return Number.isFinite(number) ? number : null;
    }

    function calibratorClampFieldValue(key, value) {
      const rounded = Math.round(Number(value) || 0);
      if (key === "x") return clamp(rounded, -120, 500);
      if (key === "y") return clamp(rounded, -120, 520);
      if (key === "w") return clamp(rounded, 12, 360);
      if (key === "h") return clamp(rounded, 12, 420);
      if (key === "rotation") return clamp(rounded, -180, 180);
      return rounded;
    }

    function calibratorReadPanelRect() {
      const info = calibratorCurrentInfo();
      const rect = Object.assign({}, info.zone.rect);
      const panel = q("[data-p23m-calibrator-panel]");
      const rotation = Number(info.zone.mapRotation || 0);
      let nextRotation = rotation;
      if (!panel) return { rect, rotation };
      qa("[data-p23m-calibrator-field]").forEach((field) => {
        const key = field.dataset.p23mCalibratorField;
        const parsed = calibratorParseFieldValue(field.value);
        if (parsed === null) return;
        const value = calibratorClampFieldValue(key, parsed);
        if (["x", "y", "w", "h"].includes(key)) rect[key] = value;
        if (key === "rotation") nextRotation = value;
      });
      return { rect, rotation: nextRotation };
    }

    function calibratorPanelPointerDown(event) {
      const dragHandle = event.target.closest("[data-p23m-calibrator-drag]");
      if (!dragHandle || !root.contains(dragHandle)) return false;
      if (event.target.closest("[data-p23m-calibrator-action], input, button, select, textarea")) return false;

      const panel = q("[data-p23m-calibrator-panel]");
      if (!panel) return false;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      const host = root;
      const hostRect = host.getBoundingClientRect();
      const panelRect = panel.getBoundingClientRect();
      const startX = event.clientX;
      const startY = event.clientY;
      const baseX = Number.isFinite(Number(state.calibrator.panelX)) ? Number(state.calibrator.panelX) : (panelRect.left - hostRect.left);
      const baseY = Number.isFinite(Number(state.calibrator.panelY)) ? Number(state.calibrator.panelY) : (panelRect.top - hostRect.top);

      const move = (moveEvent) => {
        const currentHostRect = host.getBoundingClientRect();
        const currentPanelRect = panel.getBoundingClientRect();
        const maxX = Math.max(0, currentHostRect.width - currentPanelRect.width);
        const maxY = Math.max(0, currentHostRect.height - currentPanelRect.height);
        const nextX = clamp(baseX + (moveEvent.clientX - startX), 0, maxX);
        const nextY = clamp(baseY + (moveEvent.clientY - startY), 0, maxY);
        state.calibrator.panelX = nextX;
        state.calibrator.panelY = nextY;
        panel.style.left = Math.round(nextX) + "px";
        panel.style.top = Math.round(nextY) + "px";
      };

      bindPointer(move);
      return true;
    }

    function calibratorHandleClick(event) {
      const action = event.target.closest("[data-p23m-calibrator-action]");
      if (!action || !root.contains(action)) return false;
      event.preventDefault();
      event.stopPropagation();
      const info = calibratorCurrentInfo();
      const rect = Object.assign({}, info.zone.rect);
      const rotation = Number(info.zone.mapRotation || 0);
      if (action.dataset.p23mCalibratorAction === "disable") {
        state.calibrator.enabled = false;
        calibratorRender();
        return true;
      }
      if (action.dataset.p23mCalibratorAction === "rotate-left") {
        calibratorApplyRect(rect, rotation - 1);
        return true;
      }
      if (action.dataset.p23mCalibratorAction === "rotate-right") {
        calibratorApplyRect(rect, rotation + 1);
        return true;
      }
      if (action.dataset.p23mCalibratorAction === "export-group") {
        calibratorExportGroup();
        return true;
      }
      if (action.dataset.p23mCalibratorAction === "export-all") {
        calibratorExportAll();
        return true;
      }
      return false;
    }

    function calibratorHandleFieldFocus(event) {
      const field = event.target.closest("[data-p23m-calibrator-field]");
      if (!field || !root.contains(field)) return false;
      window.setTimeout(() => {
        try { field.select(); } catch (error) {}
      }, 0);
      return true;
    }

    function calibratorCommitFields(event) {
      const field = event.target.closest("[data-p23m-calibrator-field]");
      if (!field || !root.contains(field)) return false;
      event.stopPropagation();
      const data = calibratorReadPanelRect();
      calibratorApplyRect(data.rect, data.rotation);
      return true;
    }

    function calibratorHandleKeydown(event) {
      const field = event.target.closest("[data-p23m-calibrator-field]");
      if (!field || !root.contains(field)) return false;

      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        const data = calibratorReadPanelRect();
        calibratorApplyRect(data.rect, data.rotation);
        field.blur();
        return true;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        calibratorRenderPanel();
        return true;
      }

      return false;
    }

    function calibratorHandleInput(event) {
      const field = event.target.closest("[data-p23m-calibrator-field]");
      if (!field || !root.contains(field)) return false;
      event.stopPropagation();

      const parsed = calibratorParseFieldValue(field.value);
      if (parsed === null) return true;

      const data = calibratorReadPanelRect();
      calibratorApplyRect(data.rect, data.rotation, { skipPanel: true });
      return true;
    }

    function calibratorPointerDown(event) {
      if (!state.calibrator.enabled) return;
      const safe = q("[data-p23m-safe]");
      if (!safe || !safe.contains(event.target)) return;
      event.preventDefault();
      event.stopPropagation();

      const resizeHandle = event.target.closest("[data-p23m-calibrator-resize]");
      const handle = resizeHandle ? resizeHandle.dataset.p23mCalibratorResize : "move";
      const info = calibratorCurrentInfo();
      const base = Object.assign({}, info.zone.rect);
      const rotation = Number(info.zone.mapRotation || 0);
      const sx = event.clientX;
      const sy = event.clientY;
      const scale = state.zoom / 100;

      const move = (moveEvent) => {
        const dx = (moveEvent.clientX - sx) / scale;
        const dy = (moveEvent.clientY - sy) / scale;
        const next = Object.assign({}, base);

        if (handle === "move") {
          next.x = base.x + dx;
          next.y = base.y + dy;
        } else {
          if (handle.includes("e")) next.w = base.w + dx;
          if (handle.includes("s")) next.h = base.h + dy;
          if (handle.includes("w")) { next.x = base.x + dx; next.w = base.w - dx; }
          if (handle.includes("n")) { next.y = base.y + dy; next.h = base.h - dy; }
        }

        next.w = clamp(next.w, 12, 360);
        next.h = clamp(next.h, 12, 420);
        next.x = clamp(next.x, -120, 500);
        next.y = clamp(next.y, -120, 520);
        calibratorApplyRect(next, rotation);
      };

      bindPointer(move);
    }

    function exposeCalibratorApi() {
      window.P23DTFCalibrator = {
        enable() {
          state.calibrator.enabled = true;
          calibratorRender();
          console.info("[23DTF] Calibrador activo. Arrastra la zona roja y usa P23DTFCalibrator.exportGroup().");
          return calibratorCurrentInfo();
        },
        disable() {
          state.calibrator.enabled = false;
          calibratorRender();
          return true;
        },
        status() {
          return Object.assign({ enabled: state.calibrator.enabled }, calibratorCurrentInfo());
        },
        exportGroup: calibratorExportGroup,
        exportAll: calibratorExportAll,
        set(rect, rotation) {
          const info = calibratorCurrentInfo();
          calibratorApplyRect(Object.assign({}, info.zone.rect, rect || {}), typeof rotation === "number" ? rotation : Number(info.zone.mapRotation || 0));
          return calibratorCurrentInfo();
        }
      };
    }

    function renderCropActions() {
      const canvas = q("[data-p23m-canvas]");
      const coordSpace = ensureCoordinateSpace();
      const host = coordSpace || canvas;
      if (!host) return;

      let actions = q("[data-p23m-crop-actions]");
      const layer = activeLayer();
      const active = state.mode === "image" && state.subtoolImage === "crop" && layer && layer.type === "image";

      qa("[data-p23m-coordinate-space], [data-p23m-layer-stage]").forEach((node) => {
        node.classList.toggle("is-p23m-cropping", !!active);
      });

      if (!active) {
        if (actions) actions.remove();
        state.cropBefore = null;
        return;
      }

      if (!state.cropBefore || state.cropBefore.id !== layer.id) {
        state.cropBefore = { id: layer.id, x: layer.x, y: layer.y, w: layer.w, h: layer.h };
      }

      if (!actions) {
        actions = document.createElement("div");
        actions.className = "p23m__crop-actions";
        actions.dataset.p23mCropActions = "true";
        actions.innerHTML = '<button type="button" class="p23m__crop-cancel" data-p23m-crop-cancel>✕ Cancelar</button><button type="button" class="p23m__crop-apply" data-p23m-crop-apply>✓ Aplicar</button>';
      }

      if (actions.parentElement !== host) {
        host.appendChild(actions);
      }

      /*
        23DTF REV78:
        Los botones de recorte se pegan al recuadro azul real, no a la parte superior
        del canvas. Al hacer zoom acompañan al área de recorte y siguen visibles junto
        al punto que el cliente está ajustando.
      */
      const crop = ensureCropDraft(layer) || { left: 0, top: 0, right: 0, bottom: 0 };
      const keptLeft = clamp(Number(crop.left || 0), 0, 45) / 100;
      const keptRight = clamp(Number(crop.right || 0), 0, 45) / 100;
      const keptTop = clamp(Number(crop.top || 0), 0, 45) / 100;
      const keptBottom = clamp(Number(crop.bottom || 0), 0, 45) / 100;
      const boxX = Number(layer.x || 0) + Number(layer.w || 0) * keptLeft;
      const boxY = Number(layer.y || 0) + Number(layer.h || 0) * keptTop;
      const boxW = Number(layer.w || 0) * Math.max(0.08, 1 - keptLeft - keptRight);
      const boxH = Number(layer.h || 0) * Math.max(0.08, 1 - keptTop - keptBottom);
      /*
        23DTF REV79:
        Los botones ya no se quedan fijos ni saltan arriba si haces zoom.
        Siguen siempre la línea inferior real del recorte azul.
      */
      const centerX = boxX + boxW / 2;
      const topY = boxY + boxH + (isMobileViewport() ? 8 : 10);
      actions.style.left = centerX + "px";
      actions.style.top = topY + "px";
      actions.style.setProperty("--p23m-crop-actions-left", centerX + "px");
      actions.style.setProperty("--p23m-crop-actions-top", topY + "px");
      actions.style.setProperty("--p23m-crop-actions-shift", "-50%, 0");
    }

    function allExportableZones() {
      const result = [];
      PLACEMENTS.forEach((placement) => {
        (placement.zones || []).forEach((zone) => {
          const mapped = mappedZone(zone);
          const layers = (state.layersByZone && state.layersByZone[zone.id]) || [];
          const visibleLayers = layers.filter((layer) => layer && layer.visible !== false);
          if (visibleLayers.length) {
            result.push({ placement, zone: mapped, zoneId: zone.id, layers: visibleLayers });
          }
        });
      });
      return result;
    }

    function slugifyExportName(value) {
      return String(value || "personalizacion")
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "personalizacion";
    }

    function exportTimestamp() {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + "-" + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds());
    }

    function downloadBlob(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      window.setTimeout(() => {
        URL.revokeObjectURL(url);
        a.remove();
      }, 1200);
    }


    /*
      23DTF v0.8.2 EXPORTACIÓN PROFESIONAL:
      Genera una única descarga .zip con estructura legible para producción:
      PED-YYYYMMDD-HHMMSS-PRUEBA/
        Proyecto.json
        Manifiesto.json
        Originales/
        Impresión/
        Vista previa/
      No usa librerías externas para evitar dependencias en Shopify.
    */
    let p23mZipCrcTable = null;

    function zipCrcTable() {
      if (p23mZipCrcTable) return p23mZipCrcTable;
      const table = new Uint32Array(256);
      for (let n = 0; n < 256; n += 1) {
        let c = n;
        for (let k = 0; k < 8; k += 1) {
          c = (c & 1) ? (0xedb88320 ^ (c >>> 1)) : (c >>> 1);
        }
        table[n] = c >>> 0;
      }
      p23mZipCrcTable = table;
      return table;
    }

    function zipCrc32(bytes) {
      const table = zipCrcTable();
      let crc = 0xffffffff;
      for (let i = 0; i < bytes.length; i += 1) {
        crc = table[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
      }
      return (crc ^ 0xffffffff) >>> 0;
    }

    function zipUint16(value) {
      const out = new Uint8Array(2);
      out[0] = value & 0xff;
      out[1] = (value >>> 8) & 0xff;
      return out;
    }

    function zipUint32(value) {
      const out = new Uint8Array(4);
      out[0] = value & 0xff;
      out[1] = (value >>> 8) & 0xff;
      out[2] = (value >>> 16) & 0xff;
      out[3] = (value >>> 24) & 0xff;
      return out;
    }

    function zipDosTime(date) {
      const d = date || new Date();
      return ((d.getHours() & 31) << 11) | ((d.getMinutes() & 63) << 5) | ((Math.floor(d.getSeconds() / 2)) & 31);
    }

    function zipDosDate(date) {
      const d = date || new Date();
      return (((d.getFullYear() - 1980) & 127) << 9) | (((d.getMonth() + 1) & 15) << 5) | (d.getDate() & 31);
    }

    async function blobToBytes(blob) {
      const buffer = await blob.arrayBuffer();
      return new Uint8Array(buffer);
    }

    function zipConcat(parts) {
      return new Blob(parts, { type: "application/zip" });
    }

    async function buildZipBlob(entries) {
      const encoder = new TextEncoder();
      const now = new Date();
      const localParts = [];
      const centralParts = [];
      const records = [];
      let offset = 0;

      for (const entry of entries || []) {
        if (!entry || !entry.blob || !entry.path) continue;
        const name = String(entry.path).replace(/^\/+/, "").replace(/\\/g, "/");
        const nameBytes = encoder.encode(name);
        const dataBytes = await blobToBytes(entry.blob);
        const crc = zipCrc32(dataBytes);
        const size = dataBytes.length >>> 0;
        const time = zipDosTime(now);
        const date = zipDosDate(now);
        const flags = 0x0800; // UTF-8 filenames
        const method = 0; // store, no compression

        const localHeader = [
          zipUint32(0x04034b50), zipUint16(20), zipUint16(flags), zipUint16(method),
          zipUint16(time), zipUint16(date), zipUint32(crc), zipUint32(size), zipUint32(size),
          zipUint16(nameBytes.length), zipUint16(0), nameBytes
        ];
        localParts.push(...localHeader, dataBytes);

        records.push({ nameBytes, crc, size, time, date, flags, method, offset });
        offset += 30 + nameBytes.length + size;
      }

      let centralSize = 0;
      for (const record of records) {
        const centralHeader = [
          zipUint32(0x02014b50), zipUint16(20), zipUint16(20), zipUint16(record.flags), zipUint16(record.method),
          zipUint16(record.time), zipUint16(record.date), zipUint32(record.crc), zipUint32(record.size), zipUint32(record.size),
          zipUint16(record.nameBytes.length), zipUint16(0), zipUint16(0), zipUint16(0), zipUint16(0),
          zipUint32(0), zipUint32(record.offset), record.nameBytes
        ];
        centralParts.push(...centralHeader);
        centralSize += 46 + record.nameBytes.length;
      }

      const end = [
        zipUint32(0x06054b50), zipUint16(0), zipUint16(0),
        zipUint16(records.length), zipUint16(records.length),
        zipUint32(centralSize), zipUint32(offset), zipUint16(0)
      ];

      return zipConcat([...localParts, ...centralParts, ...end]);
    }

    function canvasToBlob(canvas, type) {
      return new Promise((resolve, reject) => {
        try {
          if (canvas.toBlob) {
            canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("No se pudo crear el archivo PNG.")), type || "image/png");
          } else {
            const data = canvas.toDataURL(type || "image/png");
            const bin = atob(data.split(",")[1] || "");
            const arr = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i += 1) arr[i] = bin.charCodeAt(i);
            resolve(new Blob([arr], { type: type || "image/png" }));
          }
        } catch (error) {
          reject(error);
        }
      });
    }

    const exportImageCache = new Map();
    function loadExportImage(src) {
      return new Promise((resolve, reject) => {
        if (!src) return reject(new Error("Imagen sin origen."));
        if (exportImageCache.has(src)) return resolve(exportImageCache.get(src));
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          exportImageCache.set(src, img);
          resolve(img);
        };
        img.onerror = () => reject(new Error("No se pudo cargar una imagen para exportar."));
        img.src = src;
      });
    }



    async function waitForExportFonts() {
      /*
        23DTF REV69P TEXT FONT LOCK:
        Espera global a document.fonts.ready. No intenta incrustar fuentes ni
        crear source-text separado; solo estabiliza medición y render del texto.
      */
      if (!document.fonts || !document.fonts.ready) return;
      try {
        await document.fonts.ready;
      } catch (error) {
        console.warn("[23DTF] No se pudo esperar a document.fonts.ready", error);
      }
    }

    function exportPrimaryFontFamily(fontValue) {
      const first = String(fontValue || "Arial, sans-serif").split(",")[0] || "Arial";
      return first.trim().replace(/^['\"]+|['\"]+$/g, "");
    }

    function exportCssFontFamily(layer) {
      return layer && layer.font ? String(layer.font) : "Arial, sans-serif";
    }

    function textExportFontWeight(layer) {
      /*
        REV69R:
        Exportación y editor usan exactamente el mismo peso.
        Evita pedir 900 a fuentes 23DTF declaradas en @font-face como 400.
      */
      return textLayerFontWeight(layer);
    }

    function exportFontCheck(layer) {
      const family = exportPrimaryFontFamily(layer && layer.font);
      const cssFamily = exportCssFontFamily(layer);
      const weight = textExportFontWeight(layer);
      const fontSize = Math.max(1, textLayerFontSize(layer));
      const result = {
        family,
        cssFamily,
        weight,
        requested: weight + " " + fontSize + "px " + cssFamily,
        available: null
      };
      if (!document.fonts || !document.fonts.check) return result;
      try {
        result.available = document.fonts.check(result.requested);
      } catch (error) {
        result.available = null;
      }
      return result;
    }

    async function ensureTextExportFontReady(layer) {
      if (!document.fonts || !document.fonts.load) return exportFontCheck(layer);
      const cssFamily = exportCssFontFamily(layer);
      const weight = textExportFontWeight(layer);
      const size = Math.max(1, textLayerFontSize(layer));
      try {
        await document.fonts.load(weight + " " + size + "px " + cssFamily);
        await document.fonts.ready;
      } catch (error) {
        console.warn("[23DTF] No se pudo precargar la fuente exacta del texto", error);
      }
      return exportFontCheck(layer);
    }

    function applyTextExportProbeStyles(probe, layer, cssFontSize) {
      probe.style.position = "absolute";
      probe.style.left = "-99999px";
      probe.style.top = "-99999px";
      probe.style.visibility = "hidden";
      probe.style.pointerEvents = "none";
      probe.style.boxSizing = "border-box";
      probe.style.padding = "0";
      probe.style.margin = "0";
      probe.style.border = "0";
      probe.style.whiteSpace = "pre";
      probe.style.overflowWrap = "normal";
      probe.style.wordBreak = "normal";
      probe.style.lineHeight = ".88";
      probe.style.fontFamily = exportCssFontFamily(layer);
      probe.style.fontSize = Math.max(1, Number(cssFontSize || 1)) + "px";
      probe.style.fontWeight = textExportFontWeight(layer);
      probe.style.fontStyle = "normal";
      probe.style.fontSynthesis = "none";
      probe.style.fontKerning = "auto";
      probe.style.letterSpacing = "normal";
      probe.style.color = layer.color || "#111111";
      probe.style.webkitTextStroke = Number(layer.outlineWeight || 0) + "px " + (layer.outlineColor || "#000000");
      probe.style.textShadow = layerShadow(layer);
    }

    function measureTextExportIntrinsic(layer, cssFontSize) {
      /*
        REV69P:
        Medimos el texto SIN fijar width/height. En REV69L el probe tenía la
        anchura de la caja, y en algunos navegadores eso ocultaba el ancho real
        de la tipografía que luego se rasterizaba en foreignObject.
      */
      const probe = document.createElement("div");
      probe.textContent = String(layer.text || "Tu texto aquí").replace(/\r/g, "");
      probe.style.display = "inline-block";
      applyTextExportProbeStyles(probe, layer, cssFontSize);
      document.body.appendChild(probe);
      const rect = probe.getBoundingClientRect();
      const result = {
        w: Math.max(1, rect.width || 0, probe.scrollWidth || 0),
        h: Math.max(1, rect.height || 0, probe.scrollHeight || 0)
      };
      probe.remove();
      return result;
    }

    function textExportSafety(layer, boxW, boxH, fontStatus) {
      const outlineCss = Math.max(0, Number(layer.outlineWeight || 0));
      const shadowCss = Number(layer.shadowDistance || 0) > 0 ? Math.abs(Number(layer.shadowDistance || 0) * 12) : 0;
      const widthGuard = fontStatus && fontStatus.available === false ? 1.18 : 1.10;
      const heightGuard = fontStatus && fontStatus.available === false ? 1.10 : 1.06;
      const pad = Math.max(3, outlineCss * 3, shadowCss * 1.25, Number(boxW || 0) * 0.045, Number(boxH || 0) * 0.045);
      return { pad, widthGuard, heightGuard };
    }

    function measureTextExportDom(layer, cssFontSize, boxW, boxH, fontStatus) {
      const intrinsic = measureTextExportIntrinsic(layer, cssFontSize);
      const safety = textExportSafety(layer, boxW, boxH, fontStatus);
      return {
        w: intrinsic.w * safety.widthGuard,
        h: intrinsic.h * safety.heightGuard,
        rawW: intrinsic.w,
        rawH: intrinsic.h,
        pad: safety.pad,
        widthGuard: safety.widthGuard,
        heightGuard: safety.heightGuard
      };
    }

    function exportTextLayerHtml(layer, innerW, innerH, fontSize, scale) {
      const stroke = Math.max(0, Number(layer.outlineWeight || 0) * scale);
      const shadowDistance = Number(layer.shadowDistance || 0) * 12 * scale;
      const textShadow = shadowDistance > 0
        ? shadowDistance.toFixed(2) + "px " + shadowDistance.toFixed(2) + "px 0 " + (layer.shadowColor || "#000000")
        : "none";

      const outerStyle = [
        "position:relative",
        "width:" + Math.max(1, Number(innerW || 1)) + "px",
        "height:" + Math.max(1, Number(innerH || 1)) + "px",
        "overflow:hidden",
        "padding:0",
        "margin:0",
        "box-sizing:border-box",
        "background:transparent"
      ].join(";");

      const textStyle = [
        "position:absolute",
        "left:0",
        "top:0",
        "width:100%",
        "height:100%",
        "display:flex",
        "align-items:center",
        "justify-content:center",
        "text-align:center",
        "box-sizing:border-box",
        "padding:0",
        "margin:0",
        "overflow:visible",
        "white-space:pre",
        "overflow-wrap:normal",
        "word-break:normal",
        "line-height:.88",
        "font-family:" + exportCssFontFamily(layer),
        "font-size:" + Math.max(1, fontSize) + "px",
        "font-weight:" + textExportFontWeight(layer),
        "font-style:normal",
        "font-synthesis:none",
        "font-kerning:auto",
        "letter-spacing:normal",
        "text-rendering:geometricPrecision",
        "color:" + (layer.color || "#111111"),
        "-webkit-text-stroke:" + stroke + "px " + (layer.outlineColor || "#000000"),
        "text-shadow:" + textShadow
      ].join(";");

      return '<div xmlns="http://www.w3.org/1999/xhtml" style="' + escapeHtml(outerStyle) + '">' +
        '<div style="' + escapeHtml(textStyle) + '">' + escapeHtml(layer.text || "Tu texto aquí") + "</div>" +
      "</div>";
    }

    async function drawExportTextLayer(ctx, layer, w, h, scale) {
      /*
        23DTF REV69T SAFE TEXT EXPORT:
        Render Canvas 2D protegido. Esta función no debe abortar toda la
        exportación por una capa de texto. Si falla la fuente o la medición,
        registra el error y usa un fallback Canvas simple.
      */
      const rawText = String(layer && layer.text || "Tu texto aquí").replace(/\r/g, "");
      const lines = rawText.split("\n");
      const boxPxW = Math.max(1, Number(w || 1));
      const boxPxH = Math.max(1, Number(h || 1));
      const cssBoxW = Math.max(1, Number(layer && layer.w || 1));
      const cssBoxH = Math.max(1, Number(layer && layer.h || 1));
      const baseCssFontSize = textLayerFontSize(layer);
      const lineHeightFactor = 0.88;

      try {
        await ensureTextExportFontReady(layer);

        const weight = textExportFontWeight(layer);
        const family = exportCssFontFamily(layer);
        const baseOutlinePx = Math.max(0, Number(layer.outlineWeight || 0) * scale);
        const shadowCss = Number(layer.shadowDistance || 0) > 0 ? Number(layer.shadowDistance || 0) * 12 : 0;
        const baseShadowPx = shadowCss * scale;
        const basePxFontSize = Math.max(1, baseCssFontSize * scale);

        const measureCanvas = document.createElement("canvas");
        measureCanvas.width = 16;
        measureCanvas.height = 16;
        const measureCtx = measureCanvas.getContext("2d");
        if (!measureCtx) throw new Error("No se pudo crear contexto Canvas 2D para medir texto.");

        const setMeasureFont = (fontSizePx) => {
          measureCtx.font = weight + " " + Math.max(1, fontSizePx) + "px " + family;
          measureCtx.textAlign = "center";
          measureCtx.textBaseline = "middle";
        };

        const measureAt = (fontSizePx) => {
          setMeasureFont(fontSizePx);
          let maxW = 1;
          lines.forEach((line) => {
            const value = line || " ";
            const metrics = measureCtx.measureText(value);
            const left = Math.abs(Number(metrics.actualBoundingBoxLeft || 0));
            const right = Math.abs(Number(metrics.actualBoundingBoxRight || 0));
            const mW = Math.max(Number(metrics.width || 0), left + right);
            maxW = Math.max(maxW, mW);
          });
          const totalH = Math.max(1, lines.length * fontSizePx * lineHeightFactor);
          return { w: maxW, h: totalH };
        };

        const safePadPx = Math.max(2 * scale, baseOutlinePx * 3, Math.abs(baseShadowPx) * 1.2, boxPxW * 0.04);
        const availableW = Math.max(1, boxPxW - safePadPx * 2);
        const availableH = Math.max(1, boxPxH - safePadPx * 2);
        const measured = measureAt(basePxFontSize);
        const fit = Math.min(1, availableW / Math.max(1, measured.w), availableH / Math.max(1, measured.h));
        const fontSize = Math.max(1, basePxFontSize * fit);
        const lineHeight = fontSize * lineHeightFactor;
        const outlinePx = Math.max(0, baseOutlinePx * fit);
        const shadowPx = baseShadowPx * fit;
        const canvasStrokeWidth = outlinePx > 0 ? Math.max(0.6, outlinePx * 0.98) : 0;
        const canvasShadowStrokeWidth = canvasStrokeWidth > 0 ? canvasStrokeWidth * 0.72 : 0;
        const visualShadowPx = shadowPx ? shadowPx * 0.78 : 0;

        ctx.save();
        ctx.beginPath();
        ctx.rect(-boxPxW / 2 - safePadPx, -boxPxH / 2 - safePadPx, boxPxW + safePadPx * 2, boxPxH + safePadPx * 2);
        ctx.clip();

        ctx.font = weight + " " + fontSize + "px " + family;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = layer.color || "#111111";
        ctx.lineJoin = "miter";
        ctx.lineCap = "butt";
        ctx.miterLimit = 10;

        const strokeColor = layer.outlineColor || "#000000";
        const shadowColor = layer.shadowColor || "#000000";
        if (outlinePx > 0) {
          ctx.strokeStyle = strokeColor;
          ctx.lineWidth = canvasStrokeWidth;
        }

        const startY = -((lines.length - 1) * lineHeight) / 2;
        const drawTextPass = (drawer) => {
          lines.forEach((line, index) => {
            const value = line || " ";
            const y = startY + index * lineHeight;
            drawer(value, y);
          });
        };

        /*
          REV70B:
          1) sombra en una sola pasada independiente
          2) contorno limpio sin sombra encima
          3) relleno final limpio
          Esto evita la doble sombra de strokeText+fillText y mejora la fidelidad
          visual con respecto al editor.
        */
        ctx.shadowColor = "transparent";
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;

        if (visualShadowPx) {
          ctx.save();
          ctx.translate(visualShadowPx, visualShadowPx);
          ctx.fillStyle = shadowColor;
          if (outlinePx > 0) {
            ctx.strokeStyle = shadowColor;
            ctx.lineWidth = Math.max(0.35, (canvasShadowStrokeWidth || canvasStrokeWidth) * 0.6);
            drawTextPass((value, y) => {
              ctx.strokeText(value, 0, y);
              ctx.fillText(value, 0, y);
            });
            ctx.strokeStyle = strokeColor;
            ctx.lineWidth = canvasStrokeWidth;
          } else {
            drawTextPass((value, y) => ctx.fillText(value, 0, y));
          }
          ctx.restore();
          ctx.fillStyle = layer.color || "#111111";
          if (outlinePx > 0) {
            ctx.strokeStyle = strokeColor;
            ctx.lineWidth = canvasStrokeWidth;
          }
        }

        if (outlinePx > 0) {
          drawTextPass((value, y) => ctx.strokeText(value, 0, y));
        }
        drawTextPass((value, y) => ctx.fillText(value, 0, y));
        ctx.restore();
        return;
      } catch (error) {
        console.warn("[23DTF] Falló render Canvas 2D de texto; usando fallback seguro", {
          error,
          text: rawText,
          font: layer && layer.font,
          box: { w: cssBoxW, h: cssBoxH }
        });
      }

      /*
        Fallback interno: nunca debe romper la exportación completa.
        Usa sans-serif si la fuente personalizada falla.
      */
      try {
        const fallbackFontSize = Math.max(1, baseCssFontSize * scale * 0.82);
        const fallbackLineHeight = fallbackFontSize * lineHeightFactor;
        const outlinePx = Math.max(0, Number(layer.outlineWeight || 0) * scale);
        ctx.save();
        ctx.beginPath();
        ctx.rect(-boxPxW / 2, -boxPxH / 2, boxPxW, boxPxH);
        ctx.clip();
        ctx.font = "400 " + fallbackFontSize + "px sans-serif";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = layer.color || "#111111";
        if (outlinePx > 0) {
          ctx.strokeStyle = layer.outlineColor || "#000000";
          ctx.lineWidth = outlinePx * 2;
        }
        const startY = -((lines.length - 1) * fallbackLineHeight) / 2;
        lines.forEach((line, index) => {
          const value = line || " ";
          const y = startY + index * fallbackLineHeight;
          if (outlinePx > 0) ctx.strokeText(value, 0, y);
          ctx.fillText(value, 0, y);
        });
        ctx.restore();
      } catch (fallbackError) {
        console.error("[23DTF] Falló incluso el fallback de texto. Se omite esta capa para no abortar exportación.", fallbackError);
      }
    }

    const EXPORT_SCHEMA_VERSION = "23DTF_PERSONALIZER_EXPORT_V0_9_3";
    const EXPORT_DPI = 300;
    const EXPORT_PREVIEW_SCALE = 2;
    const EXPORT_INCLUDE_DEBUG_GUIDES = false;

    function parsePrintCmFromArea(value) {
      const match = String(value || "").replace(/,/g, ".").match(/([0-9]+(?:\.[0-9]+)?)\s*[×x]\s*([0-9]+(?:\.[0-9]+)?)/i);
      if (!match) return null;
      return { w: Number(match[1]), h: Number(match[2]) };
    }

    function defaultPrintCmForZone(zoneId) {
      const map = {
        front_full: { w: 30, h: 35 },
        left_chest: { w: 10, h: 10 },
        back_full: { w: 30, h: 35 },
        left_sleeve_outer: { w: 8, h: 12 },
        right_sleeve_outer: { w: 8, h: 12 },
        inner_label_zone: { w: 6, h: 4 }
      };
      return map[zoneId] || null;
    }

    function exportZonePrintCm(zone, zoneId) {
      return (zone && zone.printCm) || parsePrintCmFromArea(zone && zone.area) || defaultPrintCmForZone(zoneId) || null;
    }

    function exportZoneScale(zone, zoneId) {
      const rect = zone && zone.rect ? zone.rect : { w: 216, h: 260 };
      const cm = exportZonePrintCm(zone, zoneId);
      if (cm && cm.w && cm.h) {
        const pxW = Math.round(Number(cm.w || 0) / 2.54 * EXPORT_DPI);
        const pxH = Math.round(Number(cm.h || 0) / 2.54 * EXPORT_DPI);
        const rawScale = Math.min(pxW / Math.max(1, rect.w), pxH / Math.max(1, rect.h));
        return clamp(Number.isFinite(rawScale) ? rawScale : 4, 2, 18);
      }
      return 6;
    }

    function exportSolidColor(value, fallback) {
      const raw = String(value || "").trim();
      if (/^#[0-9a-f]{3,8}$/i.test(raw) || /^rgba?\(/i.test(raw) || /^hsla?\(/i.test(raw)) return raw;
      const hexMatch = raw.match(/#[0-9a-f]{3,8}/i);
      if (hexMatch) return hexMatch[0];
      return fallback || "#f3f4f6";
    }

    function exportSelectedColorName() {
      return activeColorName();
    }

    function exportSelectedGarmentBackground() {
      return activeGarmentBackground();
    }

    function exportOrderContext() {
      const groups = personalizedGroups ? personalizedGroups() : [];
      return {
        selectedColor: exportSelectedColorName() || "",
        selectedColorBackground: exportSelectedGarmentBackground() || "",
        personalizedQty: clonePlain(state.personalizedQty, {}),
        groups: clonePlain(groups, []),
        totalPersonalizedQty: personalizedQtyTotal ? personalizedQtyTotal() : 0,
        quantitySnapshot: "initial_add_to_cart",
        quantityAuthority: "shopify_order_lines"
      };
    }

    async function drawExportLayer(ctx, layer, zoneRect, scale) {
      if (!layer || layer.visible === false) return;
      const x = (Number(layer.x || 0) - Number(zoneRect.x || 0)) * scale;
      const y = (Number(layer.y || 0) - Number(zoneRect.y || 0)) * scale;
      const w = Number(layer.w || 0) * scale;
      const h = Number(layer.h || 0) * scale;
      const cx = x + w / 2;
      const cy = y + h / 2;

      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate((Number(layer.r || 0) || 0) * Math.PI / 180);
      ctx.scale(layer.flipX ? -1 : 1, layer.flipY ? -1 : 1);

      if (layer.type === "image") {
        const img = await loadExportImage(layer.src);
        ctx.drawImage(img, -w / 2, -h / 2, w, h);
      } else {
        await drawExportTextLayer(ctx, layer, w, h, scale);
      }
      ctx.restore();
    }

    async function renderPrintCanvasForZone(zone, layers, zoneId) {
      const rect = zone && zone.rect ? zone.rect : { x: 0, y: 0, w: 216, h: 260 };
      const scale = exportZoneScale(zone, zoneId);
      const maxSide = 5200;
      const outputScale = Math.min(scale, maxSide / Math.max(1, rect.w), maxSide / Math.max(1, rect.h));
      const canvas = document.createElement("canvas");
      canvas.width = Math.max(1, Math.round(rect.w * outputScale));
      canvas.height = Math.max(1, Math.round(rect.h * outputScale));
      const ctx = canvas.getContext("2d", { alpha: true });
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const ordered = (layers || []).filter((layer) => layer && layer.visible !== false);
      for (const layer of ordered) {
        await drawExportLayer(ctx, layer, rect, outputScale);
      }
      return {
        canvas,
        scale: outputScale,
        transparentBackground: true,
        dpi: EXPORT_DPI,
        printCm: exportZonePrintCm(zone, zoneId),
        outputWidth: canvas.width,
        outputHeight: canvas.height
      };
    }

    async function renderPreviewBackgroundForPlacement(ctx, canvas, placement) {
      const scale = EXPORT_PREVIEW_SCALE;
      const previewPlacement = placement || currentPlacement();
      const innerLabel = previewPlacement && previewPlacement.id === "inner_label";
      const garmentBackground = exportSelectedGarmentBackground();

      ctx.fillStyle = innerLabel ? exportSolidColor(garmentBackground, "#f3f4f6") : "#f3f4f6";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const mirrorMockup = !innerLabel && shouldMirrorMockup(previewPlacement);
      const fallbackProductRect = () => {
        ctx.fillStyle = innerLabel ? exportSolidColor(garmentBackground, "#111111") : "#e5e7eb";
        ctx.fillRect(60 * scale, 35 * scale, 260 * scale, 360 * scale);
      };

      try {
        const src = innerLabel ? safeAssetUrl("23dtf-inner-label-neck.png") : ((mediaForPlacement(previewPlacement) || {}).src || "");
        if (src) {
          const img = await loadExportImage(src);
          ctx.save();
          ctx.globalAlpha = innerLabel ? 1 : 0.95;
          if (mirrorMockup) {
            ctx.translate(canvas.width, 0);
            ctx.scale(-1, 1);
          }
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          ctx.restore();
        } else {
          fallbackProductRect();
        }
      } catch (error) {
        fallbackProductRect();
      }
    }

    async function renderPreviewCanvasForZone(zone, layers, placement, options) {
      const scale = EXPORT_PREVIEW_SCALE;
      const canvas = document.createElement("canvas");
      canvas.width = 380 * scale;
      canvas.height = 460 * scale;
      const ctx = canvas.getContext("2d");

      await renderPreviewBackgroundForPlacement(ctx, canvas, placement);

      const rect = zone && zone.rect ? zone.rect : { x: 0, y: 0, w: 216, h: 260 };
      const debugGuides = options && options.debugGuides === true;
      if (debugGuides) {
        ctx.save();
        ctx.strokeStyle = "rgba(239,68,68,.85)";
        ctx.lineWidth = 2 * scale;
        ctx.setLineDash([8 * scale, 6 * scale]);
        ctx.strokeRect(rect.x * scale, rect.y * scale, rect.w * scale, rect.h * scale);
        ctx.restore();
      }

      for (const layer of (layers || []).filter((layer) => layer && layer.visible !== false)) {
        await drawExportLayer(ctx, layer, { x: 0, y: 0 }, scale);
      }
      return canvas;
    }

    
    function exportMimeFromDataUrl(src) {
      const match = String(src || "").match(/^data:([^;,]+)[;,]/i);
      return match ? match[1].toLowerCase() : "";
    }

    function exportExtensionFromMime(mime) {
      const clean = String(mime || "").toLowerCase();
      if (clean.indexOf("jpeg") >= 0 || clean.indexOf("jpg") >= 0) return "jpg";
      if (clean.indexOf("webp") >= 0) return "webp";
      if (clean.indexOf("gif") >= 0) return "gif";
      if (clean.indexOf("svg") >= 0) return "svg";
      if (clean.indexOf("png") >= 0) return "png";
      return "png";
    }

    function exportExtensionFromName(name) {
      const clean = String(name || "").split("?")[0].split("#")[0];
      const match = clean.match(/\.([a-z0-9]{2,5})$/i);
      if (!match) return "";
      const ext = match[1].toLowerCase();
      if (["png", "jpg", "jpeg", "webp", "gif", "svg"].includes(ext)) return ext === "jpeg" ? "jpg" : ext;
      return "";
    }

    function exportSourceMime(layer) {
      const src = layer && (layer.originalSrc || layer.src) || "";
      const dataMime = exportMimeFromDataUrl(src);
      if (dataMime) return dataMime;
      const explicit = String(layer && (layer.originalMimeType || layer.mimeType || layer.fileType) || "").toLowerCase();
      if (explicit) return explicit;
      const ext = exportExtensionFromName(layer && (layer.originalName || layer.name) || "");
      if (ext === "jpg") return "image/jpeg";
      if (ext === "webp") return "image/webp";
      if (ext === "gif") return "image/gif";
      if (ext === "svg") return "image/svg+xml";
      return "image/png";
    }

    function exportSourceExtension(layer, index) {
      const nameExt = exportExtensionFromName(layer && (layer.originalName || layer.name) || "");
      if (nameExt) return nameExt;
      return exportExtensionFromMime(exportSourceMime(layer));
    }


    const EXPORT_FOLDER_ORIGINALES = "Originales";
    const EXPORT_FOLDER_IMPRESION = "Impresión";
    const EXPORT_FOLDER_PREVIEW = "Vista previa";
    const CLOUDFLARE_UPLOAD_ENDPOINT = "https://23dtf-produccion-production.up.railway.app/api/personalizer/upload-project";

    function exportSafeHumanName(value, fallback) {
      return String(value || fallback || "Archivo")
        .replace(/[\\/:*?"<>|]+/g, "-")
        .replace(/\s+/g, " ")
        .replace(/\.+$/g, "")
        .trim() || String(fallback || "Archivo");
    }

    function exportZoneHumanLabel(zoneId, fallback) {
      const labels = {
        front_full: "Frontal completo",
        left_chest: "Pecho izquierdo",
        back_full: "Espalda completa",
        left_sleeve_outer: "Manga izquierda",
        right_sleeve_outer: "Manga derecha",
        inner_label_zone: "Etiqueta interior"
      };
      return exportSafeHumanName(labels[zoneId] || fallback || zoneId || "Zona", "Zona");
    }

    function exportDateParts(date) {
      const d = date || new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return {
        year: String(d.getFullYear()),
        month: pad(d.getMonth() + 1),
        day: pad(d.getDate()),
        hour: pad(d.getHours()),
        minute: pad(d.getMinutes()),
        second: pad(d.getSeconds())
      };
    }

    function exportSanitizeCustomerToken(value) {
      const clean = String(value || "")
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9_-]+/g, "")
        .slice(0, 48);
      return clean || "sinid";
    }

    function exportCustomerContext() {
      const customer = product && product.customer ? product.customer : null;
      if (!customer || !customer.id) {
        return {
          isLoggedIn: false,
          shopifyCustomerId: null,
          folderToken: "PRUEBA",
          nombre: null,
          nombreCompleto: null,
          email: null,
          firstName: null,
          lastName: null,
          nota: "Exportación local de prueba sin cliente conectado."
        };
      }

      const firstName = customer.firstName || customer.first_name || null;
      const lastName = customer.lastName || customer.last_name || null;
      const nombreCompleto = customer.name || [firstName, lastName].filter(Boolean).join(" ") || customer.email || ("Cliente " + customer.id);
      const customerId = String(customer.id);
      return {
        isLoggedIn: true,
        shopifyCustomerId: customerId,
        folderToken: "C" + exportSanitizeCustomerToken(customerId),
        nombre: nombreCompleto,
        nombreCompleto,
        email: customer.email || null,
        firstName,
        lastName,
        nota: "El nombre/email se guarda dentro de los JSON privados; la carpeta solo usa el ID de cliente para evitar datos personales en rutas o URLs."
      };
    }

    function buildExportPackageMeta() {
      const d = new Date();
      const parts = exportDateParts(d);
      const dateStamp = parts.year + parts.month + parts.day;
      const timeStamp = parts.hour + parts.minute + parts.second;
      const cliente = exportCustomerContext();
      const customerToken = cliente && cliente.isLoggedIn ? cliente.folderToken : "PRUEBA";
      const id = "PED-" + dateStamp + "-" + timeStamp + "-" + customerToken;
      return {
        id,
        rootFolder: id,
        zipFilename: id + ".zip",
        createdAt: d.toISOString(),
        createdDate: parts.year + "-" + parts.month + "-" + parts.day,
        createdTime: parts.hour + ":" + parts.minute + ":" + parts.second,
        mode: cliente && cliente.isLoggedIn ? "local_zip_customer_test" : "local_zip_test",
        cliente
      };
    }

    function exportRelativePath(folder, filename) {
      return exportSafeHumanName(folder, "Archivos") + "/" + exportSafeHumanName(filename, "Archivo");
    }

    function exportZipPath(exportPackage, relativePath) {
      return exportSafeHumanName(exportPackage && exportPackage.rootFolder || "PED-PRUEBA", "PED-PRUEBA") + "/" + String(relativePath || "Archivo").replace(/^\/+/, "");
    }

    function exportSourceZonesLabel(sourceEntry) {
      const zoneIds = (sourceEntry && sourceEntry.usedByZones) || [];
      const names = zoneIds.map((zoneId) => exportZoneHumanLabel(zoneId, zoneId)).filter(Boolean);
      if (!names.length) return "Sin zona asignada";
      if (names.length === 1) return names[0];
      if (names.length === 2) return names[0] + " y " + names[1];
      return names.slice(0, -1).join(", ") + " y " + names[names.length - 1];
    }

    function assignExportSourceFilenames(sourceCatalog) {
      (sourceCatalog || []).forEach((sourceEntry, index) => {
        const ext = sourceEntry.extension || "png";
        const number = String(index + 1).padStart(2, "0");
        const zoneLabel = exportSourceZonesLabel(sourceEntry);
        const filename = "Original - " + number + " - " + zoneLabel + "." + ext;
        sourceEntry.filename = exportRelativePath(EXPORT_FOLDER_ORIGINALES, filename);
        sourceEntry.displayName = exportSafeHumanName(filename, "Original - " + number + "." + ext);
      });
      return sourceCatalog || [];
    }

    function buildExportSourceCatalog(zones, base) {
      const bySrc = new Map();
      (zones || []).forEach((entry) => {
        (entry.layers || []).forEach((layer) => {
          if (!layer || layer.visible === false || layer.type !== "image") return;
          const src = layer.originalSrc || layer.src || "";
          if (!src) return;
          if (!bySrc.has(src)) {
            const index = bySrc.size + 1;
            const ext = exportSourceExtension(layer, index);
            const originalName = layer.originalName || layer.name || "source-" + index;
            bySrc.set(src, {
              sourceId: "source-" + String(index).padStart(2, "0"),
              assetId: "asset-" + String(index).padStart(2, "0"),
              src,
              filename: "",
              displayName: "",
              originalName,
              mimeType: exportSourceMime(layer),
              extension: ext,
              size: layer.originalFileSize || null,
              width: layer.originalUploadWidth || layer.uploadWidth || layer.optimizedWidth || null,
              height: layer.originalUploadHeight || layer.uploadHeight || layer.optimizedHeight || null,
              wasOptimizedForEditor: !!layer.optimizedForEditor,
              usedByZones: [],
              usedByLayerIds: []
            });
          }

          const item = bySrc.get(src);
          if (entry.zoneId && !item.usedByZones.includes(entry.zoneId)) item.usedByZones.push(entry.zoneId);
          if (layer.id && !item.usedByLayerIds.includes(layer.id)) item.usedByLayerIds.push(layer.id);
        });
      });
      return assignExportSourceFilenames(Array.from(bySrc.values()));
    }

    function sourceCatalogBySrc(sourceCatalog) {
      const map = new Map();
      (sourceCatalog || []).forEach((item) => {
        if (item && item.src) map.set(item.src, item);
      });
      return map;
    }

    function exportRoleCounts(generatedFiles) {
      const counts = {};
      (generatedFiles || []).forEach((file) => {
        const role = file && file.role ? String(file.role) : "unknown";
        counts[role] = (counts[role] || 0) + 1;
      });
      return counts;
    }

    function layerHasBackgroundWarning(layer) {
      if (!layer || layer.type !== "image") return false;
      const keys = [
        "backgroundWarning",
        "backgroundWarningShown",
        "backgroundWarningAccepted",
        "hasBackgroundWarning",
        "possibleBackground",
        "possibleSolidBackground",
        "possibleWhiteBackground",
        "possibleBlackBackground",
        "whiteBackgroundWarning",
        "blackBackgroundWarning"
      ];
      return keys.some((key) => layer[key] === true || layer[key] === "true" || layer[key] === "warning");
    }

    function exportValidationLayerSummary(layer, sourceBySrc) {
      const sourceSrc = layer && layer.type === "image" ? (layer.originalSrc || layer.src || "") : "";
      const sourceEntry = sourceSrc && sourceBySrc ? sourceBySrc.get(sourceSrc) : null;
      return {
        id: layer.id || null,
        type: layer.type || null,
        visible: layer.visible !== false,
        name: layer.name || layer.originalName || null,
        sourceId: sourceEntry ? sourceEntry.sourceId : null,
        hasSource: layer.type === "image" ? !!sourceEntry : null,
        hasCrop: layer.type === "image" ? !!(layer.appliedCrop || layer.cropDraft) : null,
        wasOptimizedForEditor: layer.type === "image" ? !!layer.optimizedForEditor : null,
        possibleBackgroundWarning: layerHasBackgroundWarning(layer),
        text: layer.type === "text" ? layer.text || "" : null,
        font: layer.type === "text" ? layer.font || null : null,
        color: layer.type === "text" ? layer.color || null : null,
        position: {
          x: Number(layer.x || 0),
          y: Number(layer.y || 0),
          w: Number(layer.w || 0),
          h: Number(layer.h || 0),
          rotation: Number(layer.r || 0) || 0
        }
      };
    }

    function buildExportValidation(zones, context) {
      /*
        23DTF REV69O VALIDATION:
        Capa de validación NO invasiva. No renderiza, no mueve capas,
        no modifica previews/prints/sources. Solo lee el proyecto exportado
        y registra un contrato interno dentro de project.json.
      */
      const generatedFiles = context && context.generatedFiles ? context.generatedFiles : [];
      const sourceCatalog = context && context.sourceCatalog ? context.sourceCatalog : [];
      const sourceBySrc = sourceCatalogBySrc(sourceCatalog);
      const roleCounts = exportRoleCounts(generatedFiles);
      const warnings = [];
      const errors = [];
      const zonesWithDesign = [];
      const placementsWithDesign = [];
      const layerSummaries = [];
      let visibleLayerCount = 0;
      let imageLayerCount = 0;
      let textLayerCount = 0;
      let croppedImageLayerCount = 0;
      let optimizedImageLayerCount = 0;
      let backgroundWarningCount = 0;
      let imageLayersMissingSource = 0;
      const textWarnings = [];

      (zones || []).forEach((entry) => {
        const visibleLayers = (entry.layers || []).filter((layer) => layer && layer.visible !== false);
        if (!visibleLayers.length) return;

        zonesWithDesign.push({
          placementId: entry.placement && entry.placement.id || null,
          placementLabel: entry.placement && entry.placement.label || null,
          zoneId: entry.zoneId || null,
          zoneLabel: entry.zone && entry.zone.label || null,
          layerCount: visibleLayers.length,
          imageLayerCount: visibleLayers.filter((layer) => layer.type === "image").length,
          textLayerCount: visibleLayers.filter((layer) => layer.type === "text").length
        });

        const placementId = entry.placement && entry.placement.id;
        if (placementId && !placementsWithDesign.includes(placementId)) placementsWithDesign.push(placementId);

        visibleLayers.forEach((layer) => {
          visibleLayerCount += 1;
          if (layer.type === "image") {
            imageLayerCount += 1;
            if (layer.appliedCrop || layer.cropDraft) croppedImageLayerCount += 1;
            if (layer.optimizedForEditor) optimizedImageLayerCount += 1;
            if (layerHasBackgroundWarning(layer)) backgroundWarningCount += 1;
            const sourceSrc = layer.originalSrc || layer.src || "";
            if (!sourceSrc || !sourceBySrc.get(sourceSrc)) imageLayersMissingSource += 1;
          }
          if (layer.type === "text") {
            textLayerCount += 1;
            const fontDiag = exportFontCheck(layer);
            const boxW = Math.max(1, Number(layer.w || 1));
            const boxH = Math.max(1, Number(layer.h || 1));
            try {
              const measured = measureTextExportDom(layer, textLayerFontSize(layer), boxW, boxH, fontDiag);
              const safety = textExportSafety(layer, boxW, boxH, fontDiag);
              const fitX = (boxW - safety.pad * 2) / Math.max(1, measured.w);
              const fitY = (boxH - safety.pad * 2) / Math.max(1, measured.h);
              if (fontDiag.available === false || fitX < 0.98 || fitY < 0.98) {
                textWarnings.push({
                  layerId: layer.id || null,
                  text: layer.text || "",
                  font: layer.font || null,
                  fontAvailable: fontDiag.available,
                  estimatedFit: Math.max(0, Math.min(1, fitX, fitY)),
                  issue: fontDiag.available === false ? "font_not_confirmed_for_export" : "text_requires_safe_fit"
                });
              }
            } catch (error) {
              textWarnings.push({
                layerId: layer.id || null,
                text: layer.text || "",
                font: layer.font || null,
                issue: "text_measurement_failed"
              });
            }
          }
          layerSummaries.push({
            placementId: entry.placement && entry.placement.id || null,
            zoneId: entry.zoneId || null,
            layer: exportValidationLayerSummary(layer, sourceBySrc)
          });
        });
      });

      if (!zonesWithDesign.length) errors.push("No hay zonas con capas visibles.");
      if (imageLayerCount > 0 && sourceCatalog.length === 0) errors.push("Hay imágenes visibles, pero no se ha creado catálogo de imágenes fuente.");
      if (imageLayersMissingSource > 0) warnings.push("Hay " + imageLayersMissingSource + " capa(s) de imagen sin imagen fuente asociada en el catálogo.");
      if (backgroundWarningCount > 0) warnings.push("Hay " + backgroundWarningCount + " imagen(es) con aviso de posible fondo blanco/negro.");
      if ((roleCounts.print || 0) !== zonesWithDesign.length) warnings.push("El número de prints no coincide con las zonas diseñadas.");
      if ((roleCounts.preview || 0) !== zonesWithDesign.length) warnings.push("El número de previews no coincide con las zonas diseñadas.");
      if ((roleCounts.source || 0) < sourceCatalog.length) warnings.push("No todas las imágenes fuente del catálogo aparecen como archivo generado.");
      if (textWarnings.length) warnings.push("Hay " + textWarnings.length + " capa(s) de texto que requieren ajuste seguro o revisión de fuente.");

      const status = errors.length ? "error" : (warnings.length ? "warning" : "ok");
      return {
        schema: "23DTF_VALIDATION_V0_9_3",
        createdAt: new Date().toISOString(),
        status,
        canProceedToR2: !errors.length,
        summary: {
          zoneCount: zonesWithDesign.length,
          visibleLayerCount,
          imageLayerCount,
          textLayerCount,
          sourceImageCount: sourceCatalog.length,
          croppedImageLayerCount,
          optimizedImageLayerCount,
          backgroundWarningCount,
          generatedFileCount: generatedFiles.length,
          roleCounts,
          hasProjectJsonFile: (generatedFiles || []).some((file) => file && file.role === "project")
        },
        zonesWithDesign,
        placementsWithDesign,
        sourceImages: sourceCatalog.map((source) => ({
          sourceId: source.sourceId,
          filename: source.filename,
          originalName: source.originalName,
          mimeType: source.mimeType,
          usedByZones: source.usedByZones,
          usedByLayerIds: source.usedByLayerIds,
          wasOptimizedForEditor: source.wasOptimizedForEditor
        })),
        layers: layerSummaries,
        textWarnings,
        warnings,
        errors
      };
    }

    async function sourceBlobFromEntry(entry) {
      const src = entry && entry.src || "";
      if (!src) throw new Error("Imagen original no disponible para exportar.");
      const response = await fetch(src);
      if (!response.ok && src.indexOf("data:") !== 0) throw new Error("No se pudo leer la imagen original.");
      return response.blob();
    }

    function imageDimensionsFromBlob(blob) {
      return new Promise((resolve) => {
        if (!blob || typeof URL === "undefined" || !URL.createObjectURL) {
          resolve({ width: null, height: null });
          return;
        }
        const url = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
          const dims = { width: img.naturalWidth || img.width || null, height: img.naturalHeight || img.height || null };
          URL.revokeObjectURL(url);
          resolve(dims);
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          resolve({ width: null, height: null });
        };
        img.src = url;
      });
    }

    function jsonSafeLayerReference(layer, sourceEntry) {
      if (!layer || layer.type !== "image") return null;
      if (!sourceEntry) return null;
      return {
        sourceId: sourceEntry.sourceId || null,
        assetId: sourceEntry.assetId || sourceEntry.sourceId || null,
        sourceFile: sourceEntry.filename || null,
        originalName: sourceEntry.originalName || layer.originalName || layer.name || null,
        mimeType: sourceEntry.mimeType || null,
        width: sourceEntry.width || null,
        height: sourceEntry.height || null
      };
    }

    function exportLayerJson(layer, index, sourceBySrc) {
      const sourceSrc = layer.type === "image" ? (layer.originalSrc || layer.src || "") : "";
      const sourceEntry = sourceSrc && sourceBySrc ? sourceBySrc.get(sourceSrc) : null;
      /*
        v0.8.1:
        No guardamos data:image/base64 dentro de Proyecto.json.
        El ZIP ya incluye las imágenes en /Originales y el proyecto referencia
        cada asset por sourceId/assetId. Esto reduce muchísimo el peso del JSON
        y deja el contrato preparado para sustituir sourceFile por URL de Cloudflare.
      */
      return {
        order: index,
        id: layer.id,
        type: layer.type,
        name: layer.name || null,
        text: layer.type === "text" ? layer.text || "" : null,
        sourceId: sourceEntry ? sourceEntry.sourceId : null,
        assetId: sourceEntry ? (sourceEntry.assetId || sourceEntry.sourceId) : null,
        sourceFile: sourceEntry ? sourceEntry.filename : null,
        source: jsonSafeLayerReference(layer, sourceEntry),
        crop: layer.type === "image" ? layer.appliedCrop || layer.cropDraft || null : null,
        uploadWidth: layer.uploadWidth || layer.optimizedWidth || layer.originalUploadWidth || null,
        uploadHeight: layer.uploadHeight || layer.optimizedHeight || layer.originalUploadHeight || null,
        x: layer.x,
        y: layer.y,
        w: layer.w,
        h: layer.h,
        rotation: layer.r || 0,
        flipX: !!layer.flipX,
        flipY: !!layer.flipY,
        color: layer.color || null,
        font: layer.font || null,
        fontSize: layer.fontSize || null,
        outlineColor: layer.outlineColor || null,
        outlineWeight: layer.outlineWeight || 0,
        shadowColor: layer.shadowColor || null,
        shadowDistance: layer.shadowDistance || 0,
        textWrapWidth: layer.type === "text" ? layer.textWrapWidth || null : null,
        textBoxAspect: layer.type === "text" ? layer.textBoxAspect || null : null,
        wasOptimizedForEditor: !!layer.optimizedForEditor,
        originalName: layer.originalName || layer.name || null,
        originalFileSize: layer.originalFileSize || null
      };
    }

    function exportProjectJson(zones, context) {
      const generatedFiles = context && context.generatedFiles ? context.generatedFiles : [];
      const sourceCatalog = context && context.sourceCatalog ? context.sourceCatalog : [];
      const validation = context && context.validation ? context.validation : null;
      const exportPackage = context && context.exportPackage ? context.exportPackage : null;
      const sourceBySrc = sourceCatalogBySrc(sourceCatalog);
      return {
        schema: EXPORT_SCHEMA_VERSION,
        createdAt: new Date().toISOString(),
        pedido: exportPackage ? {
          pedidoInterno: exportPackage.id,
          tipo: "prueba local",
          carpeta: exportPackage.rootFolder,
          archivoZip: exportPackage.zipFilename,
          fechaCreacion: exportPackage.createdDate,
          horaCreacion: exportPackage.createdTime,
          clienteToken: exportPackage.cliente ? exportPackage.cliente.folderToken : null
        } : null,
        cliente: exportPackage && exportPackage.cliente ? exportPackage.cliente : exportCustomerContext(),
        product: {
          id: product.id || null,
          handle: product.handle || null,
          title: product.title || null,
          vendor: product.vendor || product.fabricante || product.manufacturer || null,
          url: window.location.href
        },
        orderContext: exportOrderContext(),
        editor: {
          activePlacement: state.placement,
          activeZone: state.zone,
          zoom: state.zoom,
          selectedColor: state.selectedColor || ""
        },
        export: {
          version: "V0.9.3_EXPORT_ES_ZIP_LIGHT_CUSTOMER_READY",
          mode: "local_zip",
          carpetaRaiz: exportPackage ? exportPackage.rootFolder : null,
          dpi: EXPORT_DPI,
          previewMode: EXPORT_INCLUDE_DEBUG_GUIDES ? "debug" : "customer_visual",
          textExportFidelity: "REV70B_SCHEMA_CONSTANT_RESTORED_CANVAS_TEXT",
          restoreHotfix: "REV69G_NO_GLOBAL_CONSTRAIN_ON_DRAFT_RESTORE",
          generatedFiles: generatedFiles.map((file) => ({
            role: file.role,
            filename: file.filename,
            displayName: file.displayName || file.filename,
            folder: file.folder || "",
            zoneId: file.zoneId || null,
            placementId: file.placementId || null,
            mimeType: file.mimeType || null,
            width: file.width || null,
            height: file.height || null,
            sizeBytes: file.sizeBytes || null,
            transparentBackground: file.transparentBackground === true,
            debugGuides: file.debugGuides === true
          }))
        },
        validation,
        assets: {
          sourceFiles: sourceCatalog.map((source) => ({
            sourceId: source.sourceId,
            assetId: source.assetId || source.sourceId,
            filename: source.filename,
            displayName: source.displayName || source.filename,
            originalName: source.originalName,
            mimeType: source.mimeType,
            extension: source.extension,
            size: source.size,
            width: source.width,
            height: source.height,
            wasOptimizedForEditor: source.wasOptimizedForEditor,
            usedByZones: source.usedByZones,
            usedByLayerIds: source.usedByLayerIds
          }))
        },
        zones: zones.map((entry) => {
          const printCm = exportZonePrintCm(entry.zone, entry.zoneId);
          const rect = entry.zone && entry.zone.rect ? entry.zone.rect : null;
          const printScale = rect ? exportZoneScale(entry.zone, entry.zoneId) : null;
          return {
            placementId: entry.placement.id,
            placementLabel: entry.placement.label,
            zoneId: entry.zoneId,
            zoneLabel: entry.zone.label,
            rect: entry.zone.rect,
            printCm,
            output: rect ? {
              dpi: EXPORT_DPI,
              estimatedPrintWidthPx: Math.round(rect.w * printScale),
              estimatedPrintHeightPx: Math.round(rect.h * printScale),
              transparentBackground: true
            } : null,
            layers: (entry.layers || []).filter((layer) => layer && layer.visible !== false).map((layer, index) => exportLayerJson(layer, index, sourceBySrc))
          };
        })
      };
    }

    async function buildPersonalizationExportBundle() {
      const zones = allExportableZones();
      if (!zones.length) {
        throw new Error("No hay capas visibles para exportar.");
      }

        await waitForExportFonts();
        const exportPackage = buildExportPackageMeta();
        const generatedFiles = [];
        const zipEntries = [];
        const sourceCatalog = buildExportSourceCatalog(zones, exportPackage.rootFolder);

        for (const sourceEntry of sourceCatalog) {
          try {
            const sourceBlob = await sourceBlobFromEntry(sourceEntry);
            const sourceDims = await imageDimensionsFromBlob(sourceBlob);
            sourceEntry.mimeType = sourceBlob.type || sourceEntry.mimeType || null;
            sourceEntry.size = sourceBlob.size || sourceEntry.size || null;
            sourceEntry.width = sourceDims.width || sourceEntry.width || null;
            sourceEntry.height = sourceDims.height || sourceEntry.height || null;
            generatedFiles.push({
              role: "source",
              filename: sourceEntry.filename,
              displayName: sourceEntry.displayName || sourceEntry.filename,
              folder: EXPORT_FOLDER_ORIGINALES,
              mimeType: sourceEntry.mimeType,
              width: sourceEntry.width || null,
              height: sourceEntry.height || null,
              sizeBytes: sourceEntry.size || null,
              sourceId: sourceEntry.sourceId,
              assetId: sourceEntry.assetId || sourceEntry.sourceId
            });
            zipEntries.push({ blob: sourceBlob, path: exportZipPath(exportPackage, sourceEntry.filename) });
          } catch (sourceError) {
            console.warn("[23DTF] No se pudo exportar una imagen fuente", sourceError);
          }
        }

        for (const entry of zones) {
          const zoneLabel = exportZoneHumanLabel(entry.zoneId, entry.zone && entry.zone.label);
          const printResult = await renderPrintCanvasForZone(entry.zone, entry.layers, entry.zoneId);
          const printBlob = await canvasToBlob(printResult.canvas, "image/png");
          const printFilename = exportRelativePath(EXPORT_FOLDER_IMPRESION, "Impresión - " + zoneLabel + ".png");
          generatedFiles.push({
            role: "print",
            filename: printFilename,
            displayName: "Impresión - " + zoneLabel + ".png",
            folder: EXPORT_FOLDER_IMPRESION,
            zoneId: entry.zoneId,
            zoneLabel,
            placementId: entry.placement.id,
            placementLabel: entry.placement.label,
            mimeType: "image/png",
            width: printResult.canvas.width,
            height: printResult.canvas.height,
            dpi: EXPORT_DPI,
            printCm: printResult.printCm,
            sizeBytes: printBlob.size || null,
            transparentBackground: true
          });
          zipEntries.push({ blob: printBlob, path: exportZipPath(exportPackage, printFilename) });

          const previewCanvas = await renderPreviewCanvasForZone(entry.zone, entry.layers, entry.placement, { debugGuides: EXPORT_INCLUDE_DEBUG_GUIDES });
          const previewBlob = await canvasToBlob(previewCanvas, "image/png");
          const previewFilename = exportRelativePath(EXPORT_FOLDER_PREVIEW, "Vista previa - " + zoneLabel + ".png");
          generatedFiles.push({
            role: "preview",
            filename: previewFilename,
            displayName: "Vista previa - " + zoneLabel + ".png",
            folder: EXPORT_FOLDER_PREVIEW,
            zoneId: entry.zoneId,
            zoneLabel,
            placementId: entry.placement.id,
            placementLabel: entry.placement.label,
            mimeType: "image/png",
            width: previewCanvas.width,
            height: previewCanvas.height,
            sizeBytes: previewBlob.size || null,
            transparentBackground: false,
            debugGuides: EXPORT_INCLUDE_DEBUG_GUIDES
          });
          zipEntries.push({ blob: previewBlob, path: exportZipPath(exportPackage, previewFilename) });
        }

        const projectFilename = "Proyecto.json";
        const manifestFilename = "Manifiesto.json";
        const customerFilename = "Cliente.json";
        generatedFiles.unshift({ role: "project", filename: projectFilename, displayName: projectFilename, folder: "", mimeType: "application/json" });
        generatedFiles.splice(1, 0, { role: "manifest", filename: manifestFilename, displayName: manifestFilename, folder: "", mimeType: "application/json" });
        generatedFiles.splice(2, 0, { role: "customer", filename: customerFilename, displayName: customerFilename, folder: "", mimeType: "application/json" });

        const validation = buildExportValidation(zones, { generatedFiles, sourceCatalog });

        const buildCustomerDocument = () => ({
          schema: "23DTF_CLIENTE_EXPORT_V1_0_PRE",
          createdAt: new Date().toISOString(),
          pedido: {
            pedidoInterno: exportPackage.id,
            carpeta: exportPackage.rootFolder,
            fechaCreacion: exportPackage.createdDate,
            horaCreacion: exportPackage.createdTime
          },
          cliente: exportPackage.cliente || exportCustomerContext(),
          privacidad: {
            carpetaIncluyeNombreCliente: false,
            motivo: "El nombre y el email del cliente se guardan solo dentro de este JSON privado. La carpeta usa el ID de Shopify para evitar datos personales en rutas o URLs."
          }
        });

        const buildManifestDocument = (project, customer, manifestSizeBytes) => ({
          schema: "23DTF_MANIFIESTO_EXPORT_V1_0_PRE",
          createdAt: new Date().toISOString(),
          pedido: project.pedido,
          cliente: project.cliente || null,
          product: project.product,
          resumen: validation && validation.summary ? validation.summary : null,
          estructura: {
            carpetaRaiz: exportPackage.rootFolder,
            proyecto: projectFilename,
            manifiesto: manifestFilename,
            cliente: customerFilename,
            originales: EXPORT_FOLDER_ORIGINALES,
            impresion: EXPORT_FOLDER_IMPRESION,
            vistaPrevia: EXPORT_FOLDER_PREVIEW
          },
          archivos: generatedFiles.map((file) => ({
            role: file.role,
            filename: file.filename,
            displayName: file.displayName || file.filename,
            folder: file.folder || "",
            zoneId: file.zoneId || null,
            zoneLabel: file.zoneLabel || null,
            placementId: file.placementId || null,
            mimeType: file.mimeType || null,
            width: file.width || null,
            height: file.height || null,
            sizeBytes: file.role === "manifest" ? manifestSizeBytes : file.sizeBytes || null,
            sourceId: file.sourceId || null,
            assetId: file.assetId || null
          }))
        });

        let project = null;
        let projectJson = "";
        let projectBlob = null;
        let customer = buildCustomerDocument();
        let customerJson = JSON.stringify(customer, null, 2);
        let customerBlob = new Blob([customerJson], { type: "application/json" });
        let manifest = null;
        let manifestJson = "";
        let manifestBlob = null;
        let manifestSizeBytes = null;

        const projectFile = generatedFiles.find((file) => file && file.role === "project");
        const manifestFile = generatedFiles.find((file) => file && file.role === "manifest");
        const customerFile = generatedFiles.find((file) => file && file.role === "customer");
        if (customerFile) customerFile.sizeBytes = customerBlob.size || null;

        for (let pass = 0; pass < 8; pass += 1) {
          project = exportProjectJson(zones, { generatedFiles, sourceCatalog, validation, exportPackage });
          projectJson = JSON.stringify(project, null, 2);
          projectBlob = new Blob([projectJson], { type: "application/json" });
          if (projectFile) projectFile.sizeBytes = projectBlob.size || null;

          customer = buildCustomerDocument();
          customerJson = JSON.stringify(customer, null, 2);
          customerBlob = new Blob([customerJson], { type: "application/json" });
          if (customerFile) customerFile.sizeBytes = customerBlob.size || null;

          manifest = buildManifestDocument(project, customer, manifestSizeBytes);
          manifestJson = JSON.stringify(manifest, null, 2);
          manifestBlob = new Blob([manifestJson], { type: "application/json" });
          const nextManifestSize = manifestBlob.size || null;
          if (manifestFile) manifestFile.sizeBytes = nextManifestSize;
          if (nextManifestSize === manifestSizeBytes) break;
          manifestSizeBytes = nextManifestSize;
        }

        // Última pasada para que Proyecto y Manifiesto recojan los sizeBytes definitivos.
        project = exportProjectJson(zones, { generatedFiles, sourceCatalog, validation, exportPackage });
        projectJson = JSON.stringify(project, null, 2);
        projectBlob = new Blob([projectJson], { type: "application/json" });
        if (projectFile) projectFile.sizeBytes = projectBlob.size || null;

        manifest = buildManifestDocument(project, customer, manifestFile ? manifestFile.sizeBytes || manifestSizeBytes : manifestSizeBytes);
        manifestJson = JSON.stringify(manifest, null, 2);
        manifestBlob = new Blob([manifestJson], { type: "application/json" });
        if (manifestFile) manifestFile.sizeBytes = manifestBlob.size || null;

        zipEntries.unshift({ blob: projectBlob, path: exportZipPath(exportPackage, projectFilename) });
        zipEntries.splice(1, 0, { blob: manifestBlob, path: exportZipPath(exportPackage, manifestFilename) });
        zipEntries.splice(2, 0, { blob: customerBlob, path: exportZipPath(exportPackage, customerFilename) });

        return {
          zones,
          exportPackage,
          generatedFiles,
          zipEntries,
          sourceCatalog,
          validation,
          project,
          manifest,
          customer,
          projectBlob,
          manifestBlob,
          customerBlob
        };
    }

    function exportRelativePathFromZipEntry(exportPackage, entryPath) {
      const root = exportSafeHumanName(exportPackage && exportPackage.rootFolder || "PED-PRUEBA", "PED-PRUEBA") + "/";
      const raw = String(entryPath || "").replace(/^\/+/, "");
      return raw.startsWith(root) ? raw.slice(root.length) : raw;
    }

    function exportFilenameFromRelativePath(relativePath) {
      const parts = String(relativePath || "archivo").split("/").filter(Boolean);
      return parts.pop() || "archivo";
    }

    async function uploadPersonalizationToCloudflare() {
      if (state.exportBusy) return;

      state.exportBusy = true;
      state.exportStatus = "Preparando subida de prueba a Cloudflare R2…";
      renderLayerPanel();

      try {
        const bundle = await buildPersonalizationExportBundle();
        const formData = new FormData();
        const customerId = bundle.exportPackage && bundle.exportPackage.cliente ? bundle.exportPackage.cliente.shopifyCustomerId || "" : "";

        formData.append("projectId", bundle.exportPackage.id);
        formData.append("customerId", customerId || "");
        formData.append("mode", "cloudflare_test_from_personalizer");

        bundle.zipEntries.forEach((item) => {
          const relativePath = exportRelativePathFromZipEntry(bundle.exportPackage, item.path);
          const filename = exportFilenameFromRelativePath(relativePath);
          formData.append("file:" + relativePath, item.blob, filename);
        });

        state.exportStatus = "Subiendo " + bundle.zipEntries.length + " archivos a Cloudflare R2…";
        renderLayerPanel();

        const response = await fetch(CLOUDFLARE_UPLOAD_ENDPOINT, {
          method: "POST",
          body: formData
        });

        let result = null;
        const resultText = await response.text();
        try {
          result = resultText ? JSON.parse(resultText) : null;
        } catch (parseError) {
          result = { ok: false, raw: resultText };
        }

        if (!response.ok || !result || result.ok !== true) {
          const message = result && result.error ? result.error : ("Error HTTP " + response.status);
          throw new Error(message);
        }

        window.P23DTF_LAST_CLOUDFLARE_UPLOAD = result;
        state.exportStatus = "Cloudflare OK: " + result.projectId + " · " + result.fileCount + " archivos subidos.";
      } catch (error) {
        console.error("[23DTF] Error subiendo personalización a Cloudflare", error);
        state.exportStatus = "No se pudo subir a Cloudflare: " + (error && error.message ? error.message : String(error || "error desconocido"));
      } finally {
        state.exportBusy = false;
        renderLayerPanel();
      }
    }

    async function uploadBundleToCloudflare(bundle, mode) {
      const formData = new FormData();
      const customerId = bundle.exportPackage && bundle.exportPackage.cliente ? bundle.exportPackage.cliente.shopifyCustomerId || "" : "";

      formData.append("projectId", bundle.exportPackage.id);
      formData.append("customerId", customerId || "");
      formData.append("mode", mode || "cloudflare_from_personalizer");

      bundle.zipEntries.forEach((item) => {
        const relativePath = exportRelativePathFromZipEntry(bundle.exportPackage, item.path);
        const filename = exportFilenameFromRelativePath(relativePath);
        formData.append("file:" + relativePath, item.blob, filename);
      });

      const response = await fetch(CLOUDFLARE_UPLOAD_ENDPOINT, {
        method: "POST",
        body: formData
      });

      let result = null;
      const resultText = await response.text();
      try {
        result = resultText ? JSON.parse(resultText) : null;
      } catch (parseError) {
        result = { ok: false, raw: resultText };
      }

      if (!response.ok || !result || result.ok !== true) {
        const message = result && result.error ? result.error : ("Error HTTP " + response.status);
        throw new Error(message);
      }

      return result;
    }

    function selectedCartEntries() {
      const entries = [];
      Object.entries(state.personalizedQty || {}).forEach(([key, rawQty]) => {
        const quantity = Math.max(0, parseInt(rawQty || "0", 10) || 0);
        if (!quantity) return;
        const parts = String(key || "").split("__");
        entries.push({
          color: parts[0] || "Único",
          size: parts[1] || "Única",
          quantity
        });
      });
      return entries;
    }

    function findVariantForPersonalizedSelection(color, size) {
      const data = productSelectionData();
      const variants = Array.isArray(data.variants) ? data.variants : [];
      const colorIndex = Number(data.colorIndex || 0);
      const sizeIndex = Number(data.sizeIndex || 0);

      return variants.find((variant) => {
        const opts = Array.isArray(variant.options) ? variant.options : [];
        const optionColor = opts[colorIndex] || opts[0] || "Único";
        const optionSize = opts[sizeIndex] || opts[1] || "Única";
        return String(optionColor) === String(color) && String(optionSize) === String(size);
      }) || null;
    }

    function zonesSummaryFromBundle(bundle) {
      const zones = bundle && bundle.validation && Array.isArray(bundle.validation.zonesWithDesign)
        ? bundle.validation.zonesWithDesign
        : [];

      const names = [];
      zones.forEach((entry) => {
        const label = entry.zoneLabel || entry.zoneId || "Zona";
        if (label && !names.includes(label)) names.push(label);
      });

      return names;
    }

    const PERSONALIZATION_SERVICE_VARIANTS = {
      front_full: {
        id: 65230630781277,
        label: "Frontal completo",
        title: "Personalización - Frontal completo",
        priceCents: 300
      },
      left_chest: {
        id: 65230642282845,
        label: "Pecho izquierdo",
        title: "Personalización - Pecho izquierdo",
        priceCents: 200
      },
      back_full: {
        id: 65230642708829,
        label: "Espalda completa",
        title: "Personalización - Espalda completa",
        priceCents: 400
      },
      left_sleeve_outer: {
        id: 65230643364189,
        label: "Manga izquierda",
        title: "Personalización - Manga izquierda",
        priceCents: 150
      },
      right_sleeve_outer: {
        id: 65230643757405,
        label: "Manga derecha",
        title: "Personalización - Manga derecha",
        priceCents: 150
      },
      inner_label_zone: {
        id: 65230644281693,
        label: "Etiqueta interior",
        title: "Personalización - Etiqueta interior",
        priceCents: 100
      }
    };

    function personalizationServiceZonesFromBundle(bundle) {
      const zones = bundle && bundle.validation && Array.isArray(bundle.validation.zonesWithDesign)
        ? bundle.validation.zonesWithDesign
        : [];

      const serviceZones = [];
      const seen = [];

      zones.forEach((entry) => {
        const zoneId = entry && entry.zoneId ? String(entry.zoneId) : "";
        if (!zoneId || seen.includes(zoneId)) return;

        const config = PERSONALIZATION_SERVICE_VARIANTS[zoneId];
        if (!config || !config.id) return;

        seen.push(zoneId);
        serviceZones.push({
          zoneId,
          label: config.label || entry.zoneLabel || zoneId,
          title: config.title || config.label || entry.zoneLabel || zoneId,
          variantId: Number(config.id),
          priceCents: Math.max(0, Number(config.priceCents || 0))
        });
      });

      return serviceZones;
    }

    function totalQuantityFromCartEntries(cartEntries) {
      return (cartEntries || []).reduce((total, entry) => {
        return total + Math.max(0, parseInt(entry && entry.quantity || "0", 10) || 0);
      }, 0);
    }


    function parseMoneyHtmlToCents(value) {
      const plain = String(value || "")
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      if (!plain) return 0;

      const numeric = plain.replace(/[^0-9,.-]/g, "");
      if (!numeric) return 0;

      const comma = numeric.lastIndexOf(",");
      const dot = numeric.lastIndexOf(".");
      const separatorIndex = Math.max(comma, dot);
      let integerPart = numeric;
      let decimalPart = "";

      if (separatorIndex >= 0 && numeric.length - separatorIndex - 1 <= 2) {
        integerPart = numeric.slice(0, separatorIndex);
        decimalPart = numeric.slice(separatorIndex + 1);
      }

      const sign = numeric.trim().startsWith("-") ? -1 : 1;
      const euros = parseInt(integerPart.replace(/[^0-9]/g, "") || "0", 10) || 0;
      const cents = parseInt((decimalPart.replace(/[^0-9]/g, "") + "00").slice(0, 2), 10) || 0;
      return sign * (euros * 100 + cents);
    }

    function variantPriceCents(variant) {
      if (!variant) return 0;
      const direct = Number(variant.price);
      if (Number.isFinite(direct) && direct >= 0) return Math.round(direct);
      return Math.max(0, parseMoneyHtmlToCents(variant.priceHtml));
    }

    function formatMoneyCents(cents) {
      const currency = String(product.currency || "EUR").toUpperCase();
      const locale = (document.documentElement && document.documentElement.lang) || "es-ES";
      try {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(Math.max(0, Number(cents || 0)) / 100);
      } catch (error) {
        return (Math.max(0, Number(cents || 0)) / 100).toFixed(2).replace(".", ",") + " €";
      }
    }

    function confirmationSizeRank(size, sizeOrder) {
      const key = String(size || "").trim().toUpperCase();
      if (sizeOrder && sizeOrder.has(key)) return sizeOrder.get(key);
      const fallback = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "2XL", "3XL", "4XL", "5XL", "6XL"];
      const index = fallback.indexOf(key);
      return index >= 0 ? index : 1000;
    }

    function buildPersonalizedCartConfirmationSummary() {
      const cartEntries = selectedCartEntries();
      if (!cartEntries.length) {
        throw new Error("Selecciona al menos una prenda, talla y cantidad antes de continuar.");
      }

      const exportableZones = allExportableZones();
      if (!exportableZones.length) {
        throw new Error("Añade al menos un diseño visible antes de continuar.");
      }

      const data = productSelectionData();
      const colorOrder = new Map((data.colors || []).map((item, index) => [String(item.name || ""), index]));
      const sizeOrder = new Map((data.sizes || []).map((item, index) => [String(item || "").trim().toUpperCase(), index]));
      let garmentSubtotalCents = 0;

      const normalizedEntries = cartEntries.map((entry) => {
        const variant = findVariantForPersonalizedSelection(entry.color, entry.size);
        if (!variant || !variant.id) {
          throw new Error("No se encontró la variante " + entry.color + " / " + entry.size + ".");
        }
        if (variant.available === false) {
          throw new Error("La variante " + entry.color + " / " + entry.size + " no está disponible.");
        }

        const unitPriceCents = variantPriceCents(variant);
        garmentSubtotalCents += unitPriceCents * entry.quantity;
        return {
          color: entry.color,
          size: entry.size,
          quantity: entry.quantity,
          unitPriceCents
        };
      });

      normalizedEntries.sort((a, b) => {
        const colorDiff = (colorOrder.get(String(a.color)) ?? 9999) - (colorOrder.get(String(b.color)) ?? 9999);
        if (colorDiff) return colorDiff;
        return confirmationSizeRank(a.size, sizeOrder) - confirmationSizeRank(b.size, sizeOrder);
      });

      const groupsMap = new Map();
      normalizedEntries.forEach((entry) => {
        if (!groupsMap.has(entry.color)) {
          groupsMap.set(entry.color, {
            color: entry.color,
            swatch: colorSwatch(entry.color),
            total: 0,
            sizes: []
          });
        }
        const group = groupsMap.get(entry.color);
        group.total += entry.quantity;
        group.sizes.push({ size: entry.size, quantity: entry.quantity });
      });

      const seenZones = new Set();
      const serviceZones = [];
      exportableZones.forEach((entry) => {
        const zoneId = String(entry.zoneId || "");
        if (!zoneId || seenZones.has(zoneId)) return;
        const config = PERSONALIZATION_SERVICE_VARIANTS[zoneId];
        if (!config || !config.id) {
          throw new Error("La zona " + (entry.zone && entry.zone.label ? entry.zone.label : zoneId) + " no tiene un servicio configurado.");
        }
        seenZones.add(zoneId);
        serviceZones.push({
          zoneId,
          label: config.label || (entry.zone && entry.zone.label) || zoneId,
          priceCents: Math.max(0, Number(config.priceCents || 0))
        });
      });

      const totalQuantity = totalQuantityFromCartEntries(normalizedEntries);
      const personalizationUnitCents = serviceZones.reduce((sum, zone) => sum + zone.priceCents, 0);
      const personalizationSubtotalCents = personalizationUnitCents * totalQuantity;

      return {
        productTitle: product.title || "Prenda personalizada",
        totalQuantity,
        groups: Array.from(groupsMap.values()),
        serviceZones,
        garmentSubtotalCents,
        personalizationUnitCents,
        personalizationSubtotalCents,
        grandTotalCents: garmentSubtotalCents + personalizationSubtotalCents
      };
    }

    function renderPersonalizedCartConfirmation(summary) {
      const body = q("[data-p23m-cart-confirm-body]");
      if (!body) return;

      const groupRows = summary.groups.map((group) => {
        const sizes = group.sizes.map((item) => {
          return '<span class="p23m-confirm__size-chip"><b>' + escapeHtml(item.size) + '</b><em>× ' + Number(item.quantity) + '</em></span>';
        }).join("");

        return '<div class="p23m-confirm__color-row">' +
          '<span class="p23m-confirm__swatch" style="background:' + escapeHtml(group.swatch) + '"></span>' +
          '<div class="p23m-confirm__color-main"><div class="p23m-confirm__color-head"><strong>' + escapeHtml(group.color) + '</strong><small>' + Number(group.total) + ' ' + unitLabel(group.total) + '</small></div>' +
          '<div class="p23m-confirm__sizes">' + sizes + '</div></div>' +
        '</div>';
      }).join("");

      const zoneRows = summary.serviceZones.map((zone) => {
        return '<div class="p23m-confirm__zone-row">' +
          '<span class="p23m-confirm__zone-check" aria-hidden="true">✓</span>' +
          '<strong>' + escapeHtml(zone.label) + '</strong>' +
          '<small>' + escapeHtml(formatMoneyCents(zone.priceCents)) + ' / ud.</small>' +
        '</div>';
      }).join("");

      body.innerHTML =
        '<div class="p23m-confirm__hero">' +
          '<span class="p23m-confirm__quantity-badge">' + Number(summary.totalQuantity) + ' ' + unitLabel(summary.totalQuantity) + '</span>' +
          '<h3>' + escapeHtml(summary.productTitle) + '</h3>' +
          '<p>Comprueba las cantidades, tallas y zonas antes de generar los archivos y añadirlo al carrito.</p>' +
        '</div>' +
        '<div class="p23m-confirm__content-grid">' +
          '<section class="p23m-confirm__section">' +
            '<div class="p23m-confirm__section-head"><strong>Colores y tallas</strong><span>' + Number(summary.groups.length) + ' ' + (summary.groups.length === 1 ? 'color' : 'colores') + '</span></div>' +
            '<div class="p23m-confirm__color-list">' + groupRows + '</div>' +
          '</section>' +
          '<section class="p23m-confirm__section">' +
            '<div class="p23m-confirm__section-head"><strong>Zonas aplicadas</strong><span>' + Number(summary.serviceZones.length) + ' ' + (summary.serviceZones.length === 1 ? 'zona' : 'zonas') + '</span></div>' +
            '<div class="p23m-confirm__zone-list">' + zoneRows + '</div>' +
            '<p class="p23m-confirm__zone-note">Las zonas se cobran por cada prenda personalizada.</p>' +
          '</section>' +
        '</div>' +
        '<section class="p23m-confirm__totals">' +
          '<div><span>Prendas</span><strong>' + escapeHtml(formatMoneyCents(summary.garmentSubtotalCents)) + '</strong></div>' +
          '<div><span>Personalización · ' + Number(summary.serviceZones.length) + ' ' + (summary.serviceZones.length === 1 ? 'zona' : 'zonas') + '</span><strong>' + escapeHtml(formatMoneyCents(summary.personalizationSubtotalCents)) + '</strong></div>' +
          '<div class="p23m-confirm__grand-total"><span>Total estimado</span><strong>' + escapeHtml(formatMoneyCents(summary.grandTotalCents)) + '</strong></div>' +
          '<small>El envío, los descuentos y cualquier ajuste final se calcularán en el carrito.</small>' +
        '</section>';
    }

    function setPersonalizedCartConfirmationError(message) {
      const errorBox = q("[data-p23m-cart-confirm-error]");
      if (!errorBox) return;
      const text = String(message || "").trim();
      errorBox.hidden = !text;
      errorBox.textContent = text;
    }

    function setPersonalizedCartConfirmationBusy(isBusy, label) {
      const modal = q("[data-p23m-cart-confirm]");
      const confirmButton = q("[data-p23m-cart-confirm-submit]");
      const closeButtons = qa("[data-p23m-cart-confirm-close]");
      if (modal) modal.classList.toggle("is-busy", !!isBusy);
      if (confirmButton) {
        confirmButton.disabled = !!isBusy;
        confirmButton.textContent = isBusy ? (label || "Preparando…") : "Confirmar y añadir al carrito";
      }
      closeButtons.forEach((button) => { button.disabled = !!isBusy; });
    }

    function closePersonalizedCartConfirmation(force) {
      if (state.exportBusy && !force) return;
      const modal = q("[data-p23m-cart-confirm]");
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");
      root.classList.remove("is-p23m-cart-confirm-open");
      setPersonalizedCartConfirmationError("");
      setPersonalizedCartConfirmationBusy(false);
      const focusTarget = cartConfirmationLastFocus;
      cartConfirmationLastFocus = null;
      if (focusTarget && typeof focusTarget.focus === "function" && document.contains(focusTarget)) {
        window.setTimeout(() => focusTarget.focus(), 0);
      }
    }

    function openPersonalizedCartConfirmation() {
      if (state.exportBusy) return;

      const customer = product && product.customer ? product.customer : null;
      if (!customer || !customer.id) {
        alert("Inicia sesión o crea una cuenta para poder personalizar tu prenda.");
        return;
      }

      try {
        const summary = buildPersonalizedCartConfirmationSummary();
        const modal = q("[data-p23m-cart-confirm]");
        if (!modal) throw new Error("No se pudo abrir la confirmación del carrito.");

        renderPersonalizedCartConfirmation(summary);
        setPersonalizedCartConfirmationError("");
        setPersonalizedCartConfirmationBusy(false);
        cartConfirmationLastFocus = document.activeElement;
        modal.hidden = false;
        modal.setAttribute("aria-hidden", "false");
        root.classList.add("is-p23m-cart-confirm-open");

        window.requestAnimationFrame(() => {
          const confirmButton = q("[data-p23m-cart-confirm-submit]");
          if (confirmButton) confirmButton.focus();
        });
      } catch (error) {
        alert(error && error.message ? error.message : String(error || "No se pudo preparar el resumen."));
      }
    }

    function setAddToCartBusy(isBusy) {
      const button = q("[data-p23m-add-to-cart]");
      if (!button) return;
      button.disabled = !!isBusy;
      button.textContent = isBusy ? "Añadiendo…" : "Añadir al carrito";
    }

    function personalizedCartAddLockKey() {
      return "23dtf:personalized-cart-add:" + draftProductIdentity();
    }

    function acquirePersonalizedCartAddLock() {
      const key = personalizedCartAddLockKey();
      const now = Date.now();
      try {
        const previous = JSON.parse(window.sessionStorage.getItem(key) || "null");
        if (previous && previous.status === "adding" && now - Number(previous.startedAt || 0) < 10 * 60 * 1000) {
          return false;
        }
        window.sessionStorage.setItem(key, JSON.stringify({ status: "adding", startedAt: now }));
      } catch (error) {
        // sessionStorage puede estar deshabilitado; exportBusy sigue protegiendo el doble clic.
      }
      return true;
    }

    function releasePersonalizedCartAddLock() {
      try { window.sessionStorage.removeItem(personalizedCartAddLockKey()); } catch (error) {}
    }

    function personalizedParentReference(groupId, variantId, color, size) {
      return [
        String(groupId || "personalizado"),
        String(variantId || "0"),
        String(color || "Único").replace(/[^a-zA-Z0-9_-]+/g, "-"),
        String(size || "Única").replace(/[^a-zA-Z0-9_-]+/g, "-")
      ].join("__");
    }

    function buildPersonalizedCartItems(uploadResult, bundle) {
      const cartEntries = selectedCartEntries();
      if (!cartEntries.length) {
        throw new Error("Selecciona al menos una prenda, talla y cantidad antes de añadir al carrito.");
      }

      const zones = zonesSummaryFromBundle(bundle);
      if (!zones.length) {
        throw new Error("Añade al menos un diseño visible antes de añadir al carrito.");
      }

      const serviceZones = personalizationServiceZonesFromBundle(bundle);
      if (!serviceZones.length) {
        throw new Error("No se encontró ningún servicio de personalización configurado para las zonas usadas.");
      }

      const customerId = uploadResult.customerId || (bundle.exportPackage && bundle.exportPackage.cliente ? bundle.exportPackage.cliente.shopifyCustomerId : "") || "";
      const groupId = "23dtf-personalizado-" + String(uploadResult.projectId || bundle.exportPackage.id || Date.now()).replace(/[^a-zA-Z0-9_-]/g, "-");
      const zonesText = zones.join(", ");
      const projectId = uploadResult.projectId || (bundle.exportPackage && bundle.exportPackage.id) || "";
      const r2Path = uploadResult.rootFolder || "";
      const items = [];

      cartEntries.forEach((entry) => {
        const variant = findVariantForPersonalizedSelection(entry.color, entry.size);
        if (!variant || !variant.id) {
          throw new Error("No se encontró la variante " + entry.color + " / " + entry.size + ".");
        }
        if (variant.available === false) {
          throw new Error("La variante " + entry.color + " / " + entry.size + " no está disponible.");
        }

        const parentVariantId = Number(variant.id);
        const parentRef = personalizedParentReference(groupId, parentVariantId, entry.color, entry.size);

        items.push({
          id: parentVariantId,
          quantity: entry.quantity,
          properties: {
            "Personalización": "Sí",
            "Zonas": zonesText,
            "_item_type": "personalized_garment",
            "_group_id": groupId,
            "_23dtf_parent_ref": parentRef,
            "_23dtf_project_id": projectId,
            "_23dtf_r2_path": r2Path,
            "_23dtf_customer_id": customerId,
            "_23dtf_zones": zonesText,
            "_23dtf_cloudflare_uploaded_at": uploadResult.uploadedAt || "",
            "_23dtf_cart_schema": "v1.0-pre13a1-clean",
            "_23dtf_quantity_source": "shopify_order"
          }
        });

        serviceZones.forEach((service) => {
          items.push({
            id: service.variantId,
            quantity: entry.quantity,
            parent_id: parentVariantId,
            properties: {
              "_23dtf_zone_label": service.label,
              "_item_type": "personalization",
              "_group_id": groupId,
              "_23dtf_service": "zone_personalization",
              "_23dtf_service_zone": service.zoneId,
              "_23dtf_nested_service": "1",
              "_23dtf_parent_ref": parentRef,
              "_23dtf_parent_variant_id": String(parentVariantId),
              "_23dtf_project_id": projectId,
              "_23dtf_customer_id": customerId,
              "_23dtf_cart_schema": "v1.0-pre13a1-clean",
              "_23dtf_quantity_source": "shopify_order"
            }
          });
        });
      });

      return items;
    }

    async function rollbackPersonalizedCartGroup(groupId) {
      if (!groupId) return;
      try {
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/");
        const cartResponse = await fetch(rootUrl + "cart.js", { headers: { "Accept": "application/json" } });
        if (!cartResponse.ok) return;
        const cart = await cartResponse.json();
        const updates = {};
        (cart.items || []).forEach((item) => {
          const properties = item && item.properties ? item.properties : {};
          if (String(properties._group_id || "") === String(groupId)) updates[item.key] = 0;
        });
        if (!Object.keys(updates).length) return;
        await fetch(rootUrl + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ updates })
        });
      } catch (rollbackError) {
        console.error("[23DTF] No se pudo revertir el grupo tras fallar el vínculo padre-hijo", rollbackError);
      }
    }

    function verifyNestedPersonalizationResponse(cartResult, items) {
      const expectedChildren = (items || []).filter((item) => item && item.properties && item.properties._23dtf_nested_service === "1").length;
      if (!expectedChildren) return true;

      const responseItems = cartResult && Array.isArray(cartResult.items) ? cartResult.items : [];
      const nestedChildren = responseItems.filter((item) => {
        const properties = item && item.properties ? item.properties : {};
        return properties._23dtf_nested_service === "1" && item.parent_relationship && item.parent_relationship.parent_key;
      }).length;

      return nestedChildren === expectedChildren;
    }

    async function addPersonalizedSelectionToCart() {
      if (state.exportBusy) return;

      const customer = product && product.customer ? product.customer : null;
      if (!customer || !customer.id) {
        alert("Inicia sesión o crea una cuenta para poder personalizar tu prenda.");
        return;
      }

      if (personalizedQtyTotal() <= 0) {
        alert("Selecciona al menos una talla y cantidad para la prenda personalizada.");
        return;
      }

      if (!acquirePersonalizedCartAddLock()) {
        alert("La personalización ya se está añadiendo al carrito. Espera unos segundos.");
        return;
      }

      state.exportBusy = true;
      state.exportStatus = "Preparando archivos para añadir al carrito…";
      setAddToCartBusy(true);
      setPersonalizedCartConfirmationError("");
      setPersonalizedCartConfirmationBusy(true, "Preparando archivos…");
      renderLayerPanel();

      try {
        const bundle = await buildPersonalizationExportBundle();

        state.exportStatus = "Subiendo personalización a Cloudflare antes de añadir al carrito…";
        setPersonalizedCartConfirmationBusy(true, "Subiendo personalización…");
        renderLayerPanel();

        const uploadResult = await uploadBundleToCloudflare(bundle, "cart_add_personalized_garment");
        const items = buildPersonalizedCartItems(uploadResult, bundle);

        state.exportStatus = "Cloudflare OK. Añadiendo prenda y servicios de personalización al carrito…";
        setPersonalizedCartConfirmationBusy(true, "Añadiendo al carrito…");
        renderLayerPanel();

        const response = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ items })
        });

        let cartResult = null;
        const cartText = await response.text();
        try {
          cartResult = cartText ? JSON.parse(cartText) : null;
        } catch (parseError) {
          cartResult = { raw: cartText };
        }

        if (!response.ok) {
          const message = cartResult && (cartResult.description || cartResult.message) ? (cartResult.description || cartResult.message) : "No se pudo añadir la prenda personalizada al carrito.";
          throw new Error(message);
        }

        const nestedGroupId = items[0] && items[0].properties ? items[0].properties._group_id : "";
        if (!verifyNestedPersonalizationResponse(cartResult, items)) {
          await rollbackPersonalizedCartGroup(nestedGroupId);
          throw new Error("Shopify no vinculó correctamente los servicios a sus prendas. No se ha conservado el grupo en el carrito.");
        }

        window.P23DTF_LAST_PERSONALIZED_CART_ADD = {
          upload: uploadResult,
          cart: cartResult
        };

        state.exportStatus = "Añadido al carrito: " + uploadResult.projectId + ".";
        setPersonalizedCartConfirmationBusy(true, "Limpiando borrador y abriendo carrito…");
        renderLayerPanel();

        // v1.0-pre11: marcamos el reset antes de navegar. Así, si el navegador
        // recupera la página del producto desde bfcache, el editor se vacía otra vez.
        markSuccessfulCartReset();
        await clearLocalDraftAndDesign({ keepAutosaveBlocked: true });
        releasePersonalizedCartAddLock();
        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart";
      } catch (error) {
        console.error("[23DTF] Error añadiendo personalización al carrito", error);
        releasePersonalizedCartAddLock();
        state.exportStatus = "No se pudo añadir al carrito: " + (error && error.message ? error.message : String(error || "error desconocido"));
        state.exportBusy = false;
        setAddToCartBusy(false);
        setPersonalizedCartConfirmationBusy(false);
        setPersonalizedCartConfirmationError(state.exportStatus);
        renderLayerPanel();
      }
    }

    async function exportPersonalizationLocal() {
      if (state.exportBusy) return;

      state.exportBusy = true;
      state.exportStatus = "Preparando ZIP local v1.0-pre…";
      renderLayerPanel();

      try {
        const bundle = await buildPersonalizationExportBundle();
        try {
          const zipBlob = await buildZipBlob(bundle.zipEntries);
          downloadBlob(zipBlob, bundle.exportPackage.zipFilename);
          state.exportStatus = "ZIP v1.0-pre generado: Proyecto, Cliente, Manifiesto, Originales, Impresión y Vista previa.";
        } catch (zipError) {
          console.warn("[23DTF] No se pudo crear ZIP. Se descargan archivos sueltos como respaldo.", zipError);
          let delay = 0;
          bundle.zipEntries.forEach((item) => {
            window.setTimeout(() => downloadBlob(item.blob, item.path.split("/").pop() || "archivo"), delay);
            delay += 450;
          });
          state.exportStatus = "ZIP no disponible: archivos sueltos descargados como respaldo.";
        }
      } catch (error) {
        console.error("[23DTF] Error exportando personalización v1.0-pre", error);
        state.exportStatus = "No se pudo exportar: " + (error && error.message ? error.message : String(error || "error desconocido"));
      } finally {
        state.exportBusy = false;
        renderLayerPanel();
      }
    }

    function installNativeImageGestureGuards() {
      /*
        v4.11m-REV36:
        En iOS/Android, mantener pulsado una imagen abre el menú nativo
        Guardar/Copiar/Abrir imagen. Dentro del personalizador eso rompe la UX,
        porque la pulsación larga debe servir para mover/reordenar/interactuar.
      */
      if (root.dataset.p23mNativeGuards === "1") return;
      root.dataset.p23mNativeGuards = "1";

      const isEditableTextTarget = (target) => {
        return !!(
          target &&
          target.closest &&
          target.closest('input, textarea, [contenteditable="true"], [data-p23m-control="text"], [data-p23m-canvas-text-edit]')
        );
      };

      const shouldBlockNativeImageMenu = (event) => {
        const target = event.target;
        if (!target || !root.contains(target)) return false;

        /*
          v4.11m-REV49:
          Permitimos menú nativo/selección/copy/paste en texto editable.
          El bloqueo de pulsación larga sigue activo para imágenes/canvas.
        */
        if (isEditableTextTarget(target)) return false;

        return !!(
          target.closest &&
          target.closest(".p23m, .mpv2c-modal, [data-p23m-canvas], [data-p23m-mockup], [data-p23m-layer], [data-p23m-layer-stage], [data-p23m-safe], [data-p23m-toolbar]")
        );
      };

      root.addEventListener("contextmenu", (event) => {
        if (shouldBlockNativeImageMenu(event)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { capture: true });

      root.addEventListener("dragstart", (event) => {
        if (shouldBlockNativeImageMenu(event)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { capture: true });

      root.addEventListener("selectstart", (event) => {
        if (shouldBlockNativeImageMenu(event)) {
          event.preventDefault();
        }
      }, { capture: true });
    }

    function renderAll() {
      installNativeImageGestureGuards();
      renderPanels();
      renderProductSelection();
      renderUploads();
      renderProductImage();
      renderPlacements();
      renderToolbar();
      renderZone();
      renderCanvasUploadButton();
      renderLayers();
      updatePrintAreaLayerMask();
      renderLayerPanel();
      renderControls();
      renderCropActions();
      calibratorRender();
      renderPrintAreaWarning();
      normalizeZoomControls();
      scheduleResponsiveMockupScale();
      scheduleDraftSave();
    }

    exposeCalibratorApi();
  }
})();


/* ======================================================================
   23DTF v4.10r - Bloqueo scroll exterior popup móvil/tablet
   Evita que iPhone/Android arrastren la página exterior cuando el popup
   de personalización está abierto. Mantiene scroll interno en paneles.
   ====================================================================== */
(function p23mMobileModalScrollLock() {
  if (window.__p23mMobileModalScrollLockReady) return;
  window.__p23mMobileModalScrollLockReady = true;

  const LOCK_CLASS = "p23m-modal-scroll-locked";
  let locked = false;
  let savedScrollY = 0;
  let startX = 0;
  let startY = 0;

  function isMobileModalViewport() {
    return window.matchMedia && window.matchMedia("(max-width: 989px)").matches;
  }

  function openModal() {
    return document.querySelector(
      ".mpv2c-modal:not([hidden])[aria-hidden='false'], " +
      ".mpv2c-modal:not([hidden]), " +
      ".mpv2-phase1-modal:not([hidden])[aria-hidden='false'], " +
      ".mpv2-phase1-modal:not([hidden])"
    );
  }

  function lockPage() {
    if (locked || !isMobileModalViewport()) return;

    savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    locked = true;

    document.documentElement.classList.add(LOCK_CLASS);
    document.body.classList.add(LOCK_CLASS);

    document.body.dataset.p23mScrollLockY = String(savedScrollY);
    document.body.style.setProperty("position", "fixed", "important");
    document.body.style.setProperty("top", "-" + savedScrollY + "px", "important");
    document.body.style.setProperty("left", "0", "important");
    document.body.style.setProperty("right", "0", "important");
    document.body.style.setProperty("width", "100%", "important");
    document.body.style.setProperty("overflow", "hidden", "important");
  }

  function unlockPage() {
    if (!locked) return;

    const y = Number(document.body.dataset.p23mScrollLockY || savedScrollY || 0);

    locked = false;
    document.documentElement.classList.remove(LOCK_CLASS);
    document.body.classList.remove(LOCK_CLASS);

    document.body.style.removeProperty("position");
    document.body.style.removeProperty("top");
    document.body.style.removeProperty("left");
    document.body.style.removeProperty("right");
    document.body.style.removeProperty("width");
    document.body.style.removeProperty("overflow");
    delete document.body.dataset.p23mScrollLockY;

    window.scrollTo(0, y);
  }

  function syncLock() {
    if (openModal()) lockPage();
    else unlockPage();
  }

  function onTouchStart(event) {
    if (!locked || !event.touches || event.touches.length !== 1) return;
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  }

  function onTouchMove(event) {
    if (!locked || !event.touches || event.touches.length !== 1) return;

    const modal = openModal();
    if (!modal || !modal.contains(event.target)) {
      event.preventDefault();
      return;
    }

    const currentX = event.touches[0].clientX;
    const currentY = event.touches[0].clientY;
    const dx = currentX - startX;
    const dy = currentY - startY;

    /* Si el gesto es principalmente horizontal, dejamos trabajar a tablas/zonas */
    if (Math.abs(dx) > Math.abs(dy)) return;

    /*
      23DTF REV62 SAFE:
      Scroll táctil anidado. Antes se bloqueaba el gesto al llegar al final
      del primer bloque scrollable detectado; en Capas eso podía impedir que
      el panel padre siguiera deslizando. Ahora buscamos cualquier contenedor
      scrollable padre que todavía pueda moverse en esa dirección.
    */
    let node = event.target;
    let canAnyScrollerMove = false;

    while (node && node !== document.body && node !== document.documentElement) {
      if (node.nodeType === 1) {
        const style = window.getComputedStyle(node);
        const overflowY = style.overflowY || "";
        const canScrollY = /(auto|scroll)/.test(overflowY) && node.scrollHeight > node.clientHeight + 2;

        if (canScrollY) {
          const atTop = node.scrollTop <= 0;
          const atBottom = node.scrollTop + node.clientHeight >= node.scrollHeight - 1;

          if ((dy > 0 && !atTop) || (dy < 0 && !atBottom)) {
            canAnyScrollerMove = true;
            break;
          }
        }
      }

      if (node === modal) break;
      node = node.parentElement;
    }

    if (!canAnyScrollerMove) {
      event.preventDefault();
    }
  }

  document.addEventListener("touchstart", onTouchStart, { passive: true, capture: true });
  document.addEventListener("touchmove", onTouchMove, { passive: false, capture: true });

  const observer = new MutationObserver(() => {
    window.requestAnimationFrame(syncLock);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["hidden", "aria-hidden", "class"]
  });

  document.addEventListener("DOMContentLoaded", syncLock);
  document.addEventListener("shopify:section:load", syncLock);
  document.addEventListener("click", () => {
    window.setTimeout(syncLock, 80);
    window.setTimeout(syncLock, 300);
  }, true);
  window.addEventListener("resize", syncLock, { passive: true });
  window.addEventListener("pagehide", unlockPage);

  syncLock();
})();
